webpackJsonp([1],{

/***/ "+9mr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+qkY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card cads"},[_c('div',{staticClass:"card-header"},[_vm._v("CADS Details")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('table',{staticClass:"table table-borderless"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',{key:item.ID},[_c('td',[_vm._v(_vm._s(item.AssetComponentID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.SerialNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.SalesOrderNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.LicensingItemNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.SKU))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getReadableDate(item.DeliveryDate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.TermExpDate === null
              ? 'Permanent'
              : _vm.getReadableDate(item.TermExpDate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getReadableDate(item.MPEndDate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.Status))])])}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("AC ID")]),_vm._v(" "),_c('th',[_vm._v("Serial Number")]),_vm._v(" "),_c('th',[_vm._v("SAP Order Number")]),_vm._v(" "),_c('th',[_vm._v("LIC Item Number")]),_vm._v(" "),_c('th',[_vm._v("SKU")]),_vm._v(" "),_c('th',[_vm._v("Delivery Date")]),_vm._v(" "),_c('th',[_vm._v("Term End Date")]),_vm._v(" "),_c('th',[_vm._v("MP End Date")]),_vm._v(" "),_c('th',[_vm._v("Status")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/HoS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.sizeClasses},[(_vm.$slots.prepend || _vm.prepend)?_c('div',{ref:"prependDiv",staticClass:"input-group-prepend"},[_vm._t("prepend",function(){return [_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(_vm.prepend))])]})],2):_vm._e(),_vm._v(" "),_c('input',{ref:"input",class:("form-control " + _vm.inputClass),attrs:{"type":"search","placeholder":_vm.placeholder,"aria-label":_vm.placeholder,"autocomplete":"off"},domProps:{"value":_vm.inputValue},on:{"focus":function($event){_vm.isFocused = true},"blur":_vm.handleBlur,"input":function($event){return _vm.handleInput($event.target.value)}}}),_vm._v(" "),(_vm.$slots.append || _vm.append)?_c('div',{staticClass:"input-group-append"},[_vm._t("append",function(){return [_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(_vm.append))])]})],2):_vm._e()]),_vm._v(" "),_c('vue-bootstrap-typeahead-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFocused && _vm.data.length > 0),expression:"isFocused && data.length > 0"}],ref:"list",staticClass:"vbt-autcomplete-list",attrs:{"query":_vm.inputValue,"data":_vm.formattedData,"background-variant":_vm.backgroundVariant,"text-variant":_vm.textVariant,"maxMatches":_vm.maxMatches,"minMatchingChars":_vm.minMatchingChars},on:{"hit":_vm.handleHit},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(slot,slotName){return {key:slotName,fn:function(ref){
var data = ref.data;
var htmlText = ref.htmlText;
return [_vm._t(slotName,null,null,{ data: data, htmlText: htmlText })]}}})],null,true)})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/KFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("AHJT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37220788_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("XBkc");
function injectStyle (ssrContext) {
  __webpack_require__("pOoN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37220788_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/uQD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('license-checker-header',{on:{"search":_vm.handleSearch}}),_vm._v(" "),(_vm.response)?[_c('div',[_c('license-checker-body',{attrs:{"is-loading":_vm.isLoading,"aside-list":_vm.asideList,"set-selected-id":_vm.setSelectedId,"selected-id":_vm.selectedId,"table-data":_vm.tableData,"line-items-to-modify":_vm.lineItemsToModify,"grid":_vm.grid,"fix-issues":_vm.fixIssues,"fix-issues-button-text":_vm.isFixing ? 'Fixing...' : 'Fix all issues',"modal-data":_vm.modalData,"order-details":_vm.orderDetails,"initial-order-details":_vm.initialOrderDetails,"renewal-order-details":_vm.renewalOrderDetails,"is-api-complete":_vm.isApiComplete}}),_vm._v(" "),_c('license-checker-modal',{ref:"issuesFixed",attrs:{"data":_vm.modalData}})],1)]:[_c('h5',{staticClass:"text-center",staticStyle:{"margin-top":"90px"}},[_vm._v("No records found.")])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0G52":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0WNb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allItems.length > 0)?_c('div',{staticClass:"table-container"},[_c('b-row',[_c('div',{staticClass:"col-xs-12 col-md-8 no-padding"},[_c('h3',{staticClass:"table-title"},[_vm._v("\n        "+_vm._s(_vm.isTypeRecentPurchases ? _vm.$t('newLicenses') : _vm.$t('expiringTermLicenses'))+"\n      ")]),_vm._v(" "),_c('span',{staticClass:"items-count"},[(_vm.isTypeRecentPurchases)?[_vm._v("\n          "+_vm._s(_vm.$t('last30Days'))+"\n        ")]:_vm._e(),_vm._v("\n        "+_vm._s(_vm.$t(
            'itemsCount',
            { number: _vm.allItems.length > 5 ? 5 : _vm.allItems.length, total: _vm.total }
          ))+"\n      ")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-4 view-all-link"},[(_vm.allItems.length > 5)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleViewAllClick.apply(null, arguments)}}},[_vm._v("\n        "+_vm._s(_vm.isTypeRecentPurchases
            ? _vm.$t('viewAllNewPurchases')
            : _vm.$t('viewAllExpiringTermLicense'))+"\n      ")]):_vm._e()])]),_vm._v(" "),_c('b-row',{class:[_vm.tableHeaderClass, 'vertical-padding'],staticStyle:{"padding-left":"10px"}},[(_vm.isTypeRecentPurchases)?_c('div',{staticClass:"col checkbox-col"},[_c('b-checkbox',{on:{"change":_vm.toggleAllLicensesSelection},model:{value:(_vm.areAllLicensesSelected),callback:function ($$v) {_vm.areAllLicensesSelected=$$v},expression:"areAllLicensesSelected"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-row',[_c('div',{class:("col " + (_vm.isTypeRecentPurchases ? 'indend-text' : ''))},[_vm._v("\n          "+_vm._s(_vm.$t('productName'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block col dynamic-column-select-container header"},[_vm._v("\n          "+_vm._s(_vm.dynamicColumnHeader)+"\n             \n          "),_c('i',{staticClass:"fa fa-caret-down"}),_vm._v(" "),_c('b-select',{staticClass:"dynamic-column-select",attrs:{"options":_vm.dynamicColumnOptions},model:{value:(_vm.dynamicColumnOption),callback:function ($$v) {_vm.dynamicColumnOption=$$v},expression:"dynamicColumnOption"}})],1),_vm._v(" "),(!_vm.isTypeRecentPurchases)?[_c('div',{staticClass:"d-none d-md-block col allocated-col text-right"},[_vm._v("\n            "+_vm._s(_vm.$t('allocated'))+"\n          ")])]:_vm._e()],2)],1),_vm._v(" "),_c('div',{staticClass:"col last-col header"},[_vm._v("\n      "+_vm._s(_vm.lastColumnHeaderText)+"\n    ")])]),_vm._v(" "),_vm._l((_vm.items),function(item,i){return [_c('b-row',{key:item.ActivationID,class:_vm.getTableRowClasses(item.ExpirationDate, i)},[(_vm.isTypeRecentPurchases)?_c('div',{staticClass:"col checkbox-col"},[_c('b-checkbox',{class:_vm.isLicenseInvalid(item) ? 'error-checkbox' : '',attrs:{"checked":_vm.isLicenseSelected(item)},on:{"change":function($event){return _vm.toggleLicenseSelection(item)}}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-row',[_c('div',{class:("col " + (_vm.isTypeRecentPurchases ? 'indend-text' : ''))},[_c('a',{attrs:{"href":("/#/license/" + (item.ActivationID)),"title":item.ProductName},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleLicenseLinkClick(item)}}},[_vm._v("\n              "+_vm._s(item.ProductName)+"\n            ")]),_vm._v(" "),(_vm.isLicenseInvalid(item))?_c('p',{staticClass:"error-row-text"},[_vm._v("\n              "+_vm._s(_vm.$t('multipleSelectionHostTypeError', { hostType: _vm.hostType }))+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block col dynamic-column-select-container",attrs:{"title":_vm.dynamicColumnOption === 'HostValue' ? _vm.dynamicColumnItem(item) : ''}},[_vm._v("\n            "+_vm._s(_vm.dynamicColumnItem(item))+"\n          ")]),_vm._v(" "),(!_vm.isTypeRecentPurchases)?[_c('div',{staticClass:"d-none d-md-block col allocated-col text-right"},[_vm._v("\n              "+_vm._s(_vm.getAllocatedText(item))+"\n            ")])]:_vm._e()],2)],1),_vm._v(" "),[_c('div',{class:_vm.getLastColumnClasses(item)},[_vm._v("\n          "+_vm._s(_vm.getLastColumnItemText(item))+"\n        ")])]],2)]}),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-xs-12 col-md-6 cta-container no-padding"},[(_vm.isTypeRecentPurchases)?_c('b-button',{staticClass:"cta-button",attrs:{"size":"lg","variant":"primary","disabled":_vm.isCtaButtonDisabled || (_vm.isInternal && !_vm.isPersonInRole),"title":_vm.selectedLicenses.length === 0 ? _vm.$t('noSelectionInfoText') : ''},on:{"click":function($event){return _vm.handleAllocateClick()}}},[_vm._v("\n        "+_vm._s(_vm.$t('allocateLicenses'))+"\n      ")]):_vm._e()],1)]),_vm._v(" "),_c('b-row',[(_vm.allItems.length > 0 && !_vm.isTypeRecentPurchases)?_c('div',{staticClass:"col-12 no-padding"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('expiringInfo', { customerServiceUrl: _vm.UrlBuilder.customerServiceUrl }))}})]):_vm._e()]),_vm._v(" "),_c('allocation-modal',{attrs:{"modal":_vm.allocationModal,"closeModal":_vm.closeAllocationModal,"selectedLicenses":_vm.selectedLicenses,"getUpdatedLicenses":_vm.getUpdatedLicenses}})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0k7g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "15ZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__ = __webpack_require__("olAn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var locale = 'en';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Email',
  components: { VueRecaptcha: __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__["a" /* default */] },
  data: function data() {
    this.$i18n.locale = 'en';
    return {
      email: '',
      laCode: '',
      isSubmitting: false,
      wasEmailInput: false,
      isEmailValid: false,
      recaptchaVerified: this.UrlBuilder.isInternalUser || this.$route.params && this.$route.params.internal === 'true',
      alert: true,
      isApiCallComplete: false,
      wasApiSuccessful: false,
      selectedLocal: 'en',
      langauges: [{
        key: 'en',
        value: 'English (US)'
      }, {
        key: 'de-DE',
        value: 'Deutsch (Deutschland)'
      }, {
        key: 'fr-FR',
        value: 'Francais (France)'
      }, {
        key: 'es-CO',
        value: 'Español'
      }, {
        key: 'pt-BR',
        value: 'Português (Brasil)'
      }, {
        key: 'jp-JP',
        value: '日本語'
      }, {
        key: 'ko-KR',
        value: '한국어'
      }, {
        key: 'zh-CN',
        value: '简体中文'
      }, {
        key: 'zh-TW',
        value: '繁體中文'
      }]
    };
  },

  computed: {
    emailState: function emailState() {
      if (!this.wasEmailInput) return null;
      return this.isEmailValid;
    },
    staticDirPrefix: function staticDirPrefix() {
      var devEnv = 'development';
      var env = "production" || devEnv;
      return env === devEnv ? '' : '/licensingui';
    },
    isSubmitButtonDisabled: function isSubmitButtonDisabled() {
      return !this.isEmailValid || !this.laCode || !this.recaptchaVerified;
    }
  },
  methods: {
    handleEmailBlur: function handleEmailBlur(evt) {
      if (evt.data === null) {
        this.wasEmailInput = false;
      } else {
        this.wasEmailInput = true;
        // eslint-disable-next-line
        this.isEmailValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(this.email).toLowerCase().trim());
      }
    },
    verifyRecaptcha: function verifyRecaptcha(response) {
      this.recaptchaVerified = !!response;
    },
    handleRecaptchaExpiry: function handleRecaptchaExpiry(response) {
      this.recaptchaVerified = false;
    },
    sendEmail: function sendEmail() {
      var _this = this;

      this.isSubmitting = true;
      this.alert = true;
      this.bottle
      // hard-coded URL, change later
      .post(this.UrlBuilder.resendEmailUrl, {
        LicensingAllocationCode: this.laCode,
        EmailId: this.email
      }).then(function (response) {
        _this.wasApiSuccessful = true;
      }).catch(function (error) {
        if (error.response.status == 400) // eslint-disable-line
          _this.wasApiSuccessful = false;
        _this.loggly.log({
          errorMessage: 'Failed to resend email',
          errorObject: error,
          errorStack: error.stack
        });
      }).finally(function () {
        _this.isApiCallComplete = true;
        _this.isSubmitting = false;
      });
    },
    clearScreen: function clearScreen() {
      this.isApiCallComplete = false;
      this.email = '';
      this.laCode = '';
      this.isSubmitting = false;
      this.wasEmailInput = false;
      this.isEmailValid = false;
      this.recaptchaVerified = this.UrlBuilder.isInternalUser || this.$route.params && this.$route.params.internal === 'true';
      this.wasApiSuccessful = false;
    },
    onSelectLocal: function onSelectLocal(evt) {
      var _this2 = this;

      locale = evt.target.value || locale;
      if (!locale.includes('en')) {
        this.$store.dispatch('fetchLocaleJson', {
          bottle: this.bottle,
          url: this.staticDirPrefix + '/static/' + locale + '.json'
        }).then(function () {
          _this2.$i18n.setLocaleMessage(locale, _this2.$store.getters.localeJson);
          _this2.$i18n.locale = locale;
        }).catch(this.handleError);
      } else {
        this.$i18n.locale = locale;
      }
    }
  }
});

/***/ }),

/***/ "1NgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_License_vue__ = __webpack_require__("Y3bG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39679c11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_License_vue__ = __webpack_require__("UHXU");
function injectStyle (ssrContext) {
  __webpack_require__("p0U2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_License_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39679c11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_License_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2fHg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"visible":_vm.modal},on:{"hide":_vm.closeModal}},[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"},[_vm._v("\n    "+_vm._s(_vm.$t('bulkActions'))+"\n  ")]),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"error-title"},[_vm._v("\n          "+_vm._s(_vm.modalTitle)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"error-description",domProps:{"innerHTML":_vm._s(_vm.modalDescription)}})])]),_vm._v(" "),_c('b-row',{staticClass:"buttons-container text-center"},[_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"10px"}},[_c('b-button',{staticClass:"cta-btn",attrs:{"variant":"primary","size":"lg","disabled":_vm.disableCta},on:{"click":_vm.handleCtaClick}},[_vm._v("\n          "+_vm._s(_vm.ctaButtonText)+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"20px"}},[_c('a',{staticClass:"primary-text",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.closeModal.apply(null, arguments)}}},[_vm._v("\n          "+_vm._s(_vm.$t('closeAndChange'))+"\n        ")])])])],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "34eJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Bke":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Datepicker__ = __webpack_require__("ZzAB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SomethingWentWrong__ = __webpack_require__("cFPt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AllocationModal__ = __webpack_require__("CeJl");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EasyAllocation',
  components: {
    'datepicker': __WEBPACK_IMPORTED_MODULE_5__Datepicker__["a" /* default */],
    'loading': __WEBPACK_IMPORTED_MODULE_6__Loading__["a" /* default */],
    'something-went-wrong': __WEBPACK_IMPORTED_MODULE_7__SomethingWentWrong__["a" /* default */],
    'allocation-modal': __WEBPACK_IMPORTED_MODULE_8__AllocationModal__["a" /* default */]
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].AppInsights.trackPageView('Easy allocate page', '/easy');
  },
  data: function data() {
    return {
      loading: false,
      hasApiCallFailed: false,
      currentPage: 1,
      orderNumber: null,
      orderDate: null,
      showOptions: false,
      sortOption: '',
      sortOptions: [{ value: 'ProductNameAsc', text: this.$t('productAsc') }, { value: 'ProductNameDesc', text: this.$t('productDesc') }],
      pageSizeOption: 25,
      pageSizeOptions: [25, 50, 75, 100],
      licenseCreationValue: null,
      areAllLicensesSelected: false,
      allLicenses: [],
      selectedLicenses: [],
      totalFilteredSortedLicenses: 0,
      hasError: false,
      pageToLoad: null,
      showPagingWarning: false,
      shouldDisableAllocate: false,
      dynamicColumnOption: 'SerialNumber',
      dynamicColumnOptions: [{ value: 'SerialNumber', text: this.$t('licenseAccessCode') }, { value: 'SAPSalesOrderNumber', text: this.$tc('orderNumber', 2) }],
      hasNoRecords: false,
      allocateModal: false,
      responseStatus: null
    };
  },

  computed: {
    licenses: function licenses() {
      var startIndex = (this.currentPage - 1) * this.pageSizeOption;
      var endIndex = this.currentPage * this.pageSizeOption;
      var licenses = this.getSortedLicenses([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.allLicenses)));
      this.totalFilteredSortedLicenses = licenses.length;
      return licenses.slice(startIndex, endIndex);
    },
    isAllocateDisabled: function isAllocateDisabled() {
      return this.selectedLicenses.length === 0 || this.hasError || this.shouldDisableAllocate;
    },
    dynamicColumnHeader: function dynamicColumnHeader() {
      var _this = this;

      return this.dynamicColumnOptions.find(function (o) {
        return o.value === _this.dynamicColumnOption;
      }).text;
    },
    hostType: function hostType() {
      return this.selectedLicenses.length > 0 ? this.$t(this.selectedLicenses[0].HostType.toLowerCase()) : '';
    },
    customHeader: function customHeader() {
      return this.$route.params.id || '';
    },
    authToken: function authToken() {
      var authToken = JSON.parse(sessionStorage.getItem('auth_token') || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({}));
      return authToken.access_token || '';
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      this.getLicenses();
    } else {
      this.$router.push('/');
    }
  },

  methods: {
    validateMultipleSelection: function validateMultipleSelection() {
      var hostType = void 0;
      if (!this.selectedLicenses.length) return;
      hostType = this.selectedLicenses[0].HostType;
      this.selectedLicenses = this.selectedLicenses.map(function (l) {
        if (l.HostType === hostType) {
          delete l.isValid;
          return l;
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, l, { isValid: false });
        }
      });
      this.hasError = this.selectedLicenses.some(function (l) {
        return l.hasOwnProperty('isValid');
      });
      this.shouldDisableAllocate = this.selectedLicenses.some(function (l) {
        return l.RemainingUserCount === 0;
      });
    },
    isLicenseInvalid: function isLicenseInvalid(license) {
      return (this.isLicenseSelected(license, true) || {}).hasOwnProperty('isValid');
    },
    handleSortChange: function handleSortChange(sort) {
      this.sortOption = sort;
      this.currentPage = 1;
      this.handleInteraction('sort');
    },
    handlePageNumberChange: function handlePageNumberChange(pageNumber) {
      this.pageSizeOption = pageNumber;
      this.currentPage = 1;
    },
    handleDateChange: function handleDateChange(_ref) {
      var fromDate = _ref.fromDate,
          toDate = _ref.toDate;

      this.fromDate = fromDate;
      this.toDate = toDate;
      if (this.fromDate && this.toDate) {
        this.currentPage = 1;
      }
    },
    toggleAllLicensesSelection: function toggleAllLicensesSelection() {
      this.selectedLicenses = this.areAllLicensesSelected ? [] : [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.licenses));
      this.validateMultipleSelection();
    },
    toggleLicenseSelection: function toggleLicenseSelection(license) {
      if (!this.selectedLicenses.length || !this.isLicenseSelected(license)) {
        this.selectedLicenses.push(license);
      } else {
        this.selectedLicenses = this.selectedLicenses.filter(function (l) {
          return l.ActivationID !== license.ActivationID;
        });
      }
      this.areAllLicensesSelected = this.selectedLicenses.length === this.licenses.length;
      this.validateMultipleSelection();
    },
    getTableRowClasses: function getTableRowClasses(item, i) {
      var classes = ['vertical-padding', 'table-row', i % 2 === 1 ? 'odd-row' : ''];
      if (this.isLicenseNew(item)) {
        classes.push('new-license-row');
      } else if (this.isLicenseExpiringLow(item)) {
        classes.push('expiring-license-row-low');
      } else if (this.isLicenseExpiringHigh(item)) {
        classes.push('expiring-license-row-high');
      } else if (this.isLicenseInvalid(item)) {
        classes.push('error-row', 'left-spacing');
      } else {
        classes.push('left-spacing');
      }
      return classes;
    },
    calculateDayDifference: function calculateDayDifference(date) {
      var expiring = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var isDateLessThanToday = void 0,
          from = void 0,
          to = void 0,
          number = void 0;
      number = expiring ? 0 : 1;
      date = new Date(date);
      date = date.setTime(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
      isDateLessThanToday = Date.now() < new Date(date).getTime();
      if (__WEBPACK_IMPORTED_MODULE_4_moment___default()().isSame(__WEBPACK_IMPORTED_MODULE_4_moment___default()(date), 'day')) {
        return 0;
      }
      if (expiring && !isDateLessThanToday) {
        return -1;
      }
      from = isDateLessThanToday ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(date) : __WEBPACK_IMPORTED_MODULE_4_moment___default()();
      to = isDateLessThanToday ? __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1, 'days') : __WEBPACK_IMPORTED_MODULE_4_moment___default()(date);
      return from.diff(to, 'days') + number;
    },
    isLicenseNew: function isLicenseNew(item) {
      var dayDifference = this.calculateDayDifference(item.StartDate);
      return dayDifference >= 0 && dayDifference <= 30;
    },
    isLicenseExpiringLow: function isLicenseExpiringLow(item) {
      var dayDifference = this.calculateDayDifference(item.ExpirationDate, true);
      return dayDifference >= 0 && dayDifference <= 29;
    },
    isLicenseExpiringHigh: function isLicenseExpiringHigh(item) {
      var dayDifference = this.calculateDayDifference(item.ExpirationDate, true);
      return dayDifference > 29 && dayDifference <= 89;
    },
    getAllocatedText: function getAllocatedText(_ref2) {
      var RemainingUserCount = _ref2.RemainingUserCount,
          UserCount = _ref2.UserCount;

      return RemainingUserCount > UserCount ? UserCount + ' of ' + UserCount : UserCount - RemainingUserCount + ' of ' + UserCount;
    },
    handleInteraction: function handleInteraction(interactionType) {
      switch (interactionType) {
        case 'exportToCSV':
          __WEBPACK_IMPORTED_MODULE_3_vue__["default"].AppInsights.trackEvent('Export to CSV', {
            eventType: 'click',
            page: 'Easy allocation'
          });
          break;
        case 'sort':
          __WEBPACK_IMPORTED_MODULE_3_vue__["default"].AppInsights.trackEvent('Sort', {
            eventType: 'change',
            sortValue: this.sortOption,
            page: 'Easy allocation'
          });
          break;
        default:
          break;
      }
    },
    getSortedLicenses: function getSortedLicenses(licenses) {
      switch (this.sortOption) {
        case 'ProductNameAsc':
          return licenses.sort(function (a, b) {
            return a.ProductName < b.ProductName ? -1 : 1;
          });
        case 'ProductNameDesc':
          return licenses.sort(function (a, b) {
            return a.ProductName > b.ProductName ? -1 : 1;
          });
        default:
          return licenses;
      }
    },
    setLicenseInfo: function setLicenseInfo() {
      var _this2 = this;

      var minStartDate = void 0;
      var maxStartDate = void 0;
      this.allLicenses.forEach(function (l, i) {
        if (i === 0) {
          minStartDate = new Date(_this2.allLicenses[0].StartDate).getTime();
          maxStartDate = new Date(_this2.allLicenses[_this2.allLicenses.length - 1].StartDate).getTime();
          _this2.orderNumber = _this2.allLicenses[0].SAPSalesOrderNumber;
          _this2.orderDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this2.allLicenses[0].StartDate).format('DD MMM YYYY');
        }
        var timestamp = new Date(l.StartDate).getTime();
        minStartDate = timestamp < minStartDate ? timestamp : minStartDate;
        maxStartDate = timestamp > maxStartDate ? timestamp : maxStartDate;
      });
      this.licenseCreationValue = [__WEBPACK_IMPORTED_MODULE_4_moment___default()(minStartDate).format('MM/DD/YYYY'), __WEBPACK_IMPORTED_MODULE_4_moment___default()(maxStartDate).format('MM/DD/YYYY')];
    },
    handleExportLinkClick: function handleExportLinkClick() {
      this.bottle.post(this.UrlBuilder.exportCsvUrl, this.requestBody).then(console.log).catch(console.error);
      this.handleInteraction('exportToCSV');
    },
    isLicenseSelected: function isLicenseSelected(license) {
      var returnItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selectedLicense = this.selectedLicenses.find(function (val) {
        return val.ActivationID === license.ActivationID;
      });
      return returnItem ? selectedLicense : !!selectedLicense;
    },
    paginate: function paginate(page) {
      this.currentPage = page;
      window.scrollTo(0, document.getElementById('page-top').offsetTop);
    },
    handlePageChange: function handlePageChange(currentPage) {
      if (this.selectedLicenses.length === 0) {
        this.paginate(currentPage);
      } else {
        this.pageToLoad = currentPage;
        this.showPagingWarning = true;
      }
    },
    handleModalClose: function handleModalClose() {
      this.showPagingWarning = false;
      this.$refs.pagination.currentPage = this.currentPage;
    },
    clearLicensesAndPaginate: function clearLicensesAndPaginate() {
      this.selectedLicenses = [];
      this.handleModalClose();
      this.paginate(this.pageToLoad);
    },
    dynamicColumnItem: function dynamicColumnItem(license) {
      switch (this.dynamicColumnOption) {
        case 'SAPSalesOrderNumber':
          if (!license.LicenseItemNumber) {
            return license.SAPSalesOrderNumber + '/' + this.getLicenseItemNumber(license);
          }
          return license.SAPSalesOrderNumber + '/' + license.LicenseItemNumber;
        case 'HostValue':
          return license.HostValue || '';
        case 'SerialNumber':
        default:
          return license.SerialNumber || '';
      }
    },
    getLicenseItemNumber: function getLicenseItemNumber(_ref3) {
      var ActivationID = _ref3.ActivationID;

      return ActivationID.match(/^.*-.*-(.*)/)[1];
    },
    closeAllocateModal: function closeAllocateModal() {
      this.allocateModal = false;
      this.selectedLicenses = [];
      this.areAllLicensesSelected = false;
    },
    getLicenses: function getLicenses() {
      var _this3 = this;

      this.loading = true;
      this.bottle.get(this.UrlBuilder.easyUrl, {
        headers: {
          'X-Easyheader': this.customHeader
        }
      }).then(function (_ref4) {
        var data = _ref4.data,
            status = _ref4.status;

        console.log('inside then');
        _this3.responseStatus = status;
        _this3.allLicenses = data.Licenses || [];
        _this3.allLicenses = _this3.allLicenses.sort(function (a, b) {
          return Number(a.LicenseItemNumber) - Number(b.LicenseItemNumber);
        });
        _this3.hasNoRecords = _this3.allLicenses.length === 0;
        _this3.$store.commit('setCustomerId', data.CustomerID);
        _this3.setLicenseInfo();
        _this3.loading = false;
      }).catch(function (error) {
        _this3.responseStatus = error.response.status;
        _this3.loading = false;
        _this3.hasApiCallFailed = true;
        _this3.loggly.log({
          errorMessage: 'Failed to fetch easy allocation licenses',
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    handleSignInClick: function handleSignInClick() {
      window.open(this.UrlBuilder.easyPageSignInUrl, '_self');
    }
  }
});

/***/ }),

/***/ "5Klg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5SxN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  active: 'Active',
  activeOnly: 'Active only',
  activateCitrixMetaframeXPLicenses: 'Activate Citrix MetaFrame XP licenses',
  activity: 'Activity',
  activityLog: 'Activity log',
  addLicense: 'Add license to my account',
  all: 'All',
  allActive: 'All active',
  allArchived: 'All hidden',
  allLicenses: 'All licenses',
  allocateAvailablelicenses: 'Allocate available licenses',
  allocateConfirmation: 'Is this correct?',
  allocateConfirmationInfo: 'Allocate <b>{remainingCount}</b> {license} to host: <b>{hostValue}</b>',
  allocateConfirmationNo: 'No, modify the allocation',
  allocateConfirmationYes: 'Yes, create license file',
  allocateConfirmationLoadingHeader: 'Generating license file.',
  allocateConfirmationLoadingInfo: 'This could take a minute or two, please be patient.',
  allocated: 'Allocated',
  allocateDownload: 'Your new license file is ready for download.',
  allocateDownloadInfo: 'Install this license file on host: <b>{hostValue}</b>.',
  allocateFailCtaButtonText: 'Download completed licenses',
  allocateFailSecondaryButtonText: 'Download list (.txt) of failed licenses',
  allocateLicense: 'Allocate license',
  allocateLicenses: 'Allocate licenses',
  allocateMoreLicenses: 'Allocate more licenses',
  allocateNow: 'Allocate now',
  allocationHelp: 'Allocation help',
  allocations: 'Allocations',
  any: 'Any',
  archive: 'Archive',
  archiveLicenses: 'Hide licenses',
  available: 'Available',
  availableAllocations: 'Available allocations',
  bulkActionCtaButtonText: 'Keep selection, stay on page',
  bulkActionErrorInfo: '<p>You can apply bulk actions only to multiple items on a single page.</p><p>If you continue to the next page, selected items are deselected.</p>',
  bulkActionErrorTitle: 'One page at a time.',
  bulkActions: 'Bulk actions',
  bulkActionSecondaryButtonText: 'Deselect all and continue to next page',
  by: 'By',
  cancel: 'Cancel',
  clearSearch: 'Clear search',
  closeAndChange: 'Close and change selection',
  closeWindow: 'Close window',
  contactCitrix: 'Customer Care contact details:\r\nEmail: support@citrix.com\r\nPhone - US: 800-000-0000',
  contactCustomerService: 'Contact Customer Service',
  continue: 'Continue',
  createLicenseFile: 'Create license file',
  date: 'Date',
  dateRange: 'Date range',
  day: '1 day | {count} days',
  deleteAllNotes: 'Delete all notes',
  didYouKnow: 'Did you know...',
  didYouKnowContent: '...XenApp and XenDesktop are now Citrix Virtual Apps and Desktops?',
  download: 'Download',
  downloadLicenseFiles: 'Download license file | Download license files ',
  dontSeeLicenses: "Don't see a new license?",
  surveyLicense: 'Tell us how we are doing?',
  easyAllocation: 'Easy allocation',
  easyAnswer1: 'To see all licenses or perform a download, return, or modification of other licenses sign in to your account.',
  easyAnswer2: "See the <a id='link' target='_blank' href='{citrixLicensingDocumentationUrl}'>Citrix Licensing documentation</a>. For more detailed information about licensing your specific Citrix products, see the product's administrator documentation at <a id='link' target='_blank' href='{docsUrl}'>https://docs.citrix.com/</a>.",
  easyQuestion1: 'How do I find licenses from a different order?',
  easyQuestion2: 'How do I learn more about Citrix Licensing?',
  email: 'Email',
  enterHostName: 'Enter host name',
  enterIpAddress: 'Enter IP address',
  enterMacAddress: 'Enter MAC address',
  ethernet: 'Ethernet',
  expirationDate: 'Expiration date',
  enterLicenseCode: 'Enter license code',
  expires: 'Expires',
  expiring: '(Expiring) | Expiring',
  expiredActivationLink: 'The activation link has expired.\n\nTo proceed with the easy allocation of your purchased licenses, please click here to Resend Email',
  expiringInfo: "Once the expiration date passes, these licenses do not work on your server nor appear in your list of licenses. If you need assistance with expired licenses, contact <a id='link' href='{customerServiceUrl}' target='_blank'>Customer Service</a>.",
  expiringLicenses: 'Expiring Licenses',
  expiringMaintenance: 'expiring maintenance',
  expiringTermLicenses: 'Expiring term licenses',
  exportList: 'Export list (.CSV)',
  exportToExcel: 'Export to Excel (.CSV)',
  failDataErrorDescription: "We are unable to complete your request online. Contact <a id='link' href='{customerServiceUrl}' target='_blank'>Citrix Customer Care</a> to resolve the issue.",
  failDataErrorTitle: 'We ran into a problem.',
  failSystemErrorDescription: "<p>We encountered an issue generating your licenses. Try again later.</p><p>If the issue persists, contact <a id='link' href='{customerServiceUrl}' target='_blank'>Citrix Customer Care</a>.",
  failSystemErrorTitle: 'There was a system error on our end.',
  filterBy: 'Filter by',
  findLicenseBy: 'Find a license by...',
  from: 'From',
  fullAllocationMessage: 'You must allocate this license in full.',
  fullModificationMessage: 'You must modify this license in full.',
  help: 'help | Help',
  hidden: 'Hidden',
  hiddenLicenseEmptyStateMessage: 'To perform any action on this license, please unhide the license.',
  hiddenOnly: 'Hidden only',
  hide: 'Hide | hide',
  hideAdvancedSearchOptions: 'Hide advanced search options',
  hideLicensesModalDescription: 'You will need to unhide these licenses to make them available for allocation in the future.',
  hideUnhideLicenses: '{typeText} licenses',
  hideUnhideLicensesModalTitle: 'Are you sure you want to {typeText} {count} {license}?',
  host: 'Host',
  hostId: 'Host ID | host ID',
  hostIdAsc: 'Host ID (A-Z)',
  hostIdDesc: 'Host ID (Z-A)',
  hostname: 'Host name',
  hostnameInfo: '<b class="danger-text">IMPORTANT</b>: Host names are caSe SenSitive',
  internet: 'Internet',
  invalidAllocateCount: 'You must allocate at least 1 license OR use the Return allocation action.',
  invalidAllocateCountNonNumeric: 'Only numbers allowed.',
  invalidAllocateCountExcessCount: 'You may only allocate up to {count} licenses.',
  invalidEmailFormat: 'Email format is invalid',
  invalidHostTypeMessage: "You've entered an invalid {hostType}.",
  invalidModifyCount: 'You must modify at least 1 license OR use the Return allocation action.',
  invalidModifyCountExcessCount: 'You may only modify up to {count} licenses.',
  invalidWebkey: 'Oops! Seems like you have entered incorrect web key. Please try again.',
  ipAddress: 'IP Address',
  itemsCount: 'showing {number} of {total}',
  last30Days: '(last 30 days)',
  learnMore: 'Learn more',
  license: 'license',
  licenseAccessCode: 'License access code',
  licenseAllocationTextPrefix: 'You have {available} of {total} {license} available for allocation.',
  licenseAllocationTextSuffix: 'Click "Allocate licenses" to begin allocating your licenses now.',
  licenseAsc: 'License (A-Z)',
  licenseCreation: 'License creation',
  licenseCode: 'License code',
  licenseDesc: 'License (Z-A)',
  licenseDetail: 'License detail',
  licenseFile: 'License file',
  licenseFullyAllocated: 'License already fully allocated.',
  licenseOrSerialNumber: 'License/serial number',
  licenses: 'Licenses | licenses',
  licensingFaqs: 'Licensing FAQs',
  licensingSurveyHeader: 'Tell us how we are doing?',
  licensingSurveyBody: 'Kindly provide your feedback on the new Licensing Tool.',
  lineItemNumber: 'Line item number',
  locateAMissingLicense: 'Associate a new license code to your account',
  loginId: 'Login ID',
  loginPrompt: 'Please enter the Login ID of the customer below and click on Continue',
  macAddress: 'MAC Address',
  manageLicenses: 'Manage licenses',
  missingLicenseHelpText: 'Some types of licenses must be allocated before they are associated to your account. Enter your license code below to allocate a license now.',
  modify: 'Modify',
  modifyAllocations: 'Modify allocations',
  modifyDownload: 'Your modified license file is ready for download.',
  modifyDownloadInfo: 'Remove existing license file from host: <b>{hostValue}</b>.',
  modifyLicenseFile: 'Modify license file',
  modifyMoreLicenses: 'Modify more licenses',
  multipleSelectionAllocateErrorTitle: 'One or more licenses are fully allocated.',
  multipleSelectionAllocateErrorDescription: '<p>You can apply allocations only to items with available allocations.</p><p>If you continue, any fully allocated licenses are ignored.</p>',
  multipleSelectionErrorModalButtonText: '{action} allocated licenses',
  multipleSelectionHostTypeError: 'To apply a bulk action, all items must match your first selection of host type={hostType}',
  futureDateLicenseError: 'You can allocate and download licenses with a future start date. They\'re unusable until the start date-{StartDate}',
  multipleSelectionOtherErrorTitle: 'One or more licenses are not allocated.',
  multipleSelectionOtherErrorDescription: '<p>You can only apply this action to items that have been allocated.</p><p>If you continue, any licenses that have not been allocated are ignored.</p>',
  name: 'Name',
  new: '(New)',
  newestFirst: 'Newest first',
  newLicenses: 'New Licenses',
  no: 'No',
  noExpiringLicensesBody: 'You have no expiring maintenance agreements that require your attention.',
  noExpiringLicensesTitle: 'No expiring maintenance',
  noLicenseActivityBody: 'You have no recent purchases or expiring maintenance agreements that require your attention.',
  noLicenseActivityTitle: 'No pending activity',
  noNewPurchasesBody: 'You have no recent purchases that require your attention.',
  noNewPurchasesTitle: 'No recent purchases',
  noRecordsFound: 'No matching records found',
  noSelectionInfoText: 'Please select at least one license from the list below.',
  notApplicable: 'Not applicable',
  notAvailable: 'Not available',
  notes: 'Notes',
  number: 'Number',
  oldestFirst: 'Oldest first',
  orderDate: 'Order date',
  orderDetails: 'Order details',
  orderNumber: 'Order number | Order Number',
  paginationPrevText: 'Prev',
  paginationNextText: 'Next',
  productAsc: 'Product (A-Z)',
  productDesc: 'Product (Z-A)',
  productName: 'Product name',
  purchased: 'Purchased',
  purchasedBy: 'Purchased by',
  purchaseDate: 'Purchase date',
  quantity: 'Quantity',
  quickFind: 'Quick find',
  recentPurchases: 'recent purchases | Recent Purchases',
  reenterCode: 'Re-enter code',
  reloadPage: 'reload this page.',
  renewLicenses: 'Renew licenses in DOTI | Renew licenses',
  renewMyLicenses: 'Renew my licenses',
  renewalHelp: 'Expiring term license help',
  resendEmail: 'To proceed with the easy allocation of your purchased licenses, please click here to ',
  resendEmailLinkText: 'Resend Email',
  resendEmailFailureMessage: 'Email Address or License Access Code you entered is incorrect. Please check the License delivery notification email for details.',
  resendEmailSuccessMessage: 'Email has been resent successfully. Please request the recipient to check their inbox.',
  resendEmailTitle: 'Resend email with Easy Allocation Link',
  resendEmailExternalMessage: 'Thank you, you will receive an email shortly. Note: If you do not receive an email, please re-verify the email address and the license access code in the license delivery notification email and try again or contact customer service for further assistance.',
  return: 'Return',
  returnAllocations: 'Return allocations',
  returnAllLicenses: 'Return all licenses',
  returnConfirmation: 'Are you sure you want to return {count} {license} from host: <b>{hostIds}</b>?',
  returnConfirmationFinalInfo: '{count} allocations have been returned and are available for reuse.',
  returnConfirmationFinalTitle: 'Remove existing license file on host: <b>{hostValue}</b>.',
  returnConfirmationInfo: 'This action cannot be undone.',
  returnConfirmationLoadingHeader: 'Returning selected license now.',
  returnNo: 'No, cancel return',
  returnYes: 'Yes, process return',
  saveNote: 'Save note',
  search: 'Search',
  selectAnAction: 'Select an action',
  show: 'Show',
  showAdvancedSearchOptions: 'Show advanced search options',
  showing: 'showing {number} of {total}',
  signInToMyAccount: 'Sign in to manage licenses',
  somethingWentWrong: 'Something went wrong on our side',
  somethingWentWrongInfo: 'Server encountered an error while processing the <b>{text}</b> request.<br />',
  sortBy: 'Sort by',
  submit: 'Submit',
  submitting: 'Submitting',
  to: 'To',
  today: 'Today',
  trialLicenses: 'Trial Licenses',
  tryAgainLater: 'Please try again later or',
  unallocatedLicenses: '{count} {license} not allocated',
  unarchive: 'Unarchive',
  undoArchive: 'Undo hide',
  undoArchiveLicenses: 'Unhide licenses',
  unhide: 'Unhide | unhide',
  unhideLicensesModalDescription: 'Your unhide action will make these licenses available for future action',
  view: 'View',
  viewAllExpiringTermLicense: 'View all expiring term licenses',
  viewAllLicenses: 'View all licenses',
  viewAllNewPurchases: 'View all new purchases',
  viewHideOptions: '{action} options',
  viewPendingHardwareReturns: 'View pending hardware returns',
  personNotFoundError: 'Invalid Username',
  referCustomerCare: 'Refer to this list when speaking to Customer Care',
  unableToAllocatePrefix: 'We were unable to complete your request for the following items:',
  unableToAllocateSuffix: 'We apologies for any inconvenience this may have caused. Our Customer Care experts will assist you to resolve the issue as quickly as possible.',
  upgradeMyLicenses: 'Upgrade my licenses',
  webkeyAllocate: 'This license code will be associated to your account after you allocate it.',
  webkeyInvalid: "The license code entered is invalid. Try re-entering the code. If the problem persists, contact <a id='link' href='{customerServiceUrl}' target='_blank'>Customer Service</a> for assistance.",
  webkeyRegistered: "The license code entered is already associated to an account. If you still do not see it listed in your account, contact <a id='link' href='{customerServiceUrl}' target='_blank'>Customer Service</a> for assistance.",
  yes: 'Yes',
  contactCustomerCareReturn: 'The ability to "Return" and "Modify" licenses is no longer available. For more information <a id="link">click here</a>',
  contactCustomerCareReturnInternal: 'Security changes have been implemented for this tool and only Customer service team were granted access. If your access has been revoked, please create a ticket by clicking here and add a note to assign this ticket to the Customer Service team.',
  otherReason: 'Other Reason',
  selectReason: 'Select a Reason',
  returnReasonOption1: 'Retire/Decommission license server',
  returnReasonOption2: 'Changed license allocation quantity',
  returnReasonOption3: 'Mistyped hostname or host ID',
  returnReasonOption4: 'Technical issues on the Citrix portal',
  returnReasonOption5: 'Server renamed or replaced',
  returnReasonOption6: 'Incorrect expiration date',
  returnReasonOption7: 'Contract allows for rehosting',
  returnReasonOptionOther: 'Other with free form text',
  returnRenameReason: "If the reason you have given is that the current hostname is incorrect or outdated for certain licenses, the new hostname provided for those licenses must not match the hostname or server to which they are currently allocated. If requesting to modify a license matching the hostname which they are currently allocated, use the redownload option. <a id='link' target='_blank' href='{warningLicenseRehostLink}'>Click here</a> for more information",
  modifyReasonOption1: 'Mistyped hostname or host ID',
  modifyReasonOption2: 'Technical issues on the Citrix portal',
  modifyReasonOption3: 'Server renamed or replaced',
  modifyReasonOption4: 'Incorrect expiration date',
  modifyReasonOption5: 'Contract allows for rehosting',
  modifyReasonOptionOther: 'Other with free form text',
  eformlegalTextCheck: "By checking this box, I undertake, on behalf of the license owner, to promptly destroy   Returned or Modified licenses  and all copies thereof. I acknowledge that licenses may only be loaded on a single license server, appliance or instance in accordance with the <a id='link' target='_blank' href='{endUserLicenseAgreement}'>Citrix End User License Agreement</a> (EULA), unless otherwise agreed between Citrix and the license owner in writing, I confirm that the information provided in this form is true and accurate and that I am authorized to submit this form and to provide these undertakings on behalf of the license owner. I understand that Citrix reserves its rights generally including under the EULA and its <a id='link' target='_blank' href='{rightToAuditCompliance}'>right to audit compliance</a>. I agree that Citrix may contact me at the email address provided in this form to confirm its accuracy and to obtain further information regarding this request.",
  rehostLegalText: "PLEASE READ CAREFULLY BEFORE DOWNLOADING THIS FILE.<br />By downloading this file, I undertake, on behalf of the license owner, to promptly destroy Modified licenses and all copies thereof. I acknowledge that licenses may only be loaded on a single license server, appliance or instance in accordance with the <a id='link' target='_blank' href='{endUserLicenseAgreement}'>Citrix End User License Agreement</a> (EULA), unless otherwise agreed between Citrix and the license owner in writing. I understand that Citrix reserves its rights generally including under the EULA and its <a id='link' target='_blank' href='{rightToAuditCompliance}'>right to audit compliance</a>.",
  addDomainsForStrongNetwork: 'Add domains for strong network',
  enterDomainName: 'Enter Domain Name',
  addDomain: 'Add Domain',
  submitDomainFailureMessage: 'Domain registration failed',
  submitDomainSuccessMessage: 'Domains registered successfully.',
  addUniconCustomer: 'Add Unicon Customer',
  enterFirstName: 'Enter first name',
  enterLastName: 'Enter last name',
  enterEmail: 'Enter Email',
  ActivateCustomer: 'Activate Customer',
  ManageLicensesUnicon: 'Manage Licenses - Unicon',
  submitUserFailureMessage: 'User registration failed',
  submitUserSuccessMessage: 'User registered successfully.',
  FirstName: 'First Name',
  LastName: 'Last Name',
  Email: 'Email'
});

/***/ }),

/***/ "65nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_typeahead__ = __webpack_require__("pmKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SurveyModal__ = __webpack_require__("F6yq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UniconCustomerModal',
  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_4__Loading__["a" /* default */],
    'typeahead': __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_typeahead__["a" /* default */],
    'survey-modal': __WEBPACK_IMPORTED_MODULE_3__SurveyModal__["a" /* default */]
  },
  props: {
    modal: { type: Boolean, required: true },
    closeModal: { type: Function, required: true },
    openModal: { type: Function, required: true },
    customHeader: { type: String, default: 'Manage Licenses - Unicon' }
  },
  data: function data() {
    return {
      FirstName: '',
      LastName: '',
      Email: '',
      editing: {},
      isSuccess: false,
      loading: false,
      isApiCallComplete: false,
      tableData: []
    };
  },
  mounted: function mounted() {
    this.getUserListForUnicon();
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].AppInsights.trackPageView('Unicon Customer page', '/uniconCustomer');
  },
  updated: function updated() {},

  computed: {
    allocateTitle: function allocateTitle() {
      return this.$t('ManageLicensesUnicon');
    },
    enterFirstName: function enterFirstName() {
      return this.$t('enterFirstName');
    },
    enterLastName: function enterLastName() {
      return this.$t('enterLastName');
    },
    enterEmail: function enterEmail() {
      return this.$t('enterEmail');
    }
  },
  methods: {
    getUserListForUnicon: function getUserListForUnicon() {
      var _this = this;

      this.bottle.get(this.UrlBuilder.getUserListForUnicon(this.$store.getters.person.customerId)).then(function (_ref) {
        var Data = _ref.data;

        _this.tableData = Data.OrganizationUsers;
      }).catch(function (error) {
        _this.loading = false;
        _this.hasApiCallFailed = true;
        _this.isApiCallDone = true;
        _this.loggly.log({
          errorMessage: 'Failed to get UserList For Unicon',
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    upsertUniconCustomer: function upsertUniconCustomer() {
      var _this2 = this;

      this.loading = true;
      var Request = {
        firstname: this.FirstName,
        lastname: this.LastName,
        email: this.Email,
        softlimitationdate: Math.floor(new Date(this.$store.getters.UniconLicDetails[0].Expiry).getTime() / 1000),
        deviceLimit: this.$store.getters.UniconLicDetails[0].Quantity,
        organizationId: this.$store.getters.person.customerId
      };

      this.bottle.post(this.UrlBuilder.updateUserListForUnicon(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Request)).then(function (_ref2) {
        var data = _ref2.data;

        if (data) {
          _this2.isSuccess = true;
          _this2.tableData = data.OrganizationUsers;
        } else {
          _this2.isSuccess = false;
        }
      }).catch(function (error) {
        _this2.loading = false;
        _this2.loggly.log({
          errorMessage: 'Failed to save user',
          errorObject: error,
          errorStack: error.stack
        });
      }).finally(function () {
        _this2.isApiCallComplete = true;
        _this2.loading = false;
      });
    },
    clearScreen: function clearScreen() {
      this.isSuccess = false;
      this.isApiCallComplete = false;
      this.FirstName = '';
      this.LastName = '';
      this.Email = '';
    },
    resetModalAndClose: function resetModalAndClose() {
      this.loading = false;
      this.closeModal();
      this.clearScreen();
      this.getUserListForUnicon();
    },
    editRow: function editRow(user) {
      this.FirstName = user.FirstName;
      this.LastName = user.LastName;
      this.Email = user.Username;
    }
  }
});

/***/ }),

/***/ "6Aj3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Email_vue__ = __webpack_require__("15ZP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2a6bdcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Email_vue__ = __webpack_require__("T/7N");
function injectStyle (ssrContext) {
  __webpack_require__("N95D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f2a6bdcc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Email_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2a6bdcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Email_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6awa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6hPw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[(!_vm.loading)?[_c('div',{staticClass:"col-12 activity-log-container"},[_c('b-row',{staticClass:"remove-default-row-margin"},[_c('div',{staticClass:"col-2"},[_c('b',[_vm._v(_vm._s(_vm.$t('date')))])]),_vm._v(" "),(_vm.isInternal)?_c('div',{staticClass:"col-2"},[_c('b',[_vm._v(_vm._s(_vm.$t('loginId')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('b',[_vm._v(_vm._s(_vm.$t('activity')))])])]),_vm._v(" "),_vm._l((_vm.activityDetails),function(activityLogItem){return [_c('b-row',{key:activityLogItem.AuditId,staticClass:"remove-default-row-margin"},[_c('div',{staticClass:"col-2"},[_vm._v(_vm._s(_vm.getReadableDate(activityLogItem.CreatedDate)))]),_vm._v(" "),(_vm.isInternal)?_c('div',{staticClass:"col-2"},[_vm._v(_vm._s(("" + (activityLogItem.UserLogin ? activityLogItem.UserLogin : ''))))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('b',[_vm._v(_vm._s(((activityLogItem.Action) + " " + (activityLogItem.Quantity || '') + ",")))]),_vm._v("\n            "+_vm._s(("" + (_vm.hostIdType ? ("Host ID type: " + _vm.hostIdType) : '')))+"\n            "+_vm._s(("" + (activityLogItem.HostID ? (", Host ID: " + (activityLogItem.HostID)) : '')))+"\n          ")])])]}),_vm._v(" "),_c('b-row',{staticClass:"remove-default-row-margin"},[_c('div',{staticClass:"col-2"},[_vm._v(_vm._s(_vm.getReadableDate(_vm.purchaseDate)))]),_vm._v(" "),(_vm.isInternal)?_c('div',{staticClass:"col-2"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-8"},[_vm._v("Purchased")])])],2)]:[_c('loading',{attrs:{"customStyle":"padding-top: 0;"}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "75l9":
/***/ (function(module, exports) {

module.exports = {"_from":"axios@^0.21.1","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"axios@^0.21.1","name":"axios","escapedName":"axios","rawSpec":"^0.21.1","saveSpec":null,"fetchSpec":"^0.21.1"},"_requiredBy":["/"],"_resolved":"https://mia-repo.citrite.net/api/npm/sts-virtual-npm/axios/-/axios-0.21.4.tgz","_shasum":"c67b90dc0568e5c1cf2b0b858c43ba28e2eda575","_spec":"axios@^0.21.1","_where":"C:\\Users\\nehapra\\Licensing\\licensing\\client","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundleDependencies":false,"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"deprecated":false,"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),

/***/ "7879":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_order_details_vue__ = __webpack_require__("OGxo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e04b74c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_order_details_vue__ = __webpack_require__("pV3e");
function injectStyle (ssrContext) {
  __webpack_require__("AQZS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_order_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e04b74c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_order_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7k9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"no-activity-container"},[_c('b-col',{attrs:{"sm":"12"}},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('p',[_vm._v(_vm._s(_vm.body))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Fkx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Zaz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReturnAllocationModal_vue__ = __webpack_require__("HNxM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69acd3ed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnAllocationModal_vue__ = __webpack_require__("RAvm");
function injectStyle (ssrContext) {
  __webpack_require__("liru")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69acd3ed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReturnAllocationModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69acd3ed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnAllocationModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8gGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.modalName),expression:"modalName"}],attrs:{"visible":_vm.modal},on:{"hide":_vm.resetModalAndClose}},[[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"}),_vm._v(" "),_c('b-alert',{attrs:{"dismissible":"","variant":_vm.isSuccess ?('success') :('danger')},on:{"dismissed":_vm.clearScreen},model:{value:(_vm.isApiCallComplete),callback:function ($$v) {_vm.isApiCallComplete=$$v},expression:"isApiCallComplete"}},[_vm._v("\n        "+_vm._s((_vm.isSuccess && _vm.isApiCallComplete) ? (_vm.$t('submitUserSuccessMessage')) : (_vm.$t('submitUserFailureMessage')))+"\n      ")])],_vm._v(" "),_c('div',{staticClass:"popup-container"},[_c('div',{staticClass:"input-section"},[[_c('h6',[_vm._v("Activate Users for Unicon")]),_vm._v(" "),_c('div',[_c('div',[_c('fieldset',{staticClass:"form-group"},[_c('legend',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('FirstName')))]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-input',{staticClass:"style-input",attrs:{"size":"md","placeholder":_vm.enterFirstName},model:{value:(_vm.FirstName),callback:function ($$v) {_vm.FirstName=$$v},expression:"FirstName"}})],1)])]),_vm._v(" "),_c('div',[_c('fieldset',{staticClass:"form-group"},[_c('legend',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('LastName')))]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-input',{staticClass:"style-input",attrs:{"size":"md","placeholder":_vm.enterLastName},model:{value:(_vm.LastName),callback:function ($$v) {_vm.LastName=$$v},expression:"LastName"}})],1)])]),_vm._v(" "),_c('div',[_c('fieldset',{staticClass:"form-group"},[_c('legend',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('Email')))]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-input',{staticClass:"style-input",attrs:{"size":"md","placeholder":_vm.enterEmail},model:{value:(_vm.Email),callback:function ($$v) {_vm.Email=$$v},expression:"Email"}})],1)])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('i',{staticClass:"fa fa-spinner loading-animation fa-3x"})]):_vm._e(),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"rdm-btn",attrs:{"variant":"primary"},on:{"click":_vm.upsertUniconCustomer}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)])]],2),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"user-list-section"},[[_c('h6',[_vm._v("Active Users")]),_vm._v(" "),_c('table',{staticClass:"rdm-table"},[_c('tbody',_vm._l((_vm.tableData),function(user,index){return _c('tr',{key:index},[_c('td',{staticStyle:{"margin-left":"5px"}},[_c('p',{staticClass:"firstNameRow"},[_vm._v(" "+_vm._s(user.FirstName)+" "+_vm._s(user.LastName))]),_vm._v(" "),_c('p',{staticClass:"emailRow"},[_vm._v(" "+_vm._s(user.Username)+" ")])]),_vm._v(" "),_c('td',{staticStyle:{"margin":"0px"}},[_c('b-button',{staticClass:"rdm-table-btn",on:{"click":function($event){return _vm.editRow(user)}}},[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"#2071c5"}})])],1)])}),0)])]],2)]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8taH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Loading',
  props: {
    customStyle: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "8vQ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NoLicenseActivity',
  props: {
    mode: {
      type: String,
      required: true
    }
  },
  computed: {
    title: function title() {
      switch (this.mode) {
        case 'newPurchases':
          return this.$t('noNewPurchasesTitle');
        case 'expiringLicenses':
          return this.$t('noExpiringLicensesTitle');
        default:
          return this.$t('noLicenseActivityTitle');
      }
    },
    body: function body() {
      switch (this.mode) {
        case 'newPurchases':
          return this.$t('noNewPurchasesBody');
        case 'expiringLicenses':
          return this.$t('noExpiringLicensesBody');
        default:
          return this.$t('noLicenseActivityBody');
      }
    }
  }
});

/***/ }),

/***/ "9G1o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("AIPa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de30794e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("/uQD");
function injectStyle (ssrContext) {
  __webpack_require__("EfgU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de30794e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9VdD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9xPZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A2DV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SomethingWentWrong',
  methods: {
    reloadPage: function reloadPage() {
      window.location.reload();
    }
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    fromEasy: {
      type: Boolean,
      default: false
    },
    responseStatus: {
      type: Number,
      default: null
    }
  }
});

/***/ }),

/***/ "ACwM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllAssets_vue__ = __webpack_require__("shoT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_626db26b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllAssets_vue__ = __webpack_require__("xASe");
function injectStyle (ssrContext) {
  __webpack_require__("HpSu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllAssets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_626db26b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllAssets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AHJT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__("IC97");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Search',
  components: {
    'datepicker': __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      dateOptions: [{ value: 'StartDate', text: this.$t('purchaseDate') }, { value: 'ExpirationDate', text: this.$t('expirationDate') }],
      licenseTypeOptions: [{ value: 'active', text: this.$t('activeOnly') }, { value: 'archived', text: this.$t('hiddenOnly') }],
      datePickerFormat: 'MM/dd/yyyy'
    };
  },

  props: {
    findLicenseByOption: {
      type: String,
      default: 'licenseOrSerialNumber'
    },
    searchInput: {
      type: String,
      default: ''
    },
    dateOption: {
      type: String,
      default: 'orderDate'
    },
    licenseTypeOption: {
      type: String,
      default: 'all'
    },
    fromDateValue: {
      type: String,
      default: ''
    },
    toDateValue: {
      type: String,
      default: ''
    },
    isAdvancedSearchVisible: {
      type: Boolean,
      required: true
    },
    isFromAllAssetsPage: {
      type: Boolean,
      default: false
    },
    isSearchEmpty: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    findLicenseByOptions: function findLicenseByOptions() {
      var options = [{ value: 'SerialNumber', text: this.$t('licenseOrSerialNumber') }, { value: 'ProductName', text: this.$t('productName') }, { value: 'SAPSalesOrderNumber', text: this.$tc('orderNumber', 1) }];
      if (!this.isFromAllAssetsPage) {
        options.push({ value: 'HostValue', text: this.$tc('hostId', 1) });
      }
      return options;
    },
    advancedOptionsLinkText: function advancedOptionsLinkText() {
      return this.$t(!this.isAdvancedSearchVisible ? 'showAdvancedSearchOptions' : 'hideAdvancedSearchOptions');
    },
    isSearchDisabled: function isSearchDisabled() {
      if (!(this.searchInput.length < 3)) {
        if (this.fromDateValue && !this.toDateValue) return true;else return false;
      }
      return !this.fromDateValue || !this.toDateValue;
    },
    disabledDatesFrom: function disabledDatesFrom() {
      if (this.toDateValue !== '') {
        var date = new Date(this.toDateValue);
        date = date.setDate(date.getDate());
        return { from: new Date(date) };
      }
    },
    disabledDatesTo: function disabledDatesTo() {
      if (this.fromDateValue !== '') {
        var date = new Date(this.fromDateValue);
        date = date.setDate(date.getDate() + 1);
        return { to: new Date(date) };
      }
    },
    shouldShowClearSearch: function shouldShowClearSearch() {
      if (!this.isFromAllAssetsPage) return false;else if (this.isSearchEmpty) return false;
      return true;
    },
    setDateFormat: function setDateFormat() {
      var locale = this.$store.getters.person.preferences.locale || 'en-US';
      var formats = {
        'zh-CN': 'yyyy/MM/dd',
        'zh-TW': 'yyyy/MM/dd',
        'jp-JP': 'yyyy/MM/dd',
        'ko-KR': 'yyyy/MM/dd',
        'es-CO': 'dd/MM/yyyy',
        'pt-BR': 'dd/MM/yyyy',
        'fr-FR': 'dd/MM/yyyy',
        'de-DE': 'dd/MM/yyyy',
        'en-US': 'MM/dd/yyyy'
      };
      locale = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(formats).includes(locale) ? locale : 'en-US';
      return formats[locale];
    }
  },
  methods: {
    handleAdvancedSearchButtonClick: function handleAdvancedSearchButtonClick() {
      this.$emit('advancedSearchButtonClick', !this.isAdvancedSearchVisible);
    },
    handleSearchInput: function handleSearchInput($event) {
      this.$emit('searchInputChange', $event);
    },
    handleKeypress: function handleKeypress(_ref) {
      var key = _ref.key;

      if (key === 'Enter') {
        this.$emit('onSearchClick');
      }
    }
  }
});

/***/ }),

/***/ "AIPa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__license_checker_header__ = __webpack_require__("lu1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__license_checker_body__ = __webpack_require__("Uggu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__license_checker_modal__ = __webpack_require__("ajn2");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseChecker',
  components: { LicenseCheckerHeader: __WEBPACK_IMPORTED_MODULE_4__license_checker_header__["a" /* default */], LicenseCheckerBody: __WEBPACK_IMPORTED_MODULE_5__license_checker_body__["a" /* default */], LicenseCheckerModal: __WEBPACK_IMPORTED_MODULE_6__license_checker_modal__["a" /* default */] },
  data: function data() {
    return {
      isLoading: false,
      response: { AssetDetails: [] }, // to avoid reference error.
      selectedId: '',
      sortedIndicesMap: {},
      uniqueIndicesMap: {},
      isFixing: false,
      searchInput: '',
      modalData: [],
      isApiComplete: false,
      modifyAPIUserName: 'la-007'
    };
  },
  mounted: function mounted() {
    if (this.$store.getters.authToken !== null && this.$store.getters.authToken !== undefined) {
      this.modifyAPIUserName = this.$store.getters.authToken.userName === null || this.$store.getters.authToken.userName === undefined ? 'la-007' : this.$store.getters.authToken.userName;
    }
  },

  computed: {
    asideList: function asideList() {
      return this.response.AssetDetails.reduce(function (acc, cur, i) {
        if (!i || !acc.find(function (i) {
          return i.assetId === cur.AssetId;
        })) {
          acc.push({
            assetId: cur.AssetId,
            faulty: false,
            children: [{
              orderId: cur.OrderId,
              faultyChildren: cur.LineItemsToModify && !!cur.LineItemsToModify.length
            }]
          });
        } else {
          acc.find(function (i) {
            return i.assetId === cur.AssetId;
          }).children.push({
            orderId: cur.OrderId,
            faultyChildren: cur.LineItemsToModify && !!cur.LineItemsToModify.length
          });
        }
        return acc;
      }, []);
    },
    tableData: function tableData() {
      var item = this.getSelectedItem();
      if (!item) return undefined;
      return {
        lineItems: item.LineItems,
        assetComponentList: item.AssetComponentList
      };
    },
    lineItemsToModify: function lineItemsToModify() {
      var item = this.getSelectedItem();
      if (!item) return undefined;
      if (!item.LineItemsToModify || !item.LineItemsToModify.length) return {};
      return item.LineItemsToModify.reduce(function (acc, cur) {
        if (!acc[cur.ACTIVATION_ID]) {
          acc[cur.ACTIVATION_ID] = cur;
        }
        return acc;
      }, {});
    },
    grid: function grid() {
      var item = this.getSelectedItem();
      var sortedArray = void 0;
      if (!item) return undefined;
      sortedArray = item.LineItems.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(a.CREATED_ON).diff(__WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(b.CREATED_ON));
      }).map(function (i) {
        return i.ACTIVATION_ID;
      });
      item.RenewalChainDetails = item.RenewalChainDetails || [];
      if (sortedArray && item.RenewalChainDetails && sortedArray.length !== item.RenewalChainDetails.length) return undefined;
      return sortedArray.map(function (id, i) {
        return [id].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(item.RenewalChainDetails[i]));
      });
    },
    existingDetails: function existingDetails() {
      return this.response.ExistingDetails;
    },
    orderDetails: function orderDetails() {
      var ExistingDetails = this.response.ExistingDetails;

      if (!ExistingDetails) return [];
      if (!ExistingDetails.OrderDetails) return [];
      return this.response.ExistingDetails.OrderDetails;
    },
    initialOrderDetails: function initialOrderDetails() {
      var ExistingDetails = this.response.ExistingDetails;

      if (!ExistingDetails) return [];
      if (!ExistingDetails.InitialOrderDetails) return [];
      return this.response.ExistingDetails.InitialOrderDetails;
    },
    renewalOrderDetails: function renewalOrderDetails() {
      var ExistingDetails = this.response.ExistingDetails;

      if (!ExistingDetails) return [];
      if (!ExistingDetails.RenewalOrderDetails) return [];
      return this.response.ExistingDetails.RenewalOrderDetails;
    }
  },
  methods: {
    getSelectedItem: function getSelectedItem() {
      var selectedId = this.selectedId,
          response = this.response;

      var _selectedId$split = selectedId.split('|'),
          _selectedId$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_selectedId$split, 2),
          assetId = _selectedId$split2[0],
          orderId = _selectedId$split2[1];

      if (selectedId === '') {
        return undefined;
      }
      return response.AssetDetails.find(function (a) {
        return a.AssetId === assetId && a.OrderId === orderId;
      });
    },
    handleSearch: function handleSearch(searchInput) {
      var _this = this;

      var fromSecondCall = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      searchInput = searchInput.trim();
      this.searchInput = searchInput;
      if (this.isSerialNumbervalid(searchInput)) {
        this.isLoading = true;
        if (!fromSecondCall) this.selectedId = '';
        this.bottle.get(this.UrlBuilder.getLa007SearchUrl(searchInput)).then(function (_ref) {
          var data = _ref.data;

          _this.response = data;
          _this.isApiComplete = true;
        }).catch(console.error).finally(function () {
          _this.isLoading = false;
        });
      }
    },
    setSelectedId: function setSelectedId(assetId, orderId) {
      this.selectedId = assetId + '|' + orderId;
    },
    isSerialNumbervalid: function isSerialNumbervalid(serialNumber) {
      return (/^([0-9a-zA-Z]*-){2,}([0-9a-zA-Z]*)$/ig.test(serialNumber)
      );
    },
    fixIssues: function fixIssues() {
      var _this2 = this;

      var _selectedId$split3 = this.selectedId.split('|'),
          _selectedId$split4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_selectedId$split3, 2),
          assetId = _selectedId$split4[0],
          orderId = _selectedId$split4[1];

      var licenseDetailsToModify = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()((this.response.AssetDetails.find(function (item) {
        return item.AssetId === assetId && item.OrderId === orderId;
      }) || { LineItemsToModify: [] }).LineItemsToModify));
      var existingDetails = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.existingDetails);
      this.isFixing = true;
      this.bottle.post(this.UrlBuilder.la007ModifyUrl, { licenseDetailsToModify: licenseDetailsToModify, existingDetails: existingDetails, loggedInUserName: this.modifyAPIUserName }).then(function (_ref2) {
        var data = _ref2.data;

        _this2.modalData = data.AItemDetails;
        _this2.$nextTick(function () {
          _this2.$refs.issuesFixed.showModal();
        });
        _this2.handleSearch(_this2.searchInput, true);
      }).catch(console.error).finally(function () {
        _this2.isFixing = false;
      });
    }
  }
});

/***/ }),

/***/ "AQZS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AXNf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_typeahead__ = __webpack_require__("pmKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SurveyModal__ = __webpack_require__("F6yq");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ModifyAllocationModal',
  components: {
    typeahead: __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_typeahead__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_6__Loading__["a" /* default */],
    'survey-modal': __WEBPACK_IMPORTED_MODULE_7__SurveyModal__["a" /* default */]
  },
  props: {
    modal: { type: Boolean, required: true },
    toggleModal: { type: Function, required: true },
    selectedLicenses: { type: Array, required: true },
    allowPartial: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      isInternal: window.location.host.includes('citrite.net'),
      currentStep: 1,
      count: 0,
      totalCount: 0,
      hostValue: '',
      dropdownData: [],
      isHostValueInvalid: false,
      isModifyCountInvalid: false,
      wasDataUpdated: false,
      errorType: '',
      isDownloading: false,
      modalName: 'survey-license-modal',
      showModal: false,
      showOtherInput: false,
      showRenameText: false,
      consent: false,
      otherReason: '',
      reasonOption: '',
      reasonOptions: [{ value: this.$t('modifyReasonOption1'), text: this.$t('modifyReasonOption1') }, { value: this.$t('modifyReasonOption2'), text: this.$t('modifyReasonOption2') }, { value: this.$t('modifyReasonOption3'), text: this.$t('modifyReasonOption3') }, { value: this.$t('modifyReasonOption4'), text: this.$t('modifyReasonOption4') }, { value: this.$t('modifyReasonOption5'), text: this.$t('modifyReasonOption5') }, { value: this.$t('modifyReasonOptionOther'), text: this.$t('modifyReasonOptionOther') }]
    };
  },
  updated: function updated() {
    if (this.isHostTypeAny) {
      this.hostValue = 'Any';
      if (this.$refs.typeahead) {
        this.$refs.typeahead.inputValue = 'Any';
      }
    }
    if (this.modal && !this.wasDataUpdated) {
      var count = this.selectedLicenses[0].Fulfillments.reduce(function (a, c) {
        return a + +c.fulfilledQuantity;
      }, 0);
      this.count = this.totalCount = count;
      this.wasDataUpdated = true;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['showSurveyModal']), {
    hostType: function hostType() {
      if (this.selectedLicenses.length > 0) {
        return this.selectedLicenses[0].HostType;
      }
      return '';
    },
    getHostValues: function getHostValues() {
      var hostValues = [];
      this.selectedLicenses[0].Fulfillments.forEach(function (f) {
        if (!hostValues.includes(f.hostIDValue)) {
          hostValues.push(f.hostIDValue);
        }
      });
      return hostValues.join(', ');
    },
    readableHostType: function readableHostType() {
      switch (this.hostType) {
        case 'Ethernet':
          return this.$t('macAddress');
        case 'Internet':
          return this.$t('ipAddress');
        case 'HostName':
          return this.$t('hostname');
      }
    },
    isHostTypeAny: function isHostTypeAny() {
      return this.hostType.toLowerCase() === 'any';
    },
    isHostTypeHostname: function isHostTypeHostname() {
      return this.hostType.toLowerCase() === 'hostname';
    },
    hostValuePlaceholder: function hostValuePlaceholder() {
      switch (this.hostType) {
        case 'Ethernet':
          return this.$t('enterMacAddress');
        case 'Internet':
          return this.$t('enterIpAddress');
        case 'HostName':
          return this.$t('enterHostName');
        case 'Any':
          return this.$t('any');
        default:
          return '';
      }
    },
    isHostValueValid: function isHostValueValid() {
      var regEx = void 0;
      var isValid = false;
      switch (this.hostType) {
        case 'Ethernet':
          regEx = /^[0-9a-fA-F]{12}$/;
          break;
        case 'Internet':
          regEx = /\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/;
          break;
        case 'HostName':
          regEx = /^[^~{}[\]<>\s]+$/; // exclude characters ~{}[]<>
          break;
        case 'Any':
          // match ethernet or internet or any
          regEx = /(^[0-9a-fA-F]{12}$|\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b|^\S*$)/;
          break;
        default:
          return false;
      }
      isValid = regEx.test(this.hostValue);
      if (isValid) {
        return !this.$store.getters.hasXssKeyWord(this.hostValue);
      }
      return false;
    },
    isStepOneCtaButtonDisabled: function isStepOneCtaButtonDisabled() {
      return this.hostValue === '' || !this.isHostValueValid || this.count > this.totalCount || this.isModifyCountInvalid;
    },
    customerId: function customerId() {
      return this.$store.getters.person.customerId;
    },
    loggedInUserName: function loggedInUserName() {
      return this.$store.getters.authToken.userName || '';
    },
    loggedInUserPersonID: function loggedInUserPersonID() {
      return this.$store.getters.authToken.personId || '';
    },
    modifyTitle: function modifyTitle() {
      switch (this.errorType) {
        case 'data':
          return this.$t('failDataErrorTitle');
        case 'system':
          return this.$t('failSystemErrorTitle');
        default:
          return this.$t('modifyAllocations');
      }
    },
    errorDescription: function errorDescription() {
      switch (this.errorType) {
        case 'data':
          return this.$t('failDataErrorDescription', {
            customerServiceUrl: this.UrlBuilder.customerServiceUrl
          });
        case 'system':
          return this.$t('failSystemErrorDescription', {
            customerServiceUrl: this.UrlBuilder.customerServiceUrl
          });
        default:
          return '';
      }
    },
    failedDownloadText: function failedDownloadText() {
      return this.$t('referCustomerCare') + '\r\n\r\n' + (this.$t('unableToAllocatePrefix') + '\r\n\r\n') + (this.failedModifications.join('\r\n') + '\r\n\r\n') + (this.$t('unableToAllocateSuffix') + '\r\n\r\n') + ('' + this.$t('contactCitrix'));
    },
    hasMultipleItems: function hasMultipleItems() {
      return this.selectedLicenses[0].Fulfillments.length > 1 || !this.allowPartial;
    },
    topMarginClass: function topMarginClass() {
      return this.isHostTypeHostname ? 'message top-margin' : '';
    },
    allocateConfirmationInfo: function allocateConfirmationInfo() {
      return this.$t('allocateConfirmationInfo', {
        remainingCount: this.count,
        hostValue: this.hostValue,
        license: this.count === 1 ? this.$t('license') : this.$tc('licenses', 2)
      });
    },
    invalidModifyCount: function invalidModifyCount() {
      if (isNaN(Number(this.count))) {
        return this.$t('invalidAllocateCountNonNumeric');
      } else if (Number(this.count) > Number(this.totalCount)) {
        return this.$t('invalidModifyCountExcessCount', { count: this.totalCount });
      }
      return this.$t('invalidModifyCount');
    },
    downloadRequestBody: function downloadRequestBody() {
      var _this = this;

      return this.succeededModifications.map(function (l) {
        return {
          activationID: l.ActivationID,
          customerId: _this.customerId,
          hostId: [_this.hostType === 'Ethernet' ? 'Ethernet=' + _this.hostValue : _this.hostValue],
          hostType: _this.hostType,
          loggedInUserName: _this.loggedInUserName,
          loggedInUserPersonID: _this.$store.getters.person.id,
          action: 'Reallocate Download',
          licenseLineItemNumber: l.LicenseItemNumber,
          productName: l.ProductName,
          assetID: l.AssetID
        };
      });
    }
  }),
  methods: {
    onReasonSelect: function onReasonSelect() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.showOtherInput = _this2.reasonOption === _this2.$t('modifyReasonOptionOther');
        _this2.showRenameText = _this2.reasonOption === _this2.$t('modifyReasonOption1') || _this2.reasonOption === _this2.$t('modifyReasonOption3');
      });
    },
    handleModifyCountBlur: function handleModifyCountBlur() {
      var count = Number(this.count);
      this.isModifyCountInvalid = count === 0 || isNaN(count) || count > Number(this.totalCount);
    },
    handleHostValueChange: function handleHostValueChange(hostValue) {
      this.isHostValueInvalid = !this.isHostValueValid;
      this.$refs.typeahead.inputValue = hostValue.slice(0, 1000);
    },
    createLicenseFiles: function createLicenseFiles() {
      var _this3 = this;

      this.currentStep = 3;
      if (this.totalCount >= this.count) {
        this.bottle.post(this.UrlBuilder.modifyUrl, this.selectedLicenses[0].Fulfillments.map(function (l) {
          return {
            customerID: _this3.customerId,
            activationID: _this3.selectedLicenses[0].ActivationID,
            hostID: encodeURIComponent(_this3.hostValue),
            hostType: _this3.hostType,
            quantity: _this3.hasMultipleItems ? +l.fulfilledQuantity : _this3.count,
            loggedInUserName: _this3.loggedInUserName,
            loggedInUserPersonID: _this3.$store.getters.person.id,
            action: 'ReAllocate',
            assetID: _this3.selectedLicenses[0].AssetID,
            licenseLineItemNumber: _this3.selectedLicenses[0].LicenseItemNumber,
            productName: _this3.selectedLicenses[0].ProductName,
            fulfillmentID: l.fulfillmentID,
            serialNumber: _this3.selectedLicenses[0].SerialNumber,
            actionReason: _this3.otherReason ? _this3.otherReason : _this3.reasonOption,
            consentBy: _this3.consent ? _this3.$store.getters.person.username : ''
          };
        })).then(function (_ref) {
          var data = _ref.data;

          _this3.totalCount = _this3.totalCount - _this3.count;
          _this3.count = _this3.totalCount;
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].AppInsights.trackEvent('Modify action', {
            customerId: _this3.customerId,
            data: data.map(function (d) {
              return {
                hostType: d.hostIDType,
                hostId: d.hostIDValue,
                quantity: d.fulfilledQuantity,
                status: d.status,
                activationID: d.activationID
              };
            })
          });
          if (data.some(function (d) {
            return d.status === 'FAILURE';
          })) {
            var failedModifications = data.filter(function (d) {
              return d.status === 'FAILURE';
            }).map(function (d) {
              return d.activationID;
            });
            _this3.selectedLicenses.forEach(function (l) {
              var arr = void 0;
              if (failedModifications.includes(l.ActivationID)) {
                arr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this3.failedModifications));
                arr.push(l);
                _this3.failedModifications = arr.map(function (l) {
                  return l.ActivationID;
                });
              }
            });
            _this3.currentStep = 5;
            _this3.errorType = 'data';
          } else {
            _this3.currentStep = 4;
            _this3.succeededModifications = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this3.selectedLicenses));
          }
        }).catch(function (error) {
          _this3.currentStep = 5;
          _this3.errorType = 'system';
          _this3.loggly.log({
            errorMessage: 'Failed to modify licenses',
            errorObject: error,
            errorStack: error.stack
          });
        });
      }
    },
    downloadLicenseFiles: function downloadLicenseFiles() {
      var _this4 = this;

      this.isDownloading = true;
      this.bottle.post(this.UrlBuilder.getDownloadUrl(), this.downloadRequestBody, {
        responseType: 'arraybuffer'
      }).then(function (_ref2) {
        var data = _ref2.data,
            headers = _ref2.headers;

        var fileName = _this4.getDownloadFilename(headers['content-disposition']);
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].AppInsights.trackEvent('Download action', _this4.downloadRequestBody);
        _this4.isDownloading = false;
        switch (headers['content-type']) {
          case 'application/zip':
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([data], { type: 'application/zip' }));
            link.download = fileName;
            link.click();
            break;
          case 'text/html':
            __WEBPACK_IMPORTED_MODULE_5_downloadjs___default()(data, fileName, 'text/html');
        }
      }).catch(function (error) {
        _this4.isDownloading = false;
        _this4.loggly.log({
          errorMessage: 'License download failed',
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    closeModal: function closeModal() {
      // reset values before closing modal
      this.showModal = true;
      this.currentStep = 1;
      this.count = 0;
      this.totalCount = 0;
      this.hostValue = '';
      this.dropdownData = [];
      this.isHostValueInvalid = false;
      this.isModifyCountInvalid = false;
      this.wasDataUpdated = false;
      this.errorType = '';
      this.isDownloading = false;
      this.otherReason = '';
      this.showOtherInput = false;
      this.showRenameText = false;
      this.consent = false;
      this.reasonOption = '';
      this.toggleModal();
      this.clearTypeahead();
    },
    getDownloadFilename: function getDownloadFilename(string) {
      return string.split('; ')[1].split('=')[1];
    },
    downloadFailedTextFile: function downloadFailedTextFile() {
      __WEBPACK_IMPORTED_MODULE_5_downloadjs___default()(this.failedDownloadText, 'failed-licenses.txt', 'text/html');
    },
    clearTypeahead: function clearTypeahead() {
      if (this.$refs.typeahead) {
        this.$refs.typeahead.inputValue = '';
      }
    },
    goToStepOne: function goToStepOne() {
      var _this5 = this;

      this.currentStep = 1;
      this.$nextTick(function () {
        if (_this5.$refs.typeahead) {
          _this5.$refs.typeahead.value = _this5.hostValue;
          _this5.$refs.typeahead.inputValue = _this5.hostValue;
        }
      });
    }
  }
});

/***/ }),

/***/ "C/bm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CeJl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllocationModal_vue__ = __webpack_require__("uqRl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_194badcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllocationModal_vue__ = __webpack_require__("DUUI");
function injectStyle (ssrContext) {
  __webpack_require__("5Klg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-194badcc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllocationModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_194badcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllocationModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cgqp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D+ix":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_check_cross_vue__ = __webpack_require__("HUKa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42361dd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_check_cross_vue__ = __webpack_require__("e2L8");
function injectStyle (ssrContext) {
  __webpack_require__("Wyfo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42361dd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_check_cross_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42361dd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_check_cross_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D1ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadList_vue__ = __webpack_require__("FYpH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill__ = __webpack_require__("z+gd");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypehead',

  components: {
    VueBootstrapTypeaheadList: __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadList_vue__["a" /* default */]
  },

  props: {
    size: {
      type: String,
      default: null,
      validator: function validator(size) {
        return ['lg', 'sm'].indexOf(size) > -1;
      }
    },
    value: {
      type: String
    },
    data: {
      type: Array,
      required: true,
      validator: function validator(d) {
        return d instanceof Array;
      }
    },
    serializer: {
      type: Function,
      default: function _default(d) {
        return d;
      },
      validator: function validator(d) {
        return d instanceof Function;
      }
    },
    backgroundVariant: String,
    textVariant: String,
    inputClass: {
      type: String,
      default: ''
    },
    maxMatches: {
      type: Number,
      default: 10
    },
    minMatchingChars: {
      type: Number,
      default: 2
    },
    placeholder: String,
    prepend: String,
    append: String
  },

  computed: {
    sizeClasses: function sizeClasses() {
      return this.size ? 'input-group input-group-' + this.size : 'input-group';
    },
    formattedData: function formattedData() {
      var _this = this;

      if (!(this.data instanceof Array)) {
        return [];
      }
      return this.data.map(function (d, i) {
        return {
          id: i,
          data: d,
          text: _this.serializer(d)
        };
      });
    }
  },

  methods: {
    resizeList: function resizeList(el) {
      var rect = el.getBoundingClientRect();
      var listStyle = this.$refs.list.$el.style;

      // Set the width of the list on resize
      listStyle.width = rect.width + 'px';

      // Set the margin when the prepend prop or slot is populated
      // (setting the "left" CSS property doesn't work)
      if (this.$refs.prependDiv) {
        var prependRect = this.$refs.prependDiv.getBoundingClientRect();
        listStyle.marginLeft = prependRect.width + 'px';
      }
    },
    handleHit: function handleHit(evt) {
      if (typeof this.value !== 'undefined') {
        this.$emit('input', evt.text);
      }

      this.inputValue = evt.text;
      this.$emit('hit', evt.data);
      this.$refs.input.blur();
      this.isFocused = false;
    },
    handleBlur: function handleBlur(evt) {
      var tgt = evt.relatedTarget;
      if (tgt && tgt.classList.contains('vbst-item')) {
        return;
      }
      this.isFocused = false;
    },
    handleInput: function handleInput(newValue) {
      this.inputValue = newValue;

      // If v-model is being used, emit an input event
      if (typeof this.value !== 'undefined') {
        this.$emit('input', newValue);
      }
    }
  },

  data: function data() {
    return {
      isFocused: false,
      inputValue: ''
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$_ro = new __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill__["a" /* default */](function (e) {
      _this2.resizeList(_this2.$refs.input);
    });
    this.$_ro.observe(this.$refs.input);
    this.$_ro.observe(this.$refs.list.$el);
  },
  beforeDestroy: function beforeDestroy() {
    this.$_ro.disconnect();
  }
});

/***/ }),

/***/ "DOMq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'WebKeyAllocation',
  data: function data() {
    return {
      hostValue: '',
      isWebkeyInvalid: false,
      isApiCallComplete: false,
      shouldProceedToAllocate: false,
      licenses: [],
      isLoading: false,
      screen: 0,
      hostValueUpdated: false
    };
  },

  props: {
    modal: { type: Boolean, required: true },
    closeModal: { type: Function, required: true },
    webkeyModalCallback: { type: Function, required: true },
    allocateFlowCallback: { type: Function, required: true },
    webkey: { type: String, default: '' }
  },
  updated: function updated() {
    if (!this.hostValueUpdated) {
      this.hostValue = this.webkey;
      this.hostValueUpdated = true;
    }
  },

  computed: {
    isCtaButtonDisabled: function isCtaButtonDisabled() {
      return this.hostValue === '' || this.isHostValueInvalid;
    },
    isHostValueInvalid: function isHostValueInvalid() {
      return !/^([0-9a-zA-Z]*-){2,}([0-9a-zA-Z]*)$/ig.test(this.hostValue);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(['IS_ALLOW_PARTIAL_FOR_WEB_KEY']), {
    getWebkeyLicenses: function getWebkeyLicenses() {
      var _this = this;

      this.isLoading = true;
      this.bottle.get(this.UrlBuilder.getWebkeyUrl(this.hostValue, this.$store.getters.person.customerId)).then(function (_ref) {
        var data = _ref.data;
        var _data$Licenses = data.Licenses,
            Licenses = _data$Licenses === undefined ? [] : _data$Licenses,
            WebKeyStatus = data.WebKeyStatus,
            TotalCount = data.TotalCount,
            MinDate = data.MinDate,
            MaxDate = data.MaxDate,
            IsPartialForWebKey = data.IsPartialForWebKey;

        _this.isLoading = false;
        _this.isApiCallComplete = true;
        _this.IS_ALLOW_PARTIAL_FOR_WEB_KEY(IsPartialForWebKey);
        if (WebKeyStatus === 'NewWebKey') {
          _this.screen = 1;
          _this.licenses = Licenses;
        } else if (WebKeyStatus === 'WebKeyRegistered') {
          _this.screen = 2;
        } else if (WebKeyStatus === 'InvalidKey') {
          _this.screen = 3;
        } else if (WebKeyStatus === null) {
          _this.webkeyModalCallback(null, Licenses, TotalCount, MinDate, MaxDate);
        }
      }).catch(function (error) {
        _this.isLoading = false;
        _this.loggly.log({
          errorMessage: 'Failed to fetch webkey licenses',
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    resetModal: function resetModal() {
      this.hostValue = '';
      this.isWebkeyInvalid = false;
      this.isApiCallComplete = false;
      this.shouldProceedToAllocate = false;
      this.licenses = [];
      this.isLoading = false;
      this.screen = 0;
    },
    resetAndCloseModal: function resetAndCloseModal() {
      this.resetModal();
      this.closeModal();
    },
    proceedToAllocate: function proceedToAllocate() {
      this.allocateFlowCallback(this.licenses);
    }
  })
});

/***/ }),

/***/ "DUUI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showSurveyModalProp)?[_c('survey-modal',{attrs:{"show-modal":((_vm.showSurveyModal && (!_vm.isSurveyModalInteracted)) || (_vm.showSurveyModalXS && !_vm.isSurveyModalInteractedXS)) && (_vm.selectedLicenses.length !== 0),"productName":_vm.selectedLicenses,"close-action":_vm.closeSurveyModal}})]:_vm._e(),_vm._v(" "),_c('b-modal',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.modalName),expression:"modalName"}],attrs:{"visible":_vm.modal},on:{"hide":_vm.resetModalAndClose}},[(_vm.errorType === '')?[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"},[_vm._v("\n      "+_vm._s(_vm.allocateTitle)+"\n      "),(_vm.isFull && _vm.currentStep === 1)?_c('div',{staticClass:"full-allocation-message"},[_vm._v("\n        "+_vm._s(_vm.$t('fullAllocationMessage'))+"\n      ")]):_vm._e()])]:[_c('div',{staticClass:"danger-text",attrs:{"slot":"modal-title"},slot:"modal-title"},[_vm._v("\n      "+_vm._s(_vm.allocateTitle)+"\n    ")])],_vm._v(" "),(_vm.currentStep === 1)?_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"inputs-row"},[_c('div',{staticClass:"col-4"},[_c('b-input',{staticClass:"modal-input",attrs:{"state":_vm.remainingCountState,"disabled":_vm.isFull,"tabindex":"1"},nativeOn:{"input":function($event){return _vm.handleAllocateCountBlur.apply(null, arguments)}},model:{value:(_vm.remainingCount),callback:function ($$v) {_vm.remainingCount=$$v},expression:"remainingCount"}}),_vm._v(" of "+_vm._s(_vm.totalRemainingCount)+"\n      ")],1),_vm._v(" "),_c('div',{staticClass:"col-8"},[(_vm.isFromEasyPage)?[_c('fieldset',{class:_vm.isHostValueInvalid ? ' error-border' : ''},[_c('legend',{staticStyle:{"z-index":"5"}},[_vm._v(_vm._s(_vm.$t('host')))]),_vm._v(" "),_c('b-input',{staticClass:"modal-input right",attrs:{"placeholder":_vm.hostValuePlaceholder,"disabled":_vm.isHostTypeAny,"tabindex":"2"},nativeOn:{"input":function($event){return _vm.validateHostValue.apply(null, arguments)}},model:{value:(_vm.hostValue),callback:function ($$v) {_vm.hostValue=$$v},expression:"hostValue"}}),_vm._v(" "),(_vm.isHostTypeHostname)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('hostnameInfo'))}}):_vm._e()],1)]:[_c('fieldset',{class:_vm.isHostTypeAny ? 'typeahead-fieldset' : ''},[_c('legend',{staticStyle:{"z-index":"5"}},[_vm._v(_vm._s(_vm.$t('host')))]),_vm._v(" "),_c('typeahead',{ref:"typeahead",staticClass:"modal-input right dropdown",attrs:{"placeholder":_vm.hostValuePlaceholder,"data":_vm.dropdownData},on:{"input":_vm.handleHostValueChange},model:{value:(_vm.hostValue),callback:function ($$v) {_vm.hostValue=$$v},expression:"hostValue"}}),_vm._v(" "),(_vm.isHostTypeHostname)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('hostnameInfo'))}}):_vm._e(),_vm._v(" "),(_vm.isHostTypeAny)?_c('div',{staticClass:"disable-typeahead"}):_vm._e()],1)]],2)]),_vm._v(" "),_c('b-row',[(_vm.isAllocateCountInvalid)?_c('div',{staticClass:"col-12"},[_c('p',{class:("invalid-host-value-text " + _vm.topMarginClass)},[_vm._v("\n          "+_vm._s(_vm.invalidAllocateCount)+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.isHostValueInvalid)?_c('div',{staticClass:"col-12"},[_c('p',{class:("invalid-host-value-text " + _vm.topMarginClass)},[_vm._v("\n          "+_vm._s(_vm.$t('invalidHostTypeMessage', { hostType: _vm.readableHostType }))+"\n        ")])]):_vm._e()]),_vm._v(" "),_c('b-row',{staticClass:"buttons-container text-center"},[_c('div',{staticClass:"col-12"},[_c('b-button',{staticClass:"cta-btn",attrs:{"variant":"primary","size":"lg","disabled":_vm.isStepOneCtaButtonDisabled,"tabindex":_vm.isHostTypeAny ? 2 : 3},on:{"click":function($event){_vm.currentStep = 2}}},[_vm._v("\n          "+_vm._s(_vm.$t('createLicenseFile'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.modalName),expression:"modalName"}],staticClass:"danger-text",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.resetModalAndClose.apply(null, arguments)}}},[_vm._v("\n          "+_vm._s(_vm.$t('cancel'))+"\n        ")])])])],1):(_vm.currentStep === 2)?_c('b-container',{staticClass:"step text-center",attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v(_vm._s(_vm.$t('allocateConfirmation')))]),_vm._v(" "),_c('h6',{domProps:{"innerHTML":_vm._s(_vm.allocateConfirmationInfo)}})])]),_vm._v(" "),_c('b-row',{staticClass:"buttons-container"},[_c('div',{staticClass:"col-12"},[_c('b-button',{staticClass:"cta-btn",attrs:{"variant":"success","size":"lg"},on:{"click":_vm.createLicenseFile}},[_vm._v("\n          "+_vm._s(_vm.$t('allocateConfirmationYes'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('a',{staticClass:"danger-text",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.goToStepOne.apply(null, arguments)}}},[_vm._v("\n          "+_vm._s(_vm.$t('allocateConfirmationNo'))+"\n        ")])])])],1):(_vm.currentStep === 3)?_c('b-container',{staticClass:"step text-center",attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v(_vm._s(_vm.$t('allocateConfirmationLoadingHeader')))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.$t('allocateConfirmationLoadingInfo')))])])]),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-12"},[_c('loading',{attrs:{"customStyle":"padding: 10px;"}})],1)])],1):(_vm.currentStep === 4)?_c('b-container',{staticClass:"step text-center",attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"success-text"},[_vm._v(_vm._s(_vm.$t('allocateDownload')))]),_vm._v(" "),_c('h6',{domProps:{"innerHTML":_vm._s(_vm.$t('allocateDownloadInfo', { hostValue: _vm.hostValue }))}})])]),_vm._v(" "),_c('b-row',{staticClass:"buttons-container"},[_c('div',{staticClass:"col-12"},[_c('b-button',{staticClass:"cta-btn",attrs:{"variant":"primary","disabled":_vm.isDownloading},on:{"click":_vm.downloadLicenseFiles}},[_vm._v("\n          "+_vm._s(_vm.$tc('downloadLicenseFiles', 1))+"\n          "),(_vm.isDownloading)?_c('i',{staticClass:"fa fa-spinner loading-animation"}):_vm._e()])],1),_vm._v(" "),(!_vm.isFull && _vm.remainingCount > 0)?_c('div',{staticClass:"col-12"},[_c('a',{staticClass:"primary-text",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.currentStep = 1; _vm.hostValue = ''}}},[_vm._v("\n          "+_vm._s(_vm.$t('allocateMoreLicenses'))+"\n        ")])]):_vm._e()])],1):_c('b-container',{staticClass:"step",attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('h6',{domProps:{"innerHTML":_vm._s(_vm.errorDescription)}})])]),_vm._v(" "),(_vm.errorType === 'data')?_c('b-row',{staticClass:"buttons-container text-center"},[_c('div',{staticClass:"col-12"},[_c('b-button',{staticClass:"cta-btn",attrs:{"variant":"primary","size":"lg","disabled":_vm.isDownloading},on:{"click":_vm.downloadLicenseFiles}},[_vm._v("\n          "+_vm._s(_vm.$t('allocateFailCtaButtonText'))+"\n          "),(_vm.isDownloading)?_c('i',{staticClass:"fa fa-spinner loading-animation"}):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('b-button',{staticClass:"secondary-btn",attrs:{"variant":"primary","size":"lg"},on:{"click":_vm.downloadFailedTextFile}},[_vm._v("\n          "+_vm._s(_vm.$t('allocateFailSecondaryButtonText'))+"\n        ")])],1)]):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"})],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DbsQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dy97":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:{ collapsed: _vm.collapsed, main: true, odd: _vm.isOdd }},[_c('td',{style:(("padding-bottom: " + (_vm.tdPaddingBottom())))},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleToggleDetails.apply(null, arguments)}}},[_c('span',{class:("icon-caret-" + (_vm.collapsed ? 'down' : 'up') + " toggle-icon")})])]),_vm._v(" "),_c('td',{style:(("padding-bottom: " + (_vm.tdPaddingBottom())))},[_c('a',{staticClass:"product-name-link",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleToggleDetails.apply(null, arguments)}}},[_vm._v("\n      "+_vm._s(_vm.item.productName)+"\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"line-item-details"},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('purchased'))+":")]),_vm._v(" "+_vm._s(_vm.getReadableDate(_vm.item.purchasedDate))+"\n        "),_c('b',[_vm._v(_vm._s(_vm.$tc('expiring', 2))+":")]),_vm._v(" "+_vm._s(_vm.getReadableDate(_vm.item.expirationDate))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"line-item-content",style:(("display: " + (_vm.collapsed ? 'none' : 'block')))},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-12"},[_c('table',{ref:"listItemTable",staticClass:"list-item-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('name')))]),_vm._v(" "),_c('th',[_c('b-select',{staticClass:"all-assets-child-dynamic-column-select",attrs:{"options":_vm.dynamicColumnOptions},on:{"change":_vm.handleDynamicColumnOptionChange},model:{value:(_vm.dynamicColumnOption),callback:function ($$v) {_vm.dynamicColumnOption=$$v},expression:"dynamicColumnOption"}})],1),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('quantity')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.childItems),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item[_vm.dynamicColumnOption]))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(item.quantity))])])}),0)])])])])]),_vm._v(" "),_c('td',{style:(("padding-bottom: " + (_vm.tdPaddingBottom())))},[_vm._v(_vm._s(_vm.item[_vm.dynamicKey]))]),_vm._v(" "),_c('td',{style:(("padding-bottom: " + (_vm.tdPaddingBottom())))},[_vm._v(_vm._s(_vm.item.quantity))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E3Yh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_typeahead__ = __webpack_require__("pmKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SurveyModal__ = __webpack_require__("F6yq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RegisterDomainModal',
  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_4__Loading__["a" /* default */],
    'typeahead': __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_typeahead__["a" /* default */],
    'survey-modal': __WEBPACK_IMPORTED_MODULE_3__SurveyModal__["a" /* default */]
  },
  props: {
    modal: { type: Boolean, required: true },
    closeModal: { type: Function, required: true },
    openModal: { type: Function, required: true },
    customHeader: { type: String, default: 'Add domains for strong network' }
  },
  data: function data() {
    return {
      domainNameInput: '',
      editing: {},
      tableData: [],
      isSuccess: false,
      loading: false,
      isApiCallComplete: false
    };
  },
  mounted: function mounted() {
    this.getDomainNameListForStrong();
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].AppInsights.trackPageView('Register Domain page', '/registerDomain');
  },
  updated: function updated() {},

  computed: {
    allocateTitle: function allocateTitle() {
      return this.$t('addDomainsForStrongNetwork');
    },
    enterDomainName: function enterDomainName() {
      return this.$t('enterDomainName');
    }
  },
  methods: {
    getDomainNameListForStrong: function getDomainNameListForStrong() {
      var _this = this;

      this.bottle.get(this.UrlBuilder.getDomainsListForStrong(this.$store.getters.person.customerId)).then(function (_ref) {
        var DomainNames = _ref.data;

        _this.tableData = DomainNames.DomainNames;
      }).catch(function (error) {
        _this.loading = false;
        _this.hasApiCallFailed = true;
        _this.isApiCallDone = true;
        _this.loggly.log({
          errorMessage: 'Failed to get DomainDetails',
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    addDomain: function addDomain() {
      if (this.domainNameInput !== '') {
        this.tableData.push(this.domainNameInput);
        this.domainNameInput = '';
      }
    },
    submitRegisterDomains: function submitRegisterDomains() {
      var _this2 = this;

      this.loading = true;
      var DomainsRequest = {
        DomainNames: this.tableData
      };
      this.bottle.post(this.UrlBuilder.saveDomainsForStrong(this.$store.getters.person.customerId), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DomainsRequest)).then(function (_ref2) {
        var data = _ref2.data;

        if (data) {
          _this2.isSuccess = true;
        } else {
          _this2.isSuccess = false;
        }
      }).catch(function (error) {
        _this2.loading = false;
        _this2.loggly.log({
          errorMessage: 'Failed to save domain names',
          errorObject: error,
          errorStack: error.stack
        });
      }).finally(function () {
        _this2.isApiCallComplete = true;
        _this2.loading = false;
      });
    },
    clearScreen: function clearScreen() {
      this.isSuccess = false;
      this.isApiCallComplete = false;
    },
    resetModalAndClose: function resetModalAndClose() {
      this.closeModal();
      this.clearScreen();
      this.getDomainNameListForStrong();
    },
    editRow: function editRow(index) {
      this.$set(this.editing, index, true);
    },
    saveRow: function saveRow(index) {
      this.$set(this.editing, index, false);
    },
    deleteRow: function deleteRow(index) {
      if (index !== -1) {
        this.tableData.splice(index, 1);
        this.$delete(this.editing, index);
      }
    }
  }
});

/***/ }),

/***/ "ECiI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoLicenseActivity_vue__ = __webpack_require__("8vQ4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3db67c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoLicenseActivity_vue__ = __webpack_require__("7k9m");
function injectStyle (ssrContext) {
  __webpack_require__("SXXF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoLicenseActivity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3db67c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoLicenseActivity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EXtw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HideUnhideModal_vue__ = __webpack_require__("UJ5i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3acc7498_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HideUnhideModal_vue__ = __webpack_require__("XCYW");
function injectStyle (ssrContext) {
  __webpack_require__("MwfS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3acc7498"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HideUnhideModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3acc7498_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HideUnhideModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EfNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LicenseTable_vue__ = __webpack_require__("qAAc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66aa3dba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LicenseTable_vue__ = __webpack_require__("0WNb");
function injectStyle (ssrContext) {
  __webpack_require__("kbj3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LicenseTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66aa3dba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LicenseTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EfgU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F/zu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticStyle:{"margin":"50px 0"},attrs:{"fluid":""}},[(_vm.hasApiCallFailed)?_c('div',[_c('something-went-wrong',{attrs:{"text":_vm.$t('easyAllocation'),"fromEasy":"","responseStatus":_vm.responseStatus}})],1):(_vm.loading)?[_c('loading')]:(!_vm.hasNoRecords)?[_c('b-row',{attrs:{"id":"page-top"}},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v(_vm._s(_vm.$t('easyAllocation')))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card card-body bg-light license-info-container"},[_c('p',[_c('span',[_vm._v(_vm._s(_vm.$tc('orderNumber', 1))+": "),_c('b',[_vm._v(_vm._s(_vm.orderNumber))])]),_vm._v(" "),_c('span',{staticClass:"pipe"},[_vm._v("|")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('orderDate'))+": "),_c('b',[_vm._v(_vm._s(_vm.orderDate))])])])]),_vm._v(" "),_c('b-row',{staticStyle:{"padding-bottom":"20px"}},[_c('div',{staticClass:"col-12 col-md-3 cta-btn-container"},[_c('b-button',{staticClass:"cta-btn",attrs:{"variant":"primary","size":"lg","disabled":_vm.isAllocateDisabled,"title":_vm.selectedLicenses.length === 0 ? _vm.$t('noSelectionInfoText') : ''},on:{"click":function($event){_vm.allocateModal = true}}},[_vm._v("\n              "+_vm._s(_vm.$t('allocateLicense'))+"\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 d-sm-block d-md-none options-btn-container"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.showOptions = !_vm.showOptions}}},[_vm._v("\n              "+_vm._s(_vm.$t('viewHideOptions', { action: !_vm.showOptions ? _vm.$t('view') : _vm.$tc('hide', 1) } ))+"\n              "),_c('i',{class:("fa fa-chevron-" + (!_vm.showOptions ? 'down' : 'up'))})])]),_vm._v(" "),_c('div',{class:['col-12 col-md-4 offset-md-5 options-container', { show: _vm.showOptions }]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('fieldset',{staticClass:"form-group"},[_c('legend',[_vm._v(_vm._s(_vm.$t('sortBy')))]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-select',{attrs:{"options":_vm.sortOptions},on:{"change":_vm.handleSortChange},model:{value:(_vm.sortOption),callback:function ($$v) {_vm.sortOption=$$v},expression:"sortOption"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('fieldset',{staticClass:"form-group"},[_c('legend',[_vm._v(_vm._s(_vm.$t('show')))]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-select',{attrs:{"options":_vm.pageSizeOptions},on:{"change":_vm.handlePageNumberChange},model:{value:(_vm.pageSizeOption),callback:function ($$v) {_vm.pageSizeOption=$$v},expression:"pageSizeOption"}})],1)])])])])])],1)]),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"all-licenses-table-header vertical-padding left-spacing"},[_c('div',{staticClass:"col checkbox-col"},[_c('b-checkbox',{on:{"change":_vm.toggleAllLicensesSelection},model:{value:(_vm.areAllLicensesSelected),callback:function ($$v) {_vm.areAllLicensesSelected=$$v},expression:"areAllLicensesSelected"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col indent-text"},[_vm._v(_vm._s(_vm.$t('productName')))]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block col dynamic-column-select-container header"},[_vm._v("\n              "+_vm._s(_vm.dynamicColumnHeader)+"\n                 \n              "),_c('i',{staticClass:"fa fa-caret-down"}),_vm._v(" "),_c('b-select',{staticClass:"dynamic-column-select",attrs:{"options":_vm.dynamicColumnOptions},model:{value:(_vm.dynamicColumnOption),callback:function ($$v) {_vm.dynamicColumnOption=$$v},expression:"dynamicColumnOption"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block col allocate-col text-right"},[_vm._v(_vm._s(_vm.$t('allocated')))])])])]),_vm._v(" "),_vm._l((_vm.licenses),function(license,i){return [_c('b-row',{key:license.ProductName + i,class:[_vm.getTableRowClasses(license, i)]},[_c('div',{staticClass:"col checkbox-col"},[_c('b-checkbox',{class:_vm.isLicenseInvalid(license) ? 'error-checkbox' : '',attrs:{"checked":_vm.isLicenseSelected(license)},on:{"change":function($event){return _vm.toggleLicenseSelection(license)}}})],1),_vm._v(" "),_c('div',{staticClass:"col product-name-col"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col product-name-col indent-text",attrs:{"title":("" + (license.ProductName))}},[_c('span',{attrs:{"title":license.ProductName}},[_vm._v("\n                  "+_vm._s(license.ProductName)+"\n                ")]),_vm._v(" "),(_vm.isLicenseNew(license))?_c('span',{staticClass:"success-text"},[_vm._v(_vm._s(_vm.$t('new')))]):(_vm.isLicenseExpiringLow(license))?_c('span',{staticClass:"danger-text"},[_vm._v("\n                  "+_vm._s(_vm.$tc('expiring', 1))+"\n                ")]):(_vm.isLicenseExpiringHigh(license))?_c('span',{staticClass:"warning-text"},[_vm._v("\n                  "+_vm._s(_vm.$tc('expiring', 1))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.isLicenseInvalid(license))?_c('p',{staticClass:"ex"},[_vm._v("\n                  "+_vm._s(_vm.$t('multipleSelectionHostTypeError', { hostType: _vm.hostType }))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block col dynamic-column-select-container truncate-col",attrs:{"title":_vm.dynamicColumnOption === 'HostValue' ? _vm.dynamicColumnItem(license) : ''}},[_vm._v("\n                "+_vm._s(_vm.dynamicColumnItem(license))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block col allocate-col text-right"},[_vm._v("\n                "+_vm._s(_vm.getAllocatedText(license))+"\n              ")])])])])]}),_vm._v(" "),_c('b-row',{staticClass:"all-licenses-table-footer"},[_c('div',{staticClass:"col-12 text-center"},[_c('div',{staticClass:"pagination-container"},[_c('b-pagination',{ref:"pagination",attrs:{"value":_vm.currentPage,"limit":6,"per-page":_vm.pageSizeOption,"hide-goto-end-buttons":"","prev-text":_vm.$t('paginationPrevText'),"next-text":_vm.$t('paginationNextText'),"total-rows":_vm.totalFilteredSortedLicenses},on:{"change":_vm.handlePageChange}})],1)])]),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-12"},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('easyQuestion1')))]),_c('br'),_vm._v("\n            "+_vm._s(_vm.$t('easyAnswer1'))+"\n          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('easyQuestion2')))]),_c('br'),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('easyAnswer2', {
                citrixLicensingDocumentationUrl: _vm.UrlBuilder.citrixLicensingDocumentationUrl,
                docsUrl: _vm.UrlBuilder.docsUrl
              }))}})])])]),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-12 text-center"},[_c('b-button',{staticClass:"outline-btn btn-c-outline",attrs:{"size":"lg"},on:{"click":_vm.handleSignInClick}},[_vm._v("\n            "+_vm._s(_vm.$t('signInToMyAccount'))+"\n          ")])],1)])],2)]:_vm._e(),_vm._v(" "),(_vm.hasNoRecords)?[_c('b-row',{staticClass:"no-records-container"},[_c('h3',[_vm._v(_vm._s(_vm.$t('licenseFullyAllocated')))])])]:_vm._e(),_vm._v(" "),_c('b-modal',{on:{"hide":_vm.handleModalClose},model:{value:(_vm.showPagingWarning),callback:function ($$v) {_vm.showPagingWarning=$$v},expression:"showPagingWarning"}},[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"},[_vm._v("\n      "+_vm._s(_vm.$t('bulkActions'))+"\n    ")]),_vm._v(" "),_c('b-container',[_c('b-row',{staticClass:"text-center"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"danger-text"},[_vm._v(_vm._s(_vm.$t('bulkActionErrorTitle')))]),_vm._v(" "),_c('h6',{domProps:{"innerHTML":_vm._s(_vm.$t('bulkActionErrorInfo'))}})])]),_vm._v(" "),_c('b-row',{staticClass:"buttons-container"},[_c('div',{staticClass:"col-12"},[_c('b-button',{staticStyle:{"margin":"30px auto 10px","display":"block"},attrs:{"variant":"primary","size":"lg"},on:{"click":_vm.handleModalClose}},[_vm._v("\n            "+_vm._s(_vm.$t('bulkActionCtaButtonText'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 text-center"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.clearLicensesAndPaginate.apply(null, arguments)}}},[_vm._v("\n            "+_vm._s(_vm.$t('bulkActionSecondaryButtonText'))+"\n          ")])])])],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"})],1),_vm._v(" "),_c('allocation-modal',{attrs:{"isFromEasyPage":"","modal":_vm.allocateModal,"closeModal":_vm.closeAllocateModal,"selectedLicenses":_vm.selectedLicenses,"getUpdatedLicenses":_vm.getLicenses,"customHeader":_vm.customHeader}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F6yq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyModal_vue__ = __webpack_require__("rkWt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d4b59c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyModal_vue__ = __webpack_require__("VJ4V");
function injectStyle (ssrContext) {
  __webpack_require__("0k7g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d4b59c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FYpH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue__ = __webpack_require__("MYbz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25372712_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadList_vue__ = __webpack_require__("y/8N");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25372712_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fr7y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TabbedHomeView__ = __webpack_require__("vCx2");
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  components: { TabbedHomeView: __WEBPACK_IMPORTED_MODULE_1__TabbedHomeView__["a" /* default */] },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].AppInsights.trackPageView('Home page', '/');
  }
});

/***/ }),

/***/ "G45Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllLicenses_vue__ = __webpack_require__("s3LN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c6c3f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllLicenses_vue__ = __webpack_require__("ah/w");
function injectStyle (ssrContext) {
  __webpack_require__("0G52")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74c6c3f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllLicenses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c6c3f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllLicenses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GF+c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseCheckerInitialOrderDetails',
  props: {
    data: { type: Array, default: function _default() {
        return [];
      } }
  },
  mounted: function mounted() {
    this.$emit('setSiblingHeight', this.$refs.initialorder.clientHeight);
  }
});

/***/ }),

/***/ "HNxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SurveyModal__ = __webpack_require__("F6yq");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReturnAllocationModal',
  props: {
    modal: { type: Boolean, required: true },
    closeModal: { type: Function, required: true },
    selectedLicenses: { type: Array, required: true },
    isFromViewAll: { type: Boolean, default: false },
    isFromDetailPage: { type: Boolean, default: false }
  },
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_6__Loading__["a" /* default */],
    'survey-modal': __WEBPACK_IMPORTED_MODULE_7__SurveyModal__["a" /* default */]
  },
  data: function data() {
    return {
      isInternal: window.location.host.includes('citrite.net'),
      currentStep: 1,
      errorType: '',
      failedReturns: [],
      modalName: 'survey-license-modal',
      showModal: false,
      showOtherInput: false,
      showRenameText: false,
      consent: false,
      otherReason: '',
      reasonOption: '',
      reasonOptions: [{ value: this.$t('returnReasonOption1'), text: this.$t('returnReasonOption1') }, { value: this.$t('returnReasonOption2'), text: this.$t('returnReasonOption2') }, { value: this.$t('returnReasonOption3'), text: this.$t('returnReasonOption3') }, { value: this.$t('returnReasonOption4'), text: this.$t('returnReasonOption4') }, { value: this.$t('returnReasonOption5'), text: this.$t('returnReasonOption5') }, { value: this.$t('returnReasonOption6'), text: this.$t('returnReasonOption6') }, { value: this.$t('returnReasonOption7'), text: this.$t('returnReasonOption7') }, { value: this.$t('returnReasonOptionOther'), text: this.$t('returnReasonOptionOther') }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['showSurveyModal', 'person']), {
    customerId: function customerId() {
      return this.$store.getters.person.customerId;
    },
    loggedInUserName: function loggedInUserName() {
      return this.$store.getters.authToken.userName || '';
    },
    loggedInUserPersonID: function loggedInUserPersonID() {
      return this.$store.getters.authToken.personId || '';
    },
    count: function count() {
      if (this.isFromDetailPage) {
        return this.selectedLicenses[0].Fulfillments.reduce(function (acc, cur) {
          return acc + +cur.fulfilledQuantity;
        }, 0);
      }
      return this.selectedLicenses.reduce(function (acc, cur) {
        acc += cur.UserCount - cur.RemainingUserCount;
        return acc;
      }, 0);
    },
    hostIds: function hostIds() {
      if (this.isFromDetailPage) {
        var HostValues = [];
        this.selectedLicenses[0].Fulfillments.forEach(function (l) {
          if (!HostValues.includes(l.hostIDValue)) {
            HostValues.push(l.hostIDValue);
          }
        });
        return HostValues.join(', ');
      } else {
        var _HostValues = [];
        this.selectedLicenses.forEach(function (f) {
          var hostValues = f.HostValue.split(',');
          if (!_HostValues.includes.apply(_HostValues, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(hostValues))) {
            _HostValues.push.apply(_HostValues, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(hostValues)));
          }
        });
        return _HostValues.join(', ');
      }
    },
    returnTitle: function returnTitle() {
      switch (this.errorType) {
        case 'data':
          return this.$t('failDataErrorTitle');
        case 'system':
          return this.$t('failSystemErrorTitle');
        default:
          return this.$t('returnAllLicenses');
      }
    },
    errorDescription: function errorDescription() {
      switch (this.errorType) {
        case 'data':
          return this.$t('failDataErrorDescription', {
            customerServiceUrl: this.UrlBuilder.customerServiceUrl
          });
        case 'system':
          return this.$t('failSystemErrorDescription', {
            customerServiceUrl: this.UrlBuilder.customerServiceUrl
          });
        default:
          return '';
      }
    },
    failedDownloadText: function failedDownloadText() {
      return this.$t('referCustomerCare') + '\r\n\r\n' + (this.$t('unableToAllocatePrefix') + '\r\n\r\n') + (this.failedReturns.join('\r\n') + '\r\n\r\n') + (this.$t('unableToAllocateSuffix') + '\r\n\r\n') + ('' + this.$t('contactCitrix'));
    }
  }),
  methods: {
    onReasonSelect: function onReasonSelect() {
      var _this = this;

      this.$nextTick(function () {
        _this.showOtherInput = _this.reasonOption === _this.$t('returnReasonOptionOther');
        _this.showRenameText = _this.reasonOption === _this.$t('returnReasonOption3') || _this.reasonOption === _this.$t('returnReasonOption5');
      });
    },
    returnLicenses: function returnLicenses() {
      var _this2 = this;

      this.currentStep = 2;
      this.bottle.post(this.UrlBuilder.returnUrl, {
        customerId: this.customerId,
        loggedInUserName: this.loggedInUserName,
        loggedInUserPersonID: this.$store.getters.person.id,
        action: 'Doreturn',
        fulfillmentsList: this.isFromDetailPage ? this.selectedLicenses[0].Fulfillments.map(function (l) {
          return {
            activationID: _this2.selectedLicenses[0].ActivationID,
            fulfillmentID: l.fulfillmentID,
            hostValue: l.hostIDValue,
            hostType: l.hostIDType,
            quantity: l.fulfilledQuantity,
            productName: _this2.selectedLicenses[0].ProductName,
            serialNumber: _this2.selectedLicenses[0].SerialNumber,
            licenseItemNumber: _this2.selectedLicenses[0].LicenseItemNumber,
            assetID: _this2.selectedLicenses[0].AssetID,
            actionReason: _this2.otherReason ? _this2.otherReason : _this2.reasonOption,
            consentBy: _this2.consent ? _this2.person.username : ''
          };
        }) : this.selectedLicenses.map(function (l) {
          return {
            activationID: l.ActivationID,
            fulfillmentID: _this2.isFromViewAll ? null : l.fulfillmentID,
            hostValue: _this2.isFromViewAll ? null : l.hostIDValue,
            hostType: _this2.isFromViewAll ? l.HostType : l.hostIDType,
            quantity: _this2.isFromViewAll ? l.UserCount - l.RemainingUserCount : l.fulfilledQuantity,
            productName: l.ProductName,
            serialNumber: l.SerialNumber,
            licenseItemNumber: l.LicenseItemNumber,
            assetID: l.AssetID,
            actionReason: _this2.otherReason ? _this2.otherReason : _this2.reasonOption,
            consentBy: _this2.consent ? _this2.person.username : ''
          };
        })
      }).then(function (_ref) {
        var data = _ref.data;

        data = data.fulfillmentsList;
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].AppInsights.trackEvent('Return action', {
          customerId: _this2.customerId,
          data: data.map(function (d) {
            return {
              hostType: d.hostIDType,
              hostId: d.hostIDValue,
              quantity: d.quantity,
              status: d.status,
              remainingQuantity: d.remainingQuantity
            };
          })
        });
        if (data.some(function (d) {
          return d.statusInfo === 'FAILURE';
        })) {
          var failedReturns = data.filter(function (d) {
            return d.statusInfo === 'FAILURE';
          }).map(function (d) {
            return d.fulfillmentID;
          });
          _this2.selectedLicenses.forEach(function (l) {
            var arr = void 0;
            if (failedReturns.includes(l.FulfillmentID)) {
              arr = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this2.failedReturns));
              arr.push(l);
              _this2.failedReturns = arr.map(function (l) {
                return l.FulfillmentID;
              });
            }
          });
          _this2.currentStep = 4;
          _this2.errorType = 'data';
        } else {
          _this2.currentStep = 3;
        }
      }).catch(function (error) {
        _this2.currentStep = 4;
        _this2.errorType = 'system';
        _this2.loggly.log({
          errorMessage: 'Failed to fetch all licenses',
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    downloadFailedTextFile: function downloadFailedTextFile() {
      __WEBPACK_IMPORTED_MODULE_5_downloadjs___default()(this.failedDownloadText, 'failed-licenses.txt', 'text/html');
    },
    resetAndCloseModal: function resetAndCloseModal() {
      this.showModal = true;
      this.currentStep = 1;
      this.errorType = '';
      this.otherReason = '';
      this.showOtherInput = false;
      this.showRenameText = false;
      this.consent = false;
      this.reasonOption = '';
      this.closeModal();
    }
  }
});

/***/ }),

/***/ "HUKa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseCheckerCheckCross',
  props: {
    check: { type: Boolean, default: false },
    cross: { type: Boolean, default: false }
  }
});

/***/ }),

/***/ "HgF3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.length!=0)?_c('div',{ref:"initialorder",staticClass:"card order-details",attrs:{"id":"initial-order"}},[_c('div',{staticClass:"card-header"},[_vm._v("Initial Order Details")]),_vm._v(" "),_c('div',{staticClass:"card-body table-scroll"},[_c('table',{staticClass:"table table-borderless"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',{key:item.SAPLineItemNumber},[_c('td',[_vm._v(_vm._s(item.SAPOrderNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.SAPSKU))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.SAPLineItemNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.QUANTITY))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.HIGHLEVELITEM))])])}),0)])])]):_c('div',{ref:"initialorder",staticClass:"card order-details",attrs:{"id":"initial-order"}},[_c('div',{staticClass:"card-header"},[_vm._v("Initial Order Details")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n      No Initial Order Found.\n    \n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("SAP Order Number")]),_vm._v(" "),_c('th',[_vm._v("SAP SKU")]),_vm._v(" "),_c('th',[_vm._v("SAP Line Item Number")]),_vm._v(" "),_c('th',[_vm._v("Quantity")]),_vm._v(" "),_c('th',[_vm._v("High Level Item")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HpSu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IZ6L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllAssetsListItem_vue__ = __webpack_require__("Lb9J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5031f8dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllAssetsListItem_vue__ = __webpack_require__("Dy97");
function injectStyle (ssrContext) {
  __webpack_require__("TdaH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5031f8dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllAssetsListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5031f8dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllAssetsListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IZoi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_aside_vue__ = __webpack_require__("pIUa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b17caa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_aside_vue__ = __webpack_require__("d56P");
function injectStyle (ssrContext) {
  __webpack_require__("Cgqp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b17caa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IoNC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseCheckerCadsDetails',
  props: {
    data: { type: Array, default: function _default() {
        return [];
      } }
  },
  methods: {
    getReadableDate: function getReadableDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD');
    }
  }
});

/***/ }),

/***/ "JGm3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterDomainModal_vue__ = __webpack_require__("E3Yh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c7e255_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterDomainModal_vue__ = __webpack_require__("wkmZ");
function injectStyle (ssrContext) {
  __webpack_require__("kOnr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06c7e255"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterDomainModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c7e255_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterDomainModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jpsp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LicenseLists__ = __webpack_require__("Rpuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AllAssets__ = __webpack_require__("ACwM");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  components: {
    'license-lists': __WEBPACK_IMPORTED_MODULE_0__LicenseLists__["a" /* default */],
    'all-assets': __WEBPACK_IMPORTED_MODULE_1__AllAssets__["a" /* default */]
  },
  computed: {
    tabIndex: function tabIndex() {
      return this.$route.path.includes('/login') || this.$route.path === '/' ? 0 : 1;
    },
    isLoginPath: function isLoginPath() {
      return this.$route.path.includes('/login');
    },
    isEmailPath: function isEmailPath() {
      return this.$route.path.includes('/email');
    },
    tabClass: function tabClass() {
      return this.isLoginPath || this.isEmailPath ? 'hidden-tab' : '';
    }
  },
  methods: {
    handleAssetTabClick: function handleAssetTabClick() {
      this.$store.commit('setPreviousPath', this.$route.path);
      if (!this.isLoginPath) {
        this.$router.replace('/');
      }
    },
    handleManageLicensesTabClick: function handleManageLicensesTabClick() {
      var path = this.$store.getters.previousPath;
      this.$router.replace(!path || path === '/login' || path === '/' ? '/manage-licenses' : path);
    }
  }
});

/***/ }),

/***/ "JypW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_table_headers_vue__ = __webpack_require__("hvHF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ec6421b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_table_headers_vue__ = __webpack_require__("dUh8");
function injectStyle (ssrContext) {
  __webpack_require__("DbsQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_table_headers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ec6421b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_table_headers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K4gw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KIbN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UniconCustomerModal_vue__ = __webpack_require__("65nu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59110e8d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UniconCustomerModal_vue__ = __webpack_require__("8gGY");
function injectStyle (ssrContext) {
  __webpack_require__("Krx0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59110e8d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UniconCustomerModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59110e8d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UniconCustomerModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KVg4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.length!=0)?_c('div',{ref:"renewalorder",staticClass:"card order-details",style:(_vm.renewalOrderStyle),attrs:{"id":"renewal-order"}},[_c('div',{staticClass:"card-header"},[_vm._v("Renewal Order Details")]),_vm._v(" "),_c('div',{staticClass:"card-body table-scroll"},[_c('table',{staticClass:"table table-borderless"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',{key:item.SAPLineItemNumber},[_c('td',[_vm._v(_vm._s(item.SAPOrderNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.SAPSKU))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.SAPLineItemNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.QUANTITY))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.HIGHLEVELITEM))])])}),0)])])]):_c('div',{ref:"renewalorder",staticClass:"card order-details",style:(_vm.renewalOrderStyle),attrs:{"id":"renewal-order"}},[_c('div',{staticClass:"card-header"},[_vm._v("Renewal Order Details")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n      No Renewal Order Found.\n    \n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("SAP Order Number")]),_vm._v(" "),_c('th',[_vm._v("SAP SKU")]),_vm._v(" "),_c('th',[_vm._v("SAP Line Item Number")]),_vm._v(" "),_c('th',[_vm._v("Quantity")]),_vm._v(" "),_c('th',[_vm._v("High Level Item")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Krx0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lb9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_DateFormatMixin__ = __webpack_require__("fgSf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AllAssetsListItem',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_DateFormatMixin__["a" /* default */]],
  data: function data() {
    return {
      collapsed: true,
      listItemTableHeight: null,
      dynamicColumnOption: 'lineItemNumber',
      dynamicColumnOptions: [{ value: 'laCode', text: this.$t('licenseAccessCode') }, { value: 'lineItemNumber', text: this.$tc('orderNumber', 2) + '/' + this.$t('lineItemNumber') }]
    };
  },

  props: {
    item: { type: Object, required: true },
    dynamicKey: { type: String, default: 'orderNumber' },
    isOdd: { type: Boolean, required: true }
  },
  computed: {
    childItems: function childItems() {
      return this.item.list.sort(function (a, b) {
        return Number(a.lineItemNumber) - Number(b.lineItemNumber);
      });
    }
  },
  methods: {
    tdPaddingBottom: function tdPaddingBottom() {
      if (this.collapsed) return '12px;';
      return this.listItemTableHeight + 50 + 'px;';
    },
    handleToggleDetails: function handleToggleDetails() {
      var _this = this;

      this.collapsed = !this.collapsed;
      this.$nextTick(function () {
        _this.updateTdPadding();
      });
    },
    updateTdPadding: function updateTdPadding() {
      this.listItemTableHeight = !this.collapsed ? this.$refs.listItemTable.clientHeight : null;
    },
    getReadableDate: function getReadableDate(date) {
      if (!date) return 'N/A';
      if (+__WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY').includes('1752')) return 'N/A';
      var temp = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format(this.getDateFormatBasedOnLocale());
      return temp.includes('0001') || temp.includes('1752') ? 'N/A' : temp;
    },
    handleDynamicColumnOptionChange: function handleDynamicColumnOptionChange(dynamicColumnOption) {
      this.dynamicColumnOption = dynamicColumnOption;
    }
  }
});

/***/ }),

/***/ "LeG/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.textClasses,attrs:{"tabindex":"0","href":"#"},on:{"mouseover":function($event){_vm.active = true},"mouseout":function($event){_vm.active = false}}},[_vm._t("suggestion",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.htmlText)}})]},null,{ data: _vm.data, htmlText: _vm.htmlText })],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LutH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[(_vm.loading)?[_c('loading')]:(_vm.isUserTypeInternal)?[_c('div',{staticClass:"login-container-new"},[_c('h5',[_vm._v(_vm._s(_vm.$t('loginPrompt')))]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"login","placeholder":_vm.$t('loginId')},nativeOn:{"input":function($event){_vm.personNotFound = false}},model:{value:(_vm.loginId),callback:function ($$v) {_vm.loginId=$$v},expression:"loginId"}}),_vm._v(" "),(_vm.personNotFound)?_c('p',{staticClass:"ex"},[_vm._v("\n          "+_vm._s(_vm.$t('personNotFoundError'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('b-button',{attrs:{"disabled":_vm.loginId === '' || !!_vm.authenticationError.errorMessage,"variant":"primary"},on:{"click":_vm.proceedWithLogin}},[_vm._v("\n          "+_vm._s(_vm.$t('continue'))+"\n        ")])],1)]:[_c('div',{staticClass:"login-container"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"error-message"},[_c('h5',[_vm._v(_vm._s(_vm.authenticationError.errorMessage))]),_vm._v(" "),_c('div',{staticClass:"stack-trace"},[_vm._v("\n            "+_vm._s(_vm.authenticationError.errorStack)+"\n          ")])])])]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5816a232_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("qaf/");
function injectStyle (ssrContext) {
  __webpack_require__("qDNa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5816a232_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MYbz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadListItem_vue__ = __webpack_require__("goSe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function sanitize(text) {
  return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypeaheadList',

  components: {
    VueBootstrapTypeaheadListItem: __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadListItem_vue__["a" /* default */]
  },

  props: {
    data: {
      type: Array,
      required: true,
      validator: function validator(d) {
        return d instanceof Array;
      }
    },
    query: {
      type: String,
      default: ''
    },
    backgroundVariant: {
      type: String
    },
    textVariant: {
      type: String
    },
    maxMatches: {
      type: Number,
      default: 10
    },
    minMatchingChars: {
      type: Number,
      default: 2
    }
  },

  computed: {
    highlight: function highlight() {
      var _this = this;

      return function (text) {
        text = sanitize(text);
        if (_this.query.length === 0) {
          return text;
        }
        var re = new RegExp(_this.escapedQuery, 'gi');

        return text.replace(re, '<strong>$&</strong>');
      };
    },
    escapedQuery: function escapedQuery() {
      return escapeRegExp(sanitize(this.query));
    },
    matchedItems: function matchedItems() {
      if (this.query.length === 0 || this.query.length < this.minMatchingChars) {
        return [];
      }

      var re = new RegExp(this.escapedQuery, 'gi');

      // Filter, sort, and concat
      return this.data.filter(function (i) {
        return i.text.match(re) !== null;
      }).sort(function (a, b) {
        var aIndex = a.text.indexOf(a.text.match(re)[0]);
        var bIndex = b.text.indexOf(b.text.match(re)[0]);

        if (aIndex < bIndex) {
          return -1;
        }
        if (aIndex > bIndex) {
          return 1;
        }
        return 0;
      }).slice(0, this.maxMatches);
    }
  },

  methods: {
    handleHit: function handleHit(item, evt) {
      this.$emit('hit', item);
      evt.preventDefault();
    }
  }
});

/***/ }),

/***/ "Mdpe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mq7Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__license_checker_check_cross__ = __webpack_require__("D+ix");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseCheckerModal',
  components: { LicenseCheckerCheckCross: __WEBPACK_IMPORTED_MODULE_0__license_checker_check_cross__["a" /* default */] },
  data: function data() {
    return {
      issues: ''
    };
  },

  props: {
    data: { type: Array, default: function _default() {
        return [];
      } }
  },
  mounted: function mounted() {},

  computed: {
    getIssues: function getIssues() {
      return this.issues;
    }
  },
  methods: {
    showModal: function showModal() {
      var _this = this;

      this.issues = [];
      var allStatuses = this.data.map(function (x) {
        return x.ACTION_STATUS;
      });
      if (allStatuses.filter(function (x) {
        return x.IsNotAutoAllocated === 'Success';
      }).length >= 1) {
        this.issues.push({ name: 'Auto Allocation Fix', status: true });
      }
      if (allStatuses.filter(function (x) {
        return x.IsNotAutoAllocated === 'Failure';
      }).length >= 1) {
        this.issues.push({ name: 'Auto Allocation Fix', status: false });
      }
      if (allStatuses.filter(function (x) {
        return x.IsCADSDataIncorrect === 'Success';
      }).length >= 1) {
        this.issues.push({ name: 'CADS Data Fix', status: true });
      }
      if (allStatuses.filter(function (x) {
        return x.IsCADSDataIncorrect === 'Failure';
      }).length >= 1) {
        this.issues.push({ name: 'CADS Data Fix', status: false });
      }
      if (allStatuses.filter(function (x) {
        return x.IsDataNotInSyncWithSAP === 'Success';
      }).length >= 1) {
        this.issues.push({ name: 'SAP Data Sync', status: true });
      }
      if (allStatuses.filter(function (x) {
        return x.IsDataNotInSyncWithSAP === 'Failure';
      }).length >= 1) {
        this.issues.push({ name: 'SAP Data Sync', status: false });
      }
      if (allStatuses.filter(function (x) {
        return x.IsOrderIdMissingInFNO === 'Success';
      }).length >= 1) {
        this.issues.push({ name: 'Create Line Item Fix', status: true });
      }
      if (allStatuses.filter(function (x) {
        return x.IsOrderIdMissingInFNO === 'Failure';
      }).length >= 1) {
        this.issues.push({ name: 'Create Line Item Fix', status: false });
      }
      if (allStatuses.filter(function (x) {
        return x.IsRenewalIncorrect === 'Success';
      }).length >= 1) {
        this.issues.push({ name: 'Renewal Fix', status: true });
      }
      if (allStatuses.filter(function (x) {
        return x.IsRenewalIncorrect === 'Failure';
      }).length >= 1) {
        this.issues.push({ name: 'Renewal Fix', status: false });
      }
      if (allStatuses.filter(function (x) {
        return x.IsOrderIdNotUpdated === 'Success';
      }).length >= 1 && allStatuses.filter(function (x) {
        return x.IsOrderIdNotUpdated === 'Failure';
      }).length === 0) {
        this.issues.push({ name: 'OrderID Update Fix', status: true });
      }
      if (allStatuses.filter(function (x) {
        return x.IsOrderIdNotUpdated === 'Success';
      }).length >= 0 && allStatuses.filter(function (x) {
        return x.IsOrderIdNotUpdated === 'Failure';
      }).length >= 1) {
        this.issues.push({ name: 'OrderID Update Fix', status: false });
      }
      if (allStatuses.filter(function (x) {
        return x.IsLineItemStateIncorrect === 'Success';
      }).length >= 1 && allStatuses.filter(function (x) {
        return x.IsLineItemStateIncorrect === 'Failure';
      }).length === 0) {
        this.issues.push({ name: 'Line Item Status Fix', status: true });
      }
      if (allStatuses.filter(function (x) {
        return x.IsLineItemStateIncorrect === 'Success';
      }).length >= 0 && allStatuses.filter(function (x) {
        return x.IsLineItemStateIncorrect === 'Failure';
      }).length >= 1) {
        this.issues.push({ name: 'Line Item Status Fix', status: false });
      }
      this.$nextTick(function () {
        _this.openModal();
      });
    },
    openModal: function openModal() {
      this.$refs['license-checker-modal'].show();
    },
    hideModal: function hideModal() {
      this.$refs['license-checker-modal'].hide();
    }
  }
});

/***/ }),

/***/ "MwfS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mzdm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N3Xj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"license-checker-modal"},[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"},[_vm._v("\n    Summary - Fix all Issues"),_c('br')]),_vm._v(" "),(_vm.data.length!=0)?_c('b-container',{staticClass:"modal-content-container"},[_c('span',{staticStyle:{"font-weight":"700"}},[_vm._v("  Asset Component ID : ")]),_vm._v(_vm._s(_vm.data[0].ORDER_ID)+" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"700"}},[_vm._v(" Serial No :")]),_vm._v(" "+_vm._s(_vm.data[0].ENTITLEMENT_ID)+" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.getIssues),function(item){return _c('b-row',{key:item.ORDER_ID},[_c('b-col',{class:item.status===true?'color-green':'color-red',attrs:{"cols":"8"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('license-checker-check-cross',{attrs:{"check":item.status===true,"cross":item.status===false}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}})],1)})],2):_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N95D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ctxs_vue_plugins__ = __webpack_require__("YWD0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ctxs_vue_plugins___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ctxs_vue_plugins__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_UrlBuilder__ = __webpack_require__("wVn8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pylon_bootstrap_vue__ = __webpack_require__("rI7h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pylon_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pylon_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_ApplicationInsights__ = __webpack_require__("t7v0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_Loggly__ = __webpack_require__("eWFx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_Pendo__ = __webpack_require__("WbYt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_Pendo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__plugins_Pendo__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














// Config app
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

// Register citrix plugins
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_ctxs_vue_plugins___default.a.BottlePlugin);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_ctxs_vue_plugins___default.a.EventDispatcherPlugin);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_ctxs_vue_plugins___default.a.AuthenticationPlugin);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_ctxs_vue_plugins___default.a.LockerPlugin);

// Register libraries
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_pylon_bootstrap_vue___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_pylon_bootstrap_vue__["BootstrapVue"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__plugins_UrlBuilder__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__plugins_ApplicationInsights__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__plugins_Loggly__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]({
  locale: "en" || 'en',
  fallbackLocale: 'en',
  messages: __WEBPACK_IMPORTED_MODULE_9__i18n__
});

// Instantiate router
var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */]
});

// Set up authentication check (ensure user is authenitcated for protected routes)
router.beforeEach(function (to, from, next) {
  var requiresAuth = to.meta.requiresAuth || false;
  var authenticated = __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].getters.authenticated;

  if (to.path !== '/login') {
    __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].commit('setPreviousPath', to.fullPath);
  }
  if (to.path === '/la-007') {
    __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].commit('setLA007User', { value: true });
  }
  if (requiresAuth && !authenticated) {
    next('/login');
  } else {
    next();
  }
});

// Bootstrap App
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_0__App__["a" /* default */] },
  store: __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */],
  i18n: i18n
});

/***/ }),

/***/ "NxGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__("8taH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f862c298_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__("R11E");
function injectStyle (ssrContext) {
  __webpack_require__("34eJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f862c298_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O4RG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OGxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseCheckerOrderDetails',
  props: {
    data: { type: Array, default: function _default() {
        return [];
      } }
  }
});

/***/ }),

/***/ "OHFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray__ = __webpack_require__("7nRM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__license_checker_table_headers__ = __webpack_require__("JypW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__license_checker_check_cross__ = __webpack_require__("D+ix");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseCheckerTable',
  components: { LicenseCheckerTableHeaders: __WEBPACK_IMPORTED_MODULE_3__license_checker_table_headers__["a" /* default */], LicenseCheckerCheckCross: __WEBPACK_IMPORTED_MODULE_4__license_checker_check_cross__["a" /* default */] },
  data: function data() {
    return {
      warningRowHeight: {},
      warningRowToggleMap: {}
    };
  },
  mounted: function mounted() {
    this.setHeight();
  },

  watch: {
    selectedId: function selectedId() {
      this.$nextTick(this.setHeight);
    }
  },
  props: {
    selectedId: { type: String, required: true },
    tableData: { type: Object, default: function _default() {
        return {};
      } },
    lineItemsToModify: { type: Object, default: function _default() {
        return {};
      } },
    modalData: { type: Array, default: function _default() {
        return [];
      } }
  },
  methods: {
    setHeight: function setHeight() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$refs).forEach(function (key) {
        if (_this.$refs[key][0]) {
          _this.warningRowHeight[key] = _this.$refs[key][0].clientHeight + 'px';
        }
      });
      this.$forceUpdate();
    },
    getReadableDate: function getReadableDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('YYYY-MM-DD');
    },
    isFaultyItem: function isFaultyItem(id) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.lineItemsToModify).includes(id);
    },
    getLineItemStatus: function getLineItemStatus(status) {
      var _status$replace = status.replace('bo.constants.states.', ''),
          _status$replace2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default()(_status$replace),
          firstChar = _status$replace2[0],
          rest = _status$replace2.slice(1);

      return '' + firstChar.toUpperCase() + rest.join('');
    },
    getFaultyLineItem: function getFaultyLineItem(id) {
      return this.lineItemsToModify[id];
    },
    getFaultyRowInfo: function getFaultyRowInfo(id) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var item = this.getFaultyLineItem(id);
      return action ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item.ACTION_TO_PERFORM || {}).map(function (key) {
        return { key: key, value: item.ACTION_TO_PERFORM[key] };
      }) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item.SUB_ACTION || {}).map(function (key) {
        return { key: key, value: item.SUB_ACTION[key] };
      });
    },
    hasActions: function hasActions(id) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var string = this.getFaultyRowInfo(id, action);
      return string !== '';
    },
    hasNoActions: function hasNoActions(id) {
      return !this.hasActions(id, true) && !this.hasActions(id);
    },
    isModified: function isModified(id) {
      var getItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var item = this.modalData.find(function (a) {
        return a.ACTIVATION_ID === id;
      });
      return getItem ? item : !!item;
    },
    shouldShowSubActions: function shouldShowSubActions(id, index) {
      var _getFaultyRowInfo$ind = this.getFaultyRowInfo(id)[index],
          key = _getFaultyRowInfo$ind.key,
          value = _getFaultyRowInfo$ind.value;

      return key && value;
    }
  }
});

/***/ }),

/***/ "Oj9N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[(_vm.showSurveyModal)?[_c('survey-modal',{attrs:{"show-modal":_vm.showModal}})]:_vm._e(),_vm._v(" "),(_vm.hasApiCallFailed)?[_c('something-went-wrong',{attrs:{"text":_vm.$tc('licenses', 1)}})]:_vm._e(),_vm._v(" "),(_vm.loading)?[_c('loading')]:[_c('b-row',[_c('search',_vm._b({attrs:{"isAdvancedSearchVisible":_vm.search.showAdvancedSearch},on:{"findLicenseByChange":_vm.handleFindLicenseByChange,"searchInputChange":_vm.handleSearchInputChange,"orderDateChange":_vm.handleOrderDateChange,"licenseTypeChange":_vm.handleLicenseTypeChange,"fromDateChange":_vm.handleFromDateChange,"toDateChange":_vm.handleToDateChange,"advancedSearchButtonClick":_vm.handleAdvancedSearchButtonClick,"onSearchClick":_vm.handleSearchClick}},'search',_vm.search,false))],1),_vm._v(" "),_c('b-row',[_c('quick-find',{attrs:{"hideQuickFind":_vm.areBothTablesEmpty,"page":"Landing page"},on:{"filterClicked":_vm.handleQuickFindClick}})],1),_vm._v(" "),(_vm.areBothTablesEmpty)?_c('b-row',{staticStyle:{"margin":"10px 0 50px"}},[_c('b-col',{staticClass:"text-center"},[_c('b-button',{staticClass:"view-all-licenses-btn",attrs:{"to":"/licenses","variant":"primary","size":"lg"}},[_vm._v("\n          "+_vm._s(_vm.$t('viewAllLicenses'))+"\n        ")])],1)],1):_vm._e(),_vm._v(" "),_c('license-table',{attrs:{"isTypeRecentPurchases":"","allItems":_vm.newPurchases,"total":_vm.newPurchasesTotal,"getUpdatedLicenses":_vm.getLicenses}}),_vm._v(" "),_c('b-row',{staticStyle:{"flex-direction":"column"}},[(!_vm.isInternal || (_vm.isInternal && _vm.isPersonInRole))?_c('div',{staticClass:"links-container"},[_c('a',{staticClass:"blue-link",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleWebKeyAllocation.apply(null, arguments)}}},[_vm._v("\n          "+_vm._s(_vm.$t('dontSeeLicenses'))+"\n        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"links-container"},[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.modalName),expression:"modalName"}],staticClass:"'margin-bottom: 10px', blue-link",attrs:{"href":"#"},on:{"click":_vm.allocateManualSurvey}},[_vm._v("\n          "+_vm._s(_vm.$t('surveyLicense'))+"\n        ")])])]),_vm._v(" "),_c('license-table',{attrs:{"allItems":_vm.expiringLicenses,"total":_vm.expiringLicensesTotal}})],_vm._v(" "),(_vm.isApiCallDone && _vm.newPurchases && _vm.expiringLicenses)?[(_vm.areBothTablesEmpty)?[_c('no-license-activity',{attrs:{"mode":"licenseActivity"}})]:(_vm.newPurchases.length === 0)?[_c('no-license-activity',{attrs:{"mode":"newPurchases"}})]:(_vm.expiringLicenses.length === 0)?[_c('no-license-activity',{attrs:{"mode":"expiringLicenses"}})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.isApiCallDone && _vm.areBothTablesEmpty)?[_c('did-you-know')]:_vm._e(),_vm._v(" "),_c('b-row',{staticStyle:{"flex-direction":"column"}},[(!_vm.loading)?_c('div',{staticClass:"links-container"},[_c('a',{staticClass:"blue-link",attrs:{"href":_vm.renewLicensesUrl,"target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.$t('renewMyLicenses'))+"\n      ")]),_vm._v(" "),_c('span',[_vm._v(" | ")]),_vm._v(" "),_c('a',{staticClass:"blue-link",attrs:{"href":_vm.upgradeLicensesUrl,"target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.$t('upgradeMyLicenses'))+"\n      ")])]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"links-container"},[(_vm.showHardware)?_c('a',{staticClass:"blue-link",attrs:{"href":_vm.hardwareUrl,"target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.$t('viewPendingHardwareReturns'))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.showMetaframe && _vm.showHardware)?_c('span',[_vm._v(" | ")]):_vm._e(),_vm._v(" "),(_vm.showMetaframe)?_c('a',{staticClass:"blue-link",attrs:{"href":_vm.metaframeUrl,"target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.$t('activateCitrixMetaframeXPLicenses'))+"\n      ")]):_vm._e()]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Onny":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PTNS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v1__ = __webpack_require__("gApy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__license_checker_circle__ = __webpack_require__("p4Bc");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseCheckerRenewalChain',
  components: { LicenseCheckerCircle: __WEBPACK_IMPORTED_MODULE_2__license_checker_circle__["a" /* default */] },
  props: {
    grid: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    var _this = this;

    return {
      randomNumberMap: this.grid.reduce(function (acc, cur, i) {
        acc['' + i] = cur.reduce(function (acc1, cur1, j) {
          if (j) {
            acc1['' + (j - 1)] = _this.randomNumber();
          }
          return acc1;
        }, {});
        return acc;
      }, {})
    };
  },

  watch: {
    grid: function grid() {
      this.removeLines();
      this.drawLines();
    }
  },
  mounted: function mounted() {
    this.drawLines();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeLines();
  },
  updated: function updated() {
    this.removeLines();
    this.drawLines();
  },

  methods: {
    getCountItems: function getCountItems(gridList) {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(gridList)).splice(1, gridList.length - 1).map(function (g) {
        if (!g) return [{ ID: __WEBPACK_IMPORTED_MODULE_1_uuid_v1___default()() }];
        return g;
      });
    },
    getLicenseStatus: function getLicenseStatus(status) {
      var capitalizeFirstWord = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!status) return capitalizeFirstWord ? 'Active' : 'none'; // eslint-disable-line
      status = status.replace('bo.constants.lifecycle.status.', '');
      return capitalizeFirstWord ? '' + status[0].toUpperCase() + status.split('').splice(1).join('') : status;
    },
    getItemClasses: function getItemClasses(item) {
      var grid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var classes = ['text-center'];
      if (this.hasChildInSameColumn(this.getCountItems(grid), item.ID)) {
        classes.push('' + item.ID);
      }
      if (!!item.ACTIVATION_COUNT) {
        // eslint-disable-line
        classes.push('item');
      } else {
        classes.push('item no');
      }
      if (item.PARENT_FULFILLMENT) {
        classes.push('is-parent ' + item.PARENT_FULFILLMENT);
      }
      classes.push(this.getColorClass(this.getLicenseStatus(item.LIFECYCLE_STATUS)));
      return classes;
    },
    getColorClass: function getColorClass(status) {
      return {
        rehost: 'rehost',
        none: 'none',
        renew: 'renew',
        return: 'return'
      }[status];
    },
    hasChildInSameColumn: function hasChildInSameColumn(grid, id) {
      return !!grid.find(function (g) {
        return g.PARENT_FULFILLMENT === id;
      }) && !!grid.find(function (g, i) {
        return grid[i + 1] && grid[i + 1].PARENT_FULFILLMENT === g.ID;
      });
    },
    drawLines: function drawLines() {
      var getColorClass = this.getColorClass;
      $('.is-parent').each(function () {
        // eslint-disable-line
        var id = $(this).attr('id'); // eslint-disable-line
        var parentId = $(this).attr('data-parent-id'); // eslint-disable-line
        $().connections({ // eslint-disable-line
          from: '#' + parentId,
          to: '#' + id,
          within: '.renewal .card-deck',
          class: getColorClass($('#' + parentId).attr('data-status')) // eslint-disable-line
        });
        $().connections({ // eslint-disable-line
          from: '#' + parentId,
          to: '.' + parentId,
          within: '.renewal .card-deck',
          class: getColorClass($('#' + parentId).attr('data-status')) // eslint-disable-line
        });
      });
    },
    removeLines: function removeLines() {
      // eslint-disable-next-line
      $('connection').each(function () {
        $(this).remove(); // eslint-disable-line
      });
    },
    randomNumber: function randomNumber() {
      var numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
      return numbers[Math.floor(Math.random() * numbers.length)];
    }
  }
});

/***/ }),

/***/ "Q/Jf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"dyk-container"},[_c('b-col',{attrs:{"sm":"12"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('didYouKnow')))])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('p',[_vm._v("\n      "+_vm._s(_vm.$t('didYouKnowContent'))+"\n      "),_c('a',{attrs:{"href":"#"}},[_c('b',[_vm._v(_vm._s(_vm.$t('learnMore')))])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QXW8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({ name: 'DidYouKnow' });

/***/ }),

/***/ "Qai8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseCheckerHeader',
  data: function data() {
    return {
      searchInput: ''
    };
  },
  methods: {
    handleSearchKeypress: function handleSearchKeypress(event) {
      if (event.key === 'Enter' || event.which === 13) {
        this.emitSearchEvent();
      }
    },
    emitSearchEvent: function emitSearchEvent() {
      var searchInput = this.searchInput;

      if (searchInput !== '') {
        this.$emit('search', searchInput);
      }
    }
  }
});

/***/ }),

/***/ "R0Ks":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R11E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container",style:(_vm.customStyle)},[_c('i',{staticClass:"fa fa-spinner loading-animation fa-3x"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RAvm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showSurveyModal)?[_c('survey-modal',{attrs:{"show-modal":_vm.showModal}})]:_vm._e(),_vm._v(" "),_c('b-modal',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.modalName),expression:"modalName"}],attrs:{"visible":_vm.modal},on:{"hide":_vm.resetAndCloseModal}},[(_vm.errorType === '')?[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"},[_vm._v("\n        "+_vm._s(_vm.returnTitle)+"\n      ")])]:[_c('div',{staticClass:"danger-text",attrs:{"slot":"modal-title"},slot:"modal-title"},[_vm._v("\n        "+_vm._s(_vm.returnTitle)+"\n      ")])],_vm._v(" "),(_vm.currentStep === 1)?_c('b-container',{staticClass:"step",attrs:{"fluid":""}},[_c('b-row',{staticClass:"text-center"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"danger-text",domProps:{"innerHTML":_vm._s(_vm.$t(
              'returnConfirmation',
              { count: _vm.count, hostIds: _vm.hostIds, license: _vm.count === 1 ? _vm.$t('license') : _vm.$tc('licenses', 2) }
            ))}}),_vm._v(" "),_c('h6',{staticClass:"description"},[_vm._v(_vm._s(_vm.$t('returnConfirmationInfo')))])])]),_vm._v(" "),_c('b-row',{staticClass:"text-left"},[_c('div',{staticClass:"col-sm-12 col-md"},[_c('fieldset',{staticClass:"form-group"},[_c('legend',[_vm._v(_vm._s(_vm.$t('selectReason'))+" "),_c('span',{staticClass:"required-colour"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-select',{attrs:{"options":_vm.reasonOptions,"required":""},nativeOn:{"change":function($event){return _vm.onReasonSelect.apply(null, arguments)}},model:{value:(_vm.reasonOption),callback:function ($$v) {_vm.reasonOption=$$v},expression:"reasonOption"}})],1)]),_vm._v(" "),(_vm.showRenameText)?_c('div',[_c('span',{staticClass:"align-left warning-colour",domProps:{"innerHTML":_vm._s(_vm.$t('returnRenameReason', {
                  warningLicenseRehostLink: _vm.UrlBuilder.warningLicenseRehostLink
                }))}})]):_vm._e()])]),_vm._v(" "),(_vm.showOtherInput)?_c('b-row',{staticClass:"text-left pt-3"},[_c('div',{staticClass:"col-sm-12 col-md"},[_c('fieldset',{staticClass:"form-group"},[_c('legend',[_vm._v(_vm._s(_vm.$t('otherReason'))+" "),_c('span',{staticClass:"required-colour"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-input',{model:{value:(_vm.otherReason),callback:function ($$v) {_vm.otherReason=$$v},expression:"otherReason"}})],1)])])]):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"text-left pt-3"},[_c('div',{staticClass:"col-sm-12 col-md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.consent),expression:"consent"}],attrs:{"type":"checkbox","name":"consentCheckbox"},domProps:{"checked":Array.isArray(_vm.consent)?_vm._i(_vm.consent,null)>-1:(_vm.consent)},on:{"change":function($event){var $$a=_vm.consent,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.consent=$$a.concat([$$v]))}else{$$i>-1&&(_vm.consent=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.consent=$$c}}}}),_vm._v("\n                  \n              "),_c('span',{staticClass:"align-left required-colour",domProps:{"innerHTML":_vm._s(_vm.$t('eformlegalTextCheck',  {
                endUserLicenseAgreement: _vm.UrlBuilder.endUserLicenseAgreement,
                rightToAuditCompliance: _vm.UrlBuilder.rightToAuditCompliance
              }))}})])]),_vm._v(" "),_c('b-row'),_vm._v(" "),_c('b-row',{staticStyle:{"padding-top":"30px"}},[_c('div',{staticClass:"col-6"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.modalName),expression:"modalName"}],staticClass:"return-modal-btn btn-c-outline",attrs:{"variant":"primary","size":"lg","title":_vm.$t('returnYes'),"disabled":!_vm.reasonOption || !_vm.consent || (!(_vm.showOtherInput && _vm.otherReason) && _vm.showOtherInput)},on:{"click":_vm.returnLicenses}},[_vm._v("\n            "+_vm._s(_vm.$t('returnYes'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.modalName),expression:"modalName"}],staticClass:"return-modal-btn btn-c-outline",attrs:{"variant":"primary","size":"lg","title":_vm.$t('returnNo')},on:{"click":_vm.resetAndCloseModal}},[_vm._v("\n            "+_vm._s(_vm.$t('returnNo'))+"\n          ")])],1)])],1):(_vm.currentStep === 2)?_c('b-container',{staticClass:"step text-center",attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v(_vm._s(_vm.$t('returnConfirmationLoadingHeader')))]),_vm._v(" "),_c('h6',{staticClass:"description"},[_vm._v(_vm._s(_vm.$t('allocateConfirmationLoadingInfo')))])])]),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-12"},[_c('loading',{attrs:{"customStyle":"padding: 10px;"}})],1)])],1):(_vm.currentStep === 3)?_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('h6',{staticClass:"step description"},[_vm._v(_vm._s(_vm.$t('returnConfirmationFinalInfo', { count: _vm.count })))]),_vm._v(" "),_c('h5',{staticClass:"step danger-text",domProps:{"innerHTML":_vm._s(_vm.$t('returnConfirmationFinalTitle', { hostValue: _vm.hostIds }))}}),_vm._v(" "),_c('span',{staticClass:"align-left",domProps:{"innerHTML":_vm._s(_vm.$t('rehostLegalText', {
              endUserLicenseAgreement: _vm.UrlBuilder.endUserLicenseAgreement,
              rightToAuditCompliance: _vm.UrlBuilder.rightToAuditCompliance
            }))}})])]),_vm._v(" "),_c('b-row',{staticClass:"step",staticStyle:{"padding":"20px 0"}},[_c('div',{staticClass:"col-12"},[_c('b-button',{staticClass:"return-modal-btn btn-c-outline final-btn",attrs:{"variant":"primary","size":"lg"},on:{"click":_vm.resetAndCloseModal}},[_vm._v("\n            "+_vm._s(_vm.$t('closeWindow'))+"\n          ")])],1)])],1):_c('b-container',{staticClass:"step",attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.errorDescription)}})])]),_vm._v(" "),(_vm.errorType === 'data')?_c('b-row',{staticClass:"buttons-container text-center"},[_c('div',{staticClass:"col-12"},[_c('b-button',{staticClass:"secondary-btn",attrs:{"variant":"primary","size":"lg"},on:{"click":_vm.downloadFailedTextFile}},[_vm._v("\n            "+_vm._s(_vm.$t('allocateFailSecondaryButtonText'))+"\n          ")])],1)]):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"})],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RXqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegisterDomainModal__ = __webpack_require__("JGm3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UniconCustomerModal__ = __webpack_require__("KIbN");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'QuickFind',
  props: {
    page: {
      type: String,
      required: true
    },
    hideQuickFind: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'registerdomain-modal': __WEBPACK_IMPORTED_MODULE_4__RegisterDomainModal__["a" /* default */],
    'uniconcustomer-modal': __WEBPACK_IMPORTED_MODULE_5__UniconCustomerModal__["a" /* default */]
  },
  data: function data() {
    return {
      registerdomainModal: false,
      uniconcustomerModal: false
    };
  },

  computed: {
    locale: function locale() {
      var locales = {
        en: 'en-us',
        fr: 'fr-fr',
        de: 'de-de',
        es: 'es-es',
        jp: 'ja-jp',
        zh: 'zh-cn'
      };
      var userLocale = this.$store.getters.person.preferences.locale.split('-')[0];
      return locales[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(locales).includes(userLocale) ? userLocale : 'en'];
    }
  },
  methods: {
    handleQuickFindLinkClick: function handleQuickFindLinkClick(linkType, filterName) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].AppInsights.trackEvent('Quick Find - ' + linkType, {
        page: this.page
      });
      this.$emit('filterClicked', filterName);
    },
    openRegisterDomainModal: function openRegisterDomainModal() {
      this.registerdomainModal = true;
    },
    downloadNonStandardLicense: function downloadNonStandardLicense(nsLicTypeId) {
      var _this = this;

      this.bottle.post(this.UrlBuilder.downloadNonStandardLic(this.$store.getters.nsLicType[nsLicTypeId], this.$store.getters.person.customerId), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.requestBody(this.$store.getters.nsLicType[nsLicTypeId])), { responseType: 'blob' }).then(function (_ref) {
        var data = _ref.data,
            headers = _ref.headers;

        var fileName = _this.getDownloadFilename(headers['content-disposition']);
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].AppInsights.trackEvent('Download action', _this.downloadRequestBody);
        _this.isDownloading = false;

        var contentType = headers['content-type'];

        if (nsLicTypeId === 0 && contentType === 'application/octet-stream') {
          // Special handling for UberAgent (nsLicTypeId = 0)
          var blob = new Blob([data], { type: 'application/octet-stream' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (contentType === 'application/zip') {
          // Standard ZIP handling for other IDs
          var _blob = new Blob([data], { type: 'application/zip' });
          var _link = document.createElement('a');
          _link.href = window.URL.createObjectURL(_blob);
          _link.download = fileName;
          document.body.appendChild(_link);
          _link.click();
          document.body.removeChild(_link);
        } else if (contentType === 'text/html') {
          // Text file handling for other IDs
          __WEBPACK_IMPORTED_MODULE_3_downloadjs___default()(data, fileName, 'text/html');
        } else {
          console.error('Unsupported file type:', contentType);
        }
      }).catch(function (error) {
        _this.loading = false;
        _this.loggly.log({
          errorMessage: 'Failed to download NonStandard License',
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    getDownloadFilename: function getDownloadFilename(string) {
      return string.split('; ')[1].split('=')[1];
    },
    requestBody: function requestBody(nsLicType) {
      if (nsLicType === 'uberAgent') {
        return {
          CustomerId: this.$store.getters.person.customerId,
          ExpiryDate: new Date(this.$store.getters.UberAgentDetails[0].Expiry).toISOString().split('T')[0],
          assetComponentId: this.$store.getters.UberAgentDetails[0].AssetComponentId
        };
      } else if (nsLicType === 'deviceTrustLic') {
        return {
          CustomerId: this.$store.getters.person.customerId,
          ExpiryDate: new Date(this.$store.getters.DeviceTrustDetails[0].Expiry).toISOString().split('T')[0],
          SerialNumber: this.$store.getters.DeviceTrustDetails[0].SerialNumber,
          assetComponentId: this.$store.getters.DeviceTrustDetails[0].AssetComponentId,
          Quantity: this.$store.getters.DeviceTrustDetails[0].Quantity,
          LicenceType: null
        };
      }
    },
    closeRegisterdomainModal: function closeRegisterdomainModal() {
      this.registerdomainModal = false;
    },
    openRegisterdomainModal: function openRegisterdomainModal() {
      this.registerdomainModal = true;
    },
    openUniconCustomerModal: function openUniconCustomerModal() {
      this.uniconcustomerModal = true;
    },
    closeUniconCustomerModal: function closeUniconCustomerModal() {
      this.uniconcustomerModal = false;
    }
  }
});

/***/ }),

/***/ "Rpuj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LicenseLists_vue__ = __webpack_require__("qJsV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e5d701_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LicenseLists_vue__ = __webpack_require__("Oj9N");
function injectStyle (ssrContext) {
  __webpack_require__("9VdD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LicenseLists_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e5d701_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LicenseLists_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SUbk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flatpickr__ = __webpack_require__("VYpO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flatpickr_dist_flatpickr_css__ = __webpack_require__("K4gw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flatpickr_dist_flatpickr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flatpickr_dist_flatpickr_css__);

//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      datepicker: null,
      fromDate: null,
      toDate: null
    };
  },

  props: {
    right: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: null
    },
    format: {
      type: String,
      default: 'm/d/Y'
    }
  },
  mounted: function mounted() {
    var _this = this;

    var formats = {
      'YYYY/MM/DD': 'Y/m/d',
      'DD/MM/YYYY': 'd/m/Y',
      'MM/DD/YYYY': 'm/d/Y'
    };
    this.datepicker = new __WEBPACK_IMPORTED_MODULE_1_flatpickr__["a" /* default */](this.$el, {
      mode: 'range',
      dateFormat: formats[this.format || 'MM/DD/YYYY'],
      static: true,
      defaultDate: this.value,
      onChange: function onChange(_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            f = _ref2[0],
            t = _ref2[1];

        if (f) {
          var date = new Date(f.getFullYear(), f.getMonth(), f.getDate());
          _this.fromDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
        }
        if (t) {
          var _date = new Date(t.getFullYear(), t.getMonth(), t.getDate());
          _this.toDate = new Date(_date.getTime() - _date.getTimezoneOffset() * 60000).toISOString();
        }
        _this.$emit('dateChange', { fromDate: _this.fromDate, toDate: _this.toDate });
      }
    });
  }
});

/***/ }),

/***/ "SXXF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T/7N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('div',{staticClass:"col-7 offset-md-2 top-padding"},[_c('h3',[_vm._v(_vm._s(_vm.$t('resendEmailTitle')))]),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.isApiCallComplete)?_c('div',[_c('fieldset',{staticClass:"form-group"},[_c('legend',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('email')))]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-input',{staticClass:"style-input",attrs:{"size":"lg","state":_vm.emailState},nativeOn:{"blur":function($event){return _vm.handleEmailBlur.apply(null, arguments)}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),(!_vm.emailState && _vm.wasEmailInput)?_c('p',{staticClass:"danger-text"},[_vm._v(_vm._s(_vm.$t('invalidEmailFormat')))]):_vm._e()],1)]),_vm._v(" "),_c('fieldset',{staticClass:"form-group"},[_c('legend',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('licenseCode')))]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-input',{staticClass:"style-input",attrs:{"size":"lg"},model:{value:(_vm.laCode),callback:function ($$v) {_vm.laCode=$$v},expression:"laCode"}})],1)]),_vm._v(" "),(!_vm.UrlBuilder.isInternalUser && !(_vm.$route.params && _vm.$route.params.internal === 'true'))?_c('div',{staticClass:"recaptcha-container"},[_c('vue-recaptcha',{attrs:{"sitekey":'6LeElsEUAAAAALSyQQonPyKb7kcenuaDLUmdodjN'},on:{"verify":_vm.verifyRecaptcha,"expired":_vm.handleRecaptchaExpiry}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 text-center"},[_c('b-button',{staticClass:"cta-btn",attrs:{"variant":"primary","size":"lg","disabled":_vm.isSubmitButtonDisabled || _vm.isSubmitting},on:{"click":_vm.sendEmail}},[_vm._v("\n            "+_vm._s(_vm.isSubmitting ? _vm.$t('submitting') + '...' : _vm.$t('submit'))+"\n          ")])],1)]):_c('div',{staticStyle:{"margin-top":"30px"}},[_c('b-alert',{attrs:{"dismissible":"","variant":_vm.wasApiSuccessful ?(_vm.$route.params.internal==='true'?'success':'success') :(_vm.$route.params.internal==='true'?'danger':'success')},on:{"dismissed":_vm.clearScreen},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v("\n          "+_vm._s(_vm.wasApiSuccessful
              ?(_vm.$route.params.internal === 'true'? _vm.$t('resendEmailSuccessMessage'):_vm.$t('resendEmailExternalMessage'))
              :(_vm.$route.params.internal === 'true'? _vm.$t('resendEmailFailureMessage'):_vm.$t('resendEmailExternalMessage')))+"\n        ")])],1)]),_vm._v(" "),(!_vm.$route.params.internal)?_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"globe-icon-padding"},[_c('span',{staticClass:"m-1 fa fa-globe fa-2x"}),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3 locale-label",attrs:{"options":_vm.langauges,"value-field":"key","text-field":"value","disabled-field":"notEnabled"},nativeOn:{"change":function($event){return _vm.onSelectLocal.apply(null, arguments)}},model:{value:(_vm.selectedLocal),callback:function ($$v) {_vm.selectedLocal=$$v},expression:"selectedLocal"}})],1)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TdaH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UHXU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('search',_vm._b({attrs:{"isAdvancedSearchVisible":_vm.search.showAdvancedSearch},on:{"findLicenseByChange":_vm.handleFindLicenseByChange,"searchInputChange":_vm.handleSearchInputChange,"orderDateChange":_vm.handleOrderDateChange,"licenseTypeChange":_vm.handleLicenseTypeChange,"fromDateChange":_vm.handleFromDateChange,"toDateChange":_vm.handleToDateChange,"advancedSearchButtonClick":_vm.handleAdvancedSearchButtonClick,"onSearchClick":_vm.handleSearchClick}},'search',_vm.search,false))],1),_vm._v(" "),_c('b-row',[_c('quick-find',{attrs:{"page":"License details"},on:{"filterClicked":_vm.handleQuickFindClick}})],1),_vm._v(" "),(_vm.isInternal && !_vm.isPersonInRole)?_c('div',[_c('a',{attrs:{"href":"https://citrix.service-now.com/sp?id=sc_cat_item&sys_id=713158551b8c50500bfeb912cd4bcbab","target":"_blank"}},[_c('b-row',[_c('b-col',{staticClass:"not-permitted-text"},[_c('h5',[_vm._v(_vm._s(_vm.$t('contactCustomerCareReturnInternal')))])])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.hasApiCallFailed)?[_c('something-went-wrong',{attrs:{"text":_vm.$t('licenseDetail')}})]:(_vm.isLoading)?[_c('div',{staticClass:"col"},[_c('loading')],1)]:[_c('b-row',{staticClass:"license-detail-container"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v(_vm._s(_vm.licenseObject.ProductName))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-4"},[_c('b-row',[_c('div',{staticClass:"col-sm-12 col-md-6 col-lg-12 text-center order-md-2 order-lg-1"},[(_vm.isLicenseArchived)?[_c('b-button',{staticClass:"available-allocations-btn",attrs:{"variant":"primary","size":"lg"}},[_vm._v("\n                "+_vm._s(_vm.$t('undoArchive'))+"\n              ")])]:_vm._e(),_vm._v(" "),(_vm.license.remainingUserCount > 0 && !_vm.licenseObject.IsArchived)?[_c('b',{staticClass:"available-allocations-info"},[_vm._v("\n                "+_vm._s(_vm.$t('unallocatedLicenses', {
                  count: _vm.license.remainingUserCount,
                  license: _vm.license.remainingUserCount === 1 ? _vm.$t('license') : _vm.$tc('licenses', 2)
                }))+"\n              ")]),_vm._v(" "),_c('b-button',{staticClass:"available-allocations-btn",attrs:{"variant":"success","size":"lg","disabled":_vm.isInternal && !_vm.isPersonInRole},on:{"click":_vm.handleAllocateClick}},[_vm._v("\n                "+_vm._s(_vm.$t('allocateLicenses'))+"\n              ")])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-6 col-lg-12 order-md-1 order-lg-2"},[_c('div',{staticClass:"card card-body bg-light license-info-container"},[_c('div',[_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('licenseAccessCode')))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.license.SerialNumber))])])]),_vm._v(" "),_c('div',[_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('orderDetails')))]),_c('br'),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(_vm.$tc('orderNumber', 1))+": \n                    "),_c('b',[_vm._v(_vm._s(_vm.getOrderNumber(_vm.license)))])]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('purchased'))+": "),_c('b',[_vm._v(_vm._s(_vm.license.userCount))])]),_c('br'),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(_vm.$t('available'))+": \n                    "),_c('b',{staticClass:"success-text"},[_vm._v(_vm._s(_vm.license.remainingUserCount))])]),_c('br'),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(_vm.$t('purchaseDate'))+": \n                    "),_c('b',[_vm._v(_vm._s(_vm.getReadableDate(_vm.license.deliveryDate)))])]),_c('br'),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(_vm.$t('expirationDate'))+": \n                    "),_c('b',[_vm._v(_vm._s(_vm.getReadableDate(_vm.license.expirationDate)))])]),_c('br'),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(_vm.$t('purchasedBy'))+": \n                    "),_c('b',[_vm._v(_vm._s(_vm.purchasedBy))])]),_vm._v(" "),_c('br')])])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-8"},[_c('b-row',[_c('div',{staticClass:"col-sm-12 col-md-4 d-block d-lg-none"},[_c('b-select',{staticStyle:{"margin-bottom":"20px"},attrs:{"options":_vm.renderOptions,"size":"lg"},model:{value:(_vm.renderOption),callback:function ($$v) {_vm.renderOption=$$v},expression:"renderOption"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-4 col-lg-12 d-none d-lg-block"},[_c('span',{class:_vm.getTabButtonClass('allocations')},[_c('span',{on:{"click":function($event){_vm.renderOption = 'allocations'}}},[_vm._v("\n                "+_vm._s(_vm.$t('allocations'))+"\n              ")]),_vm._v(" "),(_vm.renderOption === 'allocations')?_c('div',{staticClass:"triangle"}):_vm._e()]),_vm._v(" "),_c('span',{class:_vm.getTabButtonClass('notes')},[_c('span',{on:{"click":function($event){_vm.renderOption = 'notes'}}},[_vm._v("\n                "+_vm._s(_vm.$t('notes'))+"\n              ")]),_vm._v(" "),(_vm.renderOption === 'notes')?_c('div',{staticClass:"triangle"}):_vm._e()]),_vm._v(" "),_c('span',{class:_vm.getTabButtonClass('activityLog')},[_c('span',{on:{"click":function($event){_vm.renderOption = 'activityLog'}}},[_vm._v("\n                "+_vm._s(_vm.$t('activityLog'))+"\n              ")]),_vm._v(" "),(_vm.renderOption === 'activityLog')?_c('div',{staticClass:"triangle"}):_vm._e()]),_vm._v(" "),_c('hr',{staticClass:"tab-underline"})]),_vm._v(" "),(_vm.shouldShowActionsDropdown)?[_c('div',{staticClass:"col-sm-12 col-md-8"},[_c('b-select',{ref:"actionDropdown",staticClass:"action-options",attrs:{"options":_vm.actionOptions,"size":"lg","disabled":_vm.selectedFulfillments.length === 0 || _vm.hasError || _vm.hasNoRecords || (_vm.isInternal && !_vm.isPersonInRole),"title":_vm.actionsDropdownTitleText},nativeOn:{"change":function($event){return _vm.handleActionSelection.apply(null, arguments)}},model:{value:(_vm.actionOption),callback:function ($$v) {_vm.actionOption=$$v},expression:"actionOption"}})],1)]:_vm._e()],2),_vm._v(" "),(_vm.renderOption === 'allocations')?_c('b-row',[(_vm.license.remainingUserCount !== _vm.license.userCount)?_c('div',{staticClass:"col-sm-12"},[_c('b-row',{staticClass:"table-header vertical-padding"},[_c('div',{staticClass:"col checkbox-col"},[_c('b-checkbox',{on:{"change":_vm.toggleAllLicensesSelection},model:{value:(_vm.areAllLicensesSelected),callback:function ($$v) {_vm.areAllLicensesSelected=$$v},expression:"areAllLicensesSelected"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-row',[_c('div',{staticClass:"col allocate-col"},[_vm._v(_vm._s(_vm.$t('allocated')))]),_vm._v(" "),_c('div',{staticClass:"col d-none d-md-block d-lg-block"},[_vm._v("\n                    "+_vm._s(_vm.$tc('hostId', 1))+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"col download-col header text-center"},[_vm._v("\n                    "+_vm._s(_vm.$t('licenseFile'))+"\n                  ")])])],1)]),_vm._v(" "),_vm._l((_vm.fulfillmentList),function(fulfillmentListItem,i){return [_c('div',{key:("" + (fulfillmentListItem.hostIDValue) + i),staticClass:"col-12"},[_c('b-row',{class:("table-row vertical-padding " + (i % 2 === 1 ? 'odd-row' : ''))},[_c('div',{staticClass:"col checkbox-col"},[_c('b-checkbox',{class:_vm.isLicenseInvalid(fulfillmentListItem) ? 'error-checkbox' : '',attrs:{"checked":_vm.isLicenseSelected(fulfillmentListItem)},on:{"change":function($event){return _vm.toggleLicenseSelection(fulfillmentListItem)}}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-row',[_c('div',{staticClass:"col allocate-col"},[_vm._v("\n                        "+_vm._s(fulfillmentListItem.fulfilledQuantity)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"col d-none d-md-block d-lg-block"},[_vm._v("\n                        "+_vm._s(fulfillmentListItem.hostIDValue)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"col download-col text-center"},[_c('button',{staticClass:"download-icon-button",on:{"click":function($event){return _vm.downloadLicense(fulfillmentListItem, true)}}},[_c('i',{staticClass:"fa fa-download"})])])])],1)])],1)]}),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-md-6 export-link-container"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleExportClick.apply(null, arguments)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('exportToExcel'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-center"},[_c('div',{staticClass:"pagination-container"},[_c('b-pagination',{attrs:{"prev-text":_vm.$t('paginationPrevText'),"next-text":_vm.$t('paginationNextText'),"hide-goto-end-buttons":"","total-rows":_vm.license.fulfillmentList.length,"per-page":_vm.pageSize},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])],2):_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"empty-state-text"},[(_vm.licenseObject.IsArchived)?[_c('p',[_vm._v(_vm._s(_vm.$t('hiddenLicenseEmptyStateMessage')))])]:[_c('p',[_vm._v("\n                  "+_vm._s(_vm.$t('licenseAllocationTextPrefix', {
                      available: _vm.license.remainingUserCount,
                      total: _vm.license.userCount,
                      license: _vm.license.userCount === 1 ? _vm.$t('license') : _vm.$tc('licenses', 2)
                    }))+"\n                  "),(_vm.license.remainingUserCount && _vm.license.userCount)?[_c('span',[_vm._v(_vm._s(_vm.$t('licenseAllocationTextSuffix')))])]:_vm._e()],2)]],2)])]):_vm._e(),_vm._v(" "),(_vm.renderOption === 'notes')?_c('b-row',[_c('notes',{attrs:{"licenseId":_vm.license.orderID,"AssetID":_vm.license.AssetID}})],1):_vm._e(),_vm._v(" "),(_vm.renderOption === 'activityLog')?_c('b-row',{staticClass:"remove-default-row-margin"},[_c('activity-log',{attrs:{"licenseId":_vm.licenseId,"purchaseDate":_vm.license.deliveryDate,"hostIdType":_vm.license.hostIDType}})],1):_vm._e()],1)])],_vm._v(" "),_c('modify-allocation-modal',{attrs:{"modal":_vm.modifyModal,"toggleModal":_vm.closeModifyModal,"selectedLicenses":_vm.selectedLicenses,"allowPartial":_vm.licenseObject.AllowpartialAllocation}}),_vm._v(" "),_c('allocation-modal',{attrs:{"modal":_vm.allocateModal,"closeModal":_vm.closeAllocateModal,"openModal":_vm.openAllocateModel,"selectedLicenses":_vm.selectedLicenses,"getUpdatedLicenses":_vm.getUpdatedInfo}}),_vm._v(" "),_c('return-allocation-modal',{attrs:{"isFromDetailPage":"","modal":_vm.returnModal,"closeModal":_vm.closeReturnModal,"selectedLicenses":_vm.selectedLicenses}}),_vm._v(" "),_c('error-modal',{attrs:{"modal":_vm.errorModal,"closeModal":_vm.closeErrorModal,"errorType":_vm.errorModalType,"handleCtaClick":_vm.errorModalCtaClickHandler}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UJ5i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray__ = __webpack_require__("7nRM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HideUnhideModal',
  props: {
    modal: { type: Boolean, required: true },
    closeModal: { type: Function, required: true },
    selectedLicenses: { type: Array, required: true },
    type: { type: String, required: true },
    onSuccessfulAction: { type: Function, required: true }
  },
  computed: {
    typeText: function typeText() {
      return this.type === 'hide' ? this.$tc('hide', 2) : this.$tc('unhide', 2);
    },
    loggedInUser: function loggedInUser() {
      return this.$store.getters.authToken.userName || '';
    },
    hideUnhideLicensesModalDescription: function hideUnhideLicensesModalDescription() {
      return this.type === 'hide' ? this.$t('hideLicensesModalDescription') : this.$t('unhideLicensesModalDescription');
    }
  },
  methods: {
    capitalizeWord: function capitalizeWord(_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default()(_ref),
          firstChar = _ref2[0],
          rest = _ref2.slice(1);

      return '' + firstChar.toUpperCase() + rest.join('');
    },
    performHideUnhide: function performHideUnhide() {
      var _this = this;

      this.bottle.post(this.UrlBuilder.archiveLicensesUrl, this.selectedLicenses.map(function (l) {
        return {
          SerialNumber: l.ActivationID,
          loggedInUser: _this.loggedInUser,
          customerID: _this.$store.getters.person.customerId,
          ProductName: l.ProductName,
          Action: _this.type === 'hide' ? 'archive' : 'unarchive'
        };
      })).then(function (_ref3) {
        var data = _ref3.data;

        _this.onSuccessfulAction(true);
        _this.closeModal();
      }).catch(function (error) {
        _this.loggly.log({
          errorMessage: 'License ' + _this.type + 'ing failed',
          errorObject: error,
          errorStack: error.stack
        });
        _this.closeModal();
      });
    }
  }
});

/***/ }),

/***/ "Uggu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_body_vue__ = __webpack_require__("a9Vp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67cac45c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_body_vue__ = __webpack_require__("fWJX");
function injectStyle (ssrContext) {
  __webpack_require__("zjmz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_body_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67cac45c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_body_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VJ4V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"survey-license-modal","visible":_vm.showModal,"scrollable":"","title":"Licensing Survey","hide-footer":"","no-close-on-backdrop":""},on:{"hide":_vm.closeModal1},scopedSlots:_vm._u([{key:"modal-header",fn:function(){return [_c('div',[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.$t('Licensing Survey')))])]),_vm._v(" "),_c('div',[_c('b-button-close',{on:{"click":_vm.closeModal1}})],1)]},proxy:true}])},[_vm._v(" "),_c('b-embed',{attrs:{"type":"iframe","aspect":"4by3","src":_vm.getSurveyUrlBasedOnProduct}}),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"justify-content":"center","align-items":"center"}},[(_vm.surveyNotCompleted)?_c('div',{staticStyle:{"justify-content":"center"}},[_c('p',{staticStyle:{"color":"red"}},[_vm._v("Please submit the Survey")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"justify-content":"right"}},[_c('a',{ref:"dontShow",staticClass:"danger-text",attrs:{"href":"#"},on:{"click":_vm.closeModal1}},[_vm._v("\n          "+_vm._s(_vm.$t('cancel'))+"\n        ")])])])]),_vm._v(" "),(_vm.endOfSurvey)?_c('div',[_c('h1',[_vm._v("Success")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WbYt":
/***/ (function(module, exports) {

/* eslint-disable */
;(function () {
  ;(function (p, e, n, d, o) {
    var v, w, x, y, z;
    o = p[d] = p[d] || {};
    o._q = [];
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
    for (w = 0, x = v.length; w < x; ++w) {
      ;(function (m) {
        o[m] = o[m] || function () {
          o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
        };
      })(v[w]);
    }
    y = e.createElement(n);
    y.async = !0;
    y.src = './static/pendo.js';
    z = e.getElementsByTagName(n)[0];
    z.parentNode.insertBefore(y, z);
  })(window, document, 'script', 'pendo');
})();
/* eslint-disable */

/***/ }),

/***/ "WheD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseCheckerRenewalOrderDetails',
  props: {
    data: { type: Array, default: function _default() {
        return [];
      } },
    height: { type: String, default: '' }
  },
  data: function data() {
    return {
      renewalOrderStyle: {}
    };
  },
  mounted: function mounted() {},

  watch: {
    height: function height(newval, oldval) {
      this.$set(this.renewalOrderStyle, 'height', this.height + 'px');
      this.$set(this.renewalOrderStyle, 'overflow-y', 'auto');
    }
  }
});

/***/ }),

/***/ "Wyfo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XBkc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"search-container"},[_c('div',{class:("col-12 " + (_vm.shouldShowClearSearch ? 'col-md-8' : ''))},[_c('h5',{staticClass:"search-title"},[_vm._v(_vm._s(_vm.$t('findLicenseBy')))])]),_vm._v(" "),(_vm.shouldShowClearSearch)?_c('div',{staticClass:"col-12 col-md-4 text-right"},[_c('a',{staticClass:"clear-search",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('clearSearchClick')}}},[_vm._v("\n        "+_vm._s(_vm.$t('clearSearch'))+"\n      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 order-md-1"},[_c('b-select',{staticClass:"search-options",attrs:{"value":_vm.findLicenseByOption,"options":_vm.findLicenseByOptions,"size":"lg"},on:{"change":function($event){return _vm.$emit('findLicenseByChange', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-5 order-md-2"},[_c('b-form-input',{staticClass:"search-input",attrs:{"value":_vm.searchInput,"size":"lg"},on:{"input":_vm.handleSearchInput},nativeOn:{"keypress":function($event){return _vm.handleKeypress.apply(null, arguments)}}})],1),_vm._v(" "),(_vm.isAdvancedSearchVisible)?_c('div',{staticClass:"col-12 advanced-search-container order-md-4"},[_c('b-row',[_c('div',{staticClass:"col-12 col-md-4"},[_c('b-select',{staticClass:"advanced-search-options",attrs:{"value":_vm.dateOption,"options":_vm.dateOptions,"size":"lg"},on:{"change":function($event){return _vm.$emit('orderDateChange', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('b-row',[_c('div',{staticClass:"col-6"},[_c('datepicker',{staticClass:"form-control form-control-lg",attrs:{"input-class":"form-control form-control-lg","placeholder":_vm.$t('from'),"value":_vm.fromDateValue,"disabledDates":_vm.disabledDatesFrom,"format":_vm.setDateFormat},on:{"selected":function($event){return _vm.$emit('fromDateChange', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-6 to-datepicker"},[_c('datepicker',{staticClass:"form-control form-control-lg",attrs:{"input-class":"form-control form-control-lg","placeholder":_vm.$t('to'),"value":_vm.toDateValue,"disabledDates":_vm.disabledDatesTo,"disabled":_vm.fromDateValue === '',"format":_vm.setDateFormat},on:{"selected":function($event){return _vm.$emit('toDateChange', $event)}}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('b-select',{staticClass:"advanced-search-options-type",attrs:{"disabled":_vm.isFromAllAssetsPage,"value":_vm.licenseTypeOption,"options":_vm.licenseTypeOptions,"size":"lg"},on:{"change":function($event){return _vm.$emit('licenseTypeChange', $event)}}})],1)])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 order-md-3"},[_c('b-button',{attrs:{"variant":"outline-primary search-btn","size":"lg","disabled":_vm.isSearchDisabled},on:{"click":function($event){return _vm.$emit('onSearchClick')}}},[_vm._v("\n        "+_vm._s(_vm.$t('search'))+"\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 advanced-option-link-container order-md-4"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleAdvancedSearchButtonClick.apply(null, arguments)}}},[_vm._v("\n        "+_vm._s(_vm.advancedOptionsLinkText)+"\n      ")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XCYW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"visible":_vm.modal},on:{"hide":_vm.closeModal}},[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"},[_vm._v("\n    "+_vm._s(_vm.$t('hideUnhideLicenses', { typeText: _vm.capitalizeWord(_vm.typeText) }))+"\n  ")]),_vm._v(" "),_c('b-container',{staticClass:"text-center",attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"title"},[_vm._v("\n          "+_vm._s(_vm.$t('hideUnhideLicensesModalTitle', {
            count: this.selectedLicenses.length,
            typeText: _vm.typeText,
            license: this.selectedLicenses.length === 1 ? _vm.$t('license') : _vm.$tc('licenses', 2)
          }))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n          "+_vm._s(_vm.hideUnhideLicensesModalDescription)+"\n        ")])])]),_vm._v(" "),_c('b-row',{staticStyle:{"padding-top":"30px"}},[_c('div',{staticClass:"col-6"},[_c('b-button',{staticClass:"hide-modal-btn btn-c-outline",attrs:{"variant":"primary","size":"lg"},on:{"click":_vm.performHideUnhide}},[_vm._v("\n          "+_vm._s(_vm.$t('yes'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('b-button',{staticClass:"hide-modal-btn btn-c-outline",attrs:{"variant":"primary","size":"lg"},on:{"click":_vm.closeModal}},[_vm._v("\n          "+_vm._s(_vm.$t('no'))+"\n        ")])],1)])],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XFF7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_renewal_order_details_vue__ = __webpack_require__("WheD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68074c62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_renewal_order_details_vue__ = __webpack_require__("KVg4");
function injectStyle (ssrContext) {
  __webpack_require__("fIjG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_renewal_order_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68074c62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_renewal_order_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y3bG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_json2csv__ = __webpack_require__("GtXM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_json2csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_json2csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SomethingWentWrong__ = __webpack_require__("cFPt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Notes__ = __webpack_require__("jPU1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ActivityLog__ = __webpack_require__("ctTL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_SearchMixin__ = __webpack_require__("x/Xg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_DateFormatMixin__ = __webpack_require__("fgSf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AllocationModal__ = __webpack_require__("CeJl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ReturnAllocationModal__ = __webpack_require__("8Zaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ModifyAllocationModal__ = __webpack_require__("tKwA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ErrorModal__ = __webpack_require__("eKWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SurveyModal__ = __webpack_require__("F6yq");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















var parseCsv = __WEBPACK_IMPORTED_MODULE_6_json2csv___default.a.parse;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'License',
  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_SearchMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_DateFormatMixin__["a" /* default */]],
  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_8__Loading__["a" /* default */],
    'something-went-wrong': __WEBPACK_IMPORTED_MODULE_9__SomethingWentWrong__["a" /* default */],
    'notes': __WEBPACK_IMPORTED_MODULE_10__Notes__["a" /* default */],
    'activity-log': __WEBPACK_IMPORTED_MODULE_11__ActivityLog__["a" /* default */],
    'allocation-modal': __WEBPACK_IMPORTED_MODULE_14__AllocationModal__["a" /* default */],
    'modify-allocation-modal': __WEBPACK_IMPORTED_MODULE_16__ModifyAllocationModal__["a" /* default */],
    'return-allocation-modal': __WEBPACK_IMPORTED_MODULE_15__ReturnAllocationModal__["a" /* default */],
    'error-modal': __WEBPACK_IMPORTED_MODULE_17__ErrorModal__["a" /* default */],
    'f': __WEBPACK_IMPORTED_MODULE_18__SurveyModal__["a" /* default */]
  },
  mounted: function mounted() {
    this.getUpdatedInfo();
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].AppInsights.trackPageView('License details page', '/licence/' + this.licenseId);
  },
  data: function data() {
    return {
      isInternal: window.location.host.includes('citrite.net'),
      currentPage: 1,
      pageSize: 5,
      license: {
        activationID: '',
        AssetID: '',
        productName: '',
        deliveryDate: '',
        versionDate: '',
        userCount: 0,
        remainingCount: 0,
        hostIDType: '',
        expirationDate: '',
        orderID: '',
        SAPSalesOrderNumber: '',
        licenseItemNumber: '',
        hostIDValue: '',
        isFullAllocation: '',
        isArchived: '',
        purchasedBy: '',
        fulfillmentList: []
      },
      selectedFulfillments: [],
      areAllLicensesSelected: false,
      hasError: false,
      notesInput: '',
      renderOption: 'allocations',
      renderOptions: [{ value: 'allocations', text: this.$t('allocations') }, { value: 'notes', text: this.$t('notes') }, { value: 'activityLog', text: this.$t('activityLog') }],
      actionOption: '',
      isLoading: true,
      hasApiCallFailed: false,
      allocateModal: false,
      modifyModal: false,
      errorModal: false,
      errorModalType: '',
      returnModal: false,
      showSurveyModalProp: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['isPersonInRole', 'isSurveyModalInteracted', 'isSurveyModalInteractedXS', 'showSurveyModal', 'validXSSurveyURL']), {
    purchasedBy: function purchasedBy() {
      var purchasedBy = this.license.purchasedBy;
      return purchasedBy === null || purchasedBy === 'NA' || purchasedBy === 'N/A' || purchasedBy === 'N.A' ? this.$t('notAvailable') : purchasedBy;
    },
    actionOptions: function actionOptions() {
      var dummyOption = { value: '', text: this.$t('selectAnAction'), disabled: true };
      var actionOptions = [{ value: 'downloadLicenseFiles', text: this.$tc('downloadLicenseFiles', 2) }, { value: 'modifyAllocations', text: this.$t('modifyAllocations') }, { value: 'returnAllocations', text: this.$t('returnAllocations') }];
      return [dummyOption].concat(actionOptions);
    },
    fulfillmentList: function fulfillmentList() {
      var startIndex = (this.currentPage - 1) * this.pageSize;
      var endIndex = this.currentPage * this.pageSize;
      return this.license.fulfillmentList.slice(startIndex, endIndex);
    },
    isLicenseArchived: function isLicenseArchived() {
      // Write logic for finding if a license is archived here.
      // Return true or false temporarily
      return this.license.isArchived || false;
    },
    isLicenseExpiring: function isLicenseExpiring() {
      // Write logic for determining if a license is renewable here.
      // Using expiring licenses logic temporarily
      var dayDifference = __WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date(this.license.expirationDate)).diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(), 'days') + 1;
      dayDifference = Math.abs(dayDifference);
      return dayDifference < 30 || dayDifference > 30 && dayDifference < 90;
    },
    shouldShowActionsDropdown: function shouldShowActionsDropdown() {
      return this.renderOption === 'allocations' && this.license.remainingUserCount !== this.license.userCount;
    },
    licenseId: function licenseId() {
      return this.$route.params.licenseId;
    },
    orderNumberFromCode: function orderNumberFromCode() {
      return this.licenseId.match(/^.*-(.*)-.*/)[1];
    },
    licenseObject: function licenseObject() {
      return this.$store.getters.licenseDetails;
    },
    loggedInUserName: function loggedInUserName() {
      return this.$store.getters.authToken.userName || '';
    },
    loggedInUserPersonID: function loggedInUserPersonID() {
      return this.$store.getters.authToken.personId || '';
    },
    fulfillmentID: function fulfillmentID() {
      return this.selectedFulfillments[0] ? this.selectedFulfillments[0].fulfillmentID : '';
    },
    selectedLicenses: function selectedLicenses() {
      return [{
        ActivationID: this.license.activationID,
        HostType: this.license.hostIDType,
        RemainingUserCount: this.license.remainingUserCount,
        OrderID: this.license.orderID,
        SerialNumber: this.license.SerialNumber,
        AssetID: this.license.AssetID,
        LicenseItemNumber: this.license.licenseItemNumber,
        ProductName: this.licenseObject.ProductName,
        UserCount: this.license.userCount,
        FulfillmentID: this.fulfillmentID,
        Fulfillments: this.selectedFulfillments
      }];
    },
    errorModalCtaClickHandler: function errorModalCtaClickHandler() {
      var _this = this;

      var closeModalAndProceed = function closeModalAndProceed(value) {
        _this.closeErrorModal();
        _this.handleActionSelection({ target: { value: value } });
      };
      switch (this.errorModalType) {
        case 'return':
          return function () {
            _this.selectedLicenses = _this.selectedLicenses.filter(function (l) {
              return l.UserCount !== l.RemainingUserCount;
            });
            closeModalAndProceed('returnAllocations');
          };
        default:
          return function () {};
      }
    },
    actionsDropdownTitleText: function actionsDropdownTitleText() {
      if (this.licenseObject.IsArchived) return this.$t('hiddenLicenseEmptyStateMessage');
      if (this.selectedFulfillments.length === 0) return this.$t('noSelectionInfoText');
      return '';
    },
    downloadRequestBody: function downloadRequestBody() {
      return [{
        activationID: this.license.activationID,
        customerId: this.$store.getters.person.customerId,
        hostId: this.selectedFulfillments.map(function (l) {
          return l.hostIDValue;
        }),
        hostType: this.license.hostIDType,
        loggedInUserName: this.loggedInUserName,
        loggedInUserPersonID: this.$store.getters.person.id,
        action: 'Redownload',
        licenseLineItemNumber: this.license.licenseItemNumber,
        productName: this.licenseObject.ProductName,
        assetID: this.license.AssetID
      }];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapMutations */])(['VALID_SURVEY_DATA', 'SHOW_SURVEY_MODAL', 'SHOW_SURVEY_MODAL_XS', 'VALID_SURVEY_DATA_XS']), {
    validateMultipleSelection: function validateMultipleSelection() {
      var hostType = void 0;
      if (!this.selectedFulfillments.length) return;
      hostType = this.selectedFulfillments[0].hostIDType;
      this.selectedFulfillments = this.selectedFulfillments.map(function (l) {
        if (l.hostIDType === hostType) {
          delete l.isValid;
          return l;
        } else {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, l, { isValid: false });
        }
      });
      this.hasError = this.selectedFulfillments.some(function (l) {
        return l.hasOwnProperty('isValid');
      });
    },
    isLicenseInvalid: function isLicenseInvalid(license) {
      return (this.isLicenseSelected(license, true) || {}).hasOwnProperty('isValid');
    },
    isLicenseSelected: function isLicenseSelected(license) {
      var returnItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selectedLicense = this.selectedFulfillments.find(function (val) {
        return val.fulfillmentID === license.fulfillmentID;
      });
      return returnItem ? selectedLicense : !!selectedLicense;
    },
    calculateDayDifference: function calculateDayDifference(date) {
      var expiring = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var isDateLessThanToday = void 0,
          from = void 0,
          to = void 0,
          number = void 0;
      number = expiring ? 0 : 1;
      date = new Date(date);
      date = date.setTime(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
      isDateLessThanToday = Date.now() < new Date(date).getTime();
      if (__WEBPACK_IMPORTED_MODULE_5_moment___default()().isSame(__WEBPACK_IMPORTED_MODULE_5_moment___default()(date), 'day')) {
        return 0;
      }
      if (expiring && !isDateLessThanToday) {
        return -1;
      }
      from = isDateLessThanToday ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(date) : __WEBPACK_IMPORTED_MODULE_5_moment___default()();
      to = isDateLessThanToday ? __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(1, 'days') : __WEBPACK_IMPORTED_MODULE_5_moment___default()(date);
      return from.diff(to, 'days') + number;
    },
    toggleAllLicensesSelection: function toggleAllLicensesSelection() {
      this.selectedFulfillments = this.areAllLicensesSelected ? [] : [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.fulfillmentList));
      this.validateMultipleSelection();
    },
    toggleLicenseSelection: function toggleLicenseSelection(license) {
      if (!this.selectedFulfillments.length || !this.isLicenseSelected(license)) {
        this.selectedFulfillments.push(license);
      } else {
        this.selectedFulfillments = this.selectedFulfillments.filter(function (l) {
          return l.fulfillmentID !== license.fulfillmentID;
        });
      }
      this.areAllLicensesSelected = this.selectedFulfillments.length === this.license.fulfillmentList.length;
      this.validateMultipleSelection();
    },
    handleAdvancedSearchButtonClick: function handleAdvancedSearchButtonClick(showAdvancedSearch) {
      this.search.showAdvancedSearch = showAdvancedSearch;
    },
    handleSearchClick: function handleSearchClick() {
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].AppInsights.trackEvent(this.search.showAdvancedSearch ? 'Advanced search' : 'Search', {
        eventType: 'click',
        searchInput: this.search.searchInput,
        searchType: this.search.findLicenseByOption,
        page: 'License details'
      });
      this.$router.push({
        name: 'AllLicenses',
        params: {
          search: this.search,
          isAdvancedSearchVisible: this.search.showAdvancedSearch
        }
      });
    },
    getTabButtonClass: function getTabButtonClass(renderOption) {
      return [{
        'tab-btn': true,
        'primary-text': this.renderOption !== renderOption,
        'disabled-text': this.renderOption === renderOption
      }];
    },
    getReadableDate: function getReadableDate(date) {
      var validDate = new Date(date);
      if (Date.parse(validDate) === 'NaN') {
        return this.$t('notApplicable');
      }
      var temp = __WEBPACK_IMPORTED_MODULE_5_moment___default.a.utc(date).format(this.getDateFormatBasedOnLocale());
      var year = validDate.getFullYear();
      return year < 2 ? this.$t('notApplicable') : temp;
    },
    handleQuickFindClick: function handleQuickFindClick(filterName) {
      this.$router.push({
        name: 'AllLicenses',
        params: {
          quickFind: filterName
        }
      });
    },
    getOrderNumber: function getOrderNumber(_ref) {
      var SAPSalesOrderNumber = _ref.SAPSalesOrderNumber,
          licenseItemNumber = _ref.licenseItemNumber;

      return !licenseItemNumber ? SAPSalesOrderNumber || this.orderNumberFromCode : (SAPSalesOrderNumber || this.orderNumberFromCode) + '/' + licenseItemNumber;
    },
    handleExportClick: function handleExportClick() {
      var data = this.license.fulfillmentList.map(this.cleanObject);
      var fields = data.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data[0]) : [];
      try {
        __WEBPACK_IMPORTED_MODULE_7_downloadjs___default()(parseCsv(data, { fields: fields }), 'licenses.csv', 'application/octet-stream');
      } catch (error) {
        this.loggly.log({
          errorMessage: 'Error parsing CSV in license details page',
          errorObject: error,
          errorStack: error.stack
        });
      }
    },
    cleanObject: function cleanObject(objectToClean) {
      return {
        fulfillmentID: this.cleanData(objectToClean.fulfillmentID),
        hostIDValue: this.cleanData(objectToClean.hostIDValue),
        hostIDType: this.cleanData(objectToClean.hostIDType),
        fulfilledQuantity: this.cleanData(objectToClean.fulfilledQuantity),
        parentFulfillmentID: this.cleanData(objectToClean.parentFulfillmentID)
      };
    },
    cleanData: function cleanData(dataToClean) {
      var checkRegex = '^[=+\\-@].*';
      return dataToClean.length > 0 ? dataToClean.match(checkRegex) ? '\'' + dataToClean : dataToClean : dataToClean;
    },
    handleActionSelection: function handleActionSelection(_ref2) {
      var action = _ref2.target.value;

      switch (action) {
        case 'downloadLicenseFiles':
          this.downloadLicense();
          break;
        case 'modifyAllocations':
          this.modifyModal = true;
          break;
        case 'returnAllocations':
          if (this.selectedLicenses.some(function (l) {
            return l.UserCount === l.RemainingUserCount;
          })) {
            this.errorModal = true;
            this.errorModalType = 'return';
            break;
          }
          if (this.selectedLicenses.length > 0) {
            this.returnModal = true;
          }
          break;
        default:
          break;
      }
    },
    resetActionOption: function resetActionOption() {
      var clearLicenses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (clearLicenses) {
        this.selectedFulfillments = [];
      }
      this.areAllLicensesSelected = false;
      this.actionOption = '';
      if (this.$refs.actionDropdown) {
        this.$refs.actionDropdown.localValue = '';
      }
    },
    downloadLicense: function downloadLicense(licence) {
      var _this2 = this;

      var directDownload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (directDownload) {
        this.selectedFulfillments = [licence];
      }
      this.bottle.post(this.UrlBuilder.getDownloadUrl(), this.downloadRequestBody, {
        responseType: 'arraybuffer'
      }).then(function (_ref3) {
        var data = _ref3.data,
            headers = _ref3.headers;

        var fileName = _this2.getDownloadFilename(headers['content-disposition']);
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].AppInsights.trackEvent('Download action', _this2.downloadRequestBody);
        switch (headers['content-type']) {
          case 'application/zip':
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([data], { type: 'application/zip' }));
            link.download = fileName;
            link.click();
            break;
          case 'text/html':
            __WEBPACK_IMPORTED_MODULE_7_downloadjs___default()(data, fileName, 'text/html');
            break;
          default:
            break;
        }
        _this2.showModal = true;
        _this2.resetActionOption();
      }).catch(function (error) {
        _this2.loggly.log({
          errorMessage: 'License download failed',
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    handleAllocateClick: function handleAllocateClick() {
      console.log('handle allocate click', this.showModal);
      console.log('selectedLicenses: ', this.selectedLicenses);
      if (this.selectedLicenses.some(function (item) {
        return item.ProductName.includes('XenServer');
      }) && this.validXSSurveyURL) {
        if (!this.isSurveyModalInteractedXS) {
          this.SHOW_SURVEY_MODAL_XS(true);
          this.SHOW_SURVEY_MODAL(false);
          this.allocateModal = false;
        } else {
          this.allocateModal = true;
          this.SHOW_SURVEY_MODAL_XS(false);
          this.SHOW_SURVEY_MODAL(false);
        }
      } else {
        this.allocateModal = true;
        this.SHOW_SURVEY_MODAL(false);
        this.SHOW_SURVEY_MODAL_XS(false);
      }
    },
    closeAllocateModal: function closeAllocateModal() {
      this.allocateModal = false;
      this.resetActionOption();
      this.getUpdatedInfo();
    },
    openAllocateModel: function openAllocateModel() {
      this.allocateModal = true;
      this.SHOW_SURVEY_MODAL_XS(false);
      this.SHOW_SURVEY_MODAL(false);
    },
    closeReturnModal: function closeReturnModal() {
      this.returnModal = false;
      this.resetActionOption();
      this.getUpdatedInfo();
    },
    closeModifyModal: function closeModifyModal() {
      this.modifyModal = false;
      this.resetActionOption();
      this.getUpdatedInfo();
    },
    getUpdatedInfo: function getUpdatedInfo() {
      var _this3 = this;

      var licenseId = this.$route.params.licenseId;

      this.isLoading = true;
      this.bottle.post(this.UrlBuilder.allLicensesUrl, {
        CustomerID: this.$store.getters.person.customerId,
        Duration: 0,
        NoOfItems: 0,
        PageNumber: 1,
        PageIndex: 0
      }).then(function () {
        return _this3.bottle.get(_this3.UrlBuilder.licenseDetailUrl(_this3.$store.getters.person.customerId, _this3.licenseId));
      }).then(function (_ref4) {
        var data = _ref4.data;

        _this3.license = data;
        _this3.isLoading = false;
      }).catch(function (error) {
        _this3.isLoading = false;
        _this3.hasApiCallFailed = true;
        _this3.loggly.log({
          errorMessage: 'Failed to fetch license with ID: ' + licenseId,
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    getDownloadFilename: function getDownloadFilename(string) {
      return string.split('; ')[1].split('=')[1];
    },
    closeErrorModal: function closeErrorModal() {
      this.errorModal = false;
      this.resetActionOption(false);
    }
  })
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LicenseLists__ = __webpack_require__("Rpuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_About__ = __webpack_require__("c27y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AllLicenses__ = __webpack_require__("G45Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_License__ = __webpack_require__("1NgH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_EasyAllocation__ = __webpack_require__("z3zT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AllAssets__ = __webpack_require__("ACwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Email__ = __webpack_require__("6Aj3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_license_checker__ = __webpack_require__("9G1o");










/* harmony default export */ __webpack_exports__["a"] = ([{
  // non-protected route to handle application authentication
  path: '/login/:hasEditRole?',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */],
  meta: { requiresAuth: false }
}, {
  // protected route to application home component
  path: '/',
  name: 'AllAssets',
  component: __WEBPACK_IMPORTED_MODULE_6__components_AllAssets__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  // protected route to application about component
  path: '/about',
  name: 'About',
  component: __WEBPACK_IMPORTED_MODULE_1__components_About__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  // protected route to application all licenses component
  path: '/licenses/:isNewOrAllocated?/:licenseFromBetaEval?',
  name: 'AllLicenses',
  component: __WEBPACK_IMPORTED_MODULE_3__components_AllLicenses__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  // protected route to application license component
  path: '/license/:licenseId',
  name: 'License',
  component: __WEBPACK_IMPORTED_MODULE_4__components_License__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/easy/:id',
  name: 'EasyAllocation',
  component: __WEBPACK_IMPORTED_MODULE_5__components_EasyAllocation__["a" /* default */],
  meta: { requiresAuth: false }
}, {
  path: '/manage-licenses',
  name: 'LicenseLists',
  component: __WEBPACK_IMPORTED_MODULE_0__components_LicenseLists__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/email/:internal?',
  name: 'Email',
  component: __WEBPACK_IMPORTED_MODULE_7__components_Email__["a" /* default */],
  meta: { requiresAuth: false }
}, {
  path: '/la-007',
  name: 'LicenseChecker',
  component: __WEBPACK_IMPORTED_MODULE_8__components_license_checker__["a" /* default */],
  meta: { requiresAuth: false }
}]);

/***/ }),

/***/ "Z+Ud":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZH+V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseCheckerCircle',
  props: {
    top: { type: Number, default: 0 },
    left: { type: Number, default: 0 }
  }
});

/***/ }),

/***/ "ZM1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypeaheadListItem',

  props: {
    data: {},
    htmlText: {
      type: String
    },
    backgroundVariant: {
      type: String
    },
    textVariant: {
      type: String
    }
  },

  data: function data() {
    return {
      active: false
    };
  },


  computed: {
    textClasses: function textClasses() {
      var classes = '';
      classes += this.active ? 'active' : '';
      classes += this.backgroundVariant ? ' bg-' + this.backgroundVariant : '';
      classes += this.textVariant ? ' text-' + this.textVariant : '';
      return 'vbst-item list-group-item list-group-item-action ' + classes;
    }
  }
});

/***/ }),

/***/ "Zs8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'About',
  data: function data() {
    return {
      pageTitle: 'About Page'
    };
  },
  created: function created() {
    // created lifecycle hook...
  }
});

/***/ }),

/***/ "ZzAB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datepicker_vue__ = __webpack_require__("SUbk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77940f27_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__ = __webpack_require__("p3TE");
function injectStyle (ssrContext) {
  __webpack_require__("Mzdm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77940f27"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datepicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77940f27_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a1G9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[(!_vm.loading)?[_c('div',{staticClass:"col-12"},[_c('b-form-textarea',{staticClass:"notes-input",model:{value:(_vm.notes),callback:function ($$v) {_vm.notes=$$v},expression:"notes"}}),_vm._v(" "),_c('b-button',{staticClass:"save-note",attrs:{"size":"lg","variant":"primary","disabled":_vm.disableSaveNotesBtn || _vm.isSaving},on:{"click":_vm.saveNotes}},[_vm._v("\n        "+_vm._s(_vm.$t('saveNote'))+"\n        "),(_vm.isSaving)?_c('i',{staticClass:"fa fa-spinner loading-animation"}):_vm._e()]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.deleteAllNotes.apply(null, arguments)}}},[_vm._v("\n        "+_vm._s(_vm.$t('deleteAllNotes'))+"\n      ")])],1)]:[_c('loading',{attrs:{"customStyle":"padding-top: 0;"}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a9Vp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__license_checker_aside__ = __webpack_require__("IZoi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__license_checker_table__ = __webpack_require__("yttA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__license_checker_cads_details__ = __webpack_require__("aynH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__license_checker_renewal_chain__ = __webpack_require__("uBC9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__license_checker_order_details__ = __webpack_require__("7879");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__license_checker_inital_order_details__ = __webpack_require__("ispu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__license_checker_renewal_order_details__ = __webpack_require__("XFF7");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseCheckerHeader',
  components: {
    LicenseCheckerAside: __WEBPACK_IMPORTED_MODULE_1__license_checker_aside__["a" /* default */],
    LicenseCheckerTable: __WEBPACK_IMPORTED_MODULE_2__license_checker_table__["a" /* default */],
    LicenseCheckerCadsDetails: __WEBPACK_IMPORTED_MODULE_3__license_checker_cads_details__["a" /* default */],
    LicenseCheckerRenewalChain: __WEBPACK_IMPORTED_MODULE_4__license_checker_renewal_chain__["a" /* default */],
    LicenseCheckerOrderDetails: __WEBPACK_IMPORTED_MODULE_5__license_checker_order_details__["a" /* default */],
    LicenseCheckerInitialOrderDetails: __WEBPACK_IMPORTED_MODULE_6__license_checker_inital_order_details__["a" /* default */],
    LicenseCheckerRenewalOrderDetails: __WEBPACK_IMPORTED_MODULE_7__license_checker_renewal_order_details__["a" /* default */]
  },
  data: function data() {
    return {
      renewalHeight: 200
    };
  },

  props: {
    isLoading: { type: Boolean, default: false },
    asideList: { type: Array, default: function _default() {
        return [];
      } },
    setSelectedId: { type: Function, required: true },
    selectedId: { type: String, default: '' },
    tableData: { type: Object, default: function _default() {
        return {};
      } },
    grid: { type: Array, default: function _default() {
        return [];
      } },
    lineItemsToModify: { type: Object, default: function _default() {
        return {};
      } },
    existingDetails: { type: Object, default: function _default() {
        return {};
      } },
    fixIssues: { type: Function, default: function _default() {} },
    fixIssuesButtonText: { type: String, default: 'Fix all issues' },
    orderDetails: { type: Array, default: function _default() {
        return [];
      } },
    modalData: { type: Array, default: function _default() {
        return [];
      } },
    isApiComplete: { type: Boolean, default: false },
    initialOrderDetails: { type: Array, default: function _default() {
        return [];
      } },
    renewalOrderDetails: { type: Array, default: function _default() {
        return [];
      } }
  },
  methods: {
    setRenewalOrderHeight: function setRenewalOrderHeight(params) {
      var _this = this;

      this.$nextTick(function () {
        _this.renewalHeight = params;
      });
    }
  },
  computed: {
    getRenewalHeight: function getRenewalHeight() {
      return this.renewalHeight.toString();
    },
    hasLineItemsToModify: function hasLineItemsToModify() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.lineItemsToModify).length > 0;
    }
  }
});

/***/ }),

/***/ "aGAF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aMqP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showSurveyModal)?[_c('survey-modal',{attrs:{"show-modal":_vm.showModal}})]:_vm._e(),_vm._v(" "),_c('b-modal',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.modalName),expression:"modalName"}],attrs:{"visible":_vm.modal},on:{"hide":_vm.closeModal}},[(_vm.errorType === '')?[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"},[_vm._v("\n        "+_vm._s(_vm.modifyTitle)+"\n        "),(_vm.hasMultipleItems && _vm.currentStep === 1)?_c('div',{staticClass:"full-allocation-message"},[_vm._v("\n          "+_vm._s(_vm.$t('fullModificationMessage'))+"\n        ")]):_vm._e()])]:[_c('div',{staticClass:"danger-text",attrs:{"slot":"modal-title"},slot:"modal-title"},[_vm._v("\n        "+_vm._s(_vm.modifyTitle)+"\n      ")])],_vm._v(" "),(_vm.currentStep === 1)?_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"inputs-row"},[_c('div',{staticClass:"col-4"},[_c('b-form-input',{staticClass:"modal-input",attrs:{"disabled":_vm.hasMultipleItems,"state":_vm.isModifyCountInvalid ? false : null,"tabindex":"1"},nativeOn:{"blur":function($event){return _vm.handleModifyCountBlur.apply(null, arguments)}},model:{value:(_vm.count),callback:function ($$v) {_vm.count=$$v},expression:"count"}}),_vm._v(" of "+_vm._s(_vm.totalCount)+"\n        ")],1),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('fieldset',{class:_vm.isHostTypeAny ? 'typeahead-fieldset' : ''},[_c('legend',{staticStyle:{"z-index":"5"}},[_vm._v(_vm._s(_vm.$t('host')))]),_vm._v(" "),_c('typeahead',{ref:"typeahead",staticClass:"modal-input right dropdown",attrs:{"placeholder":_vm.hostValuePlaceholder,"data":_vm.dropdownData},on:{"input":_vm.handleHostValueChange},model:{value:(_vm.hostValue),callback:function ($$v) {_vm.hostValue=$$v},expression:"hostValue"}}),_vm._v(" "),(_vm.isHostTypeHostname)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('hostnameInfo'))}}):_vm._e(),_vm._v(" "),(_vm.isHostTypeAny)?_c('div',{staticClass:"disable-typeahead"}):_vm._e()],1)])]),_vm._v(" "),_c('b-row',[(_vm.isModifyCountInvalid)?_c('div',{staticClass:"col-12"},[_c('p',{class:("invalid-host-value-text " + _vm.topMarginClass)},[_vm._v("\n            "+_vm._s(_vm.invalidModifyCount)+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.isHostValueInvalid && _vm.hostValue !== '')?_c('div',{staticClass:"col-12"},[_c('p',{class:("invalid-host-value-text " + _vm.topMarginClass + " " + (_vm.isModifyCountInvalid ? 'no': ''))},[_vm._v("\n            "+_vm._s(_vm.$t('invalidHostTypeMessage', { hostType: _vm.readableHostType }))+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('b-row',{staticClass:"text-left"},[_c('div',{staticClass:"col-sm-12 col-md"},[_c('fieldset',{staticClass:"form-group"},[_c('legend',[_vm._v(_vm._s(_vm.$t('selectReason'))+" "),_c('span',{staticClass:"required-colour"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-select',{attrs:{"options":_vm.reasonOptions,"required":""},nativeOn:{"change":function($event){return _vm.onReasonSelect.apply(null, arguments)}},model:{value:(_vm.reasonOption),callback:function ($$v) {_vm.reasonOption=$$v},expression:"reasonOption"}})],1)]),_vm._v(" "),(_vm.showRenameText)?_c('div',[_c('span',{staticClass:"align-left warning-colour",domProps:{"innerHTML":_vm._s(_vm.$t('returnRenameReason', {
                    warningLicenseRehostLink: _vm.UrlBuilder.warningLicenseRehostLink
                  }))}})]):_vm._e()])]),_vm._v(" "),(_vm.showOtherInput)?_c('b-row',{staticClass:"text-left pt-3"},[_c('div',{staticClass:"col-sm-12 col-md"},[_c('fieldset',{staticClass:"form-group"},[_c('legend',[_vm._v(_vm._s(_vm.$t('otherReason'))+" "),_c('span',{staticClass:"required-colour"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-input',{staticClass:"other-reason-height",model:{value:(_vm.otherReason),callback:function ($$v) {_vm.otherReason=$$v},expression:"otherReason"}})],1)])])]):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"text-left pt-3"},[_c('div',{staticClass:"col-sm-12 col-md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.consent),expression:"consent"}],attrs:{"type":"checkbox","name":"consentCheckbox"},domProps:{"checked":Array.isArray(_vm.consent)?_vm._i(_vm.consent,null)>-1:(_vm.consent)},on:{"change":function($event){var $$a=_vm.consent,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.consent=$$a.concat([$$v]))}else{$$i>-1&&(_vm.consent=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.consent=$$c}}}}),_vm._v("\n              \n            "),_c('span',{staticClass:"align-left required-colour",domProps:{"innerHTML":_vm._s(_vm.$t('eformlegalTextCheck',  {
                endUserLicenseAgreement: _vm.UrlBuilder.endUserLicenseAgreement,
                rightToAuditCompliance: _vm.UrlBuilder.rightToAuditCompliance
              }))}})])]),_vm._v(" "),_c('b-row'),_vm._v(" "),_c('b-row',{class:("buttons-container " + (_vm.isHostTypeHostname ? 'top-margin' : ''))},[_c('div',{staticClass:"col-12 text-center"},[_c('b-button',{staticClass:"cta-btn",attrs:{"variant":"primary","size":"lg","disabled":_vm.isStepOneCtaButtonDisabled || !_vm.reasonOption || !_vm.consent || (!(_vm.showOtherInput && _vm.otherReason) && _vm.showOtherInput),"tabindex":"2"},on:{"click":function($event){_vm.currentStep = 2}}},[_vm._v("\n            "+_vm._s(_vm.$t('modifyLicenseFile'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 text-center"},[_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.modalName),expression:"modalName"}],staticClass:"danger-text",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.closeModal.apply(null, arguments)}}},[_vm._v("\n            "+_vm._s(_vm.$t('cancel'))+"\n          ")])])])],1):_vm._e(),_vm._v(" "),(_vm.currentStep === 2)?_c('b-container',{staticClass:"step text-center",attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v(_vm._s(_vm.$t('allocateConfirmation')))]),_vm._v(" "),_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.allocateConfirmationInfo)}})])]),_vm._v(" "),_c('b-row',{staticClass:"buttons-container"},[_c('div',{staticClass:"col-12 text-center"},[_c('b-button',{staticClass:"cta-btn",attrs:{"variant":"success","size":"lg"},on:{"click":_vm.createLicenseFiles}},[_vm._v("\n            "+_vm._s(_vm.$t('allocateConfirmationYes'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 text-center"},[_c('a',{staticClass:"danger-text",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.goToStepOne.apply(null, arguments)}}},[_vm._v("\n           "+_vm._s(_vm.$t('allocateConfirmationNo'))+"\n          ")])])])],1):(_vm.currentStep === 3)?_c('b-container',{staticClass:"step",attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v(_vm._s(_vm.$t('allocateConfirmationLoadingHeader')))]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.$t('allocateConfirmationLoadingInfo')))])])]),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-12"},[_c('loading',{attrs:{"customStyle":"padding: 10px;"}})],1)])],1):(_vm.currentStep === 4)?_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"step success-text"},[_vm._v(_vm._s(_vm.$t('modifyDownload')))]),_vm._v(" "),_c('div',{staticClass:"step description",domProps:{"innerHTML":_vm._s(_vm.$t('modifyDownloadInfo', { hostValue: _vm.getHostValues }))}}),_vm._v(" "),_c('span',{staticClass:"align-left",domProps:{"innerHTML":_vm._s(_vm.$t('rehostLegalText', {
              endUserLicenseAgreement: _vm.UrlBuilder.endUserLicenseAgreement,
              rightToAuditCompliance: _vm.UrlBuilder.rightToAuditCompliance
              }))}})])]),_vm._v(" "),_c('b-row',{staticClass:"buttons-container"},[_c('div',{staticClass:"col-12 text-center"},[_c('b-button',{staticClass:"cta-btn",attrs:{"variant":"primary","disabled":_vm.isDownloading},on:{"click":_vm.downloadLicenseFiles}},[_vm._v("\n            "+_vm._s(_vm.$tc('downloadLicenseFiles', 1))+"\n            "),(_vm.isDownloading)?_c('i',{staticClass:"fa fa-spinner loading-animation"}):_vm._e()])],1)])],1):_c('b-container',{staticClass:"step",attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.errorDescription)}})])]),_vm._v(" "),(_vm.errorType === 'data')?_c('b-row',{staticClass:"buttons-container text-center"},[_c('div',{staticClass:"col-12"},[_c('b-button',{staticClass:"secondary-btn",attrs:{"variant":"primary","size":"lg"},on:{"click":_vm.downloadFailedTextFile}},[_vm._v("\n            "+_vm._s(_vm.$t('allocateFailSecondaryButtonText'))+"\n          ")])],1)]):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"})],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ah/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[(_vm.hasApiCallFailed)?[_c('something-went-wrong',{attrs:{"text":"View all licenses"}})]:[_c('div',{attrs:{"id":"page-top"}},[_c('b-row',[_c('search',_vm._b({attrs:{"isAdvancedSearchVisible":_vm.search.showAdvancedSearch},on:{"findLicenseByChange":_vm.handleFindLicenseByChange,"searchInputChange":_vm.handleSearchInputChange,"orderDateChange":_vm.handleOrderDateChange,"licenseTypeChange":_vm.handleLicenseTypeChange,"fromDateChange":_vm.handleFromDateChange,"toDateChange":_vm.handleToDateChange,"advancedSearchButtonClick":_vm.handleAdvancedSearchButtonClick,"onSearchClick":_vm.handleSearchClick}},'search',_vm.search,false))],1),_vm._v(" "),_c('b-row',[_c('quick-find',{ref:"quickFind",attrs:{"page":"All licenses"},on:{"filterClicked":_vm.setLicenseFilter}})],1),_vm._v(" "),(_vm.isInternal && !_vm.isPersonInRole)?_c('div',[_c('a',{attrs:{"href":"https://citrix.service-now.com/sp?id=sc_cat_item&sys_id=713158551b8c50500bfeb912cd4bcbab","target":"_blank"}},[_c('b-row',[_c('b-col',{staticClass:"not-permitted-text"},[_c('h5',[_vm._v(_vm._s(_vm.$t('contactCustomerCareReturnInternal')))])])],1)],1)]):_vm._e(),_vm._v(" "),(!_vm.loading)?[_c('b-row',{staticClass:"all-licenses-table-row"},[_c('div',{staticClass:"col-12 col-md-3"},[_c('b-select',{ref:"actionDropdown",staticClass:"select-action-dropdown",attrs:{"value":_vm.actionOption,"options":_vm.actionOptions,"disabled":_vm.selectedLicenses.length === 0 || _vm.hasError || _vm.hasNoRecords || (_vm.isInternal && !_vm.isPersonInRole),"title":_vm.selectedLicenses.length === 0 ? _vm.$t('noSelectionInfoText') : ''},nativeOn:{"change":function($event){return _vm.handleActionSelection.apply(null, arguments)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 d-sm-block d-md-none options-btn-container"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.showOptions = !_vm.showOptions}}},[_vm._v("\n              "+_vm._s(_vm.$t('viewHideOptions', { action: !_vm.showOptions ? _vm.$t('view') : _vm.$tc('hide', 1) } ))+"\n            ")])]),_vm._v(" "),_c('div',{class:['col-12 col-md-9 options-container', { show: _vm.showOptions }]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md"},[_c('fieldset',{staticClass:"form-group"},[_c('legend',[_vm._v(_vm._s(_vm.$t('filterBy')))]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-select',{attrs:{"options":_vm.filterOptions},on:{"change":_vm.handleFilterChange},model:{value:(_vm.filterOption),callback:function ($$v) {_vm.filterOption=$$v},expression:"filterOption"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md"},[_c('fieldset',{staticClass:"form-group"},[_c('legend',[_vm._v(_vm._s(_vm.$t('sortBy')))]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-select',{attrs:{"options":_vm.sortOptions},on:{"change":_vm.handleSortChange},model:{value:(_vm.sortOption),callback:function ($$v) {_vm.sortOption=$$v},expression:"sortOption"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md page-size-col"},[_c('fieldset',{staticClass:"form-group"},[_c('legend',[_vm._v(_vm._s(_vm.$t('show')))]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-select',{attrs:{"options":_vm.pageSizeOptions},on:{"change":_vm.handlePageNumberChange},model:{value:(_vm.pageSizeOption),callback:function ($$v) {_vm.pageSizeOption=$$v},expression:"pageSizeOption"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-4 date-picker"},[_c('fieldset',{staticClass:"form-group"},[_c('legend',[_vm._v(_vm._s(_vm.$t('dateRange')))]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-input',{attrs:{"value":_vm.dateRangeValue,"disabled":""}})],1)])])])])]),_vm._v(" "),(_vm.hasNoRecords)?_c('b-row',{staticClass:"no-records-container"},[_c('h3',[_vm._v(_vm._s(_vm.$t('noRecordsFound')))])]):_vm._e(),_vm._v(" "),(!_vm.hasNoRecords)?_c('b-row',{staticClass:"all-licenses-table-header vertical-padding left-spacing"},[_c('div',{staticClass:"col checkbox-col"},[_c('b-checkbox',{on:{"change":_vm.toggleAllLicensesSelection},model:{value:(_vm.areAllLicensesSelected),callback:function ($$v) {_vm.areAllLicensesSelected=$$v},expression:"areAllLicensesSelected"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-row',[_c('div',{staticClass:"col indent-text"},[_vm._v("\n                "+_vm._s(_vm.$t('productName'))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block col dynamic-column-select-container header"},[_vm._v("\n                "+_vm._s(_vm.dynamicColumnHeader)+"\n                   \n                "),_c('i',{staticClass:"fa fa-caret-down"}),_vm._v(" "),_c('b-select',{staticClass:"dynamic-column-select",attrs:{"options":_vm.dynamicColumnOptions},model:{value:(_vm.dynamicColumnOption),callback:function ($$v) {_vm.dynamicColumnOption=$$v},expression:"dynamicColumnOption"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block col allocate-col text-right"},[_vm._v("\n                "+_vm._s(_vm.$t('allocated'))+"\n              ")])])],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.licenses),function(license,i){return [_c('b-row',{key:license.ProductName + i,class:_vm.getTableRowClasses(license, i)},[_c('div',{staticClass:"col checkbox-col"},[_c('b-checkbox',{class:_vm.isLicenseInvalid(license) ? 'error-checkbox' : '',attrs:{"checked":_vm.isLicenseSelected(license)},on:{"change":function($event){return _vm.toggleLicenseSelection(license)}}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-row',[_c('div',{staticClass:"col indent-text"},[_c('a',{attrs:{"href":("/#/license/" + (license.ActivationID)),"title":license.ProductName},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleLicenseLinkClick(license)}}},[_vm._v("\n                    "+_vm._s(license.ProductName)+"\n                  ")]),_vm._v(" "),(_vm.isLicenseNew(license))?_c('span',{staticClass:"success-text"},[_vm._v(_vm._s(_vm.$t('new')))]):(_vm.isLicenseExpiringLow(license))?_c('span',{staticClass:"danger-text"},[_vm._v("\n                    "+_vm._s(_vm.$tc('expiring', 1))+"\n                  ")]):(_vm.isLicenseExpiringHigh(license))?_c('span',{staticClass:"warning-text"},[_vm._v("\n                    "+_vm._s(_vm.$tc('expiring', 1))+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.isLicenseInvalid(license))?_c('p',{staticClass:"error-row-text"},[_vm._v("\n                    "+_vm._s(_vm.$t('multipleSelectionHostTypeError', { hostType: _vm.hostType }))+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.isFutureLicense(license))?_c('p',{staticClass:"warning-text"},[_vm._v("\n                  "+_vm._s(_vm.$t('futureDateLicenseError', { StartDate:_vm.getReadableDate(license.StartDate) }))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block col dynamic-column-select-container",attrs:{"title":_vm.dynamicColumnOption === 'HostValue' ? _vm.dynamicColumnItem(license) : ''}},[_vm._v("\n                  "+_vm._s(_vm.dynamicColumnItem(license))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block col allocate-col text-right"},[_vm._v("\n                  "+_vm._s(_vm.getAllocatedText(license))+"\n                ")])])],1)])]}),_vm._v(" "),(!_vm.hasNoRecords)?_c('b-row',{staticClass:"all-licenses-table-footer"},[_c('div',{staticClass:"col-6 d-none d-md-block"},[_c('a',{staticClass:"export-link",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleExportLinkClick.apply(null, arguments)}}},[_vm._v("\n              "+_vm._s(_vm.$t('exportToExcel'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 text-center"},[_c('div',{staticClass:"pagination-container"},[_c('b-pagination',{ref:"pagination",attrs:{"value":_vm.currentPage,"limit":6,"per-page":_vm.pageSizeOption,"hide-goto-end-buttons":"","prev-text":_vm.$t('paginationPrevText'),"next-text":_vm.$t('paginationNextText'),"total-rows":_vm.totalLicensesCount},on:{"change":_vm.handlePageChange}})],1)])]):_vm._e(),_vm._v(" "),(!_vm.isInternal || (_vm.isInternal && _vm.isPersonInRole))?_c('b-row',[_c('a',{staticClass:"margin-bottom: 10px",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.webkeyModal = true}}},[_vm._v("\n            "+_vm._s(_vm.$t('dontSeeLicenses'))+"\n          ")])]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.loading)?[_c('loading')]:_vm._e()],2)],_vm._v(" "),_c('b-modal',{on:{"hide":_vm.handleModalClose},model:{value:(_vm.showPagingWarning),callback:function ($$v) {_vm.showPagingWarning=$$v},expression:"showPagingWarning"}},[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"},[_vm._v("\n      "+_vm._s(_vm.$t('bulkActions'))+"\n    ")]),_vm._v(" "),_c('b-container',{staticClass:"modal-content-container"},[_c('b-row',{staticClass:"text-center"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"danger-text"},[_vm._v(_vm._s(_vm.$t('bulkActionErrorTitle')))]),_vm._v(" "),_c('h6',{domProps:{"innerHTML":_vm._s(_vm.$t('bulkActionErrorInfo'))}})])]),_vm._v(" "),_c('b-row',{staticClass:"buttons-container"},[_c('div',{staticClass:"col-12"},[_c('b-button',{staticStyle:{"margin":"30px auto 10px","display":"block"},attrs:{"variant":"primary","size":"lg"},on:{"click":function($event){return _vm.handleModalClose(true)}}},[_vm._v("\n            "+_vm._s(_vm.$t('bulkActionCtaButtonText'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 text-center"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.clearLicensesAndPaginate.apply(null, arguments)}}},[_vm._v("\n            "+_vm._s(_vm.$t('bulkActionSecondaryButtonText'))+"\n          ")])])])],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"})],1),_vm._v(" "),_c('allocation-modal',{attrs:{"modal":_vm.allocateModal,"closeModal":_vm.closeAllocateModal,"openModal":_vm.openAllocateModel,"selectedLicenses":_vm.selectedLicenses,"getUpdatedLicenses":_vm.getUpdatedLicenses}}),_vm._v(" "),_c('hide-unhide-modal',{attrs:{"modal":_vm.hideUnhideModal,"closeModal":_vm.closeHideUnhideModal,"selectedLicenses":_vm.selectedLicenses,"type":_vm.hideUnhideModalType,"onSuccessfulAction":_vm.resetActionOption}}),_vm._v(" "),_c('return-allocation-modal',{attrs:{"isFromViewAll":"","modal":_vm.returnModal,"closeModal":_vm.closeReturnModal,"selectedLicenses":_vm.selectedLicenses}}),_vm._v(" "),_c('webkey-allocation-modal',{attrs:{"modal":_vm.webkeyModal,"closeModal":_vm.closeWebkeyModal,"webkeyModalCallback":_vm.webkeyModalCallback,"allocateFlowCallback":_vm.allocateFlowCallback,"webkey":_vm.webkey}}),_vm._v(" "),_c('error-modal',{attrs:{"disableCta":_vm.disableErrorModalCta,"modal":_vm.errorModal,"closeModal":_vm.closeErrorModal,"errorType":_vm.errorModalType,"handleCtaClick":_vm.errorModalCtaClickHandler}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ajn2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_modal_vue__ = __webpack_require__("Mq7Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f100d672_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_modal_vue__ = __webpack_require__("N3Xj");
function injectStyle (ssrContext) {
  __webpack_require__("Mdpe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f100d672"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f100d672_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aynH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_cads_details_vue__ = __webpack_require__("IoNC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37fcf0b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_cads_details_vue__ = __webpack_require__("+qkY");
function injectStyle (ssrContext) {
  __webpack_require__("9xPZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_cads_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37fcf0b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_cads_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bPLJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"visible":_vm.modal},on:{"hide":_vm.resetAndCloseModal}},[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"},[_vm._v("\n    "+_vm._s(_vm.$t('locateAMissingLicense'))+"\n  ")]),_vm._v(" "),(!_vm.isApiCallComplete)?_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.$t('missingLicenseHelpText')))])])]),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-12 text-center"},[_c('fieldset',{staticClass:"form-group"},[_c('legend',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('enterLicenseCode')))]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-input',{staticClass:"host-style-input",on:{"input":function($event){_vm.isWebkeyInvalid = false}},model:{value:(_vm.hostValue),callback:function ($$v) {_vm.hostValue=$$v},expression:"hostValue"}})],1)]),_vm._v(" "),(_vm.isWebkeyInvalid)?_c('div',{staticClass:"danger-text text-left"},[_vm._v("\n          "+_vm._s(_vm.$t('invalidWebkey'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"cta-btn",attrs:{"disabled":_vm.isCtaButtonDisabled || _vm.isLoading,"variant":"primary","size":"lg"},on:{"click":_vm.getWebkeyLicenses}},[_vm._v("\n            "+_vm._s(_vm.$t('addLicense'))+"\n            "),(_vm.isLoading)?_c('i',{staticClass:"fa fa-spinner loading-animation"}):_vm._e()]),_vm._v(" "),_c('div',[_c('a',{staticClass:"danger-text",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.resetAndCloseModal.apply(null, arguments)}}},[_vm._v("\n              "+_vm._s(_vm.$t('cancel'))+"\n            ")])])],1)])])],1):_c('b-container',{staticClass:"text-center"},[(_vm.screen === 1)?_c('b-row',[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.$t('webkeyAllocate')))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('b-button',{staticClass:"cta-btn",attrs:{"variant":"primary","size":"lg"},on:{"click":_vm.proceedToAllocate}},[_vm._v("\n            "+_vm._s(_vm.$t('allocateNow'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('a',{staticClass:"danger-text",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.resetAndCloseModal.apply(null, arguments)}}},[_vm._v("\n          "+_vm._s(_vm.$t('cancel'))+"\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.screen === 2)?_c('b-row',[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.$t('webkeyRegistered', { customerServiceUrl: _vm.UrlBuilder.customerServiceUrl }))}}),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('a',{staticClass:"btn btn-primary btn-lg border-radius",attrs:{"href":_vm.UrlBuilder.customerServiceUrl,"target":"_blank"}},[_vm._v("\n            "+_vm._s(_vm.$t('contactCustomerService'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('a',{staticClass:"danger-text",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.resetAndCloseModal.apply(null, arguments)}}},[_vm._v("\n            "+_vm._s(_vm.$t('closeWindow'))+"\n          ")])])])]):_vm._e(),_vm._v(" "),(_vm.screen === 3)?_c('b-row',[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.$t('webkeyInvalid', { customerServiceUrl: _vm.UrlBuilder.customerServiceUrl}))}})]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('b-button',{staticClass:"cta-btn",attrs:{"variant":"primary","size":"lg"},on:{"click":_vm.resetModal}},[_vm._v("\n            "+_vm._s(_vm.$t('reenterCode'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('a',{staticClass:"danger-text",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.resetAndCloseModal.apply(null, arguments)}}},[_vm._v("\n          "+_vm._s(_vm.$t('cancel'))+"\n        ")])])]):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c27y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("Zs8U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_431a3361_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("sfY9");
function injectStyle (ssrContext) {
  __webpack_require__("O4RG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_431a3361_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cFPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SomethingWentWrong_vue__ = __webpack_require__("A2DV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c44abdfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SomethingWentWrong_vue__ = __webpack_require__("jj1I");
function injectStyle (ssrContext) {
  __webpack_require__("jxZW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SomethingWentWrong_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c44abdfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SomethingWentWrong_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ctTL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityLog_vue__ = __webpack_require__("sUkA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b1edaf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityLog_vue__ = __webpack_require__("6hPw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivityLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b1edaf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivityLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d56P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asideListUpdated.length)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Asset IDs")]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush aside-scroll"},_vm._l((_vm.asideListUpdated),function(ref,i){
var assetId = ref.assetId;
var faulty = ref.faulty;
var children = ref.children;
return _c('li',{key:assetId,staticClass:"list-group-item parent"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(("collapse-" + i)),expression:"`collapse-${i}`"}],staticClass:"sidebar-btn",attrs:{"variant":"light","disabled":!children.length}},[_c('span',{staticClass:"when-opened"},[_c('i',{staticClass:"fa fa-chevron-circle-up"})]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('i',{staticClass:"fa fa-chevron-circle-down"})]),_vm._v("\n         "+_vm._s(assetId)+"\n          "),(faulty)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],attrs:{"title":"Faulty AssetId"}},[_c('i',{staticClass:"fa fa-exclamation-circle faulty"})]):_vm._e()]),_vm._v(" "),_c('b-collapse',{attrs:{"id":("collapse-" + i)}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row child-list"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Asset Component IDs")]),_vm._v(" "),_c('b-list-group',_vm._l((children),function(ref){
var orderId = ref.orderId;
var faultyChildren = ref.faultyChildren;
return _c('b-list-group-item',{key:orderId},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.setId(assetId, orderId)}}},[_vm._v("\n                      "+_vm._s(orderId)+"\n                    ")]),_vm._v(" \n                    "),(faultyChildren)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],attrs:{"title":"Faulty order"}},[_c('i',{staticClass:"fa fa-exclamation-circle faulty"})]):_vm._e()])}),1)],1)])])])])],1)}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dUh8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Activation ID")]),_vm._v(" "),_c('th',[_vm._v("Allocated/Total")]),_vm._v(" "),_c('th',[_c('abbr',{attrs:{"title":"Fulfilled Count"}},[_vm._v("FC")])]),_vm._v(" "),_c('th',[_c('abbr',{attrs:{"title":"Available Reallocation Count"}},[_vm._v("ARC")])]),_vm._v(" "),_c('th',[_vm._v("Version Date")]),_vm._v(" "),_c('th',[_vm._v("Expiration Date")]),_vm._v(" "),_c('th',[_vm._v("Order ID")]),_vm._v(" "),_c('th',[_vm._v("AC ID")]),_vm._v(" "),_c('th',[_vm._v("Status")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e2L8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.check)?_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 130.2 130.2"}},[_c('circle',{staticClass:"path circle",attrs:{"fill":"none","stroke":"#73AF55","stroke-width":"6","stroke-miterlimit":"10","cx":"65.1","cy":"65.1","r":"62.1"}}),_vm._v(" "),_c('polyline',{staticClass:"path check",attrs:{"fill":"none","stroke":"#73AF55","stroke-width":"6","stroke-linecap":"round","stroke-miterlimit":"10","points":"100.2,40.2 51.5,88.8 29.8,67.5 "}})]):_vm._e(),_vm._v(" "),(_vm.cross)?_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 130.2 130.2"}},[_c('circle',{staticClass:"path circle",attrs:{"fill":"none","stroke":"#D06079","stroke-width":"6","stroke-miterlimit":"10","cx":"65.1","cy":"65.1","r":"62.1"}}),_vm._v(" "),_c('line',{staticClass:"path line",attrs:{"fill":"none","stroke":"#D06079","stroke-width":"6","stroke-linecap":"round","stroke-miterlimit":"10","x1":"34.4","y1":"37.9","x2":"95.8","y2":"92.3"}}),_vm._v(" "),_c('line',{staticClass:"path line",attrs:{"fill":"none","stroke":"#D06079","stroke-width":"6","stroke-linecap":"round","stroke-miterlimit":"10","x1":"95.8","y1":"38","x2":"34.4","y2":"92.2"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eKWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorModal_vue__ = __webpack_require__("m87b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2334c4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorModal_vue__ = __webpack_require__("2fHg");
function injectStyle (ssrContext) {
  __webpack_require__("yedN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c2334c4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2334c4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eWFx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var env = "production" || 'development';

/* harmony default export */ __webpack_exports__["a"] = ({
  userId: null,
  install: function install(Vue, options) {
    Vue.prototype.loggly = this;
    if (env === 'production' && !document.getElementById('loggly')) {
      var script = document.createElement('script');
      script.setAttribute('id', 'loggly');
      script.setAttribute('src', './static/loggly.tracker-latest.min.js');
      script.setAttribute('async', '');
      script.onload = function () {
        window._LTracker = _LTracker || []; // eslint-disable-line
        // eslint-disable-next-line
        _LTracker.push({
          'logglyKey': "02ed2b87-d30d-4826-ad77-bd0d94dceb7d&#8203;",
          'sendConsoleErrors': true,
          'tag': 'customer-licensing-portal'
        });
      };
      document.head.appendChild(script);
    }
  },
  setUserId: function setUserId(userId) {
    this.userId = userId;
  },
  log: function log(message) {
    if (env === 'production') {
      _LTracker.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ userId: this.userId, message: message })); // eslint-disable-line
    } else {
      console.log(message);
    }
  }
});

/***/ }),

/***/ "fIjG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fQX5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fWJX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[(_vm.isLoading)?_c('div',[_vm._v("Loading...")]):_c('div',[(_vm.asideList.length && _vm.isApiComplete)?_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col aside-col"},[_c('license-checker-aside',{attrs:{"aside-list":_vm.asideList,"set-selected-id":_vm.setSelectedId}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[(_vm.selectedId !== '')?_c('license-checker-table',{attrs:{"selected-id":_vm.selectedId,"table-data":_vm.tableData,"line-items-to-modify":_vm.lineItemsToModify,"modal-data":_vm.modalData}}):_vm._e(),_vm._v(" "),(_vm.selectedId !== '' && _vm.hasLineItemsToModify)?_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"30px"}},[_c('b-button',{staticClass:"fix-issue-btn",attrs:{"variant":"primary","size":"lg","disabled":_vm.fixIssuesButtonText === 'Fixing...'},on:{"click":_vm.fixIssues}},[_vm._v("\n              "+_vm._s(_vm.fixIssuesButtonText)+"\n            ")])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[(_vm.selectedId !== '')?_c('license-checker-cads-details',{attrs:{"data":_vm.tableData.assetComponentList}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[(_vm.selectedId !== '')?_c('license-checker-initial-order-details',{attrs:{"data":_vm.initialOrderDetails},on:{"setSiblingHeight":_vm.setRenewalOrderHeight}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[(_vm.selectedId !== '')?_c('license-checker-renewal-order-details',{attrs:{"data":_vm.renewalOrderDetails,"height":_vm.getRenewalHeight}}):_vm._e()],1),_vm._v(" "),(_vm.orderDetails.length)?_c('div',{staticClass:"col-12"},[(_vm.selectedId !== '')?_c('license-checker-order-details',{attrs:{"data":_vm.orderDetails}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[(_vm.selectedId !== '')?_c('license-checker-renewal-chain',{attrs:{"grid":_vm.grid}}):_vm._e()],1)])]):(_vm.isApiComplete)?_c('div',{staticClass:"container-fluid text-center"},[_c('h5',[_vm._v("No active assets or maintenance program found associated to this serial number. Please verify data in CADS.")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fgSf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getDateFormatBasedOnLocale: function getDateFormatBasedOnLocale() {
      var locale = this.$store.getters.person.preferences.locale || 'en-US';
      var formats = {
        'zh-CN': 'YYYY/MM/DD',
        'zh-TW': 'YYYY/MM/DD',
        'jp-JP': 'YYYY/MM/DD',
        'ko-KR': 'YYYY/MM/DD',
        'es-CO': 'DD/MM/YYYY',
        'pt-BR': 'DD/MM/YYYY',
        'fr-FR': 'DD/MM/YYYY',
        'de-DE': 'DD/MM/YYYY',
        'en-US': 'MM/DD/YYYY'
      };
      locale = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(formats).includes(locale) ? locale : 'en-US';
      return formats[locale];
    }
  }
});

/***/ }),

/***/ "gJII":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DidYouKnow_vue__ = __webpack_require__("QXW8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1565c45e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DidYouKnow_vue__ = __webpack_require__("Q/Jf");
function injectStyle (ssrContext) {
  __webpack_require__("8Fkx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DidYouKnow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1565c45e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DidYouKnow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gjr2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "goSe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue__ = __webpack_require__("ZM1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_bbc90f24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadListItem_vue__ = __webpack_require__("LeG/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_bbc90f24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hvHF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseCheckerTableHeaders'
});

/***/ }),

/***/ "ispu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_inital_order_details_vue__ = __webpack_require__("GF+c");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c55d435_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_inital_order_details_vue__ = __webpack_require__("HgF3");
function injectStyle (ssrContext) {
  __webpack_require__("uss5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_inital_order_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c55d435_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_inital_order_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jPU1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notes_vue__ = __webpack_require__("zCPJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a810f2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notes_vue__ = __webpack_require__("a1G9");
function injectStyle (ssrContext) {
  __webpack_require__("ltjj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a810f2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jj1I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.fromEasy && _vm.responseStatus !== 401)?_c('div',{staticClass:"sww-container"},[_c('h3',{staticClass:"sww-title"},[_vm._v(_vm._s(_vm.$t('somethingWentWrong')))]),_vm._v(" "),_c('p',[(_vm.text !== '')?_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('somethingWentWrongInfo', { text: _vm.text }))}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.$t('tryAgainLater'))+"\n      "),_c('a',{staticClass:"reload-link",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.reloadPage.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('reloadPage')))])])]):(_vm.responseStatus === 401 && _vm.fromEasy)?_c('div',[_c('h3',{staticClass:"sww-title"},[_vm._v("The activation link has expired.")]),_vm._v(" "),_c('p',[_vm._v("\n      "+_vm._s(_vm.$t('resendEmail'))+"\n      "),_c('router-link',{staticClass:"email-link",attrs:{"to":"/email"}},[_vm._v("Resend Email")])],1)]):_vm._e(),_vm._v(" "),(!_vm.fromEasy)?_c('div',{staticClass:"sww-container"},[_c('h3',{staticClass:"sww-title"},[_vm._v(_vm._s(_vm.$t('somethingWentWrong')))]),_vm._v(" "),_c('p',[(_vm.text !== '')?_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('somethingWentWrongInfo', { text: _vm.text }))}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.$t('tryAgainLater'))+"\n      "),_c('a',{staticClass:"reload-link",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.reloadPage.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('reloadPage')))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jxZW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kOnr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kbj3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kvwc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('b',[_vm._v("Asset ID:")]),_vm._v(" "+_vm._s(_vm.selectedId.split('|')[0])+" "),_c('b',[_vm._v("|")]),_vm._v(" "),_c('b',[_vm._v("Order ID:")]),_vm._v(" "+_vm._s(_vm.selectedId.split('|')[1])+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 table-container"},[_c('table',{staticClass:"table table-borderless"},[_c('license-checker-table-headers'),_vm._v(" "),_c('tbody',[(_vm.tableData.lineItems.length)?_vm._l((_vm.tableData.lineItems),function(lineItem){return _c('tr',{key:lineItem.ID,class:_vm.isFaultyItem(lineItem.ACTIVATION_ID) ? 'danger' : '',staticStyle:{"position":"relative"}},[_c('td',{class:_vm.isFaultyItem(lineItem.ACTIVATION_ID) ? 'double-cell' : ''},[(!_vm.isFaultyItem(lineItem.ACTIVATION_ID))?[_vm._v("\n                    "+_vm._s(lineItem.ACTIVATION_ID)+"\n                     \n                  ")]:[_c('div',{staticClass:"danger-cell"},[_vm._v(_vm._s(lineItem.ACTIVATION_ID)+" ")]),_vm._v(" "),_c('div',{staticClass:"success-cell",style:(("margin-bottom: " + (_vm.warningRowHeight[lineItem.ACTIVATION_ID])))},[_vm._v("\n                      "+_vm._s(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).ACTIVATION_ID)+" \n                      "),(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).IsOrderIdMissingInFNO)?_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-exclamation-circle faulty",attrs:{"title":"Line Item Not Created"}}):_vm._e()]),_vm._v(" "),(!_vm.hasNoActions(lineItem.ACTIVATION_ID))?_c('div',{ref:lineItem.ACTIVATION_ID,refInFor:true,staticClass:"warning-cell",style:(("margin-top: -" + (_vm.warningRowHeight[lineItem.ACTIVATION_ID])))},[_c('div',[_c('ul',{staticClass:"actions-list"},_vm._l((_vm.getFaultyRowInfo(lineItem.ACTIVATION_ID, true)),function(item,i){return _c('li',{key:item.key + i},[_c('b',{staticClass:"warning-text"},[_vm._v("Action to perform:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(((item.key) + ": " + (item.value))))]),_vm._v(" "),(_vm.shouldShowSubActions(lineItem.ACTIVATION_ID, i))?[_vm._v("\n                                \n                              "),_c('b',{staticClass:"warning-text"},[_vm._v("Sub action:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(((_vm.getFaultyRowInfo(lineItem.ACTIVATION_ID)[i].key) + ": " + (_vm.getFaultyRowInfo(lineItem.ACTIVATION_ID)[i].value))))])]:_vm._e()],2)}),0)])]):_vm._e()]],2),_vm._v(" "),_c('td',{class:_vm.isFaultyItem(lineItem.ACTIVATION_ID) ? 'double-cell' : ''},[(!_vm.isFaultyItem(lineItem.ACTIVATION_ID))?[_vm._v("\n                    "+_vm._s(((lineItem.ALLOCATED_QTY) + "/" + (lineItem.SEAT_COUNT)))+"\n                    "),(_vm.isModified(lineItem.ACTIVATION_ID))?[_c('license-checker-check-cross',{attrs:{"check":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsNotAutoAllocated === 'Success',"cross":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsNotAutoAllocated === 'Failure'}})]:_vm._e()]:[_c('div',{staticClass:"danger-cell"},[_vm._v("\n                      "+_vm._s(((lineItem.ALLOCATED_QTY) + "/" + (lineItem.SEAT_COUNT)))+"\n                       \n                      "),(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).IsNotAutoAllocated)?_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-exclamation-circle faulty",attrs:{"title":"Auto allocation issue"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"success-cell"},[_vm._v("\n                      "+_vm._s(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).ALLOCATED_QTY + '/' +
                        _vm.getFaultyLineItem(lineItem.ACTIVATION_ID).SEAT_COUNT)+"\n                    ")])]],2),_vm._v(" "),_c('td',{class:_vm.isFaultyItem(lineItem.ACTIVATION_ID) ? 'double-cell' : ''},[(!_vm.isFaultyItem(lineItem.ACTIVATION_ID))?[_vm._v("\n                    "+_vm._s(lineItem.FULFILLED_AMOUNT)+"\n                  ")]:[_c('div',{staticClass:"danger-cell"},[_vm._v("\n                      "+_vm._s(lineItem.FULFILLED_AMOUNT)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"success-cell"},[_vm._v("\n                      "+_vm._s(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).FULFILLED_AMOUNT)+"\n                    ")])]],2),_vm._v(" "),_c('td',{class:_vm.isFaultyItem(lineItem.ACTIVATION_ID) ? 'double-cell' : ''},[(!_vm.isFaultyItem(lineItem.ACTIVATION_ID))?[_vm._v("\n                    "+_vm._s(lineItem.AVAILABLE_REALLOCATION_COUNT)+"\n                  ")]:[_c('div',{staticClass:"danger-cell"},[_vm._v("\n                      "+_vm._s(lineItem.AVAILABLE_REALLOCATION_COUNT)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"success-cell"},[_vm._v("\n                      "+_vm._s(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).AVAILABLE_REALLOCATION_COUNT)+"\n                    ")])]],2),_vm._v(" "),_c('td',{class:_vm.isFaultyItem(lineItem.ACTIVATION_ID) ? 'double-cell' : ''},[(!_vm.isFaultyItem(lineItem.ACTIVATION_ID))?[_vm._v("\n                    "+_vm._s(_vm.getReadableDate(lineItem.VERSION_DATE))+"\n                    "),(_vm.isModified(lineItem.ACTIVATION_ID))?[_c('license-checker-check-cross',{attrs:{"check":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsRenewalIncorrect === 'Success',"cross":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsRenewalIncorrect === 'Failure'}})]:_vm._e()]:[_c('div',{staticClass:"danger-cell"},[_vm._v("\n                      "+_vm._s(_vm.getReadableDate(lineItem.VERSION_DATE))+"\n                       \n                      "),(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).IsRenewalIncorrect)?_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-exclamation-circle faulty",attrs:{"title":"Renewal issue"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"success-cell"},[_vm._v("\n                      "+_vm._s(_vm.getReadableDate(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).VERSION_DATE))+"\n                    ")])]],2),_vm._v(" "),_c('td',{class:_vm.isFaultyItem(lineItem.ACTIVATION_ID) ? 'double-cell' : ''},[(!_vm.isFaultyItem(lineItem.ACTIVATION_ID))?[_vm._v("\n                    "+_vm._s(_vm.getReadableDate(lineItem.EXPIRATION_DATE))+"\n                    "),(_vm.isModified(lineItem.ACTIVATION_ID))?[_c('license-checker-check-cross',{attrs:{"check":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsExpirationDateUpdated === 'Success',"cross":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsExpirationDateUpdated === 'Failure'}})]:_vm._e()]:[_c('div',{staticClass:"danger-cell"},[_vm._v("\n                      "+_vm._s(_vm.getReadableDate(lineItem.EXPIRATION_DATE))+"\n                       \n                      "),(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).IsExpirationDateUpdated)?_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-exclamation-circle faulty",attrs:{"title":"Expiration date incorrect"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"success-cell"},[_vm._v("\n                      "+_vm._s(_vm.getReadableDate(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).EXPIRATION_DATE))+"\n                    ")])]],2),_vm._v(" "),_c('td',{class:_vm.isFaultyItem(lineItem.ACTIVATION_ID) ? 'double-cell' : ''},[(!_vm.isFaultyItem(lineItem.ACTIVATION_ID))?[_vm._v("\n                    "+_vm._s(lineItem.ORDER_ID)+"\n                    "),(_vm.isModified(lineItem.ACTIVATION_ID))?[_c('license-checker-check-cross',{attrs:{"check":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsOrderIdNotUpdated === 'Success',"cross":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsOrderIdNotUpdated === 'Failure'}})]:_vm._e()]:[_c('div',{class:{
                        'danger-cell': true,
                        'text-center': _vm.getFaultyLineItem(lineItem.ACTIVATION_ID).IsOrderIdNotUpdated
                      }},[(!_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).IsOrderIdNotUpdated)?_c('span',[_vm._v("\n                        "+_vm._s(lineItem.ORDER_ID)+"\n                      ")]):_vm._e(),_vm._v("\n                       \n                      "),(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).IsOrderIdNotUpdated)?_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-exclamation-circle faulty",attrs:{"title":"Order ID not updated"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"success-cell"},[_vm._v("\n                      "+_vm._s(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).ORDER_ID)+"\n                    ")])]],2),_vm._v(" "),_c('td',{class:_vm.isFaultyItem(lineItem.ACTIVATION_ID) ? 'double-cell' : ''},[(!_vm.isFaultyItem(lineItem.ACTIVATION_ID))?[_vm._v("\n                    "+_vm._s(lineItem.ORDER_ID)+"\n                  ")]:[_c('div',{staticClass:"danger-cell"},[_vm._v("\n                      "+_vm._s(lineItem.ORDER_ID)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"success-cell"},[_vm._v("\n                      "+_vm._s(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).ORDER_ID)+"\n                    ")])]],2),_vm._v(" "),_c('td',{class:_vm.isFaultyItem(lineItem.ACTIVATION_ID) ? 'double-cell' : ''},[(!_vm.isFaultyItem(lineItem.ACTIVATION_ID))?[_vm._v("\n                    "+_vm._s(_vm.getLineItemStatus(lineItem.STATUS))+"\n                    "),(_vm.isModified(lineItem.ACTIVATION_ID))?[_c('license-checker-check-cross',{attrs:{"check":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsLineItemStateIncorrect === 'Success',"cross":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsLineItemStateIncorrect === 'Failure'}})]:_vm._e()]:[_c('div',{staticClass:"danger-cell"},[_vm._v("\n                      "+_vm._s(_vm.getLineItemStatus(lineItem.STATUS))+"\n                       \n                      "),(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).IsLineItemStateIncorrect)?_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.topleft.hover",modifiers:{"topleft":true,"hover":true}}],staticClass:"fa fa-exclamation-circle faulty",attrs:{"title":"Multiple line-items deployed"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"success-cell"},[_vm._v("\n                      "+_vm._s(_vm.getLineItemStatus(_vm.getFaultyLineItem(lineItem.ACTIVATION_ID).STATUS))+"\n                    ")])]],2)])}):_vm._l((_vm.lineItemsToModify),function(lineItem){return _c('tr',{key:lineItem.ID,staticClass:"danger",staticStyle:{"position":"relative"}},[_c('td',{staticClass:"double-cell"},[_c('div',{staticClass:"success-cell line-item-to-modify",style:(("margin-bottom: " + (_vm.warningRowHeight[lineItem.ACTIVATION_ID])))},[_vm._v("\n                    "+_vm._s(lineItem.ACTIVATION_ID)+"\n                  ")]),_vm._v(" "),(!_vm.hasNoActions(lineItem.ACTIVATION_ID))?_c('div',{ref:lineItem.ACTIVATION_ID,refInFor:true,staticClass:"warning-cell",style:(("margin-top: -" + (_vm.warningRowHeight[lineItem.ACTIVATION_ID])))},[_c('div',[_c('ul',{staticClass:"actions-list"},_vm._l((_vm.getFaultyRowInfo(lineItem.ACTIVATION_ID, true)),function(item,i){return _c('li',{key:item.key + i},[_c('b',{staticClass:"warning-text"},[_vm._v("Action to perform:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(((item.key) + ": " + (item.value))))]),_vm._v(" "),(_vm.shouldShowSubActions(lineItem.ACTIVATION_ID, i))?[_vm._v("\n                              \n                            "),_c('b',{staticClass:"warning-text"},[_vm._v("Sub action:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(((_vm.getFaultyRowInfo(lineItem.ACTIVATION_ID)[i].key) + ": " + (_vm.getFaultyRowInfo(lineItem.ACTIVATION_ID)[i].value))))])]:_vm._e()],2)}),0)])]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"double-cell"},[_c('div',{staticClass:"success-cell line-item-to-modify",style:(("margin-bottom: " + (_vm.warningRowHeight[lineItem.ACTIVATION_ID])))},[_vm._v("\n                    "+_vm._s(((lineItem.ALLOCATED_QTY) + "/" + (lineItem.SEAT_COUNT)))+"\n                  ")]),_vm._v(" "),(_vm.isModified(lineItem.ACTIVATION_ID))?[_c('license-checker-check-cross',{attrs:{"check":_vm.isModified(lineItem.ACTIVATION_ID, true)
                        .ACTION_STATUS.IsNotAutoAllocated === 'Success',"cross":_vm.isModified(lineItem.ACTIVATION_ID, true)
                        .ACTION_STATUS.IsNotAutoAllocated === 'Failure'}})]:_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"double-cell"},[_c('div',{staticClass:"success-cell line-item-to-modify"},[_vm._v("\n                    "+_vm._s(lineItem.FULFILLED_AMOUNT)+"\n                  ")])]),_vm._v(" "),_c('td',{staticClass:"double-cell"},[_c('div',{staticClass:"success-cell line-item-to-modify"},[_vm._v("\n                    "+_vm._s(lineItem.AVAILABLE_REALLOCATION_COUNT)+"\n                  ")])]),_vm._v(" "),_c('td',{staticClass:"double-cell"},[_c('div',{staticClass:"success-cell line-item-to-modify"},[_vm._v("\n                    "+_vm._s(_vm.getReadableDate(lineItem.VERSION_DATE))+"\n                    "),(_vm.isModified(lineItem.ACTIVATION_ID))?[_c('license-checker-check-cross',{attrs:{"check":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsRenewalIncorrect === 'Success',"cross":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsRenewalIncorrect === 'Failure'}})]:_vm._e()],2)]),_vm._v(" "),_c('td',{staticClass:"double-cell"},[_c('div',{staticClass:"success-cell line-item-to-modify"},[_vm._v("\n                    "+_vm._s(lineItem.ORDER_ID)+"\n                    "),(_vm.isModified(lineItem.ACTIVATION_ID))?[_c('license-checker-check-cross',{attrs:{"check":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsOrderIdNotUpdated === 'Success',"cross":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsOrderIdNotUpdated === 'Failure'}})]:_vm._e()],2)]),_vm._v(" "),_c('td',{staticClass:"double-cell"},[_c('div',{staticClass:"success-cell line-item-to-modify"},[_vm._v("\n                    "+_vm._s(lineItem.ORDER_ID)+"\n                  ")])]),_vm._v(" "),_c('td',{staticClass:"double-cell"},[_c('div',{staticClass:"success-cell line-item-to-modify"},[_vm._v("\n                    "+_vm._s(_vm.getLineItemStatus(lineItem.STATUS))+"\n                    "),(_vm.isModified(lineItem.ACTIVATION_ID))?[_c('license-checker-check-cross',{attrs:{"check":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsLineItemStateIncorrect === 'Success',"cross":_vm.isModified(lineItem.ACTIVATION_ID, true)
                          .ACTION_STATUS.IsLineItemStateIncorrect === 'Failure'}})]:_vm._e()],2)])])})],2)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l62O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebKeyAllocationModal_vue__ = __webpack_require__("DOMq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed257148_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebKeyAllocationModal_vue__ = __webpack_require__("bPLJ");
function injectStyle (ssrContext) {
  __webpack_require__("pSoK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ed257148"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebKeyAllocationModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed257148_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebKeyAllocationModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lLv0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"15","width":"15"}},[_c('circle',{attrs:{"cx":_vm.left,"cy":_vm.top,"r":"3","fill":"red"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d6cffac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("6awa");
function injectStyle (ssrContext) {
  __webpack_require__("C/bm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d6cffac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "liru":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ltjj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lu1g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_header_vue__ = __webpack_require__("Qai8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1626b55c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_header_vue__ = __webpack_require__("vqbv");
function injectStyle (ssrContext) {
  __webpack_require__("aGAF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1626b55c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m87b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ErrorModal',
  props: {
    modal: { type: Boolean, required: true },
    closeModal: { type: Function, required: true },
    errorType: { type: String, required: true },
    handleCtaClick: { type: Function, required: true },
    disableCta: { type: Boolean, default: false }
  },
  computed: {
    modalTitle: function modalTitle() {
      switch (this.errorType) {
        case 'allocate':
          return this.$t('multipleSelectionAllocateErrorTitle');
        default:
          return this.$t('multipleSelectionOtherErrorTitle');
      }
    },
    modalDescription: function modalDescription() {
      switch (this.errorType) {
        case 'allocate':
          return this.$t('multipleSelectionAllocateErrorDescription');
        default:
          return this.$t('multipleSelectionOtherErrorDescription');
      }
    },
    ctaButtonText: function ctaButtonText() {
      switch (this.errorType) {
        case 'allocate':
          return this.$t('allocateAvailablelicenses');
        default:
          return this.$t('multipleSelectionErrorModalButtonText', {
            action: this.$t(this.errorType)
          });
      }
    }
  }
});

/***/ }),

/***/ "mWYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en_js__ = __webpack_require__("5SxN");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return __WEBPACK_IMPORTED_MODULE_0__en_js__["a"]; });


/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loading__ = __webpack_require__("NxGh");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var locale = 'en';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_5__Loading__["a" /* default */]
  },
  data: function data() {
    return {
      title: 'User Authentication Failed!',
      loading: false,
      isUserTypeInternal: false,
      isla007User: false,
      loginId: '',
      authCookie: Object({"NODE_ENV":"production","DEBUG_MODE":false,"LICENSING_API_HOST":'licensing',"EMPLOYEE_MYCITRIX_HOST":'webapps',"EMPLOYEE_MYCITRIX_DOMAIN":'citrite.net',"EXTERNAL_MYCITRIX_HOST":'secureportal',"EXTERNAL_MYCITRIX_DOMAIN":'citrix.com',"AUTH_SERVICE_URL":"/TokenAPI/Token","PERSON_SERVICE_URL":"/AccountAPI/api/v1/person","PERSON_SERVICE_URL_INTERNAL":"/LicensingAPI/api/v1/person","RECENT_PURCHASES_URL_PREFIX":"/LicensingAPI/api/v1/","RECENT_PURCHASES_URL_SUFFIX":"/Entitlements/Recent","EXPIRING_LICENSES_URL_PREFIX":"/LicensingAPI/api/v1/","EXPIRING_LICENSES_URL_SUFFIX":"/Entitlements/Expiring","PRIME_CACHE_URL":"/Entitlements/PrimeCache","ENTITLEMENTS_URL":"/Entitlements/","LICENSES_URL":"/Licenses/","NOTES_URL":"/Notes","ACTIVITY_URL":"/Activity","LOCALE":"en","GA_ID":"UA-121797883-1","LOGGLY_KEY":"02ed2b87-d30d-4826-ad77-bd0d94dceb7d&#8203;","ALL_LICENSES_URL":"/LicensingAPI/api/v1/Entitlements/Search","APPINSIGHTS_INSTRUMENTATION_KEY":"362ae934-864d-4033-a4ff-3734c6b25dca","EXPORT_CSV_URL":"/LicensingAPI/api/v1/Entitlements/Export","ALLOCATE_URL":"/LicensingAPI/api/v1/createLicenses","ALLOCATE_DROPDOWN_URL_PREFIX":"/LicensingAPI/api/v1/","ALLOCATE_DROPDOWN_URL_SUFFIX":"/Entitlements/hostnames","DOWNLOAD_URL":"/LicensingAPI/api/v1/downloadLicenseFiles","ALLOW_PARTIAL_URL_PREFIX":"/LicensingAPI/api/v1/","ALLOW_PARTIAL_EASY_URL_PREFIX":"/LicensingAPI/api/v1/easy/","ALLOW_PARTIAL_URL_SUFFIX":"/Entitlements/getAllowPartial","ARCHIVE_URL":"/LicensingAPI/api/v1/Customization/ArchiveUnArchive","RETURN_URL":"/LicensingAPI/api/v1/returnFulfillment","SAVE_NOTES_URL":"/LicensingAPI/api/v1/Customization/Notes","EASY_URL":"/LicensingAPI/api/v1/Easy/Entitlement","MODIFY_URL":"/LicensingAPI/api/v1/modifyFulfillment","METAFRAME_ELIGIBILITY_URL":"/LicenseMisc/MetaframeEligibility","HARDWARE_ELIGIBILITY_URL":"/LicenseMisc/PendingReturns","METAFRAME_URL":"/Licensing/Login.aspx?ReturnUrl=/Licensing/CAS/elicenseactivation.aspx","HARDWARE_URL":"/Licensing/CAS/viewreturnedlicenses.aspx","WEBKEY_URL":"/Entitlements/getWebkeyDetails","RENEW_LICENSES_URL":"/dotiui/#/my-account","UPGRADE_LICENSES_URL":"/Fulfillment/Login.aspx?ReturnUrl=%2fFulfillment%2fFulfillment%2fdefault.aspx","ALLOCATE_EASY_URL":"/LicensingAPI/api/v1/easy/createLicenses","DOWNLOAD_EASY_URL":"/LicensingAPI/api/v1/easy/downloadLicenseFiles","EASY_PAGE_SIGN_IN_SUBDOMAIN":"","EASY_PAGE_SIGN_IN_URL":"/account/#/all-licensing-tools-new/overview","ALL_ASSETS_SEARCH_URL":"/LicensingAPI/api/v1/CustomerAssets/Search","ALL_ASSETS_EXPORT_URL":"/LicensingAPI/api/v1/CustomerAssets/Export","LA_007_SEARCH_URL":"/LicensingAPI/api/v1/SmartTool/","LA_007_MODIFY_URL":"/LicensingAPI/api/v1/SmartTool/ModifyFNOData","RESEND_EMAIL_URL":"/LicensingAPI/api/v1/ResendEmail/RequestNewUriEmail","SURVEY_APPLICATION_NAME":"Licensing","SURVEY_LICENSE_ACTION_RETURN":"Return","SURVEY_LICENSE_ACTION_ALLOCATE":"Allocate","SURVEY_LICENSE_ACTION_XSALLOCATE":"XSAllocate","SURVEY_APIKEY":"hW6i5LP2KLsA7Seh1NywQSzvgTXr4iyl","SURVEY_FETCH_API_URL":"https://webapi.citrix.com/survey/FetchSurveyUrlForValidSurvey","SURVEY_STORE_TRANSACTION_API_URL":"https://webapi.citrix.com/survey/StoreSurveyTransaction","LICENSE_SURVEY_URL":"https://citrix.co1.qualtrics.com/jfe/form/SV_2bFpmpvyuiPkHPf","SURVEY_ID":"SV_2bFpmpvyuiPkHPf","PARENT_FRAME_URL":"https://www.citrix.com","UBER_AGENT_DETAILS_URL":"/LicensingAPI/api/v1/UberAgent/getUberAgentLicenseDetails/","NON_STANDARD_LIC_DETAILS_URL":"/LicensingAPI/api/v1/NonStandardLIC/getNonStandardLicenseDetails/","DOWNLOAD_UBER_AGENT_LIC_URL":"/LicensingAPI/api/v1/UberAgent/DownloadUberAgentLicense/","DOWNLOAD_NON_STANDARD_LIC_URL":"/LicensingAPI/api/v1/NonStandardLIC/downloadNonStandardLicense/","GET_DOMAINS_FOR_STRONG_URL":"/LicensingAPI/api/v1/NonStandardLIC/getDomainsForStrong/","SAVE_DOMAINS_FOR_STRONG_URL":"/LicensingAPI/api/v1/NonStandardLIC/registerDomainForStrong/","GET_USERS_FOR_UNICON_URL":"/LicensingAPI/api/v1/NonStandardLIC/getUsersListForUnicon/","SAVE_USER_FOR_UNICON_URL":"/LicensingAPI/api/v1/NonStandardLIC/registerUserForUnicon/"}).AUTH_COOKIE || '',
      authServiceURL: this.UrlBuilder.authenticationUrl,
      personUrl: this.UrlBuilder.accountUrl,
      personNotFound: false,
      isInternal: window.location.host.includes('citrite.net')
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['isTokenAPICalled']), {
    authenticationError: function authenticationError() {
      return this.$store.getters.authenticationError;
    },
    staticDirPrefix: function staticDirPrefix() {
      var devEnv = 'development';
      var env = "production" || devEnv;
      return env === devEnv ? '' : '/licensingui';
    }
  }),
  // perform authentication on component create (executed when user is not authenticated)
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    if (this.$route.params.hasEditRole !== 'undefined') {
      this.IS_PERSON_IN_ROLE(this.$route.params.hasEditRole === 'true');
    }
    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].AppInsights.trackPageView('Login page', '/login');
    // move the below to url builder or a config file
    if (!this.isTokenAPICalled) {
      this.IS_TOKEN_API_CALLED(true);
      this.$store.dispatch('authenticate', {
        authURL: this.authServiceURL,
        authCookie: this.authCookie,
        authService: this.authentication
      }).then(function () {
        if (_this.isInternal) {
          _this.isUserTypeInternal = true;
          _this.loading = false;
          if (_this.$store.getters.isLA007User === true) {
            _this.$router.push('/la-007');
          }
          _this.$store.commit('setLA007User', { value: false });
        } else {
          _this.proceedWithLogin();
        }
        // pendo user identification hook
        if (!_this.isInternal) {
          var _$store$getters$authT = _this.$store.getters.authToken,
              customerId = _$store$getters$authT.customerId,
              customerOrgId = _$store$getters$authT.customerOrgId;

          try {
            var pendoObject = {
              visitor: {
                id: customerId
              },
              account: {
                id: customerOrgId
              }
            };
            var PARENT_FRAME_URL = "https://www.citrix.com";

            window.parent.postMessage(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(pendoObject), PARENT_FRAME_URL);
            window.pendo.initialize({
              visitor: {
                id: customerId
              },
              account: {
                id: customerOrgId
              }
            });
          } catch (e) {
            console.error('Pendo initialzation error');
          }
        }
      }).catch(this.handleError);
    } else {
      if (this.isInternal) {
        this.isUserTypeInternal = true;
        this.loading = false;
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapMutations */])(['IS_TOKEN_API_CALLED', 'IS_PERSON_IN_ROLE']), {
    handleError: function handleError(error) {
      this.loading = false;
      if (error.message === 'localeFetchFailed') {
        var path = this.$store.getters.previousPath;
        this.$router.push(!path ? '/' : path);
      }
      if (error.message !== 'internalUser') {
        this.loggly.log({
          errorMessage: 'Login failed',
          errorObject: error,
          errorStack: error.stack
        });
      }
    },
    proceedWithLogin: function proceedWithLogin() {
      var _this2 = this;

      this.loading = true;
      this.$store.dispatch('fetchPerson', {
        bottle: this.bottle,
        personUrl: this.UrlBuilder.accountUrl(encodeURIComponent(this.loginId))
      }).then(function () {
        var customerId = _this2.$store.getters.person.customerId;

        _this2.personNotFound = !customerId;
        if (!_this2.isUserTypeInternal) {
          locale = _this2.$store.getters.person.preferences.locale || locale;
        }
        _this2.loggly.setUserId(customerId);
        if (!locale.includes('en')) {
          return _this2.$store.dispatch('fetchLocaleJson', {
            bottle: _this2.bottle,
            url: _this2.staticDirPrefix + '/static/' + locale + '.json'
          }).catch(function () {
            throw new Error('localeFetchFailed');
          });
        }
        _this2.loading = false;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }).then(function () {
        var path = _this2.$store.getters.previousPath;
        var webkey = sessionStorage.getItem('webkey');
        if (!locale.includes('en')) {
          _this2.$i18n.setLocaleMessage(locale, _this2.$store.getters.localeJson);
          _this2.$i18n.locale = locale;
        }
        _this2.loading = false;
        if (path !== null) {
          if (path.startsWith('/login')) {
            path = '/';
          }
          _this2.$router.push(!path ? '/' : path);
        }

        if (webkey !== null) {
          _this2.$router.push('/licenses?webkey=' + webkey);
          sessionStorage.removeItem('webkey');
        }
      }).catch(this.handleError);
    }
  })
});

/***/ }),

/***/ "p0U2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p3TE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{class:("license-creation-input " + (_vm.right ? 'right' : '') + " " + (_vm.disabled ? 'disabled-input' : '')),attrs:{"type":"text","id":"datepicker-input","disabled":_vm.disabled}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p4Bc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_circle_vue__ = __webpack_require__("ZH+V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f68b3fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_circle_vue__ = __webpack_require__("lLv0");
function injectStyle (ssrContext) {
  __webpack_require__("uaU/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_circle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f68b3fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_circle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pIUa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseCheckerAside',
  props: {
    asideList: { type: Array, default: function _default() {
        return [];
      } },
    setSelectedId: { type: Function, required: true }
  },
  mounted: function mounted() {},

  computed: {
    asideListUpdated: function asideListUpdated() {
      this.asideList.forEach(function (data) {
        data.children.forEach(function (d1) {
          if (d1.faultyChildren === true) {
            data.faulty = true;
          }
        });
      });
      return this.asideList;
    }
  },
  methods: {
    setId: function setId(assetId, orderId) {
      this.setSelectedId(assetId, orderId);
    }
  }
});

/***/ }),

/***/ "pOoN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pSoK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pV3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card order-details"},[_c('div',{staticClass:"card-header"},[_vm._v("Order Details")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('table',{staticClass:"table table-borderless"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',{key:item.ID},[_c('td',[_vm._v(_vm._s(item.SAPOrderNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.SAPSKU))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.SAPLineItemNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.QUANTITY))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.HIGHLEVELITEM))])])}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("SAP Order Number")]),_vm._v(" "),_c('th',[_vm._v("SAP SKU")]),_vm._v(" "),_c('th',[_vm._v("SAP Line Item Number")]),_vm._v(" "),_c('th',[_vm._v("Quantity")]),_vm._v(" "),_c('th',[_vm._v("High Level Item")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pmKF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue__ = __webpack_require__("D1ts");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a0e87de4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeahead_vue__ = __webpack_require__("/HoS");
function injectStyle (ssrContext) {
  __webpack_require__("Onny")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0e87de4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a0e87de4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeahead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qAAc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AllocationModal__ = __webpack_require__("CeJl");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseTable',
  components: {
    'allocation-modal': __WEBPACK_IMPORTED_MODULE_5__AllocationModal__["a" /* default */]
  },
  props: {
    isTypeRecentPurchases: {
      type: Boolean,
      default: false
    },
    allItems: {
      type: Array,
      required: true
    },
    total: {
      type: Number,
      default: null
    },
    getUpdatedLicenses: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      isInternal: window.location.host.includes('citrite.net'),
      selectedLicenses: [],
      areAllLicensesSelected: false,
      hasError: false,
      isAllocateDisabled: false,
      dynamicColumnOption: 'SerialNumber',
      dynamicColumnOptions: [{ value: 'SerialNumber', text: this.$t('licenseAccessCode') }, { value: 'SAPSalesOrderNumber', text: this.$tc('orderNumber', 2) }, { value: 'HostValue', text: this.$tc('hostId', 1) }],
      allocationModal: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['isPersonInRole', 'showSurveyModal']), {
    tableHeaderClass: function tableHeaderClass() {
      return this.isTypeRecentPurchases ? 'recent-purchases-header' : 'expiring-licenses-header';
    },
    items: function items() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.allItems)).slice(0, 5);
    },
    viewAllButtonText: function viewAllButtonText() {
      return this.isTypeRecentPurchases ? 'View all new purchases link' : 'View all expiring term license link';
    },
    buttonText: function buttonText() {
      return this.isTypeRecentPurchases ? 'Allocate button' : 'Renew button';
    },
    helpButtonText: function helpButtonText() {
      return this.isTypeRecentPurchases ? 'Allocation help link' : 'Renewal help link';
    },
    isCtaButtonDisabled: function isCtaButtonDisabled() {
      if (!this.isTypeRecentPurchases) {
        return false;
      } else {
        return this.selectedLicenses.length === 0 || this.hasError || this.isAllocateDisabled;
      }
    },
    dynamicColumnHeader: function dynamicColumnHeader() {
      var _this = this;

      return this.dynamicColumnOptions.find(function (o) {
        return o.value === _this.dynamicColumnOption;
      }).text;
    },
    lastColumnHeaderText: function lastColumnHeaderText() {
      return this.isTypeRecentPurchases ? this.$t('allocated') : this.$t('expires');
    },
    hostType: function hostType() {
      return this.selectedLicenses.length > 0 ? this.$t(this.selectedLicenses[0].HostType.toLowerCase()) : '';
    }
  }),
  methods: {
    calculateDayDifference: function calculateDayDifference(date) {
      var expiring = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var isDateLessThanToday = void 0,
          from = void 0,
          to = void 0,
          number = void 0;
      number = expiring ? 0 : 1;
      date = new Date(date);
      date = date.setTime(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
      isDateLessThanToday = Date.now() < new Date(date).getTime();
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()().isSame(__WEBPACK_IMPORTED_MODULE_3_moment___default()(date), 'day')) {
        return 0;
      }
      if (expiring && !isDateLessThanToday) {
        return -1;
      }
      from = isDateLessThanToday ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(date) : __WEBPACK_IMPORTED_MODULE_3_moment___default()();
      to = isDateLessThanToday ? __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'days') : __WEBPACK_IMPORTED_MODULE_3_moment___default()(date);
      return from.diff(to, 'days') + number;
    },
    getTableRowClasses: function getTableRowClasses(expiryDate, i) {
      var classes = ['vertical-padding', i % 2 === 0 ? '' : 'odd-row'];
      var dayDifference = this.calculateDayDifference(expiryDate, true);
      if (this.isTypeRecentPurchases) {
        return classes.concat(['recent-purchases-row']);
      }
      if (dayDifference <= 29) {
        return classes.concat(['expiring-licenses-row-less-days']);
      } else if (dayDifference > 29 && dayDifference <= 89) {
        return classes.concat(['expiring-licenses-row-more-days']);
      }
      return classes;
    },
    getReadableExpiryDate: function getReadableExpiryDate(expiryDate) {
      var dayDifference = this.calculateDayDifference(expiryDate, true);
      return this.$tc('day', dayDifference, { count: dayDifference });
    },
    getTextColor: function getTextColor(expiryDate) {
      var dayDifference = this.calculateDayDifference(expiryDate, true);
      if (dayDifference >= 0 && dayDifference <= 30) return 'danger-text';else if (dayDifference > 30 && dayDifference <= 90) return 'warning-text';
      return null;
    },
    trackClick: function trackClick(linkType) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].AppInsights.trackEvent(linkType, {
        eventType: 'click',
        page: 'Landing page'
      });
    },
    handleViewAllClick: function handleViewAllClick() {
      this.trackClick(this.viewAllButtonText);
      this.$router.push({
        name: 'AllLicenses',
        params: {
          landing: this.isTypeRecentPurchases ? 'newPurchases' : 'expiringLicenses'
        }
      });
    },
    validateMultipleSelection: function validateMultipleSelection() {
      var hostType = void 0;
      if (!this.selectedLicenses.length) return;
      hostType = this.selectedLicenses[0].HostType;
      this.selectedLicenses = this.selectedLicenses.map(function (l) {
        if (l.HostType === hostType) {
          delete l.isValid;
          return l;
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, l, { isValid: false });
        }
      });
      this.hasError = this.selectedLicenses.some(function (l) {
        return l.hasOwnProperty('isValid');
      });
      this.isAllocateDisabled = this.selectedLicenses.some(function (l) {
        return l.RemainingUserCount === 0;
      });
    },
    isLicenseInvalid: function isLicenseInvalid(license) {
      return (this.isLicenseSelected(license, true) || {}).hasOwnProperty('isValid');
    },
    isLicenseSelected: function isLicenseSelected(license) {
      var returnItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selectedLicense = this.selectedLicenses.find(function (val) {
        return val.ActivationID === license.ActivationID;
      });
      return returnItem ? selectedLicense : !!selectedLicense;
    },
    toggleAllLicensesSelection: function toggleAllLicensesSelection() {
      this.selectedLicenses = this.areAllLicensesSelected ? [] : [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.items));
      this.validateMultipleSelection();
    },
    toggleLicenseSelection: function toggleLicenseSelection(license) {
      if (!this.selectedLicenses.length || !this.isLicenseSelected(license)) {
        this.selectedLicenses.push(license);
      } else {
        this.selectedLicenses = this.selectedLicenses.filter(function (l) {
          return l.ActivationID !== license.ActivationID;
        });
      }
      this.validateMultipleSelection();
    },
    handleAllocateClick: function handleAllocateClick() {
      this.trackClick(this.buttonText);
      if (this.isTypeRecentPurchases) {
        this.allocationModal = true;
      }
    },
    closeAllocationModal: function closeAllocationModal() {
      this.allocationModal = false;
    },
    handleLicenseLinkClick: function handleLicenseLinkClick(license) {
      this.$store.commit('setLicenseDetails', {
        ProductName: license.ProductName,
        ExpirationDate: license.ExpirationDate,
        IsPermanent: license.IsPermanent,
        ActivationID: license.ActivationID,
        IsArchived: license.IsArchived,
        AllowpartialAllocation: license.AllowpartialAllocation
      });
      this.$router.push('/license/' + license.ActivationID);
    },
    dynamicColumnItem: function dynamicColumnItem(license) {
      switch (this.dynamicColumnOption) {
        case 'SAPSalesOrderNumber':
          if (!license.LicenseItemNumber) {
            return license.SAPSalesOrderNumber + '/' + this.getLicenseItemNumber(license);
          }
          return license.SAPSalesOrderNumber + '/' + license.LicenseItemNumber;
        case 'HostValue':
          return license.HostValue || '';
        case 'SerialNumber':
        default:
          return license.SerialNumber || '';
      }
    },
    getAllocatedText: function getAllocatedText(_ref) {
      var RemainingUserCount = _ref.RemainingUserCount,
          UserCount = _ref.UserCount;

      return RemainingUserCount > UserCount ? UserCount + ' of ' + UserCount : UserCount - RemainingUserCount + ' of ' + UserCount;
    },
    getLastColumnItemText: function getLastColumnItemText(item) {
      return this.isTypeRecentPurchases ? this.getAllocatedText(item) : this.getReadableExpiryDate(item.ExpirationDate);
    },
    getLicenseItemNumber: function getLicenseItemNumber(_ref2) {
      var ActivationID = _ref2.ActivationID;

      return ActivationID.match(/^.*-.*-(.*)/)[1];
    },
    getLastColumnClasses: function getLastColumnClasses(_ref3) {
      var ExpirationDate = _ref3.ExpirationDate;

      var classes = ['col', 'last-col'];
      var dayDifference = this.calculateDayDifference(ExpirationDate, true);
      if (this.isTypeRecentPurchases) {
        classes.push('success-text');
      } else if (dayDifference >= 0 && dayDifference <= 30) {
        classes.push('danger-text');
      } else if (dayDifference > 30 && dayDifference <= 90) {
        classes.push('warning-text');
      }
      return classes;
    }
  }
});

/***/ }),

/***/ "qDNa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qJsV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LicenseTable__ = __webpack_require__("EfNl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DidYouKnow__ = __webpack_require__("gJII");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SomethingWentWrong__ = __webpack_require__("cFPt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NoLicenseActivity__ = __webpack_require__("ECiI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SurveyModal__ = __webpack_require__("F6yq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_SearchMixin__ = __webpack_require__("x/Xg");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var requestBody = {
  advDateFrom: null,
  advDateTo: null,
  advSearchBy: null,
  dateFrom: null,
  dateTo: null,
  duration: 0,
  noOfItems: 25,
  pageIndex: 0,
  pageNumber: 1,
  quickFind: 'active',
  searchBy: null,
  searchByValue: null,
  sortBy: null,
  sortByOrder: null
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseLists',
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_SearchMixin__["a" /* default */]],
  components: {
    'license-table': __WEBPACK_IMPORTED_MODULE_5__LicenseTable__["a" /* default */],
    'did-you-know': __WEBPACK_IMPORTED_MODULE_6__DidYouKnow__["a" /* default */],
    'something-went-wrong': __WEBPACK_IMPORTED_MODULE_7__SomethingWentWrong__["a" /* default */],
    'no-license-activity': __WEBPACK_IMPORTED_MODULE_8__NoLicenseActivity__["a" /* default */],
    'loading': __WEBPACK_IMPORTED_MODULE_9__Loading__["a" /* default */],
    'survey-modal': __WEBPACK_IMPORTED_MODULE_10__SurveyModal__["a" /* default */]
  },
  data: function data() {
    return {
      isInternal: window.location.host.includes('citrite.net'),
      newPurchases: [],
      expiringLicenses: [],
      hasApiCallFailed: false,
      loading: false,
      isApiCallDone: false,
      newPurchasesTotal: null,
      expiringLicensesTotal: null,
      showMetaframe: this.UrlBuilder.isInternalUser,
      showHardware: false,
      showModal: false,
      modalName: 'survey-license-modal',
      UberAgentDetails: [],
      DeviceTrustDetails: [],
      StrongLicDetails: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    var customerId = this.$store.getters.person.customerId;

    this.getLicenses();
    this.getUberAgentLicDetails();
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.bottle.get(this.UrlBuilder.getMetaframeEligibilityUrl(customerId)), this.bottle.get(this.UrlBuilder.getHardwareEligibilityUrl(customerId))]).then(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          showMetaframe = _ref2[0].data,
          showHardware = _ref2[1].data;

      if (!_this.UrlBuilder.isInternalUser) {
        _this.showMetaframe = showMetaframe === true || showMetaframe === 'true';
      }
      _this.showHardware = showHardware === true || showHardware === 'true';
    }).catch(function (error) {
      _this.loggly.log({
        errorMessage: 'Failed to fetch metaframe and hardware eligibility',
        errorObject: error,
        errorStack: error.stack
      });
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['isPersonInRole', 'showSurveyModal']), {
    areBothTablesEmpty: function areBothTablesEmpty() {
      return this.newPurchases.length === 0 && this.expiringLicenses.length === 0;
    },
    metaframeUrl: function metaframeUrl() {
      return this.UrlBuilder.metaframeUrl;
    },
    hardwareUrl: function hardwareUrl() {
      return this.UrlBuilder.hardwareUrl;
    },
    renewLicensesUrl: function renewLicensesUrl() {
      return this.UrlBuilder.renewLicensesUrl;
    },
    upgradeLicensesUrl: function upgradeLicensesUrl() {
      return this.UrlBuilder.upgradeLicensesUrl;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapMutations */])(['VALID_SURVEY_DATA', 'SHOW_SURVEY_MODAL', 'SURVEY_MODAL_CLOSED']), {
    handleSearchClick: function handleSearchClick() {
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].AppInsights.trackEvent(this.search.showAdvancedSearch ? 'Advanced search' : 'Search', {
        eventType: 'click',
        searchInput: this.search.searchInput,
        searchType: this.search.findLicenseByOption,
        page: 'Landing page'
      });
      this.$router.push({
        name: 'AllLicenses',
        params: {
          search: this.search,
          isAdvancedSearchVisible: this.search.showAdvancedSearch
        }
      });
    },
    handleAdvancedSearchButtonClick: function handleAdvancedSearchButtonClick(showAdvancedSearch) {
      this.search.showAdvancedSearch = showAdvancedSearch;
    },
    handleQuickFindClick: function handleQuickFindClick(filterName) {
      this.$router.push({
        name: 'AllLicenses',
        params: {
          quickFind: filterName
        }
      });
    },
    getUberAgentLicDetails: function getUberAgentLicDetails() {
      var _this2 = this;

      this.loading = true;
      this.bottle.get(this.UrlBuilder.getNonStandardLICDetails(this.$store.getters.person.customerId)).then(function (_ref3) {
        var NonStandardAssetLic = _ref3.data;

        _this2.$store.commit('setUberAgentDetails', NonStandardAssetLic.UberAgentLic);
        _this2.$store.commit('setDeviceTrustDetails', NonStandardAssetLic.deviceTrustLic);
        _this2.$store.commit('setStrongLicDetails', NonStandardAssetLic.strongLic);
        _this2.$store.commit('setUniconLicDetails', NonStandardAssetLic.uniconLic);
      }).catch(function (error) {
        _this2.loading = false;
        _this2.hasApiCallFailed = true;
        _this2.isApiCallDone = true;
        _this2.loggly.log({
          errorMessage: 'Failed to get UberAgent asset Details',
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    getLicenses: function getLicenses() {
      var _this3 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.bottle.post(this.UrlBuilder.allLicensesUrl, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, requestBody, {
        customerId: this.$store.getters.person.customerId,
        filterBy: 'newPurchases'
      })), this.bottle.post(this.UrlBuilder.allLicensesUrl, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, requestBody, {
        customerId: this.$store.getters.person.customerId,
        filterBy: 'expiringLicenses',
        sortBy: 'ExpirationDate',
        sortByOrder: 'asc'
      }))]).then(function (_ref4) {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
            newPurchasesData = _ref5[0].data,
            expiringLicensesData = _ref5[1].data;

        _this3.newPurchases = [];
        if (newPurchasesData.Licenses) {
          _this3.newPurchasesTotal = newPurchasesData.TotalCount;
          _this3.newPurchases = newPurchasesData.Licenses.filter(function (l) {
            return l.RemainingUserCount > 0;
          });
        }
        _this3.expiringLicenses = expiringLicensesData.Licenses || [];
        _this3.expiringLicensesTotal = expiringLicensesData.TotalCount;
        _this3.loading = false;
        _this3.isApiCallDone = true;
      }).catch(function (error) {
        _this3.loading = false;
        _this3.hasApiCallFailed = true;
        _this3.isApiCallDone = true;
        _this3.loggly.log({
          errorMessage: 'Failed to fetch licenses in landing page',
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    handleWebKeyAllocation: function handleWebKeyAllocation() {
      this.$router.push({
        name: 'AllLicenses',
        params: {
          showWebkeyModal: true
        }
      });
    },
    allocateManualSurvey: function allocateManualSurvey() {
      this.SURVEY_MODAL_CLOSED(false);
      this.SHOW_SURVEY_MODAL(true);
      this.VALID_SURVEY_DATA({
        surveyId: this.UrlBuilder.surveyId,
        surveyUrl: this.UrlBuilder.surveyUrl
      });
    }
  })
});

/***/ }),

/***/ "qaf/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{class:("library-citrix-icons " + _vm.localeClass),staticStyle:{"margin-top":"20px"},attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[(!_vm.UrlBuilder.isInternalUser)?[_c('home')]:[_c('tabbed-home-view')]],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rkWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { mount } from '@vue/test-utils'
// import FetchUrl from './AllLicenses.vue'

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withCredentials = false;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SurveyModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    productName: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    closeAction: {
      type: Function, required: true
    }
  },
  data: function data() {
    // endOfSurvey: document.getElementById('EndOfSurvey')
    return {
      surveyNotCompleted: false
      // wrapper: mount(this.SurveyModal)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['validSurveyData, validXSSurveyData']), {
    hasXenServer: function hasXenServer() {
      return Array.isArray(this.productName) && this.productName.some(function (item) {
        return item.ProductName.includes('XenServer');
      });
    },
    authUser: function authUser() {
      var authUser = JSON.parse(sessionStorage.getItem('auth_user') || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({}));
      authUser.perosnId ? this.sourceLink = this.sourceLink + '?PersonId=' + authUser.perosnId : this.sourceLink = this.sourceLink;
      return authUser.perosnId;
    },
    getSurveyUrl: function getSurveyUrl() {
      if (this.validSurveyData && this.validSurveyData.Url) {
        var url = this.validSurveyData.Url + '?PersonId=' + this.$store.getters.authToken.personId + '&Survey_Id=' + this.validSurveyData.Id + '&CustomerId=' + this.$store.getters.person.customerId;
        return url;
      }
    },
    getSurveyUrlBasedOnProduct: function getSurveyUrlBasedOnProduct() {
      console.log('in Survey productName', this.productName);
      // let hasXenServer = this.productName.some(item => item.ProductName.includes('XenServer'))
      console.log('in Survey hasXenServer', this.hasXenServer);
      console.log('this.validSurveyData: ', this.validSurveyData);
      if (this.hasXenServer) {
        console.log('xsUrl', this.$store.getters.xsSurveyUrl);
        if (this.$store.getters.xsSurveyUrl) {
          // (this.validXSSurveyData && this.validXSSurveyData.Url) {
          console.log('xsUrl in Survey Modal', this.$store.getters.xsSurveyUrl);
          var Xsurl = this.$store.getters.xsSurveyUrl + '?PersonId=' + this.$store.getters.authToken.personId + '&SurveyId=' + this.$store.getters.xsSurveyId + '&CustomerId=' + this.$store.getters.person.customerId;
          console.log('fina lxsUrl in Survey Modal', Xsurl);
          return Xsurl;
        }
      } else {
        console.log('validSurveyData.Url', this.$store.getters.surveyUrl);
        var url = this.$store.getters.surveyUrl + '?PersonId=' + this.$store.getters.authToken.personId + '&SurveyId=' + this.$store.getters.surveyId + '&CustomerId=' + this.$store.getters.person.customerId;
        console.log('url', url);
        return url;
      }
      // } else if (this.validSurveyData && this.validSurveyData.Url) {
      //   console.log('validSurveyData.Url', this.validSurveyData.Url)
      //   var url = this.validSurveyData.Url + '?PersonId=' + this.$store.getters.authToken.personId + '&SurveyId=' + this.validSurveyData.Id + '&CustomerId=' + this.$store.getters.person.customerId
      //   console.log('url', url)
      //   return url
      // }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapMutations */])(['SHOW_SURVEY_MODAL', 'SHOW_SURVEY_MODAL_XS', 'SURVEY_MODAL_CLOSED', 'SURVEY_MODAL_CLOSED_XS']), {
    closeModal1: function closeModal1() {
      var _this = this;

      console.log('this.productName: ', this.productName);
      console.log('this.productName: ', this.productName.length);
      if (this.hasXenServer && this.productName.length > 0) {
        console.log('endOfSurvey XenServer');
        this.checkIfSurveySubmitted().then(function (isSurveySubmitted) {
          if (isSurveySubmitted) {
            _this.SURVEY_MODAL_CLOSED_XS(true);
            _this.SHOW_SURVEY_MODAL(false);
            _this.SHOW_SURVEY_MODAL_XS(false);
            _this.closeAction(true);
          } else {
            _this.surveyNotCompleted = true;
          }
        }).catch(function (error) {
          console.error('Error checking survey submission:', error);
          _this.surveyNotCompleted = true;
        });
      } else {
        console.log('endOfSurvey');
        this.handelSurveyDisplay();
        this.SURVEY_MODAL_CLOSED(true);
        this.SHOW_SURVEY_MODAL(false);
        this.SHOW_SURVEY_MODAL_XS(false);
        this.closeAction(false);
      }
    },
    print: function print() {
      console.log('endOfSurvey', this.endOfSurvey);
    },
    handelSurveyDisplay: function handelSurveyDisplay() {
      var _this2 = this;

      var headers = {
        apiKey: this.UrlBuilder.surveyAPIKey
      };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.UrlBuilder.surveyTransactionAPIUrl, {
        PersonId: this.$store.getters.authToken.personId,
        SurveyId: this.$store.getters.surveyId,
        CustomerId: this.$store.getters.person.customerId
      }, {
        headers: headers
      }).then(function (_ref) {
        var data = _ref.data;

        if (data) {
          console.log('Don\'t Show Survey Success!');
        } else {
          console.log('Don\'t Show Survey Failure!');
        }
      }).catch(function (error) {
        _this2.loggly.log({
          errorMessage: 'Failed ',
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    checkIfSurveySubmitted: function checkIfSurveySubmitted() {
      var _this3 = this;

      var headers = {
        apiKey: this.UrlBuilder.surveyAPIKey
      };
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.UrlBuilder.surveyAPIUrl, {
        PersonId: this.$store.getters.authToken.personId,
        ApplicationName: this.UrlBuilder.surveyAppName,
        Action: 'XSAllocate'
      }, {
        headers: headers
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data && data.Url) {
          return false;
        } else {
          return true;
        }
      }).catch(function (error) {
        _this3.loggly.log({
          errorMessage: 'Failed ',
          errorObject: error,
          errorStack: error.stack
        });
        return false;
      });
    }
  })
});

/***/ }),

/***/ "s3LN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_papaparse__ = __webpack_require__("afOB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SomethingWentWrong__ = __webpack_require__("cFPt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Datepicker__ = __webpack_require__("ZzAB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_SearchMixin__ = __webpack_require__("x/Xg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_DateFormatMixin__ = __webpack_require__("fgSf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ErrorModal__ = __webpack_require__("eKWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__HideUnhideModal__ = __webpack_require__("EXtw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ReturnAllocationModal__ = __webpack_require__("8Zaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AllocationModal__ = __webpack_require__("CeJl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__WebKeyAllocationModal__ = __webpack_require__("l62O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__SurveyModal__ = __webpack_require__("F6yq");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















__WEBPACK_IMPORTED_MODULE_8_axios___default.a.defaults.withCredentials = false;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AllLicenses',
  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_10__Loading__["a" /* default */],
    'something-went-wrong': __WEBPACK_IMPORTED_MODULE_11__SomethingWentWrong__["a" /* default */],
    'datepicker': __WEBPACK_IMPORTED_MODULE_12__Datepicker__["a" /* default */],
    'error-modal': __WEBPACK_IMPORTED_MODULE_15__ErrorModal__["a" /* default */],
    'hide-unhide-modal': __WEBPACK_IMPORTED_MODULE_16__HideUnhideModal__["a" /* default */],
    'return-allocation-modal': __WEBPACK_IMPORTED_MODULE_17__ReturnAllocationModal__["a" /* default */],
    'allocation-modal': __WEBPACK_IMPORTED_MODULE_18__AllocationModal__["a" /* default */],
    'webkey-allocation-modal': __WEBPACK_IMPORTED_MODULE_19__WebKeyAllocationModal__["a" /* default */],
    'survey-modal': __WEBPACK_IMPORTED_MODULE_20__SurveyModal__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_13__mixins_SearchMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_DateFormatMixin__["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([this.fetchValidSurveyUrl('Allocate'), this.fetchValidSurveyUrl('XSAllocate')]).then(function (responses) {
      console.log('response', responses);
      var hasData = responses.some(function (response) {
        return response && response.Url;
      });
      console.log('hasData', hasData);

      // Allocate Result
      var result = responses.find(function (response) {
        return response.Action === 'Allocate';
      });
      console.log('result', result);
      if (result && result.Url) {
        _this.VALID_SURVEY_DATA({
          surveyId: result.Id,
          surveyUrl: result.Url
        });
        _this.$store.getters.surveyUrl = result.Url;
        _this.$store.getters.surveyId = result.Id;
        console.log('VALID_SURVEY_DATA', {
          surveyId: result.Id,
          surveyUrl: result.Url
        });
      } else {
        _this.SHOW_SURVEY_MODAL(false);
      }

      // XSAllocate Result
      var xsAllocationSurvey = responses.find(function (response) {
        return response.Action === 'XSAllocate';
      });
      console.log('xsAllocateionSurvey', xsAllocationSurvey);
      if (xsAllocationSurvey && xsAllocationSurvey.Url) {
        _this.VALID_SURVEY_DATA_XS({
          xsSurveyId: xsAllocationSurvey.Id,
          xsSurveyUrl: xsAllocationSurvey.Url
        });
        _this.$store.getters.xsSurveyUrl = xsAllocationSurvey.Url;
        _this.$store.getters.xsSurveyId = xsAllocationSurvey.I;
      } else {
        _this.SHOW_SURVEY_MODAL_XS(false);
      }
      console.log('VALID_SURVEY_DATA_XS', {
        xsSurveyId: xsAllocationSurvey.Id,
        xsSurveyUrl: xsAllocationSurvey.Url
      });
    }).catch(function (error) {
      _this.loggly.log({
        errorMessage: 'Failed ',
        errorObject: error,
        errorStack: error.stack
      });
    });
    // const i = this.$root.$on('XenServerAllocate', function () {
    //   i.fetchValidSurveyUrl('XSAllocate')
    // })
    var _$route$params = this.$route.params,
        search = _$route$params.search,
        isAdvancedSearchVisible = _$route$params.isAdvancedSearchVisible,
        quickFind = _$route$params.quickFind,
        landing = _$route$params.landing,
        showWebkeyModal = _$route$params.showWebkeyModal;
    var webkey = this.$route.query.webkey;

    if (showWebkeyModal) {
      this.webkeyModal = true;
    }
    if (!!webkey) {
      // eslint-disable-line
      this.webkeyModal = true;
      this.webkey = webkey;
    }
    if (quickFind && quickFind.length > 0) {
      this.quickFind = quickFind;
      this.setLicenseFilter(quickFind);
    }
    if (search && isAdvancedSearchVisible !== undefined) {
      this.search = search;
      this.wasSearchPerformed = true;
      this.isAdvancedSearchVisible = isAdvancedSearchVisible;
      if (this.search.findLicenseByOption !== 'ProductName') {
        this.dynamicColumnOption = this.search.findLicenseByOption;
      }
    }
    if (landing) {
      this.filterOption = landing;
      this.sortOption = landing === 'expiringLicenses' ? 'ExpirationDate asc' : 'StartDate asc';
    }
    if (this.$route.params.licenseFromBetaEval && this.$route.params.isNewOrAllocated) {
      if (this.$route.params.isNewOrAllocated === 'allocated') {
        this.search.searchInput = this.$route.params.licenseFromBetaEval;
        this.handleSearchClick();
      } else if (this.$route.params.isNewOrAllocated === 'new') {
        this.webkey = this.$route.params.licenseFromBetaEval;
        this.webkeyModal = true;
      }
    } else {
      this.getUpdatedLicenses();
      this.sortOption = '';
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].AppInsights.trackPageView('All licenses page', '/licenses');
  },
  data: function data() {
    return {
      isInternal: window.location.host.includes('citrite.net'),
      loading: false,
      hasApiCallFailed: false,
      currentPage: 1,
      showOptions: false,
      actionOption: '',
      filterOption: '',
      sortOption: '',
      sortOptions: [{ value: 'StartDate desc', text: this.$t('newestFirst') }, { value: 'StartDate asc', text: this.$t('oldestFirst') }, { value: 'ProductName asc', text: this.$t('productAsc') }, { value: 'ProductName desc', text: this.$t('productDesc') }, { value: 'SerialNumber asc', text: this.$t('licenseAsc') }, { value: 'SerialNumber desc', text: this.$t('licenseDesc') }, { value: 'HostValue asc', text: this.$t('hostIdAsc') }, { value: 'HostValue desc', text: this.$t('hostIdDesc') }],
      pageSizeOption: 25,
      pageSizeOptions: [25, 50, 75, 100],
      dateRangeValue: null,
      licenses: [],
      areAllLicensesSelected: false,
      selectedLicenses: [],
      dynamicColumnOption: 'SerialNumber',
      dynamicColumnOptions: [{ value: 'SerialNumber', text: this.$t('licenseAccessCode') }, { value: 'SAPSalesOrderNumber', text: this.$tc('orderNumber', 2) }, { value: 'HostValue', text: this.$tc('hostId', 1) }],
      totalLicensesCount: 0,
      quickFind: null,
      fromDate: null,
      toDate: null,
      hasError: false,
      minDate: null,
      maxDate: null,
      pageToLoad: null,
      showPagingWarning: false,
      errorModal: false,
      errorModalType: '',
      hideUnhideModal: false,
      returnModal: false,
      allocateModal: false,
      webkeyModal: false,
      hideUnhideAltered: false,
      wasSearchPerformed: false,
      webkey: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])(['isPersonInRole', 'isSurveyModalInteracted', 'isSurveyModalInteractedXS', 'showSurveyModal', 'showSurveyModalXS', 'validXSSurveyURL', 'validSurveyData']), {
    areAllActionsDisabled: function areAllActionsDisabled() {
      if (this.filterOption === 'archived' || this.quickFind === 'archived' || this.search.licenseTypeOption === 'archived') {
        return true;
      }
      if (this.selectedLicenses.some(function (l) {
        return l.IsArchived;
      })) {
        return true;
      }
      return false;
    },
    actionOptions: function actionOptions() {
      var dummyOption = { value: '', text: this.$t('selectAnAction'), disabled: true };
      var actionOptions = [{
        value: 'downloadLicenseFiles',
        text: this.$tc('downloadLicenseFiles', 2),
        disabled: this.areAllActionsDisabled
      }, {
        value: 'allocateLicenses',
        text: this.$t('allocateLicenses'),
        disabled: this.areAllActionsDisabled
      }, {
        value: 'returnAllocations',
        text: this.$t('returnAllocations'),
        disabled: this.areAllActionsDisabled
      }, {
        value: 'archiveLicenses',
        text: this.$t('archiveLicenses'),
        disabled: this.areAllActionsDisabled
      }];
      var unhideOption = {
        value: 'undoArchiveLicenses',
        text: this.$t('undoArchiveLicenses'),
        disabled: !this.licenses.every(function (l) {
          return l.IsArchived;
        })
      };
      if (this.filterOption === 'archived' || this.quickFind === 'archived' || this.search.licenseTypeOption === 'archived') {
        return [dummyOption, unhideOption];
      }
      return [dummyOption].concat(actionOptions);
    },
    filterOptions: function filterOptions() {
      return [{ value: 'expiringLicenses', text: this.$t('expiringLicenses') }, { value: 'newPurchases', text: this.$t('newLicenses') }, { value: 'availableAllocations', text: this.$t('availableAllocations') }, { value: 'trialLicenses', text: this.$t('trialLicenses') }];
    },
    isSearchInputPresent: function isSearchInputPresent() {
      return this.search.searchInput !== '';
    },
    searchBy: function searchBy() {
      if (this.quickFind !== null) {
        return null;
      }
      return this.isSearchInputPresent ? this.search.findLicenseByOption : null;
    },
    searchByValue: function searchByValue() {
      if (this.quickFind !== null) {
        return null;
      }
      return this.isSearchInputPresent ? this.search.searchInput.trim() : null;
    },
    areFromAndToDatesPresent: function areFromAndToDatesPresent() {
      var _search = this.search,
          fromDateValue = _search.fromDateValue,
          toDateValue = _search.toDateValue;

      return fromDateValue !== '' && toDateValue !== '';
    },
    advSearchBy: function advSearchBy() {
      if (this.quickFind !== null) {
        return null;
      }
      return this.areFromAndToDatesPresent ? this.search.dateOption : null;
    },
    advDateFrom: function advDateFrom() {
      if (this.quickFind !== null) {
        return null;
      }
      var fromDateValue = this.search.fromDateValue;

      return fromDateValue !== '' ? fromDateValue : null;
    },
    advDateTo: function advDateTo() {
      if (this.quickFind !== null) {
        return null;
      }
      var toDateValue = this.search.toDateValue;

      return toDateValue !== '' ? toDateValue : null;
    },
    advState: function advState() {
      if (this.quickFind !== null) {
        return null;
      }
      return this.areFromAndToDatesPresent ? this.search.licenseTypeOption : null;
    },
    sortBy: function sortBy() {
      var _this2 = this;

      if (this.filterOption === 'expiringLicenses' && this.sortOption === '') {
        var sortOption = this.sortOption;

        this.sortOption = 'ExpirationDate asc';
        setTimeout(function () {
          _this2.sortOption = sortOption;
        }, 1000);
      }
      return this.sortOption ? this.sortOption.split(' ')[0] : null;
    },
    requestBody: function requestBody() {
      if (this.quickFind !== null) {
        this.resetSearchToDefaultValues();
      }
      return {
        customerID: this.$store.getters.person.customerId,
        duration: 0,
        noOfItems: this.pageSizeOption,
        pageNumber: this.currentPage,
        pageIndex: 0,
        searchBy: this.searchBy,
        searchByValue: this.searchByValue,
        advSearchBy: this.advSearchBy,
        advDateFrom: this.advDateFrom,
        advDateTo: this.advDateTo,
        advState: this.advState,
        quickFind: this.quickFind,
        filterBy: this.filterOption || null,
        sortBy: this.sortBy,
        sortByOrder: this.sortOption ? this.sortOption.split(' ')[1] : null,
        dateFrom: this.fromDate,
        dateTo: this.toDate
      };
    },
    dynamicColumnHeader: function dynamicColumnHeader() {
      var _this3 = this;

      return this.dynamicColumnOptions.find(function (o) {
        return o.value === _this3.dynamicColumnOption;
      }).text;
    },
    hasNoRecords: function hasNoRecords() {
      return this.licenses.length === 0;
    },
    loggedInUserName: function loggedInUserName() {
      return this.$store.getters.authToken.userName || '';
    },
    loggedInUserPersonID: function loggedInUserPersonID() {
      return this.$store.getters.authToken.personId || '';
    },
    hostType: function hostType() {
      return this.selectedLicenses.length > 0 ? this.$t(this.selectedLicenses[0].HostType.toLowerCase()) : '';
    },
    errorModalCtaClickHandler: function errorModalCtaClickHandler() {
      var _this4 = this;

      var closeModalAndProceed = function closeModalAndProceed(value) {
        _this4.closeErrorModal();
        _this4.handleActionSelection({ target: { value: value } });
      };
      switch (this.errorModalType) {
        case 'allocate':
          return function () {
            _this4.selectedLicenses = _this4.selectedLicenses.filter(function (l) {
              return l.RemainingUserCount > 0;
            });
            closeModalAndProceed('allocateLicenses');
          };
        case 'download':
          return function () {
            _this4.selectedLicenses = _this4.selectedLicenses.filter(function (l) {
              return l.UserCount !== l.RemainingUserCount;
            });
            closeModalAndProceed('downloadLicenseFiles');
          };
        case 'return':
          return function () {
            _this4.selectedLicenses = _this4.selectedLicenses.filter(function (l) {
              return l.UserCount !== l.RemainingUserCount;
            });
            closeModalAndProceed('returnAllocations');
          };
        case 'hide':
          return function () {
            _this4.selectedLicenses = _this4.selectedLicenses.filter(function (l) {
              return !l.IsArchived;
            });
            closeModalAndProceed('archiveLicenses');
          };
        case 'unhide':
          return function () {
            _this4.selectedLicenses = _this4.selectedLicenses.filter(function (l) {
              return l.IsArchived;
            });
            closeModalAndProceed('archiveLicenses');
          };
        default:
          return function () {};
      }
    },
    hideUnhideModalType: function hideUnhideModalType() {
      if (this.filterOption === 'archived' || this.quickFind === 'archived' || this.search.licenseTypeOption === 'archived') {
        return 'unhide';
      }
      return 'hide';
    },
    isAllActiveMode: function isAllActiveMode() {
      return this.quickFind === 'active';
    },
    disableErrorModalCta: function disableErrorModalCta() {
      if (this.errorModalType === 'allocate') {
        return this.selectedLicenses.every(function (l) {
          return l.RemainingUserCount === 0;
        });
      } else {
        return this.selectedLicenses.every(function (l) {
          return l.UserCount === l.RemainingUserCount;
        });
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapMutations */])(['VALID_SURVEY_DATA', 'SHOW_SURVEY_MODAL', 'SHOW_SURVEY_MODAL_XS', 'SURVEY_MODAL_CLOSED', 'SURVEY_MODAL_CLOSED_XS', 'VALID_SURVEY_DATA_XS']), {
    resetSearchToDefaultValues: function resetSearchToDefaultValues() {
      this.search.showAdvancedSearch = false;
      this.search.findLicenseByOption = 'SerialNumber';
      this.search.searchInput = '';
      this.search.fromDateValue = '';
      this.search.toDateValue = '';
      this.search.licenseTypeOption = 'active';
      this.search.dateOption = 'StartDate';
    },
    getReadableDate: function getReadableDate(date) {
      var temp = __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format(this.getDateFormatBasedOnLocale());
      return temp === '01/01/0001' || temp === '0001/01/01' ? this.$t('notApplicable') : temp;
    },
    validateMultipleSelection: function validateMultipleSelection() {
      var hostType = void 0;
      if (this.filterOption === 'archived' || this.quickFind === 'archived' || this.search.licenseTypeOption === 'archived') return;
      if (!this.selectedLicenses.length) return;
      hostType = this.selectedLicenses[0].HostType;
      this.selectedLicenses = this.selectedLicenses.map(function (l) {
        if (l.HostType === hostType) {
          delete l.isValid;
          return l;
        } else {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, l, { isValid: false });
        }
      });
      this.hasError = this.selectedLicenses.some(function (l) {
        return l.hasOwnProperty('isValid');
      });
    },
    isLicenseInvalid: function isLicenseInvalid(license) {
      return (this.isLicenseSelected(license, true) || {}).hasOwnProperty('isValid');
    },
    getUpdatedLicenses: function getUpdatedLicenses() {
      var _this5 = this;

      this.loading = true;
      return this.bottle.post(this.UrlBuilder.allLicensesUrl, this.requestBody).then(function (_ref) {
        var data = _ref.data;

        _this5.licenses = data.Licenses || [];
        _this5.totalLicensesCount = data.TotalCount;
        _this5.loading = false;
        _this5.minDate = data.MinDate;
        _this5.maxDate = data.MaxDate;
        _this5.setLicenseInfo();
      }).catch(function (error) {
        _this5.loading = false;
        _this5.hasApiCallFailed = true;
        _this5.loggly.log({
          errorMessage: 'Failed to fetch all licenses',
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    calculateDayDifference: function calculateDayDifference(date) {
      var expiring = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var isDateLessThanToday = void 0,
          from = void 0,
          to = void 0,
          number = void 0;
      number = expiring ? 0 : 1;
      date = new Date(date);
      date = date.setTime(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
      isDateLessThanToday = Date.now() < new Date(date).getTime();
      if (__WEBPACK_IMPORTED_MODULE_5_moment___default()().isSame(__WEBPACK_IMPORTED_MODULE_5_moment___default()(date), 'day')) {
        return 0;
      }
      if (expiring && !isDateLessThanToday) {
        return -1;
      }
      from = isDateLessThanToday ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(date) : __WEBPACK_IMPORTED_MODULE_5_moment___default()();
      to = isDateLessThanToday ? __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(1, 'days') : __WEBPACK_IMPORTED_MODULE_5_moment___default()(date);
      return from.diff(to, 'days') + number;
    },
    isLicenseNew: function isLicenseNew(item) {
      var dayDifference = this.calculateDayDifference(item.StartDate);
      return dayDifference >= 0 && dayDifference <= 30;
    },
    isFutureLicense: function isFutureLicense(item) {
      if (this.isLicenseSelected(item, true)) {
        var date = new Date(item.StartDate);
        date = date.setTime(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
        return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).isAfter(__WEBPACK_IMPORTED_MODULE_5_moment___default()(), 'day');
      } else {
        return false;
      }
    },
    isLicenseExpiringLow: function isLicenseExpiringLow(item) {
      var dayDifference = this.calculateDayDifference(item.ExpirationDate, true);
      return dayDifference >= 0 && dayDifference <= 29;
    },
    isLicenseExpiringHigh: function isLicenseExpiringHigh(item) {
      var dayDifference = this.calculateDayDifference(item.ExpirationDate, true);
      return dayDifference > 29 && dayDifference <= 89;
    },
    getTableRowClasses: function getTableRowClasses(item, i) {
      var classes = ['vertical-padding', 'table-row', i % 2 === 1 ? 'odd-row' : ''];
      if (this.isLicenseNew(item)) {
        classes.push('new-license-row');
      } else if (this.isLicenseExpiringLow(item)) {
        classes.push('expiring-license-row-low');
      } else if (this.isLicenseExpiringHigh(item)) {
        classes.push('expiring-license-row-high');
      } else if (this.isLicenseInvalid(item)) {
        classes.push('error-row', 'left-spacing');
      } else {
        classes.push('left-spacing');
      }
      return classes;
    },
    handleFilterChange: function handleFilterChange(filter) {
      this.filterOption = filter;
      this.currentPage = 1;
      this.handleInteraction('filter');
      this.getUpdatedLicenses();
    },
    handleSortChange: function handleSortChange(value) {
      this.sortOption = value;
      this.currentPage = 1;
      this.handleInteraction('sort');
      this.getUpdatedLicenses();
      if (value.split(' ')[0] === 'HostValue') {
        this.dynamicColumnOption = 'HostValue';
      } else {
        this.dynamicColumnOption = 'SerialNumber';
      }
    },
    handleInteraction: function handleInteraction(interactionType) {
      switch (interactionType) {
        case 'action':
          __WEBPACK_IMPORTED_MODULE_4_vue__["default"].AppInsights.trackEvent('License action', {
            eventType: 'change',
            actionValue: this.actionOption,
            page: 'View all licenses'
          });
          break;
        case 'exportToCSV':
          __WEBPACK_IMPORTED_MODULE_4_vue__["default"].AppInsights.trackEvent('Export to CSV', {
            eventType: 'click',
            page: 'View all licenses'
          });
          break;
        case 'filter':
          __WEBPACK_IMPORTED_MODULE_4_vue__["default"].AppInsights.trackEvent('Filter', {
            eventType: 'change',
            filterValue: this.filterOption,
            page: 'View all licenses'
          });
          break;
        case 'sort':
          __WEBPACK_IMPORTED_MODULE_4_vue__["default"].AppInsights.trackEvent('Sort', {
            eventType: 'change',
            sortValue: this.sortOption,
            page: 'View all licenses'
          });
          break;
        case 'date':
          __WEBPACK_IMPORTED_MODULE_4_vue__["default"].AppInsights.trackEvent('Date', {
            eventType: 'change',
            dateValue: this.fromDate + ' to ' + this.toDate,
            page: 'View all licenses'
          });
          break;
        default:
          break;
      }
    },
    setLicenseFilter: function setLicenseFilter() {
      var licenseType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.quickFind = licenseType;
      this.currentPage = 1;
      this.filterOption = '';
      this.sortOption = 'StartDate desc';
      this.dateRangeValue = '';
      this.areAllLicensesSelected = false;
      this.pageSizeOption = 25;
      this.wasSearchPerformed = false;
      this.selectedLicenses = [];
      this.getUpdatedLicenses();
      this.sortOption = '';
      this.hasError = false;
    },
    getAllocatedText: function getAllocatedText(_ref2) {
      var RemainingUserCount = _ref2.RemainingUserCount,
          UserCount = _ref2.UserCount;

      return RemainingUserCount > UserCount ? UserCount + ' of ' + UserCount : UserCount - RemainingUserCount + ' of ' + UserCount;
    },
    toggleAllLicensesSelection: function toggleAllLicensesSelection() {
      this.selectedLicenses = this.areAllLicensesSelected ? [] : [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.licenses));
      this.validateMultipleSelection();
    },
    toggleLicenseSelection: function toggleLicenseSelection(license) {
      if (!this.selectedLicenses.length || !this.isLicenseSelected(license)) {
        this.selectedLicenses.push(license);
      } else {
        this.selectedLicenses = this.selectedLicenses.filter(function (l) {
          return l.ActivationID !== license.ActivationID;
        });
      }
      this.areAllLicensesSelected = this.selectedLicenses.length === this.licenses.length;
      this.validateMultipleSelection();
    },
    dynamicColumnItem: function dynamicColumnItem(license) {
      switch (this.dynamicColumnOption) {
        case 'SAPSalesOrderNumber':
          if (!license.LicenseItemNumber) {
            return license.SAPSalesOrderNumber + '/' + this.getLicenseItemNumber(license);
          }
          return license.SAPSalesOrderNumber + '/' + license.LicenseItemNumber;
        case 'HostValue':
          return license.HostValue || '';
        case 'SerialNumber':
        default:
          return license.SerialNumber || '';
      }
    },
    handleAdvancedSearchButtonClick: function handleAdvancedSearchButtonClick(showAdvancedSearch) {
      this.search.showAdvancedSearch = showAdvancedSearch;
    },
    handleSearchClick: function handleSearchClick() {
      var _this6 = this;

      this.quickFind = null;
      this.currentPage = 1;
      this.filterOption = '';
      this.dateRangeValue = '';
      this.pageSizeOption = 25;
      this.sortOption = 'StartDate desc';
      this.dynamicColumnOption = this.search.findLicenseByOption === 'ProductName' ? 'SerialNumber' : this.search.findLicenseByOption;
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].AppInsights.trackEvent(this.search.showAdvancedSearch ? 'Advanced search' : 'Search', {
        eventType: 'click',
        searchInput: this.search.searchInput,
        searchType: this.search.findLicenseByOption,
        page: 'View all licenses'
      });
      this.getUpdatedLicenses().then(function () {
        _this6.wasSearchPerformed = true;
      });
      this.sortOption = '';
    },
    paginate: function paginate(page) {
      this.currentPage = page;
      this.scrollToTop();
      this.getUpdatedLicenses();
    },
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, document.getElementById('page-top').offsetTop);
    },
    handlePageChange: function handlePageChange(currentPage) {
      if (this.selectedLicenses.length === 0) {
        if (!this.wasSearchPerformed) {
          this.search.searchInput = '';
          this.search.fromDateValue = '';
          this.search.toDateValue = '';
        }
        this.paginate(currentPage);
      } else {
        this.pageToLoad = currentPage;
        this.showPagingWarning = true;
      }
    },
    handleDateChange: function handleDateChange(_ref3) {
      var fromDate = _ref3.fromDate,
          toDate = _ref3.toDate;

      this.fromDate = fromDate;
      this.toDate = toDate;
      if (this.fromDate && this.toDate) {
        this.currentPage = 1;
        this.handleInteraction('date');
        this.getUpdatedLicenses();
      }
    },
    handlePageNumberChange: function handlePageNumberChange(pageNumber) {
      this.pageSizeOption = pageNumber;
      this.currentPage = 1;
      this.getUpdatedLicenses();
    },
    handleExportLinkClick: function handleExportLinkClick() {
      var _this7 = this;

      this.bottle.post(this.UrlBuilder.exportCsvUrl, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.requestBody, {
        noOfItems: this.totalLicensesCount
      })).then(function (_ref4) {
        var data = _ref4.data;

        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].AppInsights.trackEvent('Download action', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this7.requestBody, {
          noOfItems: _this7.totalLicensesCount
        }));
        try {
          data = __WEBPACK_IMPORTED_MODULE_7_papaparse___default.a.parse(data, {
            skipEmptyLines: true
          }).data;
          data = data.map(function (_ref5) {
            var _ref6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref5, 19),
                c1 = _ref6[0],
                c2 = _ref6[1],
                c3 = _ref6[2],
                c4 = _ref6[3],
                c6 = _ref6[5],
                c7 = _ref6[6],
                c8 = _ref6[7],
                c11 = _ref6[10],
                c12 = _ref6[11],
                c13 = _ref6[12],
                c15 = _ref6[14],
                c16 = _ref6[15],
                c17 = _ref6[16],
                c18 = _ref6[17],
                c19 = _ref6[18];

            return [_this7.cleanData(c1), _this7.cleanData(c2), _this7.cleanData(c3), _this7.cleanData(c4), _this7.cleanData(c6), _this7.cleanData(c7), _this7.cleanData(c8), _this7.cleanData(c11), _this7.cleanData(c12.includes('/1753') ? '' : c12), _this7.cleanData(c13), _this7.cleanData(c15), _this7.cleanData(c16), _this7.cleanData(c17), _this7.cleanData(c18), _this7.cleanData(c19)];
          });
          data = __WEBPACK_IMPORTED_MODULE_7_papaparse___default.a.unparse(data);
        } catch (error) {
          _this7.loggly.log({
            errorMessage: 'Error parsing the CSV data',
            errorObject: error,
            errorStack: error.stack
          });
        }
        __WEBPACK_IMPORTED_MODULE_6_downloadjs___default()(data, 'licenses.csv', 'application/octet-stream');
      }).catch(function (error) {
        _this7.loggly.log({
          errorMessage: 'Failed to fetch csv file for download',
          errorObject: error,
          errorStack: error.stack
        });
      });
      this.handleInteraction('exportToCSV');
    },
    cleanData: function cleanData(dataToClean) {
      var checkRegex = '^[=+\\-@].*';
      return dataToClean !== undefined && dataToClean !== null && dataToClean.length > 0 ? dataToClean.match(checkRegex) ? '\'' + dataToClean : dataToClean : dataToClean;
    },
    isLicenseSelected: function isLicenseSelected(license) {
      var returnItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selectedLicense = this.selectedLicenses.find(function (val) {
        return val.ActivationID === license.ActivationID;
      });
      return returnItem ? selectedLicense : !!selectedLicense;
    },
    setLicenseInfo: function setLicenseInfo() {
      this.dateRangeValue = this.getReadableDate(this.minDate) + (' ' + this.$t('to') + ' ') + this.getReadableDate(this.maxDate);
    },
    handleModalClose: function handleModalClose() {
      var shouldFocusActionDropdown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.showPagingWarning = false;
      if (this.$refs.pagination) {
        this.$refs.pagination.currentPage = this.currentPage;
      }
      if (shouldFocusActionDropdown) {
        this.scrollToTop();
      }
    },
    clearLicensesAndPaginate: function clearLicensesAndPaginate() {
      this.selectedLicenses = [];
      this.handleModalClose();
      this.paginate(this.pageToLoad);
    },
    handleActionSelection: function handleActionSelection(_ref7) {
      var _this8 = this;

      var action = _ref7.target.value;

      this.handleInteraction('action');
      switch (action) {
        case 'allocateLicenses':
          if (this.selectedLicenses.some(function (l) {
            return l.RemainingUserCount === 0;
          })) {
            this.errorModal = true;
            this.errorModalType = 'allocate';
            break;
          }
          if (this.selectedLicenses.length > 0) {
            if (this.selectedLicenses.some(function (item) {
              return item.ProductName.includes('XenServer');
            }) && this.validXSSurveyURL) {
              if (this.isSurveyModalInteractedXS) {
                this.allocateModal = true;
                this.SHOW_SURVEY_MODAL_XS(false);
                this.SHOW_SURVEY_MODAL(false);
              } else {
                this.allocateModal = false;
                this.SHOW_SURVEY_MODAL_XS(true);
                this.SHOW_SURVEY_MODAL(false);
              }
            } else {
              this.allocateModal = true;
              this.SHOW_SURVEY_MODAL(false);
              this.SHOW_SURVEY_MODAL_XS(false);
            }
          }
          break;
        case 'downloadLicenseFiles':
          if (this.selectedLicenses.some(function (l) {
            return l.UserCount === l.RemainingUserCount;
          })) {
            this.errorModal = true;
            this.errorModalType = 'download';
            break;
          }
          if (this.selectedLicenses.length > 0) {
            this.bottle.post(this.UrlBuilder.getDownloadUrl(), this.selectedLicenses.map(function (l) {
              return {
                activationID: l.ActivationID,
                customerId: _this8.$store.getters.person.customerId,
                hostId: [],
                hostType: l.HostType,
                loggedInUserName: _this8.loggedInUserName,
                loggedInUserPersonID: _this8.$store.getters.person.id,
                action: 'Redownload',
                licenseLineItemNumber: l.LicenseItemNumber,
                productName: l.ProductName,
                assetID: l.AssetID
              };
            }), {
              responseType: 'arraybuffer'
            }).then(function (_ref8) {
              var data = _ref8.data,
                  headers = _ref8.headers;

              var fileName = _this8.getDownloadFilename(headers['content-disposition']);
              switch (headers['content-type']) {
                case 'application/zip':
                  var link = document.createElement('a');
                  link.href = window.URL.createObjectURL(new Blob([data], { type: 'application/zip' }));
                  link.download = fileName;
                  link.click();
                  break;
                case 'text/html':
                  __WEBPACK_IMPORTED_MODULE_6_downloadjs___default()(data, fileName, 'text/html');
                  break;
                default:
                  break;
              }
              // this.showSurveyModal = true
              _this8.resetActionOption();
            }).catch(function (error) {
              _this8.loggly.log({
                errorMessage: 'License download failed',
                errorObject: error,
                errorStack: error.stack
              });
            });
          }
          break;
        case 'returnAllocations':
          if (this.selectedLicenses.some(function (l) {
            return l.UserCount === l.RemainingUserCount;
          })) {
            this.errorModal = true;
            this.errorModalType = 'return';
            break;
          }
          if (this.selectedLicenses.length > 0) {
            this.returnModal = true;
          }
          break;
        case 'archiveLicenses':
          if (this.selectedLicenses.some(function (l) {
            return l.IsArchived;
          })) {
            this.errorModal = true;
            this.errorModaltype = 'hide';
            break;
          }
          if (this.selectedLicenses.length > 0) {
            this.hideUnhideModal = true;
          }
          break;
        case 'undoArchiveLicenses':
          if (this.selectedLicenses.some(function (l) {
            return !l.IsArchived;
          })) {
            this.errorModal = true;
            this.errorModaltype = 'unhide';
            break;
          }
          if (this.selectedLicenses.length > 0) {
            this.hideUnhideModal = true;
          }
          break;
        default:
          break;
      }
    },
    resetActionOption: function resetActionOption() {
      var clearLicenses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (clearLicenses) {
        this.selectedLicenses = [];
      }
      this.actionOption = '';
      this.areAllLicensesSelected = false;
      if (this.$refs.actionDropdown) {
        this.$refs.actionDropdown.localValue = '';
      }
    },
    handleLicenseLinkClick: function handleLicenseLinkClick(license) {
      this.$store.commit('setLicenseDetails', {
        ProductName: license.ProductName,
        ExpirationDate: license.ExpirationDate,
        IsPermanent: license.IsPermanent,
        ActivationID: license.ActivationID,
        IsArchived: license.IsArchived,
        AllowpartialAllocation: license.AllowpartialAllocation
      });
      this.$router.push('/license/' + license.ActivationID);
    },
    closeHideUnhideModal: function closeHideUnhideModal() {
      var _this9 = this;

      this.hideUnhideModal = false;
      this.loading = true;
      this.getUpdatedLicenses().then(function () {
        _this9.resetActionOption();
        if (_this9.currentPage !== 1 && _this9.licenses.length === 0 && !_this9.hideUnhideAltered) {
          _this9.loading = true;
          _this9.currentPage = _this9.currentPage - 1;
          _this9.areAllLicensesSelected = false;
          _this9.hideUnhideAltered = true;
        }
      }).then(function () {
        return _this9.getUpdatedLicenses();
      });
    },
    closeReturnModal: function closeReturnModal() {
      this.returnModal = false;
      this.resetActionOption();
      this.getUpdatedLicenses();
    },
    closeWebkeyModal: function closeWebkeyModal() {
      this.webkeyModal = false;
    },
    closeAllocateModal: function closeAllocateModal() {
      this.allocateModal = false;
      this.resetActionOption();
      this.getUpdatedLicenses();
    },
    openAllocateModel: function openAllocateModel() {
      this.allocateModal = true;
      this.SHOW_SURVEY_MODAL_XS(false);
      this.SHOW_SURVEY_MODAL(false);
    },
    getLicenseItemNumber: function getLicenseItemNumber(_ref9) {
      var ActivationID = _ref9.ActivationID;

      return ActivationID.match(/^.*-.*-(.*)/)[1];
    },
    closeErrorModal: function closeErrorModal() {
      this.errorModal = false;
      this.resetActionOption(false);
    },
    webkeyModalCallback: function webkeyModalCallback(err, licenses, totalCount, minDate, maxDate) {
      if (!err) {
        this.licenses = licenses;
        this.totalLicensesCount = totalCount;
        this.minDate = minDate;
        this.maxDate = maxDate;
      }
      this.webkeyModal = false;
    },
    allocateFlowCallback: function allocateFlowCallback(licenses) {
      this.selectedLicenses = licenses;
      this.allocateModal = true;
    },
    getDownloadFilename: function getDownloadFilename(string) {
      return string.split('; ')[1].split('=')[1];
    },
    fetchValidSurveyUrl: function fetchValidSurveyUrl(actionType) {
      var _this10 = this;

      var headers = {
        apiKey: this.UrlBuilder.surveyAPIKey
      };
      var action = this.UrlBuilder.licenseActionAllocate;
      if (actionType === 'XSAllocate') {
        action = this.UrlBuilder.licenseActionXSAllocate;
      }
      return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(this.UrlBuilder.surveyAPIUrl, {
        PersonId: this.loggedInUserPersonID,
        ApplicationName: this.UrlBuilder.surveyAppName,
        Action: action
      }, {
        headers: headers
      }).then(function (_ref10) {
        var data = _ref10.data;

        if (data && data.Url) {
          console.log('data', data);
          var surveyData = {
            Id: data.Id,
            Url: data.Url,
            Action: data.Action
          };
          console.log('surveyData before return', surveyData);
          return surveyData;
        } else {
          return {
            Id: null,
            Url: null,
            Action: data.Action
          };
        }
      }).catch(function (error) {
        _this10.SHOW_SURVEY_MODAL(false);
        _this10.loggly.log({
          errorMessage: 'Failed ',
          errorObject: error,
          errorStack: error.stack
        });
      });
    }
  })
});

/***/ }),

/***/ "sNX3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sUkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ActivityLog',
  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_2__Loading__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      activityDetails: [],
      isInternal: window.location.host.includes('citrite.net')
    };
  },

  props: {
    hostIdType: {
      type: String,
      required: true
    },
    licenseId: {
      type: String,
      required: true
    },
    purchaseDate: {
      type: String,
      required: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    var isInternal = window.location.host.includes('citrite.net');
    var activityLogUrl = this.UrlBuilder.licenseDetailActivityLogUrl(this.$store.getters.person.customerId, this.licenseId);
    activityLogUrl = isInternal ? activityLogUrl + '/true' : activityLogUrl + '/false';
    this.bottle.get(activityLogUrl).then(function (_ref) {
      var data = _ref.data;

      _this.activityDetails = data.activityDetails || [];
      _this.loading = false;
    }).catch(function (error) {
      _this.loading = false;
      _this.loggly.log({
        errorMessage: 'Failed to fetch activity log for ' + _this.licenseId,
        errorObject: error,
        errorStack: error.stack
      });
    });
  },

  methods: {
    getReadableDate: function getReadableDate(date) {
      var locale = this.$store.getters.person.preferences.locale || 'en-US';
      var formats = {
        'zh-CN': 'YYYY/MM/DD',
        'zh-TW': 'YYYY/MM/DD',
        'jp-JP': 'YYYY/MM/DD',
        'ko-KR': 'YYYY/MM/DD',
        'en-US': 'DD/MM/YYYY'
      };
      locale = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(formats).includes(locale) ? locale : 'en-US';
      var temp = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format(formats[locale]);
      return temp === '01/01/0001' || temp === '0001/01/01' ? this.$t('notApplicable') : temp;
    }
  }
});

/***/ }),

/***/ "scEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',{attrs:{"content-class":"mt-3","value":_vm.tabIndex}},[_c('b-tab',{attrs:{"title":_vm.$t('allLicenses'),"title-link-class":_vm.tabClass},on:{"click":_vm.handleAssetTabClick}},[_c('router-view')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":_vm.$t('manageLicenses'),"title-link-class":_vm.tabClass},on:{"click":_vm.handleManageLicensesTabClick}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sfY9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v(_vm._s(_vm.pageTitle))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('p',[_vm._v("This is the app about page")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "shoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_papaparse__ = __webpack_require__("afOB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Search__ = __webpack_require__("/KFX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AllAssetsListItem__ = __webpack_require__("IZ6L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_SearchMixin__ = __webpack_require__("x/Xg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_DateFormatMixin__ = __webpack_require__("fgSf");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AllAssets',
  components: {
    'search': __WEBPACK_IMPORTED_MODULE_6__Search__["a" /* default */],
    'all-assets-list-item': __WEBPACK_IMPORTED_MODULE_7__AllAssetsListItem__["a" /* default */],
    'loading': __WEBPACK_IMPORTED_MODULE_8__Loading__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_SearchMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_DateFormatMixin__["a" /* default */]],
  mounted: function mounted() {
    this.fetchAssets();
  },
  data: function data() {
    return {
      showOptions: false,
      currentPage: 1,
      pageOption: 25,
      pageOptions: [25, 50],
      dateRangeValue: '',
      dynamicColumnOption: 'orderNumber',
      dynamicColumnOptions: [{ value: 'orderNumber', text: this.$tc('orderNumber', 2) }, { value: 'licenseAccessCode', text: this.$t('licenseAccessCode') }],
      list: [],
      loading: false,
      totalAssetsCount: 0,
      wasSearchPerformed: false
    };
  },

  computed: {
    isSearchInputPresent: function isSearchInputPresent() {
      return this.search.searchInput !== '';
    },
    searchBy: function searchBy() {
      return this.isSearchInputPresent ? this.search.findLicenseByOption : null;
    },
    searchByValue: function searchByValue() {
      return this.isSearchInputPresent ? this.search.searchInput.trim() : null;
    },
    areFromAndToDatesPresent: function areFromAndToDatesPresent() {
      var _search = this.search,
          fromDateValue = _search.fromDateValue,
          toDateValue = _search.toDateValue;

      return fromDateValue !== '' && toDateValue !== '';
    },
    advSearchBy: function advSearchBy() {
      if (this.areFromAndToDatesPresent) {
        if (this.search.dateOption === 'StartDate') return 'CreatedDate';else if (this.search.dateOption === 'ExpirationDate') return 'ExpiryDate';
        return null;
      }
      return null;
    },
    advDateFrom: function advDateFrom() {
      var fromDateValue = this.search.fromDateValue;

      return fromDateValue !== '' ? fromDateValue : null;
    },
    advDateTo: function advDateTo() {
      var toDateValue = this.search.toDateValue;

      return toDateValue !== '' ? toDateValue : null;
    },
    isSearchEmpty: function isSearchEmpty() {
      if (this.search.searchInput.length >= 2 || this.search.fromDateValue !== '' && this.search.toDateValue !== '') {
        return false;
      }
      return true;
    },
    requestBody: function requestBody() {
      return {
        customerID: this.$store.getters.person.customerId,
        noOfItems: this.pageOption,
        pageNumber: this.currentPage,
        searchBy: this.searchBy,
        searchByValue: this.searchByValue,
        advSearchBy: this.advSearchBy,
        advDateFrom: this.advDateFrom,
        advDateTo: this.advDateTo
      };
    }
  },
  methods: {
    getReadableDate: function getReadableDate(date) {
      if (!date) return 'N/A';
      if (+__WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('YYYY').includes('1752')) return 'N/A';
      var temp = __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format(this.getDateFormatBasedOnLocale());
      return temp.includes('0001') || temp.includes('1752') ? 'N/A' : temp;
    },
    fetchAssets: function fetchAssets() {
      var _this = this;

      this.loading = true;
      return this.bottle.post(this.UrlBuilder.allAssetsSearchUrl, this.requestBody).then(function (_ref) {
        var _ref$data = _ref.data,
            _ref$data$AssetList = _ref$data.AssetList,
            AssetList = _ref$data$AssetList === undefined ? [] : _ref$data$AssetList,
            TotalCount = _ref$data.TotalCount,
            MinDate = _ref$data.MinDate,
            MaxDate = _ref$data.MaxDate;

        _this.dateRangeValue = _this.getReadableDate(MinDate) + (' ' + _this.$t('to') + ' ') + _this.getReadableDate(MaxDate);
        _this.totalAssetsCount = TotalCount;
        _this.list = AssetList.map(function (d) {
          return {
            id: d.AssetID,
            productName: d.ProductName,
            orderNumber: d.SalesOrderNumber,
            licenseAccessCode: d.SerialNumber,
            quantity: d.Quantity,
            purchasedDate: d.CreatedDate,
            expirationDate: d.ExpiryDate,
            list: d.AssetComponentList.map(function (i) {
              return {
                id: i.assetcomponentID,
                name: i.ProductName,
                laCode: i.SerialNumber,
                quantity: i.Quantity,
                lineItemNumber: d.SalesOrderNumber + '/' + i.LineItemNumber
              };
            })
          };
        });
      }).catch(function (error) {
        _this.loggly.log({
          errorMessage: 'Failed to fetch assets',
          errorObject: error,
          errorStack: error.stack
        });
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleAdvancedSearchButtonClick: function handleAdvancedSearchButtonClick(showAdvancedSearch) {
      this.search.showAdvancedSearch = showAdvancedSearch;
    },
    handleSearchClick: function handleSearchClick() {
      var _this2 = this;

      if (!this.isSearchEmpty) {
        this.currentPage = 1;
        this.fetchAssets().then(function () {
          _this2.wasSearchPerformed = true;
        });
      }
    },
    handlePageNumberChange: function handlePageNumberChange(pageNumber) {
      this.pageOption = pageNumber;
      this.currentPage = 1;
      this.fetchAssets();
    },
    handleDynamicColumnOptionChange: function handleDynamicColumnOptionChange(dynamicColumnOption) {
      this.dynamicColumnOption = dynamicColumnOption;
    },
    handlePageChange: function handlePageChange(currentPage) {
      this.currentPage = currentPage;
      if (!this.wasSearchPerformed) {
        this.search.searchInput = '';
        this.search.fromDateValue = '';
        this.search.toDateValue = '';
      }
      this.fetchAssets();
    },
    handleClearSearchClick: function handleClearSearchClick() {
      this.search.searchInput = '';
      this.search.findLicenseByOption = 'SerialNumber';
      this.search.dateOption = 'StartDate';
      this.search.fromDateValue = '';
      this.search.toDateValue = '';
      this.showOptions = false;
      this.currentPage = 1;
      this.wasSearchPerformed = false;
      this.fetchAssets();
    },
    getOrderLineItemNumber: function getOrderLineItemNumber(orderNumber, lineItemNumber) {
      if (!lineItemNumber) return 'N/A';else return orderNumber + '/' + lineItemNumber;
    },
    getExpiryDate: function getExpiryDate(date) {
      return date === 'EndDate' ? 'ExpiryDate' : date;
    },
    cleanData: function cleanData(dataToClean) {
      var checkRegex = '^[=+\\-@].*';
      return dataToClean.length > 0 ? String(dataToClean).match(checkRegex) !== null ? '\'' + dataToClean : dataToClean : dataToClean;
    },
    downloadCSV: function downloadCSV() {
      var _this3 = this;

      this.bottle.post(this.UrlBuilder.allAssetsExportUrl, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestBody)).then(function (_ref2) {
        var data = _ref2.data;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].AppInsights.trackEvent('Download action', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.requestBody));
        try {
          data = __WEBPACK_IMPORTED_MODULE_4_papaparse___default.a.parse(data, {
            skipEmptyLines: true
          }).data;
          data = data.map(function (_ref3) {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 13),
                sNo = _ref4[0],
                qty = _ref4[5],
                oNo = _ref4[6],
                pName = _ref4[8],
                lNo = _ref4[10],
                eDate = _ref4[12];

            return [_this3.cleanData(pName), _this3.cleanData(sNo), _this3.cleanData(_this3.getOrderLineItemNumber(oNo, lNo)), _this3.cleanData(qty), _this3.cleanData(_this3.getExpiryDate(eDate))];
          });
          data = __WEBPACK_IMPORTED_MODULE_4_papaparse___default.a.unparse(data);
        } catch (error) {
          _this3.loggly.log({
            errorMessage: 'Error parsing the CSV data',
            errorObject: error,
            errorStack: error.stack
          });
        }
        __WEBPACK_IMPORTED_MODULE_3_downloadjs___default()(data, 'CitrixProductList.csv', 'application/octet-stream');
      }).catch(function (error) {
        _this3.loggly.log({
          errorMessage: 'Failed to fetch csv file for download',
          errorObject: error,
          errorStack: error.stack
        });
      });
    }
  }
});

/***/ }),

/***/ "t7v0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_applicationinsights_js__ = __webpack_require__("OELC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_applicationinsights_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_applicationinsights_js__);


var instrumentationKey = "362ae934-864d-4033-a4ff-3734c6b25dca";

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    __WEBPACK_IMPORTED_MODULE_0_applicationinsights_js__["AppInsights"].downloadAndSetup({ instrumentationKey: instrumentationKey, enableCorsCorrelation: true });
    Vue.AppInsights = this;
  },
  trackPageView: function trackPageView(pageName, pageUrl) {
    __WEBPACK_IMPORTED_MODULE_0_applicationinsights_js__["AppInsights"].trackPageView(pageName, pageUrl);
  },
  trackEvent: function trackEvent(eventName, eventProps) {
    __WEBPACK_IMPORTED_MODULE_0_applicationinsights_js__["AppInsights"].trackEvent(eventName, eventProps);
  },
  setAuthenticatedUserContext: function setAuthenticatedUserContext(username, customerId, storeInCookie) {
    __WEBPACK_IMPORTED_MODULE_0_applicationinsights_js__["AppInsights"].setAuthenticatedUserContext(username, customerId, storeInCookie);
  }
});

/***/ }),

/***/ "tKwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModifyAllocationModal_vue__ = __webpack_require__("AXNf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c43a5f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModifyAllocationModal_vue__ = __webpack_require__("aMqP");
function injectStyle (ssrContext) {
  __webpack_require__("Z+Ud")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31c43a5f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModifyAllocationModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c43a5f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModifyAllocationModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uBC9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_renewal_chain_vue__ = __webpack_require__("PTNS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37722eac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_renewal_chain_vue__ = __webpack_require__("y+HE");
function injectStyle (ssrContext) {
  __webpack_require__("R0Ks")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_renewal_chain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37722eac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_renewal_chain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uIWZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticStyle:{"margin-left":"-30px","margin-right":"-30px"}},[_c('div',{staticClass:"col-12 col-md-8"},[(this.$store.getters.UberAgentDetails.length>0)?_c('a',{attrs:{"href":"/"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.downloadNonStandardLicense(0)}}},[_vm._v("Download uberAgent License")]):_vm._e(),_vm._v(" "),(this.$store.getters.DeviceTrustDetails.length>0)?_c('span',{staticClass:"primary-text"},[_vm._v(" | ")]):_vm._e(),_vm._v(" "),(this.$store.getters.DeviceTrustDetails.length>0)?_c('a',{attrs:{"href":"/"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.downloadNonStandardLicense(1)}}},[_vm._v("Download deviceTRUST License")]):_vm._e(),_vm._v(" "),(this.$store.getters.StrongLicDetails.length>0)?_c('span',{staticClass:"primary-text"},[_vm._v(" | ")]):_vm._e(),_vm._v(" "),(this.$store.getters.StrongLicDetails.length>0)?_c('a',{attrs:{"href":"/"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.openRegisterDomainModal()}}},[_vm._v("Register Domain for Strong Network")]):_vm._e(),_vm._v(" "),(this.$store.getters.UniconLicDetails.length>0)?_c('span',{staticClass:"primary-text"},[_vm._v(" | ")]):_vm._e(),_vm._v(" "),(this.$store.getters.UniconLicDetails.length>0)?_c('a',{attrs:{"href":"/"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.openUniconCustomerModal()}}},[_vm._v("Activate Unicon Customer")]):_vm._e()])]),_vm._v(" "),_c('b-row',{staticStyle:{"margin-left":"-30px","margin-right":"-30px","margin-top":"10px"}},[_c('div',{staticClass:"col-12 col-md-4"},[(!_vm.hideQuickFind)?_c('p',[_vm._v("\n        "+_vm._s(_vm.$t('quickFind'))+": \n        "),_c('a',{attrs:{"href":"/#/licenses"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleQuickFindLinkClick('All Active Link', 'active')}}},[_vm._v("\n          "+_vm._s(_vm.$t('allActive'))+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"primary-text"},[_vm._v(" | ")]),_vm._v(" "),_c('a',{attrs:{"href":"/#/licenses"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleQuickFindLinkClick('All Archived Link', 'archived')}}},[_vm._v("\n          "+_vm._s(_vm.$t('allArchived'))+"\n        ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 text-right"},[_c('b-dropdown',{staticClass:"m-md-2",attrs:{"size":"sm","right":"","text":"Frequently Asked Questions"}},[(!_vm.hideQuickFind)?_c('b-dropdown-item',{attrs:{"id":"pendo-manage-my-licenses-allocate-licenses"}},[_vm._v("How to allocate a license?")]):_vm._e(),_vm._v(" "),(!_vm.hideQuickFind)?_c('b-dropdown-item',{attrs:{"id":"pendo-manage-my-licenses-reallocate-licenses"}},[_vm._v("How to re-allocate a license?")]):_vm._e(),_vm._v(" "),(!_vm.hideQuickFind)?_c('b-dropdown-item',{attrs:{"id":"pendo-manage-my-licenses-download-license-file"}},[_vm._v("How to download a license?")]):_vm._e(),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":_vm.UrlBuilder.getLicensingFaqsUrl(_vm.locale),"target":"_blank"}},[_vm._v("More on "+_vm._s(_vm.$t('licensingFaqs'))+"...")])],1)],1)]),_vm._v(" "),_c('registerdomain-modal',{attrs:{"modal":_vm.registerdomainModal,"openModal":_vm.openRegisterdomainModal,"closeModal":_vm.closeRegisterdomainModal,"customHeader":_vm.customHeader}}),_vm._v(" "),_c('uniconcustomer-modal',{attrs:{"modal":_vm.uniconcustomerModal,"openModal":_vm.openUniconCustomerModal,"closeModal":_vm.closeUniconCustomerModal,"customHeader":_vm.customHeader}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uaU/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uqRl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_typeahead__ = __webpack_require__("pmKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SurveyModal__ = __webpack_require__("F6yq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Loading__ = __webpack_require__("NxGh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AllocationModal',
  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_7__Loading__["a" /* default */],
    'typeahead': __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_typeahead__["a" /* default */],
    'survey-modal': __WEBPACK_IMPORTED_MODULE_6__SurveyModal__["a" /* default */]
  },
  props: {
    modal: { type: Boolean, required: true },
    closeModal: { type: Function, required: true },
    openModal: { type: Function, required: true },
    selectedLicenses: { type: Array, required: true },
    isFromEasyPage: { type: Boolean, default: false },
    getUpdatedLicenses: { type: Function, required: true },
    customHeader: { type: String, default: '' }
  },
  data: function data() {
    return {
      hostValue: '',
      totalRemainingCount: 0,
      remainingCount: 0,
      currentStep: 1,
      isHostValueInvalid: false,
      isFetchingDropdown: false,
      dropdownData: [],
      allowPartial: false,
      errorType: '',
      failedAllocations: [],
      succeededAllocations: [],
      wasDataFetched: false,
      isAllocateCountInvalid: false,
      isDownloading: false,
      modalName: 'survey-license-modal',
      showSurveyModalProp: true
      // showModal: false
      // (this.selectedLicenses.some(item => item.ProductName.includes('XenServer')) && (this.$store.getters.xsSurveyUrl))
    };
  },
  created: function created() {
    console.log('test', 'test');
    console.log('In Alloc modal selectedLic', this.selectedLicenses);
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].AppInsights.trackPageView('Allocation page', '/allocation');
  },
  updated: function updated() {
    var _this = this;

    if (this.modal && !this.wasDataFetched) {
      var remainingCount = this.selectedLicenses.reduce(function (a, c) {
        a = a + c.RemainingUserCount;
        return a;
      }, 0);
      this.remainingCount = remainingCount;
      this.totalRemainingCount = remainingCount;
      this.isFetchingDropdown = true;
      if (this.selectedLicenses.length === 1) {
        var _selectedLicenses$ = this.selectedLicenses[0],
            ActivationID = _selectedLicenses$.ActivationID,
            SerialNumber = _selectedLicenses$.SerialNumber;

        if (!this.isAllowPartialForWebKey) {
          this.bottle.get(this.UrlBuilder.getAllowPartialUrl(ActivationID, this.customerId, SerialNumber, this.isFromEasyPage), {
            headers: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.easyHeader)
          }).then(function (_ref) {
            var data = _ref.data;

            _this.allowPartial = data === 'true' || data === true;
          }).catch(function (error) {
            _this.loggly.log({
              errorMessage: 'Failed to fetch get allow partial parameter for license',
              errorObject: error,
              errorStack: error.stack
            });
          });
        } else {
          this.allowPartial = this.isAllowPartialForWebKey;
        }
      }
      if (!this.isFromEasyPage) {
        this.bottle.get(this.UrlBuilder.getAllocateDropdownUrl(this.activationID, this.customerId)).then(function (_ref2) {
          var data = _ref2.data;

          _this.dropdownData = data || [];
          _this.isFetchingDropdown = false;
        }).catch(function (error) {
          _this.isFetchingDropdown = false;
          _this.loggly.log({
            errorMessage: 'Failed to fetch Host IDs for dropdown',
            errorObject: error,
            errorStack: error.stack
          });
        });
      }
      this.wasDataFetched = true;
    }
    if (this.isHostTypeAny) {
      this.hostValue = 'Any';
      if (this.$refs.typeahead) {
        this.$refs.typeahead.inputValue = 'Any';
      }
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['isAllowPartialForWebKey', 'validXSSurveyData', 'isSurveyModalInteracted', 'isSurveyModalInteractedXS', 'showSurveyModal', 'showSurveyModalXS', 'validSurveyURL', 'validXSSurveyData']), {
    remainingCountState: function remainingCountState() {
      if (this.remainingCount > this.totalRemainingCount) return false;
      if (this.isAllocateCountInvalid) return false;
      return null;
    },

    // isXSSurvey () {
    //   console.log('Selected inside isXSSurvey', this.selectedLicenses)
    //   console.log('this.$store.getters.xsSurveyUrl', this.$store.getteßrs.xsSurveyUrl)
    //   if (this.$store.getters.xsSurveyUrl) {
    //     console.log('isSXSurvey method', this.validXSSurveyData.Url)
    //   }
    //   return (this.selectedLicenses.some(item => item.ProductName.includes('XenServer')) && (this.$store.getters.xsSurveyUrl))
    // },
    isFull: function isFull() {
      if (this.isAllowPartialForWebKey) return false;
      if (!this.allowPartial) return true;
      return this.selectedLicenses.length > 1;
    },
    activationID: function activationID() {
      if (this.selectedLicenses.length > 0) {
        console.log('Selected inside activationID', this.selectedLicenses);
        return this.selectedLicenses[0].ActivationID;
      }
      return '';
    },
    hostType: function hostType() {
      if (this.selectedLicenses.length > 0) {
        return this.selectedLicenses[0].HostType;
      }
      return '';
    },
    readableHostType: function readableHostType() {
      switch (this.hostType) {
        case 'Ethernet':
          return this.$t('macAddress');
        case 'Internet':
          return this.$t('ipAddress');
        case 'HostName':
          return this.$t('hostname');
      }
    },
    isHostTypeAny: function isHostTypeAny() {
      return this.hostType.toLowerCase() === 'any';
    },
    isHostTypeHostname: function isHostTypeHostname() {
      return this.hostType.toLowerCase() === 'hostname';
    },
    hostValuePlaceholder: function hostValuePlaceholder() {
      switch (this.hostType) {
        case 'Ethernet':
          return this.$t('enterMacAddress');
        case 'Internet':
          return this.$t('enterIpAddress');
        case 'HostName':
          return this.$t('enterHostName');
        case 'Any':
          return this.$t('any');
        default:
          return '';
      }
    },
    isHostValueValid: function isHostValueValid() {
      var regEx = void 0;
      var isValid = false;
      switch (this.hostType) {
        case 'Ethernet':
          regEx = /^[0-9a-fA-F]{12}$/;
          break;
        case 'Internet':
          regEx = /\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/;
          break;
        case 'HostName':
          regEx = /^[^~{}[\]<>\s]+$/; // exclude characters ~{}[]<>
          break;
        case 'Any':
          // match ethernet or internet or any
          regEx = /(^[0-9a-fA-F]{12}$|\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b|^\S*$)/;
          break;
        default:
          return false;
      }
      isValid = regEx.test(this.hostValue);
      if (isValid) {
        return !this.$store.getters.hasXssKeyWord(this.hostValue);
      }
      return false;
    },
    isStepOneCtaButtonDisabled: function isStepOneCtaButtonDisabled() {
      return this.hostValue === '' || !this.isHostValueValid || this.isAllocateCountInvalid || this.remainingCount > this.totalRemainingCount;
    },
    customerId: function customerId() {
      return this.$store.getters.person.customerId;
    },
    loggedInUserName: function loggedInUserName() {
      return this.$store.getters.authToken.userName || '';
    },
    loggedInUserPersonID: function loggedInUserPersonID() {
      return this.$store.getters.authToken.personId || '';
    },
    topMarginClass: function topMarginClass() {
      return this.isHostTypeHostname ? 'message top-margin' : '';
    },
    allocateTitle: function allocateTitle() {
      switch (this.errorType) {
        case 'data':
          return this.$t('failDataErrorTitle');
        case 'system':
          return this.$t('failSystemErrorTitle');
        default:
          return this.$t('allocateLicenses');
      }
    },
    errorDescription: function errorDescription() {
      switch (this.errorType) {
        case 'data':
          return this.$t('failDataErrorDescription', {
            customerServiceUrl: this.UrlBuilder.customerServiceUrl
          });
        case 'system':
          return this.$t('failSystemErrorDescription', {
            customerServiceUrl: this.UrlBuilder.customerServiceUrl
          });
        default:
          return '';
      }
    },
    failedDownloadText: function failedDownloadText() {
      return this.$t('referCustomerCare') + '\r\n\r\n' + (this.$t('unableToAllocatePrefix') + '\r\n\r\n') + (this.failedAllocations.join('\r\n') + '\r\n\r\n') + (this.$t('unableToAllocateSuffix') + '\r\n\r\n') + ('' + this.$t('contactCitrix'));
    },
    allocateConfirmationInfo: function allocateConfirmationInfo() {
      return this.$t('allocateConfirmationInfo', {
        remainingCount: this.remainingCount,
        hostValue: this.hostValue,
        license: this.remainingCount === 1 ? this.$t('license') : this.$tc('licenses', 2)
      });
    },
    easyHeader: function easyHeader() {
      if (!this.isFromEasyPage) return {};
      return {
        'X-Easyheader': this.customHeader
      };
    },
    invalidAllocateCount: function invalidAllocateCount() {
      if (isNaN(Number(this.remainingCount))) {
        return this.$t('invalidAllocateCountNonNumeric');
      } else if (Number(this.remainingCount) > Number(this.totalRemainingCount)) {
        return this.$t('invalidAllocateCountExcessCount', { count: this.totalRemainingCount });
      }
      return this.$t('invalidAllocateCount');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapMutations */])(['SHOW_SURVEY_MODAL', 'SHOW_SURVEY_MODAL_XS', 'SURVEY_MODAL_CLOSED', 'SURVEY_MODAL_CLOSED_XS']), {
    handleAllocateCountBlur: function handleAllocateCountBlur() {
      var count = Number(this.remainingCount);
      this.isAllocateCountInvalid = count === 0 || isNaN(count) || count > Number(this.totalRemainingCount);
    },
    createLicenseFile: function createLicenseFile() {
      var _this2 = this;

      this.currentStep = 3;
      if (this.totalRemainingCount >= this.remainingCount) {
        this.bottle.post(this.UrlBuilder.getAllocateUrl(this.isFromEasyPage), {
          customerId: this.customerId,
          fulfillmentsList: this.selectedLicenses.map(function (l) {
            return {
              activationID: l.ActivationID,
              hostValue: encodeURIComponent(_this2.hostValue),
              hostType: l.HostType,
              quantity: _this2.isFull ? l.RemainingUserCount : _this2.remainingCount,
              orderId: l.OrderID,
              serialNumber: l.SerialNumber,
              licenseLineItemNumber: l.LicenseItemNumber,
              productName: l.ProductName,
              assetID: l.AssetID
            };
          }),
          loggedInUserName: this.loggedInUserName,
          loggedInUserPersonID: this.$store.getters.person.id,
          action: 'Allocate'
        }, {
          headers: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.easyHeader)
        }).then(function (_ref3) {
          var data = _ref3.data;

          _this2.totalRemainingCount = _this2.totalRemainingCount - _this2.remainingCount;
          _this2.remainingCount = _this2.totalRemainingCount;
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].AppInsights.trackEvent('Allocation action', {
            customerId: _this2.customerId,
            data: data.map(function (d) {
              return {
                hostType: d.hostIDType,
                hostId: d.hostIDValue,
                quantity: d.quantity,
                status: d.status,
                remainingQuantity: d.remainingQuantity
              };
            })
          });
          if (data.some(function (d) {
            return d.status === 'FAILURE';
          })) {
            var failedAllocations = data.filter(function (d) {
              return d.status === 'FAILURE';
            }).map(function (d) {
              return d.activationID;
            });
            _this2.selectedLicenses.forEach(function (l) {
              var arr = void 0;
              if (failedAllocations.includes(l.ActivationID)) {
                arr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.failedAllocations));
                arr.push(l);
                _this2.failedAllocations = arr.map(function (l) {
                  return l.ActivationID;
                });
              } else {
                arr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.succeededAllocations));
                arr.push(l);
                _this2.succeededAllocations = arr;
              }
            });
            _this2.currentStep = 5;
            _this2.errorType = 'data';
          } else {
            _this2.currentStep = 4;
            _this2.succeededAllocations = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.selectedLicenses));
          }
        }).catch(function (error) {
          _this2.currentStep = 5;
          _this2.errorType = 'system';
          _this2.loggly.log({
            errorMessage: 'Failed to allocate licenses',
            errorObject: error,
            errorStack: error.stack
          });
        });
      } else {
        this.remainingCount = 0;
      }
    },
    downloadLicenseFiles: function downloadLicenseFiles() {
      var _this3 = this;

      this.isDownloading = true;
      this.bottle.post(this.UrlBuilder.getDownloadUrl(this.isFromEasyPage), this.succeededAllocations.map(function (l) {
        return {
          activationID: l.ActivationID,
          customerId: _this3.customerId,
          hostId: [_this3.hostType === 'Ethernet' ? 'Ethernet=' + _this3.hostValue : _this3.hostValue],
          hostType: _this3.hostType,
          loggedInUserName: _this3.loggedInUserName,
          loggedInUserPersonID: _this3.$store.getters.person.id,
          action: 'Allocate Download',
          licenseLineItemNumber: l.LicenseItemNumber,
          productName: l.ProductName,
          assetID: l.AssetID
        };
      }), {
        responseType: 'arraybuffer',
        headers: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.easyHeader)
      }).then(function (_ref4) {
        var data = _ref4.data,
            headers = _ref4.headers;

        var fileName = _this3.getDownloadFilename(headers['content-disposition']);
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].AppInsights.trackEvent('Download action', {
          customerId: _this3.customerId,
          data: _this3.succeededAllocations.map(function (l) {
            return {
              activationID: l.ActivationID,
              customerId: _this3.customerId,
              hostId: [_this3.hostType === 'Ethernet' ? 'Ethernet=' + _this3.hostValue : _this3.hostValue],
              hostType: _this3.hostType,
              loggedInUserName: _this3.loggedInUserName,
              loggedInUserPersonID: _this3.$store.getters.person.id,
              action: 'Allocate Download',
              licenseLineItemNumber: l.LicenseItemNumber,
              productName: l.ProductName,
              assetID: l.AssetID
            };
          })
        });
        _this3.isDownloading = false;
        switch (headers['content-type']) {
          case 'application/zip':
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([data], { type: 'application/zip' }));
            link.download = fileName;
            link.click();
            break;
          case 'text/html':
            __WEBPACK_IMPORTED_MODULE_5_downloadjs___default()(data, fileName, 'text/html');
        }
      }).catch(function (error) {
        _this3.isDownloading = false;
        _this3.loggly.log({
          errorMessage: 'License download failed',
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    validateHostValue: function validateHostValue() {
      this.isHostValueInvalid = !this.isHostValueValid;
    },
    handleHostValueChange: function handleHostValueChange(hostValue) {
      this.isHostValueInvalid = !this.isHostValueValid;
      this.$refs.typeahead.inputValue = hostValue.slice(0, 1000);
    },
    downloadFailedTextFile: function downloadFailedTextFile() {
      __WEBPACK_IMPORTED_MODULE_5_downloadjs___default()(this.failedDownloadText, 'failed-licenses.txt', 'text/html');
    },
    closeSurveyModal: function closeSurveyModal(isXenServer) {
      console.log('close survey model start');
      if (isXenServer) {
        this.openModal();
      } else {
        this.showSurveyModalProp = false;
      }
      console.log('close survey model end');
    },
    resetModalAndClose: function resetModalAndClose() {
      console.log(this.selectedLicenses);
      if (this.selectedLicenses.length > 0) {
        if (this.selectedLicenses.some(function (item) {
          return item.ProductName.includes('XenServer');
        })) {
          this.showSurveyModalProp = false;
          this.SURVEY_MODAL_CLOSED_XS(true);
          this.SHOW_SURVEY_MODAL_XS(false);
          this.SHOW_SURVEY_MODAL(false);
        } else {
          if (!this.isSurveyModalInteracted && this.validSurveyURL) {
            this.showSurveyModalProp = true;
            this.SHOW_SURVEY_MODAL(true);
            this.SHOW_SURVEY_MODAL_XS(false);
          } else {
            this.showSurveyModalProp = false;
            this.SHOW_SURVEY_MODAL(false);
            this.SHOW_SURVEY_MODAL_XS(false);
          }
        }
      }
      this.hostValue = '';
      this.totalRemainingCount = 0;
      this.remainingCount = 0;
      this.currentStep = 1;
      this.isHostValueInvalid = false;
      this.isFetchingDropdown = false;
      this.dropdownData = [];
      this.allowPartial = false;
      this.errorType = '';
      this.failedAllocations = [];
      this.succeededAllocations = [];
      this.wasDataFetched = false;
      this.isAllocateCountInvalid = false;
      this.isDownloading = false;
      this.closeModal();
      this.getUpdatedLicenses();
      this.clearTypeahead();
    },
    getDownloadFilename: function getDownloadFilename(string) {
      return string.split('; ')[1].split('=')[1];
    },
    clearTypeahead: function clearTypeahead() {
      if (this.$refs.typeahead) {
        this.$refs.typeahead.inputValue = '';
      }
    },
    goToStepOne: function goToStepOne() {
      var _this4 = this;

      this.currentStep = 1;
      this.$nextTick(function () {
        if (_this4.$refs.typeahead) {
          _this4.$refs.typeahead.value = _this4.hostValue;
          _this4.$refs.typeahead.inputValue = _this4.hostValue;
        }
      });
    }
  })
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uss5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vCx2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabbedHomeView_vue__ = __webpack_require__("Jpsp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_523f7f28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabbedHomeView_vue__ = __webpack_require__("scEU");
function injectStyle (ssrContext) {
  __webpack_require__("Fr7y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabbedHomeView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_523f7f28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabbedHomeView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vqbv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 brand-search-container"},[_c('div',{staticClass:"input-group custom-form"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticStyle:{"padding":"10px","border-radius":"3px","float":"right","position":"relative","flex":"1 1 auto"},attrs:{"type":"text","placeholder":"Enter Serial Number"},domProps:{"value":(_vm.searchInput)},on:{"keypress":function($event){return _vm.handleSearchKeypress($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn custom-btn",attrs:{"type":"button"},on:{"click":_vm.emitSearchEvent}},[_c('i',{staticClass:"fa fa-search"})])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-9 brand-title-container"},[_c('h3',[_vm._v("LA-007")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wVn8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _process$env = Object({"NODE_ENV":"production","DEBUG_MODE":false,"LICENSING_API_HOST":'licensing',"EMPLOYEE_MYCITRIX_HOST":'webapps',"EMPLOYEE_MYCITRIX_DOMAIN":'citrite.net',"EXTERNAL_MYCITRIX_HOST":'secureportal',"EXTERNAL_MYCITRIX_DOMAIN":'citrix.com',"AUTH_SERVICE_URL":"/TokenAPI/Token","PERSON_SERVICE_URL":"/AccountAPI/api/v1/person","PERSON_SERVICE_URL_INTERNAL":"/LicensingAPI/api/v1/person","RECENT_PURCHASES_URL_PREFIX":"/LicensingAPI/api/v1/","RECENT_PURCHASES_URL_SUFFIX":"/Entitlements/Recent","EXPIRING_LICENSES_URL_PREFIX":"/LicensingAPI/api/v1/","EXPIRING_LICENSES_URL_SUFFIX":"/Entitlements/Expiring","PRIME_CACHE_URL":"/Entitlements/PrimeCache","ENTITLEMENTS_URL":"/Entitlements/","LICENSES_URL":"/Licenses/","NOTES_URL":"/Notes","ACTIVITY_URL":"/Activity","LOCALE":"en","GA_ID":"UA-121797883-1","LOGGLY_KEY":"02ed2b87-d30d-4826-ad77-bd0d94dceb7d&#8203;","ALL_LICENSES_URL":"/LicensingAPI/api/v1/Entitlements/Search","APPINSIGHTS_INSTRUMENTATION_KEY":"362ae934-864d-4033-a4ff-3734c6b25dca","EXPORT_CSV_URL":"/LicensingAPI/api/v1/Entitlements/Export","ALLOCATE_URL":"/LicensingAPI/api/v1/createLicenses","ALLOCATE_DROPDOWN_URL_PREFIX":"/LicensingAPI/api/v1/","ALLOCATE_DROPDOWN_URL_SUFFIX":"/Entitlements/hostnames","DOWNLOAD_URL":"/LicensingAPI/api/v1/downloadLicenseFiles","ALLOW_PARTIAL_URL_PREFIX":"/LicensingAPI/api/v1/","ALLOW_PARTIAL_EASY_URL_PREFIX":"/LicensingAPI/api/v1/easy/","ALLOW_PARTIAL_URL_SUFFIX":"/Entitlements/getAllowPartial","ARCHIVE_URL":"/LicensingAPI/api/v1/Customization/ArchiveUnArchive","RETURN_URL":"/LicensingAPI/api/v1/returnFulfillment","SAVE_NOTES_URL":"/LicensingAPI/api/v1/Customization/Notes","EASY_URL":"/LicensingAPI/api/v1/Easy/Entitlement","MODIFY_URL":"/LicensingAPI/api/v1/modifyFulfillment","METAFRAME_ELIGIBILITY_URL":"/LicenseMisc/MetaframeEligibility","HARDWARE_ELIGIBILITY_URL":"/LicenseMisc/PendingReturns","METAFRAME_URL":"/Licensing/Login.aspx?ReturnUrl=/Licensing/CAS/elicenseactivation.aspx","HARDWARE_URL":"/Licensing/CAS/viewreturnedlicenses.aspx","WEBKEY_URL":"/Entitlements/getWebkeyDetails","RENEW_LICENSES_URL":"/dotiui/#/my-account","UPGRADE_LICENSES_URL":"/Fulfillment/Login.aspx?ReturnUrl=%2fFulfillment%2fFulfillment%2fdefault.aspx","ALLOCATE_EASY_URL":"/LicensingAPI/api/v1/easy/createLicenses","DOWNLOAD_EASY_URL":"/LicensingAPI/api/v1/easy/downloadLicenseFiles","EASY_PAGE_SIGN_IN_SUBDOMAIN":"","EASY_PAGE_SIGN_IN_URL":"/account/#/all-licensing-tools-new/overview","ALL_ASSETS_SEARCH_URL":"/LicensingAPI/api/v1/CustomerAssets/Search","ALL_ASSETS_EXPORT_URL":"/LicensingAPI/api/v1/CustomerAssets/Export","LA_007_SEARCH_URL":"/LicensingAPI/api/v1/SmartTool/","LA_007_MODIFY_URL":"/LicensingAPI/api/v1/SmartTool/ModifyFNOData","RESEND_EMAIL_URL":"/LicensingAPI/api/v1/ResendEmail/RequestNewUriEmail","SURVEY_APPLICATION_NAME":"Licensing","SURVEY_LICENSE_ACTION_RETURN":"Return","SURVEY_LICENSE_ACTION_ALLOCATE":"Allocate","SURVEY_LICENSE_ACTION_XSALLOCATE":"XSAllocate","SURVEY_APIKEY":"hW6i5LP2KLsA7Seh1NywQSzvgTXr4iyl","SURVEY_FETCH_API_URL":"https://webapi.citrix.com/survey/FetchSurveyUrlForValidSurvey","SURVEY_STORE_TRANSACTION_API_URL":"https://webapi.citrix.com/survey/StoreSurveyTransaction","LICENSE_SURVEY_URL":"https://citrix.co1.qualtrics.com/jfe/form/SV_2bFpmpvyuiPkHPf","SURVEY_ID":"SV_2bFpmpvyuiPkHPf","PARENT_FRAME_URL":"https://www.citrix.com","UBER_AGENT_DETAILS_URL":"/LicensingAPI/api/v1/UberAgent/getUberAgentLicenseDetails/","NON_STANDARD_LIC_DETAILS_URL":"/LicensingAPI/api/v1/NonStandardLIC/getNonStandardLicenseDetails/","DOWNLOAD_UBER_AGENT_LIC_URL":"/LicensingAPI/api/v1/UberAgent/DownloadUberAgentLicense/","DOWNLOAD_NON_STANDARD_LIC_URL":"/LicensingAPI/api/v1/NonStandardLIC/downloadNonStandardLicense/","GET_DOMAINS_FOR_STRONG_URL":"/LicensingAPI/api/v1/NonStandardLIC/getDomainsForStrong/","SAVE_DOMAINS_FOR_STRONG_URL":"/LicensingAPI/api/v1/NonStandardLIC/registerDomainForStrong/","GET_USERS_FOR_UNICON_URL":"/LicensingAPI/api/v1/NonStandardLIC/getUsersListForUnicon/","SAVE_USER_FOR_UNICON_URL":"/LicensingAPI/api/v1/NonStandardLIC/registerUserForUnicon/"}),
    LICENSING_API_HOST = _process$env.LICENSING_API_HOST,
    EMPLOYEE_MYCITRIX_DOMAIN = _process$env.EMPLOYEE_MYCITRIX_DOMAIN,
    EMPLOYEE_MYCITRIX_HOST = _process$env.EMPLOYEE_MYCITRIX_HOST,
    EXTERNAL_MYCITRIX_DOMAIN = _process$env.EXTERNAL_MYCITRIX_DOMAIN,
    EXTERNAL_MYCITRIX_HOST = _process$env.EXTERNAL_MYCITRIX_HOST,
    RECENT_PURCHASES_URL_PREFIX = _process$env.RECENT_PURCHASES_URL_PREFIX,
    RECENT_PURCHASES_URL_SUFFIX = _process$env.RECENT_PURCHASES_URL_SUFFIX,
    EXPIRING_LICENSES_URL_PREFIX = _process$env.EXPIRING_LICENSES_URL_PREFIX,
    EXPIRING_LICENSES_URL_SUFFIX = _process$env.EXPIRING_LICENSES_URL_SUFFIX,
    ALL_LICENSES_URL = _process$env.ALL_LICENSES_URL,
    LICENSES_URL = _process$env.LICENSES_URL,
    NOTES_URL = _process$env.NOTES_URL,
    ACTIVITY_URL = _process$env.ACTIVITY_URL,
    PRIME_CACHE_URL = _process$env.PRIME_CACHE_URL,
    EASY_URL = _process$env.EASY_URL,
    ARCHIVE_URL = _process$env.ARCHIVE_URL,
    RETURN_URL = _process$env.RETURN_URL,
    EXPORT_CSV_URL = _process$env.EXPORT_CSV_URL,
    ALLOCATE_URL = _process$env.ALLOCATE_URL,
    ALLOCATE_DROPDOWN_URL_PREFIX = _process$env.ALLOCATE_DROPDOWN_URL_PREFIX,
    MODIFY_URL = _process$env.MODIFY_URL,
    METAFRAME_ELIGIBILITY_URL = _process$env.METAFRAME_ELIGIBILITY_URL,
    ALLOCATE_DROPDOWN_URL_SUFFIX = _process$env.ALLOCATE_DROPDOWN_URL_SUFFIX,
    DOWNLOAD_URL = _process$env.DOWNLOAD_URL,
    ALLOW_PARTIAL_URL_PREFIX = _process$env.ALLOW_PARTIAL_URL_PREFIX,
    ALLOW_PARTIAL_URL_SUFFIX = _process$env.ALLOW_PARTIAL_URL_SUFFIX,
    HARDWARE_ELIGIBILITY_URL = _process$env.HARDWARE_ELIGIBILITY_URL,
    METAFRAME_URL = _process$env.METAFRAME_URL,
    HARDWARE_URL = _process$env.HARDWARE_URL,
    SAVE_NOTES_URL = _process$env.SAVE_NOTES_URL,
    WEBKEY_URL = _process$env.WEBKEY_URL,
    RENEW_LICENSES_URL = _process$env.RENEW_LICENSES_URL,
    UPGRADE_LICENSES_URL = _process$env.UPGRADE_LICENSES_URL,
    ALLOCATE_EASY_URL = _process$env.ALLOCATE_EASY_URL,
    ALLOW_PARTIAL_EASY_URL_PREFIX = _process$env.ALLOW_PARTIAL_EASY_URL_PREFIX,
    DOWNLOAD_EASY_URL = _process$env.DOWNLOAD_EASY_URL,
    EASY_PAGE_SIGN_IN_SUBDOMAIN = _process$env.EASY_PAGE_SIGN_IN_SUBDOMAIN,
    EASY_PAGE_SIGN_IN_URL = _process$env.EASY_PAGE_SIGN_IN_URL,
    ALL_ASSETS_SEARCH_URL = _process$env.ALL_ASSETS_SEARCH_URL,
    ALL_ASSETS_EXPORT_URL = _process$env.ALL_ASSETS_EXPORT_URL,
    LA_007_SEARCH_URL = _process$env.LA_007_SEARCH_URL,
    LA_007_MODIFY_URL = _process$env.LA_007_MODIFY_URL,
    RESEND_EMAIL_URL = _process$env.RESEND_EMAIL_URL,
    SURVEY_APPLICATION_NAME = _process$env.SURVEY_APPLICATION_NAME,
    SURVEY_LICENSE_ACTION_RETURN = _process$env.SURVEY_LICENSE_ACTION_RETURN,
    SURVEY_LICENSE_ACTION_ALLOCATE = _process$env.SURVEY_LICENSE_ACTION_ALLOCATE,
    SURVEY_APIKEY = _process$env.SURVEY_APIKEY,
    SURVEY_FETCH_API_URL = _process$env.SURVEY_FETCH_API_URL,
    SURVEY_STORE_TRANSACTION_API_URL = _process$env.SURVEY_STORE_TRANSACTION_API_URL,
    AUTH_SERVICE_URL = _process$env.AUTH_SERVICE_URL,
    PERSON_SERVICE_URL = _process$env.PERSON_SERVICE_URL,
    PERSON_SERVICE_URL_INTERNAL = _process$env.PERSON_SERVICE_URL_INTERNAL,
    LICENSE_SURVEY_URL = _process$env.LICENSE_SURVEY_URL,
    SURVEY_ID = _process$env.SURVEY_ID,
    DOWNLOAD_UBER_AGENT_LIC_URL = _process$env.DOWNLOAD_UBER_AGENT_LIC_URL,
    UBER_AGENT_DETAILS_URL = _process$env.UBER_AGENT_DETAILS_URL,
    NON_STANDARD_LIC_DETAILS_URL = _process$env.NON_STANDARD_LIC_DETAILS_URL,
    DOWNLOAD_NON_STANDARD_LIC_URL = _process$env.DOWNLOAD_NON_STANDARD_LIC_URL,
    GET_DOMAINS_FOR_STRONG_URL = _process$env.GET_DOMAINS_FOR_STRONG_URL,
    SAVE_DOMAINS_FOR_STRONG_URL = _process$env.SAVE_DOMAINS_FOR_STRONG_URL,
    GET_USERS_FOR_UNICON_URL = _process$env.GET_USERS_FOR_UNICON_URL,
    SAVE_USER_FOR_UNICON_URL = _process$env.SAVE_USER_FOR_UNICON_URL,
    SURVEY_LICENSE_ACTION_XSALLOCATE = _process$env.SURVEY_LICENSE_ACTION_XSALLOCATE,
    LICENSE_SURVEY_URL_XS = _process$env.LICENSE_SURVEY_URL_XS,
    SURVEY_ID_XS = _process$env.SURVEY_ID_XS;
var _location = location,
    hostname = _location.hostname,
    protocol = _location.protocol;

var licensingBasePrefix = protocol + '//' + LICENSING_API_HOST;

var UrlBuilder = {};
UrlBuilder.install = function (Vue) {
  Vue.prototype.UrlBuilder = UrlBuilder;
};
UrlBuilder.employeeBaseUrl = protocol + '//' + EMPLOYEE_MYCITRIX_HOST + '.' + EMPLOYEE_MYCITRIX_DOMAIN;
UrlBuilder.externalBaseUrl = protocol + '//' + EXTERNAL_MYCITRIX_HOST + '.' + EXTERNAL_MYCITRIX_DOMAIN;
UrlBuilder.isInternalUser = hostname.includes(EMPLOYEE_MYCITRIX_DOMAIN);
UrlBuilder.myCitrixBaseUrl = UrlBuilder.isInternalUser ? UrlBuilder.employeeBaseUrl : UrlBuilder.externalBaseUrl;
UrlBuilder.licensingBaseUrl = UrlBuilder.isInternalUser ? licensingBasePrefix + '.' + EMPLOYEE_MYCITRIX_DOMAIN : licensingBasePrefix + '.' + EXTERNAL_MYCITRIX_DOMAIN;
// UrlBuilder.licensingBaseUrl = `https://masdwebidev05.citrite.net`
UrlBuilder.authenticationUrl = '' + UrlBuilder.myCitrixBaseUrl + AUTH_SERVICE_URL;
UrlBuilder.accountUrl = function () {
  var loginId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return loginId.length <= 0 ? '' + UrlBuilder.myCitrixBaseUrl + PERSON_SERVICE_URL : '' + UrlBuilder.licensingBaseUrl + PERSON_SERVICE_URL_INTERNAL + '/username/' + loginId + '/';
};
UrlBuilder.recentPurchasesUrl = function (customerId) {
  return '' + UrlBuilder.licensingBaseUrl + RECENT_PURCHASES_URL_PREFIX + customerId + RECENT_PURCHASES_URL_SUFFIX;
};
UrlBuilder.expiringLicensesUrl = function (customerId) {
  return '' + UrlBuilder.licensingBaseUrl + EXPIRING_LICENSES_URL_PREFIX + customerId + EXPIRING_LICENSES_URL_SUFFIX;
};
UrlBuilder.allLicensesUrl = '' + UrlBuilder.licensingBaseUrl + ALL_LICENSES_URL;
UrlBuilder.licenseDetailUrl = function (customerId, activationId) {
  return '' + UrlBuilder.licensingBaseUrl + EXPIRING_LICENSES_URL_PREFIX + customerId + LICENSES_URL + activationId;
};
UrlBuilder.licenseDetailNotesUrl = function (customerId, activationId) {
  return '' + UrlBuilder.licensingBaseUrl + EXPIRING_LICENSES_URL_PREFIX + customerId + LICENSES_URL + activationId + NOTES_URL;
};
UrlBuilder.licenseDetailActivityLogUrl = function (customerId, activationId) {
  return '' + UrlBuilder.licensingBaseUrl + EXPIRING_LICENSES_URL_PREFIX + customerId + LICENSES_URL + activationId + ACTIVITY_URL;
};
UrlBuilder.getCadsFromCacheUrl = function (customerId) {
  return '' + UrlBuilder.licensingBaseUrl + EXPIRING_LICENSES_URL_PREFIX + customerId + PRIME_CACHE_URL;
};
UrlBuilder.entitlementByIdUrl = function (entitlementId) {
  return '' + UrlBuilder.licensingBaseUrl + EXPIRING_LICENSES_URL_PREFIX + EASY_URL + entitlementId;
};
UrlBuilder.exportCsvUrl = '' + UrlBuilder.licensingBaseUrl + EXPORT_CSV_URL;
UrlBuilder.getAllocateUrl = function () {
  var fromEasy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return fromEasy ? '' + UrlBuilder.licensingBaseUrl + ALLOCATE_EASY_URL : '' + UrlBuilder.licensingBaseUrl + ALLOCATE_URL;
};
UrlBuilder.getAllocateDropdownUrl = function (activationId, customerId) {
  return '' + UrlBuilder.licensingBaseUrl + ALLOCATE_DROPDOWN_URL_PREFIX + activationId + '/' + customerId + ALLOCATE_DROPDOWN_URL_SUFFIX;
};
UrlBuilder.getDownloadUrl = function () {
  var fromEasy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return fromEasy ? '' + UrlBuilder.licensingBaseUrl + DOWNLOAD_EASY_URL : '' + UrlBuilder.licensingBaseUrl + DOWNLOAD_URL;
};
UrlBuilder.getAllowPartialUrl = function (activationId, customerId, serialNumber) {
  var fromEasy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return fromEasy ? '' + UrlBuilder.licensingBaseUrl + ALLOW_PARTIAL_EASY_URL_PREFIX + activationId + '/' + customerId + '/' + serialNumber + ALLOW_PARTIAL_URL_SUFFIX : '' + UrlBuilder.licensingBaseUrl + ALLOW_PARTIAL_URL_PREFIX + activationId + '/' + customerId + '/' + serialNumber + ALLOW_PARTIAL_URL_SUFFIX;
};
UrlBuilder.archiveLicensesUrl = '' + UrlBuilder.licensingBaseUrl + ARCHIVE_URL;
UrlBuilder.returnUrl = '' + UrlBuilder.licensingBaseUrl + RETURN_URL;
UrlBuilder.saveNotesUrl = '' + UrlBuilder.licensingBaseUrl + SAVE_NOTES_URL;
UrlBuilder.easyUrl = '' + UrlBuilder.licensingBaseUrl + EASY_URL;
UrlBuilder.modifyUrl = '' + UrlBuilder.licensingBaseUrl + MODIFY_URL;
UrlBuilder.getMetaframeEligibilityUrl = function (customerId) {
  return '' + UrlBuilder.licensingBaseUrl + ALLOCATE_DROPDOWN_URL_PREFIX + customerId + METAFRAME_ELIGIBILITY_URL;
};
UrlBuilder.getHardwareEligibilityUrl = function (customerId) {
  return '' + UrlBuilder.licensingBaseUrl + ALLOCATE_DROPDOWN_URL_PREFIX + customerId + HARDWARE_ELIGIBILITY_URL;
};
UrlBuilder.metaframeUrl = '' + UrlBuilder.myCitrixBaseUrl + METAFRAME_URL;
UrlBuilder.hardwareUrl = '' + UrlBuilder.myCitrixBaseUrl + HARDWARE_URL;
UrlBuilder.getWebkeyUrl = function (value, customerId) {
  return '' + UrlBuilder.licensingBaseUrl + ALLOCATE_DROPDOWN_URL_PREFIX + value + '/' + customerId + WEBKEY_URL;
};
UrlBuilder.customerServiceUrl = 'https://www.citrix.com/support/open-a-support-case/';
UrlBuilder.citrixLicensingDocumentationUrl = 'https://docs.citrix.com/en-us/licensing/current-release.html';
UrlBuilder.docsUrl = 'https://docs.citrix.com/';
UrlBuilder.renewLicensesUrl = '' + UrlBuilder.myCitrixBaseUrl + RENEW_LICENSES_URL;
UrlBuilder.upgradeLicensesUrl = '' + UrlBuilder.myCitrixBaseUrl + UPGRADE_LICENSES_URL;
UrlBuilder.getLicensingFaqsUrl = function (locale) {
  return 'https://docs.citrix.com/' + locale + '/licensing/current-release/frequently-asked-questions.html';
};
UrlBuilder.easyPageSignInUrl = protocol + '//' + EASY_PAGE_SIGN_IN_SUBDOMAIN + EXTERNAL_MYCITRIX_DOMAIN + EASY_PAGE_SIGN_IN_URL;
UrlBuilder.allAssetsSearchUrl = '' + UrlBuilder.licensingBaseUrl + ALL_ASSETS_SEARCH_URL;
UrlBuilder.allAssetsExportUrl = '' + UrlBuilder.licensingBaseUrl + ALL_ASSETS_EXPORT_URL;
UrlBuilder.getLa007SearchUrl = function (searchInput) {
  return '' + UrlBuilder.licensingBaseUrl + LA_007_SEARCH_URL + searchInput;
};
UrlBuilder.la007ModifyUrl = '' + UrlBuilder.licensingBaseUrl + LA_007_MODIFY_URL;
UrlBuilder.resendEmailUrl = '' + UrlBuilder.licensingBaseUrl + RESEND_EMAIL_URL;
UrlBuilder.surveyAPIUrl = '' + SURVEY_FETCH_API_URL;
UrlBuilder.surveyTransactionAPIUrl = '' + SURVEY_STORE_TRANSACTION_API_URL;
UrlBuilder.surveyAppName = '' + SURVEY_APPLICATION_NAME;
UrlBuilder.licenseActionReturn = '' + SURVEY_LICENSE_ACTION_RETURN;
UrlBuilder.licenseActionAllocate = '' + SURVEY_LICENSE_ACTION_ALLOCATE;
UrlBuilder.licenseActionXSAllocate = '' + SURVEY_LICENSE_ACTION_XSALLOCATE;
UrlBuilder.surveyAPIKey = '' + SURVEY_APIKEY;
UrlBuilder.surveyUrl = '' + LICENSE_SURVEY_URL;
UrlBuilder.surveyId = '' + SURVEY_ID;
UrlBuilder.XSSurveyUrl = '' + LICENSE_SURVEY_URL_XS;
UrlBuilder.XSSurveyId = '' + SURVEY_ID_XS;
UrlBuilder.endUserLicenseAgreement = 'https://www.citrix.com/en-gb/buy/licensing/agreements.html';
UrlBuilder.rightToAuditCompliance = 'https://www.citrix.com/about/legal/product-license-compliance.html';
UrlBuilder.warningLicenseRehostLink = 'https://support.citrix.com/article/CTX134629';
UrlBuilder.getUberAgentDetails = function (customerId) {
  return '' + UrlBuilder.licensingBaseUrl + UBER_AGENT_DETAILS_URL + customerId;
};
UrlBuilder.downloadUberAgentLic = function (customerName, Quantity, Expiry, AssetComponentId) {
  return '' + UrlBuilder.licensingBaseUrl + DOWNLOAD_UBER_AGENT_LIC_URL + customerName + '/' + Quantity + '/' + Expiry + '/' + AssetComponentId;
};
UrlBuilder.getNonStandardLICDetails = function (customerId) {
  return '' + UrlBuilder.licensingBaseUrl + NON_STANDARD_LIC_DETAILS_URL + customerId;
};
UrlBuilder.downloadNonStandardLic = function (nsLicType, customerId) {
  return '' + UrlBuilder.licensingBaseUrl + DOWNLOAD_NON_STANDARD_LIC_URL + nsLicType + '/' + customerId;
};
UrlBuilder.getDomainsListForStrong = function (customerId) {
  return '' + UrlBuilder.licensingBaseUrl + GET_DOMAINS_FOR_STRONG_URL + customerId;
};
UrlBuilder.saveDomainsForStrong = function (customerId) {
  return '' + UrlBuilder.licensingBaseUrl + SAVE_DOMAINS_FOR_STRONG_URL + customerId;
};
UrlBuilder.getUserListForUnicon = function (customerId) {
  return '' + UrlBuilder.licensingBaseUrl + GET_USERS_FOR_UNICON_URL + customerId;
};
UrlBuilder.updateUserListForUnicon = function () {
  return '' + UrlBuilder.licensingBaseUrl + SAVE_USER_FOR_UNICON_URL;
};
/* harmony default export */ __webpack_exports__["a"] = (UrlBuilder);

/***/ }),

/***/ "wkmZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.modalName),expression:"modalName"}],attrs:{"visible":_vm.modal},on:{"hide":_vm.resetModalAndClose}},[[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"},[_vm._v("\n        "+_vm._s(_vm.allocateTitle)+"\n      ")]),_vm._v(" "),_c('b-alert',{attrs:{"dismissible":"","variant":_vm.isSuccess ?('success') :('danger')},on:{"dismissed":_vm.clearScreen},model:{value:(_vm.isApiCallComplete),callback:function ($$v) {_vm.isApiCallComplete=$$v},expression:"isApiCallComplete"}},[_vm._v("\n        "+_vm._s((_vm.isSuccess && _vm.isApiCallComplete) ? (_vm.$t('submitDomainSuccessMessage')) : (_vm.$t('submitDomainFailureMessage')))+"\n      ")])],_vm._v(" "),[_c('table',{staticClass:"rdm-table"},[_c('tbody',_vm._l((_vm.tableData),function(domainName,index){return _c('tr',{key:index},[_c('td',{attrs:{"width":"80%"}},[(!_vm.editing[index])?_c('span',[_vm._v(_vm._s(domainName))]):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tableData[index]),expression:"tableData[index]"}],domProps:{"value":(_vm.tableData[index])},on:{"blur":function($event){return _vm.saveRow(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tableData, index, $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('b-button',{staticClass:"rdm-table-btn",on:{"click":function($event){return _vm.editRow(index)}}},[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"#2071c5"}})]),_vm._v(" "),_c('b-button',{staticClass:"rdm-table-btn",on:{"click":function($event){return _vm.deleteRow(index)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"#2071c5"}})])],1)])}),0)])],_vm._v(" "),[_c('div',{staticStyle:{"height":"60px"}},[_c('div',{staticStyle:{"display":"inline-block","width":"70%"}},[_c('b-input',{staticClass:"modal-input",attrs:{"placeholder":_vm.enterDomainName,"disabled":_vm.isHostTypeAny},model:{value:(_vm.domainNameInput),callback:function ($$v) {_vm.domainNameInput=$$v},expression:"domainNameInput"}}),_vm._v(" "),_c('b-button',{staticClass:"rdm-btn",attrs:{"variant":"primary"},on:{"click":_vm.addDomain}},[_vm._v(_vm._s(_vm.$t('addDomain')))])],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('i',{staticClass:"fa fa-spinner loading-animation fa-3x"})]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"float":"right","margin-top":"2%"}},[_c('b-button',{staticClass:"rdm-btn",attrs:{"variant":"primary"},on:{"click":_vm.submitRegisterDomains}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)])],_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");




// set up application to use Vuex (application state management)
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

// set up the application state accessible by all components
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    authenticated: false,
    authToken: {},
    authenticationError: '',
    authenticationStackTrace: '',
    person: {},
    personFetchError: '',
    personFetchStackTrace: '',
    recentPurchases: [],
    expiringLicenses: [],
    localeJson: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({}),
    licenseDetails: {},
    previousPath: '/',
    isLA007User: false,
    isSurveyModalInteracted: false,
    isSurveyModalInteractedXS: false,
    validSurveyURL: false,
    validXSSurveyURL: false,
    validSurveyData: {},
    validXSSurveyData: {},
    surveyUrl: '',
    surveyId: '',
    xsSurveyId: '',
    xsSurveyUrl: '',
    showSurveyModal: false,
    showSurveyModalXS: false,
    showSurveyModaltemplate: false,
    xsskeyWords: ['cookie', 'document', 'script', 'javascript', 'src', 'iframe', 'svg', 'location', 'href', 'confirm', 'http', 'https'],
    isTokenAPICalled: false,
    isPersonInRole: false,
    isAllowPartialForWebKey: false,
    UberAgentDetails: [],
    DeviceTrustDetails: [],
    StrongLicDetails: [],
    UniconLicDetails: [],
    nsLicType: ['uberAgent', 'deviceTrustLic', 'strongLic']
  },
  getters: {
    authenticated: function authenticated(state) {
      return state.authenticated;
    },
    authToken: function authToken(state) {
      return state.authToken;
    },
    authenticationError: function authenticationError(state) {
      return {
        errorMessage: state.authenticationError,
        errorStack: state.authenticationStackTrace
      };
    },
    person: function person(state) {
      return state.person;
    },
    personFetchError: function personFetchError(state) {
      return {
        errorMessage: state.personFetchError,
        errorStack: state.personFetchStackTrace
      };
    },
    recentPurchases: function recentPurchases(state) {
      return state.recentPurchases;
    },
    expiringLicenses: function expiringLicenses(state) {
      return state.expiringLicenses;
    },
    localeJson: function localeJson(state) {
      return state.localeJson;
    },
    licenseDetails: function licenseDetails(state) {
      return state.licenseDetails;
    },
    previousPath: function previousPath(state) {
      return state.previousPath;
    },
    isLA007User: function isLA007User(state) {
      return state.isLA007User;
    },
    isSurveyModalInteracted: function isSurveyModalInteracted(state) {
      return state.isSurveyModalInteracted;
    },
    isSurveyModalInteractedXS: function isSurveyModalInteractedXS(state) {
      return state.isSurveyModalInteractedXS;
    },
    validSurveyURL: function validSurveyURL(state) {
      return state.validSurveyURL;
    },
    validXSSurveyURL: function validXSSurveyURL(state) {
      return state.validXSSurveyURL;
    },
    validSurveyData: function validSurveyData(state) {
      return {
        Id: state.surveyId,
        Url: state.surveyUrl
      };
    },
    validXSSurveyData: function validXSSurveyData(state) {
      return {
        Id: state.xsSurveyId,
        Url: state.xsSurveyUrl
      };
    },
    showSurveyModal: function showSurveyModal(state) {
      return state.showSurveyModal;
    },
    showSurveyModalXS: function showSurveyModalXS(state) {
      return state.showSurveyModalXS;
    },
    showSurveyModaltemplate: function showSurveyModaltemplate(state) {
      return state.showSurveyModaltemplate;
    },
    xsskeyWords: function xsskeyWords(state) {
      return state.xsskeyWords;
    },
    hasXssKeyWord: function hasXssKeyWord(state) {
      return function (hostValue) {
        var remSpace = /\s\s+/g;
        var hostUnesc = unescape(hostValue).toLowerCase().replace(remSpace, ' ');
        var arr = hostUnesc.trim().split(/[\s='"<>();:/\\’”&%(){}.*?@-`]+/);
        return state.xsskeyWords.some(function (v) {
          return arr.some(function (c) {
            return c === v;
          });
        });
      };
    },
    isTokenAPICalled: function isTokenAPICalled(state) {
      return state.isTokenAPICalled;
    },
    isPersonInRole: function isPersonInRole(state) {
      return state.isPersonInRole;
    },
    isAllowPartialForWebKey: function isAllowPartialForWebKey(state) {
      return state.isAllowPartialForWebKey;
    },
    UberAgentDetails: function UberAgentDetails(state) {
      return state.UberAgentDetails;
    },
    DeviceTrustDetails: function DeviceTrustDetails(state) {
      return state.DeviceTrustDetails;
    },
    StrongLicDetails: function StrongLicDetails(state) {
      return state.StrongLicDetails;
    },
    UniconLicDetails: function UniconLicDetails(state) {
      return state.UniconLicDetails;
    },
    nsLicType: function nsLicType(state) {
      return state.nsLicType;
    }
  },
  mutations: {
    authenticated: function authenticated(state, payload) {
      state.authenticated = payload.authenticated;
      state.authToken = payload.token;
    },
    personFetched: function personFetched(state, payload) {
      state.person = payload.person;
    },
    personFetchFailure: function personFetchFailure(state, payload) {
      state.personFetchError = payload.errorMessage;
      state.personFetchStackTrace = payload.errorStack;
    },
    authenticationFailure: function authenticationFailure(state, payload) {
      state.authenticated = false;
      state.authenticationError = payload.errorMessage;
      state.authenticationStackTrace = payload.errorStack;
    },
    setLicenseItems: function setLicenseItems(state, payload) {
      state[payload.itemType] = payload.items;
    },
    setLocaleJson: function setLocaleJson(state, localeJson) {
      state.localeJson = localeJson;
    },
    setCustomerId: function setCustomerId(state, customerId) {
      state.person.customerId = customerId;
    },
    setUberAgentDetails: function setUberAgentDetails(state, UADetails) {
      state.UberAgentDetails = UADetails;
    },
    setDeviceTrustDetails: function setDeviceTrustDetails(state, DeTrustDetails) {
      state.DeviceTrustDetails = DeTrustDetails;
    },
    setStrongLicDetails: function setStrongLicDetails(state, StLicDetails) {
      state.StrongLicDetails = StLicDetails;
    },
    setUniconLicDetails: function setUniconLicDetails(state, UcLicDetails) {
      state.UniconLicDetails = UcLicDetails;
    },
    setLicenseDetails: function setLicenseDetails(state, licenseDetails) {
      state.licenseDetails = licenseDetails;
    },
    setPreviousPath: function setPreviousPath(state, previousPath) {
      state.previousPath = previousPath;
    },
    setLA007User: function setLA007User(state, payload) {
      state.isLA007User = payload.value;
    },
    SURVEY_MODAL_CLOSED: function SURVEY_MODAL_CLOSED(state, payload) {
      state.isSurveyModalInteracted = payload;
    },
    SURVEY_MODAL_CLOSED_XS: function SURVEY_MODAL_CLOSED_XS(state, payload) {
      state.isSurveyModalInteractedXS = payload;
    },
    VALID_SURVEY_DATA: function VALID_SURVEY_DATA(state, payload) {
      state.surveyId = payload.surveyId;
      state.surveyUrl = payload.surveyUrl;
      if (payload.surveyUrl !== undefined) {
        state.validSurveyURL = true;
      }
    },
    VALID_SURVEY_DATA_XS: function VALID_SURVEY_DATA_XS(state, payload) {
      state.xsSurveyId = payload.xsSurveyId;
      state.xsSurveyUrl = payload.xsSurveyUrl;
      if (payload.xsSurveyUrl !== undefined) {
        state.validXSSurveyURL = true;
      }
    },
    SHOW_SURVEY_MODAL: function SHOW_SURVEY_MODAL(state, payload) {
      state.showSurveyModal = payload;
    },
    SHOW_SURVEY_MODAL_XS: function SHOW_SURVEY_MODAL_XS(state, payload) {
      state.showSurveyModalXS = payload;
    },
    SHOW_SURVEY_MODAL_TEMPLATE: function SHOW_SURVEY_MODAL_TEMPLATE(state, payload) {
      state.showSurveyModaltemplate = payload;
    },
    IS_TOKEN_API_CALLED: function IS_TOKEN_API_CALLED(state, payload) {
      state.isTokenAPICalled = payload;
    },
    IS_PERSON_IN_ROLE: function IS_PERSON_IN_ROLE(state, payload) {
      state.isPersonInRole = payload;
    },
    IS_ALLOW_PARTIAL_FOR_WEB_KEY: function IS_ALLOW_PARTIAL_FOR_WEB_KEY(state, payload) {
      state.isAllowPartialForWebKey = payload;
    }
  },
  actions: {
    authenticate: function authenticate(context, payload) {
      var loginId = payload.loginId || '';
      return payload.authService.authenticate(payload.authURL, loginId, payload.authCookie).then(function (res) {
        var authToken = payload.authService.getAuthenticatedUser();
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].AppInsights.setAuthenticatedUserContext(authToken.userName, authToken.customerId, true);
        // trigger the state mutation
        context.commit('authenticated', {
          authenticated: true,
          token: authToken
        });

        context.commit('IS_TOKEN_API_CALLED', false);
      }).catch(function (err) {
        // trigger authentication error state mutation
        context.commit('authenticationFailure', {
          errorMessage: err.message,
          errorStack: err.stack
        });
      });
    },
    fetchPerson: function fetchPerson(context, payload) {
      return payload.bottle.get(payload.personUrl).then(function (res) {
        // trigger state mutation
        context.commit('personFetched', {
          person: res.data
        });
      }).catch(function (err) {
        // trigger person fetch error state mutation
        context.commit('personFetchFailure', {
          errorMessage: err.message,
          errorStack: err.stack
        });
      });
    },
    fetchLicenseItems: function fetchLicenseItems(context, payload) {
      return payload.bottle.get(payload.url).then(function (_ref) {
        var data = _ref.data;

        context.commit('setLicenseItems', {
          itemType: payload.itemType,
          items: Array.isArray(data) ? data : []
        });
      });
    },
    fetchLocaleJson: function fetchLocaleJson(context, payload) {
      return payload.bottle.get(payload.url).then(function (_ref2) {
        var data = _ref2.data;
        return context.commit('setLocaleJson', data);
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "x/Xg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Search__ = __webpack_require__("/KFX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_QuickFind__ = __webpack_require__("x213");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'search': __WEBPACK_IMPORTED_MODULE_0__components_Search__["a" /* default */],
    'quick-find': __WEBPACK_IMPORTED_MODULE_1__components_QuickFind__["a" /* default */]
  },
  data: function data() {
    return {
      search: {
        findLicenseByOption: 'SerialNumber',
        searchInput: '',
        dateOption: 'StartDate',
        licenseTypeOption: 'active',
        fromDateValue: '',
        toDateValue: '',
        showAdvancedSearch: false
      }
    };
  },

  methods: {
    handleFindLicenseByChange: function handleFindLicenseByChange(value) {
      this.search.findLicenseByOption = value;
    },
    handleSearchInputChange: function handleSearchInputChange(value) {
      this.search.searchInput = value;
    },
    handleOrderDateChange: function handleOrderDateChange(value) {
      this.search.dateOption = value;
    },
    handleLicenseTypeChange: function handleLicenseTypeChange(value) {
      this.search.licenseTypeOption = value;
    },
    handleFromDateChange: function handleFromDateChange(value) {
      this.search.fromDateValue = new Date(value).toISOString();
    },
    handleToDateChange: function handleToDateChange(value) {
      this.search.toDateValue = new Date(value).toISOString();
    }
  }
});

/***/ }),

/***/ "x213":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickFind_vue__ = __webpack_require__("RXqU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326824f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickFind_vue__ = __webpack_require__("uIWZ");
function injectStyle (ssrContext) {
  __webpack_require__("+9mr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-326824f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickFind_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326824f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickFind_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xASe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"all-assets-base-container",attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('search',_vm._b({attrs:{"isFromAllAssetsPage":"","isSearchEmpty":_vm.isSearchEmpty,"isAdvancedSearchVisible":_vm.search.showAdvancedSearch},on:{"findLicenseByChange":_vm.handleFindLicenseByChange,"searchInputChange":_vm.handleSearchInputChange,"orderDateChange":_vm.handleOrderDateChange,"licenseTypeChange":_vm.handleLicenseTypeChange,"fromDateChange":_vm.handleFromDateChange,"toDateChange":_vm.handleToDateChange,"advancedSearchButtonClick":_vm.handleAdvancedSearchButtonClick,"onSearchClick":_vm.handleSearchClick,"clearSearchClick":_vm.handleClearSearchClick}},'search',_vm.search,false))],1)]),_vm._v(" "),(!_vm.loading)?_c('div',[(_vm.list.length)?_c('b-row',{staticClass:"all-licenses-table-row"},[_c('div',{staticClass:"col-12 col-md-4"},[_c('b-button',{staticClass:"all-assets-cta-btn",attrs:{"variant":"primary","size":"lg"},on:{"click":_vm.downloadCSV}},[_vm._v("\n          "+_vm._s(_vm.$t('exportList'))+"\n          "),_c('span',{staticClass:"icon-download export-list-icon"})])],1),_vm._v(" "),_c('div',{staticClass:"col-12 d-sm-block d-md-none options-btn-container"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.showOptions = !_vm.showOptions}}},[_vm._v("\n          "+_vm._s(_vm.$t('viewHideOptions', { action: !_vm.showOptions ? _vm.$t('view') : _vm.$tc('hide', 1) } ))+"\n        ")])]),_vm._v(" "),_c('div',{class:['col-12 col-md-5 offset-md-3 options-container', { show: _vm.showOptions }]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md page-size-col"},[_c('fieldset',{staticClass:"form-group"},[_c('legend',[_vm._v(_vm._s(_vm.$t('show')))]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-select',{attrs:{"options":_vm.pageOptions},on:{"change":_vm.handlePageNumberChange},model:{value:(_vm.pageOption),callback:function ($$v) {_vm.pageOption=$$v},expression:"pageOption"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md"},[_c('fieldset',{staticClass:"form-group"},[_c('legend',[_vm._v(_vm._s(_vm.$t('dateRange')))]),_vm._v(" "),_c('div',{staticClass:"select-container"},[_c('b-input',{attrs:{"value":_vm.dateRangeValue,"disabled":""}})],1)])])])])]):_vm._e(),_vm._v(" "),(_vm.list.length)?_c('b-row',[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"all-assets-table"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('productName')))]),_vm._v(" "),_c('th',[_c('b-select',{staticClass:"all-assets-dynamic-column-select",attrs:{"options":_vm.dynamicColumnOptions},on:{"change":_vm.handleDynamicColumnOptionChange},model:{value:(_vm.dynamicColumnOption),callback:function ($$v) {_vm.dynamicColumnOption=$$v},expression:"dynamicColumnOption"}})],1),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('quantity')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.list),function(item,i){return _c('all-assets-list-item',{key:item.id,attrs:{"item":item,"isOdd":i % 2 !== 0,"dynamicKey":_vm.dynamicColumnOption}})}),1)])])]):_vm._e(),_vm._v(" "),(_vm.list.length)?_c('b-row',[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"pagination-container"},[_c('b-pagination',{attrs:{"hide-goto-end-buttons":"","value":_vm.currentPage,"limit":6,"per-page":_vm.pageOption,"prev-text":_vm.$t('paginationPrevText'),"next-text":_vm.$t('paginationNextText'),"total-rows":_vm.totalAssetsCount},on:{"change":_vm.handlePageChange}})],1)])]):_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"no-records-container"},[_c('h3',[_vm._v(_vm._s(_vm.$t('noRecordsFound')))])])],1)],1):_c('div',[_c('loading')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabbedHomeView__ = __webpack_require__("vCx2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { 'home': __WEBPACK_IMPORTED_MODULE_0__components_Home__["a" /* default */], 'tabbed-home-view': __WEBPACK_IMPORTED_MODULE_1__components_TabbedHomeView__["a" /* default */] },
  data: function data() {
    return {
      timer: null
    };
  },

  computed: {
    localeClass: function localeClass() {
      if (this.$store.getters.person && this.$store.getters.person.preferences) {
        return this.$store.getters.person.preferences.locale;
      }
      return '';
    },
    isLoginPath: function isLoginPath() {
      return this.$route.path.includes('/login');
    },
    isEmailPath: function isEmailPath() {
      return this.$route.path.includes('/email');
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.UrlBuilder.isInternalUser) {
      this.$store.commit('authenticated', { authenticated: false, token: null });
      sessionStorage.clear();
      if (this.$route.name === 'LicenseChecker') {
        this.$router.push('/la-007');
      } else if (this.route.name === 'Email') {
        this.$router.push(this.route.path);
      } else {
        this.$router.push('/login');
      }
    }
    this.timer = setInterval(function () {
      if (_this.UrlBuilder.isInternalUser) {
        document.querySelector('.nav-tabs').style.borderBottom = _this.isLoginPath || _this.isEmailPath ? '1px solid transparent' : '1px solid #dee2e6';
      }
    }, 1);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e922cac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("LutH");
function injectStyle (ssrContext) {
  __webpack_require__("sNX3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e922cac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e922cac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y+HE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card renewal"},[_c('div',{staticClass:"card-header"},[_vm._v("Renewal Chain")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.grid.length)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.grid.length)?_c('div',{staticClass:"card-deck"},_vm._l((_vm.grid),function(grid,i){return _c('div',{key:grid[0],staticClass:"card-container"},[(grid.length > 1)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header normal text-center font-weight-bold"},[_vm._v(_vm._s(grid[0]))]),_vm._v(" "),_c('ul',{staticStyle:{"list-style-type":"none","padding":"0","margin":"0"}},_vm._l((_vm.getCountItems(grid)),function(item,j){return _c('li',{key:item.ID,staticClass:"list-item"},[_vm._l(([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),function(index){return _c('div',{key:index,staticStyle:{"width":"5px"}},[(
                    _vm.hasChildInSameColumn(_vm.getCountItems(grid), item.ID) &&
                    _vm.randomNumberMap[i][j] === index
                  )?[_c('div',{class:("item no connector " + (_vm.getColorClass(_vm.getLicenseStatus(item.LIFECYCLE_STATUS)))),attrs:{"id":_vm.hasChildInSameColumn(_vm.getCountItems(grid), item.ID) ? item.ID : '',"data-status":_vm.getLicenseStatus(item.LIFECYCLE_STATUS)}})]:[_c('div',{staticClass:"connector"})]],2)}),_vm._v(" "),_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],ref:item.ID,refInFor:true,class:_vm.getItemClasses(item, _vm.getCountItems(grid)),attrs:{"id":_vm.hasChildInSameColumn(_vm.getCountItems(grid), item.ID) ? '' : item.ID,"data-parent-id":item.PARENT_FULFILLMENT,"data-status":_vm.getLicenseStatus(item.LIFECYCLE_STATUS),"title":!!item.ACTIVATION_COUNT ? _vm.getLicenseStatus(item.LIFECYCLE_STATUS, true) : '',"data-original-title":!!item.ACTIVATION_COUNT ? _vm.getLicenseStatus(item.LIFECYCLE_STATUS, true) : ''}},[(!!item.ACTIVATION_COUNT)?[_c('span',[_vm._v(_vm._s(item.ACTIVATION_COUNT))])]:[_c('span',{staticClass:"white-text"},[_vm._v("000")])]],2),_vm._v(" "),_vm._l(([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]),function(index){return _c('div',{key:index},[(
                    _vm.hasChildInSameColumn(_vm.getCountItems(grid), item.ID) &&
                    _vm.randomNumberMap[i][j] === index
                  )?[_c('div',{class:("item no connector " + (_vm.getColorClass(_vm.getLicenseStatus(item.LIFECYCLE_STATUS)))),attrs:{"id":_vm.hasChildInSameColumn(_vm.getCountItems(grid), item.ID) ? item.ID : '',"data-status":_vm.getLicenseStatus(item.LIFECYCLE_STATUS)}})]:[_c('div',{staticClass:"connector"})]],2)})],2)}),0)]):_vm._e()])}),0):_c('p',{staticClass:"text-center"},[_vm._v("There are no items to show")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 offset-md-8"},[_c('div',{staticClass:"row legend text-center"},[_c('div',{staticClass:"col-3"},[_c('span',{staticClass:"rehost"}),_vm._v(" Rehost")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('span',{staticClass:"none"}),_vm._v(" Active")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('span',{staticClass:"renew"}),_vm._v(" Renew")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('span',{staticClass:"return"}),_vm._v(" Return")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y/8N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-group shadow"},_vm._l((_vm.matchedItems),function(item,id){return _c('vue-bootstrap-typeahead-list-item',{key:id,attrs:{"data":item.data,"html-text":_vm.highlight(item.text),"background-variant":_vm.backgroundVariant,"text-variant":_vm.textVariant},nativeOn:{"click":function($event){return _vm.handleHit(item, $event)}},scopedSlots:_vm._u([{key:"suggestion",fn:function(ref){
var data = ref.data;
var htmlText = ref.htmlText;
return (_vm.$scopedSlots.suggestion)?[_vm._t("suggestion",null,null,{ data: data, htmlText: htmlText })]:undefined}}],null,true)})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yedN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yttA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_table_vue__ = __webpack_require__("OHFj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fea6cdb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_table_vue__ = __webpack_require__("kvwc");
function injectStyle (ssrContext) {
  __webpack_require__("gjr2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_license_checker_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fea6cdb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_license_checker_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z3zT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EasyAllocation_vue__ = __webpack_require__("5Bke");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b96c64fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EasyAllocation_vue__ = __webpack_require__("F/zu");
function injectStyle (ssrContext) {
  __webpack_require__("fQX5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b96c64fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EasyAllocation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b96c64fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EasyAllocation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zCPJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Notes',
  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_0__Loading__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      isInputUpdated: false,
      previousNotesInput: '',
      isSaving: false,
      notes: ''
    };
  },

  props: {
    licenseId: {
      type: Number,
      required: true
    },
    AssetID: {
      type: Number,
      required: true
    }
  },
  computed: {
    disableSaveNotesBtn: function disableSaveNotesBtn() {
      if (this.notes === '' || this.notes === this.previousNotesInput) return true;
      return false;
    },
    activationId: function activationId() {
      return this.$route.params.licenseId || '';
    },
    customerId: function customerId() {
      return this.$store.getters.person.customerId;
    },
    loggedInUserName: function loggedInUserName() {
      return this.$store.getters.authToken.userName || '';
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    this.bottle.get(this.UrlBuilder.licenseDetailNotesUrl(this.$store.getters.person.customerId, this.licenseId)).then(function (_ref) {
      var data = _ref.data;

      _this.notes = (data.Notes || []).reduce(function (acc, cur) {
        return acc + cur.value;
      }, '');
      _this.previousNotesInput = _this.notes;
      _this.loading = false;
    }).catch(function (error) {
      _this.loading = false;
      _this.loggly.log({
        errorMessage: 'Failed to fetch notes for ' + _this.licenseId,
        errorObject: error,
        errorStack: error.stack
      });
    });
  },

  methods: {
    saveNotes: function saveNotes() {
      var _this2 = this;

      var isSaving = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.isSaving = isSaving;
      this.bottle.post(this.UrlBuilder.saveNotesUrl, {
        AssetId: this.AssetID,
        value: this.notes,
        customerID: this.customerId,
        loggedInUser: this.loggedInUserName
      }).then(function (_ref2) {
        var data = _ref2.data;

        _this2.isSaving = false;
        _this2.previousNotesInput = _this2.notes;
      }).catch(function (error) {
        _this2.isSaving = false;
        _this2.loggly.log({
          errorMessage: 'Failed to fetch notes for ' + _this2.activationId,
          errorObject: error,
          errorStack: error.stack
        });
      });
    },
    deleteAllNotes: function deleteAllNotes() {
      this.notes = '';
      this.saveNotes(false);
    }
  }
});

/***/ }),

/***/ "zjmz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.js